//Autogenerated

import {Language} from "@reapptor-apps/reapptor-toolkit";
import {BaseLocalizer} from "@reapptor-apps/reapptor-toolkit";

class Localizer extends BaseLocalizer {

    //Constants
    public readonly topNavFrontpageLanguageItemName: string = `_0`;
    public readonly topNavLoginLanguageItemName: string = `_1`;
    public readonly topNavAdminLanguageItemName: string = `_2`;
    public readonly topNavAccountLanguageItemName: string = `_3`;
    public readonly topNavLogoutLanguageItemName: string = `_4`;
    public readonly widgetWeAreLinkLabelLanguageItemName: string = `_5`;
    public readonly widgetWeAreLinkDescriptionLanguageItemName: string = `_6`;
    public readonly widgetLoginDescriptionLanguageItemName: string = `_7`;
    public readonly loginPageLoginButtonLanguageItemName: string = `_8`;
    public readonly loginPageSsoButtonLanguageItemName: string = `_9`;
    public readonly loginPageForgotPasswordButtonLanguageItemName: string = `_A`;
    public readonly loginPageEmailInputLanguageItemName: string = `_B`;
    public readonly linkExpiredLanguageItemName: string = `_C`;
    public readonly linkUsedLanguageItemName: string = `_D`;
    public readonly forgotPasswordPagePageTitleLanguageItemName: string = `_E`;
    public readonly forgotPasswordPageSuccessMessageLanguageItemName: string = `_F`;
    public readonly forgotPasswordPageFailedMessageLanguageItemName: string = `_10`;
    public readonly forgotPasswordPageResetButtonLanguageItemName: string = `_11`;
    public readonly forgotPasswordPageLoginButtonLanguageItemName: string = `_12`;
    public readonly forgotPasswordPageHelpTextLanguageItemName: string = `_13`;
    public readonly loginPagePasswordInputLanguageItemName: string = `_14`;
    public readonly loginPageTitleLanguageItemName: string = `_15`;
    public readonly loginPageSubtitleLanguageItemName: string = `_16`;
    public readonly enumLoginResultStatusNotFoundLanguageItemName: string = `_17`;
    public readonly enumLoginResultStatusDeletedLanguageItemName: string = `_18`;
    public readonly enumLoginResultStatusLockedLanguageItemName: string = `_19`;
    public readonly enumLoginResultStatusSecurityLanguageItemName: string = `_1A`;
    public readonly errorPageTitleLanguageItemName: string = `_1B`;
    public readonly errorPageErrorMessageLanguageItemName: string = `_1C`;
    public readonly errorPageContactSupportLanguageItemName: string = `_1D`;
    public readonly contactSupportPageTitleLanguageItemName: string = `_1E`;
    public readonly formInputEmailLanguageItemName: string = `_1F`;
    public readonly formInputPhoneLanguageItemName: string = `_20`;
    public readonly formInputFirstnameLanguageItemName: string = `_21`;
    public readonly formInputMiddlenameLanguageItemName: string = `_22`;
    public readonly formInputLastnameLanguageItemName: string = `_23`;
    public readonly formInputMessageLanguageItemName: string = `_24`;
    public readonly formInputLanguageLanguageItemName: string = `_25`;
    public readonly formInputRoleLanguageItemName: string = `_26`;
    public readonly formSendLanguageItemName: string = `_27`;
    public readonly formSaveLanguageItemName: string = `_28`;
    public readonly topNavContactSupportLanguageItemName: string = `_29`;
    public readonly dayOfWeekSundayLanguageItemName: string = `_2A`;
    public readonly dayOfWeekMondayLanguageItemName: string = `_2B`;
    public readonly dayOfWeekTuesdayLanguageItemName: string = `_2C`;
    public readonly dayOfWeekWednesdayLanguageItemName: string = `_2D`;
    public readonly dayOfWeekThursdayLanguageItemName: string = `_2E`;
    public readonly dayOfWeekFridayLanguageItemName: string = `_2F`;
    public readonly dayOfWeekSaturdayLanguageItemName: string = `_30`;
    public readonly myAccountPageTitleLanguageItemName: string = `_31`;
    public readonly myAccountPageSubtitleLanguageItemName: string = `_32`;
    public readonly myAccountPageDataSavedLanguageItemName: string = `_33`;
    public readonly myAccountPageAcceptanceLanguageItemName: string = `_34`;
    public readonly myAccountPageAcceptanceRequiredLanguageItemName: string = `_35`;
    public readonly myAccountPageAcceptanceTermsLanguageItemName: string = `_36`;
    public readonly myAccountPageAcceptanceTermsTitleLanguageItemName: string = `_37`;
    public readonly myAccountPageAcceptanceTermsContentLanguageItemName: string = `_38`;
    public readonly myAccountPageAcceptancePrivacyNoticeLanguageItemName: string = `_39`;
    public readonly myAccountPageAcceptancePrivacyNoticeTitleLanguageItemName: string = `_3A`;
    public readonly myAccountPageAcceptancePrivacyNoticeContentLanguageItemName: string = `_3B`;
    public readonly myAccountPageUserAlreadyExistsLanguageItemName: string = `_3C`;
    public readonly loginPageSsoUserNotFoundLanguageItemName: string = `_3D`;
    public readonly loginPageSsoFailedLanguageItemName: string = `_3E`;
    public readonly genericAccessDeniedLanguageItemName: string = `_3F`;
    public readonly adminSettingsKeyLanguageItemName: string = `_40`;
    public readonly adminSettingsValueLanguageItemName: string = `_41`;
    public readonly adminUserDeletedLanguageItemName: string = `_42`;
    public readonly adminUserDeletedPermanentlyLanguageItemName: string = `_43`;
    public readonly adminUserRestoredLanguageItemName: string = `_44`;
    public readonly adminAddUserLanguageItemName: string = `_45`;
    public readonly adminShowDeletedLanguageItemName: string = `_46`;
    public readonly adminButtonRestoreLanguageItemName: string = `_47`;
    public readonly adminButtonDeleteLanguageItemName: string = `_48`;
    public readonly adminButtonUnlockLanguageItemName: string = `_49`;
    public readonly adminSettingsSavedLanguageItemName: string = `_4A`;
    public readonly adminAlertMessageUnlockUserLanguageItemName: string = `_4B`;
    public readonly adminConfirmationButtonUnlockUserLanguageItemName: string = `_4C`;
    public readonly adminConfirmationButtonDeleteUserLanguageItemName: string = `_4D`;
    public readonly adminConfirmationButtonRestoreUserLanguageItemName: string = `_4E`;
    public readonly genericCancelLanguageItemName: string = `_4F`;
    public readonly resetPasswordPageTitleLanguageItemName: string = `_50`;
    public readonly resetPasswordSuccessMessageLanguageItemName: string = `_51`;
    public readonly resetPasswordSuccessMessageAndInfoLanguageItemName: string = `_52`;
    public readonly changePasswordPageTitleLanguageItemName: string = `_53`;
    public readonly changePasswordButtonLanguageItemName: string = `_54`;
    public readonly changePasswordWrongCurrentMessageLanguageItemName: string = `_55`;
    public readonly changePasswordWeakPasswordMessageLanguageItemName: string = `_56`;
    public readonly monthJanuaryLanguageItemName: string = `_57`;
    public readonly monthFebruaryLanguageItemName: string = `_58`;
    public readonly monthMarchLanguageItemName: string = `_59`;
    public readonly monthAprilLanguageItemName: string = `_5A`;
    public readonly monthMayLanguageItemName: string = `_5B`;
    public readonly monthJuneLanguageItemName: string = `_5C`;
    public readonly monthJulyLanguageItemName: string = `_5D`;
    public readonly monthAugustLanguageItemName: string = `_5E`;
    public readonly monthSeptemberLanguageItemName: string = `_5F`;
    public readonly monthOctoberLanguageItemName: string = `_60`;
    public readonly monthNovemberLanguageItemName: string = `_61`;
    public readonly monthDecemberLanguageItemName: string = `_62`;
    public readonly enumUserRoleGroupAdminsLanguageItemName: string = `_63`;
    public readonly enumUserRoleGroupSubcontractorsLanguageItemName: string = `_64`;
    public readonly enumUserRoleGroupAdminsDescriptionLanguageItemName: string = `_65`;
    public readonly enumUserRoleGroupManagersLanguageItemName: string = `_66`;
    public readonly enumUserRoleGroupContactPersonsLanguageItemName: string = `_67`;
    public readonly enumUserRoleGroupManagersDescriptionLanguageItemName: string = `_68`;
    public readonly enumUserRoleGroupEmployeesLanguageItemName: string = `_69`;
    public readonly enumUserRoleGroupEmployeesDescriptionLanguageItemName: string = `_6A`;
    public readonly adminChooseRoleLanguageItemName: string = `_6B`;
    public readonly componentFooterContactLanguageItemName: string = `_6C`;
    public readonly componentFooterFrontpageLanguageItemName: string = `_6D`;
    public readonly tasksDashboardGetManualLanguageItemName: string = `_6E`;
    public readonly adminGridNoInvitationsTextLanguageItemName: string = `_6F`;
    public readonly adminButtonResendInvitationLanguageItemName: string = `_70`;
    public readonly adminButtonResetPasswordLanguageItemName: string = `_71`;
    public readonly adminLabelAuthenticationTypeLanguageItemName: string = `_72`;
    public readonly enumAuthTypeEmailLanguageItemName: string = `_73`;
    public readonly enumAuthTypePhoneLanguageItemName: string = `_74`;
    public readonly adminTabInvitationsLanguageItemName: string = `_75`;
    public readonly adminConfirmationButtonResetPasswordLanguageItemName: string = `_76`;
    public readonly adminConfirmationButtonResendInvitationLanguageItemName: string = `_77`;
    public readonly adminAlertUserPasswordInfoLanguageItemName: string = `_78`;
    public readonly adminGridCreatedByLanguageItemName: string = `_79`;
    public readonly adminGridTypeLanguageItemName: string = `_7A`;
    public readonly genericCreatedAtLanguageItemName: string = `_7B`;
    public readonly adminGridExpiresAtLanguageItemName: string = `_7C`;
    public readonly adminGridProcessedAtLanguageItemName: string = `_7D`;
    public readonly adminGridReusableLanguageItemName: string = `_7E`;
    public readonly adminGridAuthTypeLanguageItemName: string = `_7F`;
    public readonly adminAlertMessageAccountSavedLanguageItemName: string = `_80`;
    public readonly adminAlertErrorAccountExistLanguageItemName: string = `_81`;
    public readonly adminAlertErrorWorkCardIdExistsLanguageItemName: string = `_82`;
    public readonly adminAlertErrorPhoneNumberInvalidLanguageItemName: string = `_83`;
    public readonly forgotPasswordUsernameInputLanguageItemName: string = `_84`;
    public readonly enumInvitationTypeInvitationLanguageItemName: string = `_85`;
    public readonly enumInvitationTypeResetPasswordLanguageItemName: string = `_86`;
    public readonly enumInvitationTypeForgotPasswordLanguageItemName: string = `_87`;
    public readonly adminConfirmationButtonRollbackLanguageItemName: string = `_88`;
    public readonly widgetPwaInstallLanguageItemName: string = `_89`;
    public readonly widgetPwaDescriptionLanguageItemName: string = `_8A`;
    public readonly adminOrganizationContractsLabelLanguageItemName: string = `_8B`;
    public readonly workOrdersPageTitleLanguageItemName: string = `_8C`;
    public readonly dashboardGetManualLanguageItemName: string = `_8D`;
    public readonly contactSupportPageMessageSentLanguageItemName: string = `_8E`;
    public readonly contactSupportPageMessageWithIdSentLanguageItemName: string = `_8F`;
    public readonly topNavAdminManagementLanguageItemName: string = `_90`;
    public readonly userManagementPageTitleLanguageItemName: string = `_91`;
    public readonly userManagementPageCheckboxShowExpiredLanguageItemName: string = `_92`;
    public readonly applicationSettingsPageTitleLanguageItemName: string = `_93`;
    public readonly roleNameMounterLanguageItemName: string = `_94`;
    public readonly roleNameAdminLanguageItemName: string = `_95`;
    public readonly roleNameContactPersonLanguageItemName: string = `_96`;
    public readonly roleNameBusinessManagerLanguageItemName: string = `_97`;
    public readonly roleNameManagerLanguageItemName: string = `_98`;
    public readonly adminConsolePageClearRedisCacheLanguageItemName: string = `_99`;
    public readonly adminConsolePageClearRedisCacheConfirmLanguageItemName: string = `_9A`;
    public readonly adminConsolePageDropUserSessionsLanguageItemName: string = `_9B`;
    public readonly adminConsolePageDropUserSessionsConfirmLanguageItemName: string = `_9C`;
    public readonly adminConsolePageTestEmailLanguageItemName: string = `_9D`;
    public readonly adminConsolePageTestEmailFailedLanguageItemName: string = `_9E`;
    public readonly adminConsolePageTestEmailSuccessLanguageItemName: string = `_9F`;
    public readonly adminConsolePageTestPdfLanguageItemName: string = `_A0`;
    public readonly adminConsolePageTestPdfFailedLanguageItemName: string = `_A1`;
    public readonly adminConsolePageTestPdfSuccessLanguageItemName: string = `_A2`;
    public readonly adminConsolePageTestSmsLanguageItemName: string = `_A3`;
    public readonly adminConsolePageTestSmsFailedLanguageItemName: string = `_A4`;
    public readonly adminConsolePageTestSmsSuccessLanguageItemName: string = `_A5`;
    public readonly adminConsolePageTitleLanguageItemName: string = `_A6`;
    public readonly validatorsEmailLanguageItemName: string = `_A7`;
    public readonly validatorsPasswordLanguageItemName: string = `_A8`;
    public readonly validatorsPhoneLanguageItemName: string = `_A9`;
    public readonly validatorsRequiredLanguageItemName: string = `_AA`;
    public readonly validatorsNumberRangeLanguageItemName: string = `_AB`;
    public readonly validatorsLengthLanguageItemName: string = `_AC`;
    public readonly validatorsUrlLanguageItemName: string = `_AD`;
    public readonly genericActionsLanguageItemName: string = `_AE`;
    public readonly genericSaveLanguageItemName: string = `_AF`;
    public readonly genericBackLanguageItemName: string = `_B0`;
    public readonly genericReloadLanguageItemName: string = `_B1`;
    public readonly genericSearchLanguageItemName: string = `_B2`;
    public readonly genericDeleteLanguageItemName: string = `_B3`;
    public readonly genericRestoreLanguageItemName: string = `_B4`;
    public readonly genericEditLanguageItemName: string = `_B5`;
    public readonly genericAddLanguageItemName: string = `_B6`;
    public readonly genericAddressLanguageItemName: string = `_B7`;
    public readonly genericActivateLanguageItemName: string = `_B8`;
    public readonly genericDeactivateLanguageItemName: string = `_B9`;
    public readonly genericNextLanguageItemName: string = `_BA`;
    public readonly genericDateLanguageItemName: string = `_BB`;
    public readonly genericLoadingLanguageItemName: string = `_BC`;
    public readonly genericNameLanguageItemName: string = `_BD`;
    public readonly genericNoDataLanguageItemName: string = `_BE`;
    public readonly genericVatIdLanguageItemName: string = `_BF`;
    public readonly genericBusinessIdLanguageItemName: string = `_C0`;
    public readonly genericAcceptLanguageItemName: string = `_C1`;
    public readonly genericCityLanguageItemName: string = `_C2`;
    public readonly genericCloseLanguageItemName: string = `_C3`;
    public readonly genericCommentLanguageItemName: string = `_C4`;
    public readonly genericCompanyLanguageItemName: string = `_C5`;
    public readonly genericCustomerLanguageItemName: string = `_C6`;
    public readonly genericCountLanguageItemName: string = `_C7`;
    public readonly genericCreateLanguageItemName: string = `_C8`;
    public readonly genericDayLanguageItemName: string = `_C9`;
    public readonly genericDescriptionLanguageItemName: string = `_CA`;
    public readonly genericEmailLanguageItemName: string = `_CB`;
    public readonly genericErrorLanguageItemName: string = `_CC`;
    public readonly genericFavoriteLanguageItemName: string = `_CD`;
    public readonly genericFirstNameLanguageItemName: string = `_CE`;
    public readonly genericLastNameLanguageItemName: string = `_CF`;
    public readonly genericLoginLanguageItemName: string = `_D0`;
    public readonly genericMessageLanguageItemName: string = `_D1`;
    public readonly genericMonthLanguageItemName: string = `_D2`;
    public readonly genericPasswordLanguageItemName: string = `_D3`;
    public readonly genericPhoneNumberLanguageItemName: string = `_D4`;
    public readonly genericPostalCodeLanguageItemName: string = `_D5`;
    public readonly genericRejectLanguageItemName: string = `_D6`;
    public readonly genericSendLanguageItemName: string = `_D7`;
    public readonly genericWeekLanguageItemName: string = `_D8`;
    public readonly genericFromLanguageItemName: string = `_D9`;
    public readonly genericToLanguageItemName: string = `_DA`;
    public readonly genericDownloadLanguageItemName: string = `_DB`;
    public readonly genericPreviewLanguageItemName: string = `_DC`;
    public readonly genericUsernameLanguageItemName: string = `_DD`;
    public readonly genericDeclineLanguageItemName: string = `_DE`;
    public readonly countryFinlandLanguageItemName: string = `_DF`;
    public readonly countrySwedenLanguageItemName: string = `_E0`;
    public readonly countryNorwayLanguageItemName: string = `_E1`;
    public readonly countryDenmarkLanguageItemName: string = `_E2`;
    public readonly countryPolandLanguageItemName: string = `_E3`;
    public readonly countryRussiaLanguageItemName: string = `_E4`;
    public readonly countryUkraineLanguageItemName: string = `_E5`;
    public readonly dashboardPageAdminDescriptionLanguageItemName: string = `_E6`;
    public readonly dashboardPageContactSupportDescriptionLanguageItemName: string = `_E7`;
    public readonly countryUnitedStatesLanguageItemName: string = `_E8`;
    public readonly offlineTitleLanguageItemName: string = `_E9`;
    public readonly offlineSubtitleLanguageItemName: string = `_EA`;
    public readonly genericShowMoreLanguageItemName: string = `_EB`;
    public readonly mobileNotificationsPageNoNotificationsLanguageItemName: string = `_EC`;
    public readonly mobileNotificationsPageTitleLanguageItemName: string = `_ED`;
    public readonly adminAlertErrorAccountWithSamePhoneExistLanguageItemName: string = `_EE`;
    public readonly adminAlertErrorAccountWithSameEmailExistLanguageItemName: string = `_EF`;
    public readonly topNavAppointmentBookingLanguageItemName: string = `_F0`;
    public readonly topNavDoctorsLanguageItemName: string = `_F1`;
    public readonly topNavServicesLanguageItemName: string = `_F2`;
    public readonly topNavClinicsLanguageItemName: string = `_F3`;
    public readonly topNavOccupationalHealthLanguageItemName: string = `_F4`;
    public readonly topNavPricingLanguageItemName: string = `_F5`;
    public readonly topNavCompanyLanguageItemName: string = `_F6`;
    public readonly appointmentPageTitleLanguageItemName: string = `_F7`;
    public readonly doctorsPageTitleLanguageItemName: string = `_F8`;
    public readonly servicesPageTitleLanguageItemName: string = `_F9`;
    public readonly clinicsPageTitleLanguageItemName: string = `_FA`;
    public readonly occupationalHealthPageTitleLanguageItemName: string = `_FB`;
    public readonly pricingPageTitleLanguageItemName: string = `_FC`;
    public readonly companyPageTitleLanguageItemName: string = `_FD`;
    public readonly homePageHeaderLanguageItemName: string = `_FE`;
    public readonly homePageHeaderBookATimeLanguageItemName: string = `_FF`;
    public readonly homePageHeaderCallUsLanguageItemName: string = `_100`;
    public readonly homePageHeaderRemoteBookingLanguageItemName: string = `_101`;
    public readonly homePageHeaderOccupationalHealthBookingLanguageItemName: string = `_102`;
    public readonly homePageHeaderSearchForDoctorLanguageItemName: string = `_103`;
    public readonly homePageHeaderLocationLanguageItemName: string = `_104`;
    public readonly genericTodayLanguageItemName: string = `_105`;
    public readonly buttonBookAppointmentLanguageItemName: string = `_106`;
    public readonly appointmentPageInstantlyFreeTimesLanguageItemName: string = `_107`;
    public readonly appointmentPageSpecialtyLanguageItemName: string = `_108`;
    public readonly appointmentPageNoFreeTimesLanguageItemName: string = `_109`;
    public readonly appointmentPageShowMoreTimesLanguageItemName: string = `_10A`;
    public readonly buttonShowMoreLanguageItemName: string = `_10B`;
    public readonly buttonShowAllLanguageItemName: string = `_10C`;
    public readonly buttonReadMoreLanguageItemName: string = `_10D`;
    public readonly blogPostsLatestBlogpostsLanguageItemName: string = `_10E`;
    public readonly buttonShowLessLanguageItemName: string = `_10F`;
    public readonly buttonViewOnFacebookLanguageItemName: string = `_110`;
    public readonly newsSocialMediaLanguageItemName: string = `_111`;
    public readonly appointmentPageAppointmentCancelingLanguageItemName: string = `_112`;
    public readonly appointmentPageSpecialistInChargeLanguageItemName: string = `_113`;
    public readonly appointmentPageSearchForTimesBetweenLanguageItemName: string = `_114`;
    public readonly appointmentPageChooseTimeframeLanguageItemName: string = `_115`;
    public readonly appointmentPageDoctorNothingSelectedLanguageItemName: string = `_116`;
    public readonly appointmentPageMedicalFieldNothingSelectedLanguageItemName: string = `_117`;
    public readonly appointmentPageLocationNothingSelectedLanguageItemName: string = `_118`;
    public readonly buttonGoToBookingLanguageItemName: string = `_119`;
    public readonly generalLocationsLanguageItemName: string = `_11A`;
    public readonly contactPhoneOpeningHoursLanguageItemName: string = `_11B`;
    public readonly formInputSSNLanguageItemName: string = `_11C`;
    public readonly reserveTimeModalNoOccupationalHealthFoundLanguageItemName: string = `_11D`;
    public readonly reserveTimeModalTimeBookedLanguageItemName: string = `_11E`;
    public readonly reserveTimeModalRegisterUsernameLanguageItemName: string = `_11F`;
    public readonly reserveTimeModalLoginLanguageItemName: string = `_120`;
    public readonly reserveTimeModalBookingConfirmationLanguageItemName: string = `_121`;
    public readonly reserveTimeModalCreateUserLanguageItemName: string = `_122`;
    public readonly reserveTimeModalMoreInformationLanguageItemName: string = `_123`;
    public readonly reserveTimeModalConfirmBookingLanguageItemName: string = `_124`;
    public readonly reserveTimeModalfirstTimeBookingTextLanguageItemName: string = `_125`;
    public readonly reserveTimeModalYourInformationLanguageItemName: string = `_126`;
    public readonly reserveTimeModalAppointmentDetailsLanguageItemName: string = `_127`;
    public readonly reserveTimeModalAppointmentDetailsDoctorLanguageItemName: string = `_128`;
    public readonly reserveTimeModalAppointmentDetailsDateLanguageItemName: string = `_129`;
    public readonly reserveTimeModalAppointmentDetailsTimeLanguageItemName: string = `_12A`;
    public readonly reserveTimeModalAppointmentDetailsConfirmLanguageItemName: string = `_12B`;
    public readonly contactSupportPageContactFormLanguageItemName: string = `_12C`;
    public readonly contactSupportPageElectronicBookingMessageLanguageItemName: string = `_12D`;
    public readonly contactSupportPageMoWeThLanguageItemName: string = `_12E`;
    public readonly contactSupportPageTuFrLanguageItemName: string = `_12F`;
    public readonly contactSupportPageSaLanguageItemName: string = `_130`;
    public readonly footerPhoneShortenedLanguageItemName: string = `_131`;
    public readonly footerAllOpeningHoursLanguageItemName: string = `_132`;
    public readonly cancelAppointmentModalLoginToCancelLanguageItemName: string = `_133`;
    public readonly cancelAppointmentModalEnterBookingNumberToCancelLanguageItemName: string = `_134`;
    public readonly cancelAppointmentModalNoBookingFoundLanguageItemName: string = `_135`;
    public readonly cancelAppointmentModalGetInfoLanguageItemName: string = `_136`;
    public readonly cancelAppointmentModalBookingInfoLanguageItemName: string = `_137`;
    public readonly cancelAppointmentModalDoctorLanguageItemName: string = `_138`;
    public readonly cancelAppointmentModalSpecialtyLanguageItemName: string = `_139`;
    public readonly cancelAppointmentModalTimeLanguageItemName: string = `_13A`;
    public readonly cancelAppointmentModalCancelSuccessLanguageItemName: string = `_13B`;
    public readonly cancelAppointmentModalCancelSelectedBookingLanguageItemName: string = `_13C`;
    public readonly cancelAppointmentModalBookingNumberLanguageItemName: string = `_13D`;
    public readonly occupationalHealthPageOccupationalHealthTeamRosterLanguageItemName: string = `_13E`;
    public readonly blogPageTitleLanguageItemName: string = `_13F`;
    public readonly jobsPageTitleLanguageItemName: string = `_140`;
    public readonly topNavJobsLanguageItemName: string = `_141`;
    public readonly cancelAppointmentModalFormErrorLanguageItemName: string = `_142`;
    public readonly cancelAppointmentModalLoginFailedLanguageItemName: string = `_143`;
    public readonly jobsPageOpenPositionsLanguageItemName: string = `_144`;
    public readonly jobsPageNoOpenPositionsLanguageItemName: string = `_145`;
    public readonly jobsPageEmailMessagePart1LanguageItemName: string = `_146`;
    public readonly jobsPageEmailMessagePart2LanguageItemName: string = `_147`;
    public readonly blogPageNoBlogpostsYetLanguageItemName: string = `_148`;
    public readonly homePageInfluenzaHeaderLanguageItemName: string = `_149`;
    public readonly homePageInfluenzaTextLanguageItemName: string = `_14A`;
    public readonly errorCodesRegistrationSsnExistsLanguageItemName: string = `_14B`;
    public readonly errorCodesRegistrationSsnInvalidLanguageItemName: string = `_14C`;
    public readonly errorCodesRegistrationRegistrationFailedLanguageItemName: string = `_14D`;
    public readonly errorCodesAppointmentTooManyLanguageItemName: string = `_14E`;
    public readonly errorCodesAppointmentFailedLanguageItemName: string = `_14F`;
    public readonly errorCodesAppointmentDeniedByCompanyLanguageItemName: string = `_150`;
    public readonly errorCodesAppointmentPastLanguageItemName: string = `_151`;
    public readonly errorCodesAppointmentUnknownLanguageItemName: string = `_152`;
    public readonly appointmentBookingServicePointFilterTimeLanguageItemName: string = `_153`;
    public readonly buttonGoToServiceLanguageItemName: string = `_154`;
    public readonly formInputAttachmentsLanguageItemName: string = `_155`;
    public readonly jobApplicationApplicationSentLanguageItemName: string = `_156`;
    public readonly jobsPageSendApplicationLanguageItemName: string = `_157`;
    public readonly jobsPageApplicationFormLanguageItemName: string = `_158`;
    public readonly jobsPageApplicationFormTipLanguageItemName: string = `_159`;
    public readonly jobApplicationMessagePlaceholderLanguageItemName: string = `_15A`;
    public readonly jobsPageApplicationFormFileSizeAndTypeMessageLanguageItemName: string = `_15B`;
    public readonly jobsPageOpenApplicationFormHeaderLanguageItemName: string = `_15C`;
    public readonly jobsPageOpenApplicationLanguageItemName: string = `_15D`;
    public readonly errorCodesAppointmentAlreadyReservedLanguageItemName: string = `_15E`;
    public readonly locationPageOpeningHoursLanguageItemName: string = `_15F`;
    public readonly appointmentPageOccupationalHealthInfoLanguageItemName: string = `_160`;
    public readonly appointmentPageKela65InfoBoldLanguageItemName: string = `_161`;
    public readonly appointmentPageKela65InfoTextLanguageItemName: string = `_162`;
    public readonly locationPageAccordingToAgreementLanguageItemName: string = `_163`;
    public readonly blogPostWrittenByLanguageItemName: string = `_164`;
    public readonly buttonReadWholeArticleLanguageItemName: string = `_165`;
    public readonly buttonLoadMoreLanguageItemName: string = `_166`;
    public readonly phoneBookingWidgetTitleLanguageItemName: string = `_167`;
    public readonly recentComingSoonLanguageItemName: string = `_168`;
    public readonly formInputEmailAgainLanguageItemName: string = `_169`;
    public readonly reserveTimeModalEmailMissingLanguageItemName: string = `_16A`;
    public readonly emailFormUpdateFailedLanguageItemName: string = `_16B`;
    public readonly reserveTimeModalMissingEmailMessageLanguageItemName: string = `_16C`;
    public readonly emailFormEmailNotValidLanguageItemName: string = `_16D`;
    public readonly emailFormEmailsDoNotMatchLanguageItemName: string = `_16E`;
    public readonly appointmentPageWantToCancelAppointmentLanguageItemName: string = `_16F`;
    public readonly servicesTeamIncludesLanguageItemName: string = `_170`;
    public readonly servicesFavoriteServicesLanguageItemName: string = `_171`;
    public readonly servicesAllServicesAlphabeticalLanguageItemName: string = `_172`;
    public readonly reserveTimeModalMissingInfoLanguageItemName: string = `_173`;
    public readonly reserveTimeModalAppointmentDetailsDurationLanguageItemName: string = `_174`;
    public readonly reserveTimeModalAppointmentDetailsSpecialtyLanguageItemName: string = `_175`;
    public readonly reserveTimeModalAppointmentDetailsLocationLanguageItemName: string = `_176`;
    public readonly reserveTimeModalAppointmentDetailsMedicalCenterFenixLanguageItemName: string = `_177`;
    public readonly reserveTimeModalCheckInfoTextLanguageItemName: string = `_178`;
    public readonly reserveTimeModalEditContactInfoLanguageItemName: string = `_179`;
    public readonly formInputPhoneAgainLanguageItemName: string = `_17A`;
    public readonly reserveTimeModalSavingContactInfoFailedLanguageItemName: string = `_17B`;
    public readonly editContactInfoFormPhonesDoNotMatchLanguageItemName: string = `_17C`;
    public readonly editContactInfoFormPhoneNumberNotValidLanguageItemName: string = `_17D`;
    public readonly reserveTimeModalMissingInfoMessageLanguageItemName: string = `_17E`;
    public readonly contactInfoReminderViewMessageLanguageItemName: string = `_17F`;
    public readonly contactInfoReminderViewMessagePt2LanguageItemName: string = `_180`;
    public readonly contactInfoReminderViewTitleLanguageItemName: string = `_181`;
    public readonly reserveTimeModalAppointmentDetailsConfirmPhoneTimeLanguageItemName: string = `_182`;
    public readonly servicesInstructionServicesLanguageItemName: string = `_183`;
    public readonly occupationalHealthContactUsLanguageItemName: string = `_184`;
    public readonly influenzaVaccinationWidgetTitleLanguageItemName: string = `_185`;
    public readonly companyPagePrivacyPolicyLanguageItemName: string = `_186`;
    public readonly companyPageTermsOfUseLanguageItemName: string = `_187`;
    public readonly digiFenixPageTitleLanguageItemName: string = `_188`;
    public readonly digiFenixPageTopNavTitleLanguageItemName: string = `_189`;
    public readonly digiFenixPageWebVersionButtonLanguageItemName: string = `_18A`;
    public readonly searchTitleLanguageItemName: string = `_18B`;
    public readonly searchPagenoFilterSelectedLanguageItemName: string = `_18C`;
    public readonly searchPagedoctorLanguageItemName: string = `_18D`;
    public readonly searchPageserviceLanguageItemName: string = `_18E`;
    public readonly searchPageclinicLanguageItemName: string = `_18F`;
    public readonly searchPagevoucherLanguageItemName: string = `_190`;
    public readonly searchPagemedicalFieldLanguageItemName: string = `_191`;
    public readonly topNavLocationsLanguageItemName: string = `_192`;
    public readonly searchPagemedicalFieldsLanguageItemName: string = `_193`;
    public readonly searchPagevouchersLanguageItemName: string = `_194`;
    public readonly searchPageallResultsLanguageItemName: string = `_195`;
    public readonly searchPagenoResultsLanguageItemName: string = `_196`;
    public readonly searchPagesearchFromApplicationLanguageItemName: string = `_197`;
    public readonly searchPagehitsLanguageItemName: string = `_198`;
    public readonly searchPagefoundLanguageItemName: string = `_199`;
    public readonly searchPageserviceErrorLanguageItemName: string = `_19A`;
    public readonly searchpagesearchLanguageItemName: string = `_19B`;
    public readonly childAppointmentCardTitleLanguageItemName: string = `_19C`;
    public readonly occupationalHealthOfferFormTitleLanguageItemName: string = `_19D`;
    public readonly formInputNameLanguageItemName: string = `_19E`;
    public readonly formInputCompanyNameLanguageItemName: string = `_19F`;
    public readonly occupationalHealthOfferFormFormTitleLanguageItemName: string = `_1A0`;
    public readonly occupationalHealthPageButtonTextLanguageItemName: string = `_1A1`;
    public readonly cancelAppointmentModal12hMessageLanguageItemName: string = `_1A2`;
    public readonly occupationalHealthPageReferencesLanguageItemName: string = `_1A3`;
    public readonly companyPageFeedbackLanguageItemName: string = `_1A4`;
    public readonly cancelAppointmentModal24hMessageLanguageItemName: string = `_1A5`;
    public readonly reservationGuideModalTitleLanguageItemName: string = `_1A6`;
    public readonly reservationGuideModalOptionsPrivateIndividualLanguageItemName: string = `_1A7`;
    public readonly reservationGuideModalOptionsKela65LanguageItemName: string = `_1A8`;
    public readonly reservationGuideModalOptionsOccupationalHealthLanguageItemName: string = `_1A9`;
    public readonly appointmentPageKela65LabelLanguageItemName: string = `_1AA`;
    public readonly kela65AppointmentCardTitleLanguageItemName: string = `_1AB`;
    public readonly openingHoursPageTitleLanguageItemName: string = `_1AC`;
    public readonly contactSupportPageDigiFenixAvailableLanguageItemName: string = `_1AD`;
    public readonly footerQuickLinksBillingLanguageItemName: string = `_1AE`;
    public readonly footerQuickLinksBillingServiceIdLanguageItemName: string = `_1AF`;
    public readonly footerQuickLinksLanguageItemName: string = `_1B0`;
    public readonly footerServicePointsTitleLanguageItemName: string = `_1B1`;
    public readonly footerDownloadAppLanguageItemName: string = `_1B2`;
    public readonly contactSupportPageSeasonalHoursMessageLanguageItemName: string = `_1B3`;
    public readonly newslettersPageTitleLanguageItemName: string = `_1B4`;
    public readonly newslettersPageGeneralSectionTitleLanguageItemName: string = `_1B5`;
    public readonly newslettersPageOccupationalSectionTitleLanguageItemName: string = `_1B6`;
    public readonly newslettersPageSubscriptionSectionTitleLanguageItemName: string = `_1B7`;
    public readonly reserveTimeModalAppointmentDetailsConfirmDoctorLanguageItemName: string = `_1B8`;
    public readonly reserveTimeModalAppointmentDetailsConfirmTimeLanguageItemName: string = `_1B9`;
    public readonly reserveTimeModalAppointmentDetailsConfirmLocationLanguageItemName: string = `_1BA`;
    public readonly reserveTimeModalAppointmentDetailsConfirmEndSectionLanguageItemName: string = `_1BB`;
    public readonly reserveTimeModalAppointmentDetailsConfirmDateLanguageItemName: string = `_1BC`;
    public readonly newslettersWantToSubscribeLanguageItemName: string = `_1BD`;
    public readonly newslettersSubscribeHereLanguageItemName: string = `_1BE`;
    public readonly appointmentPageLocationLanguageItemName: string = `_1BF`;

    constructor() {
        super(
            [
                new Language("fi", "Suomi"),
                new Language("en", "English"),
                new Language("nb", "Norsk bokmål"),
                new Language("pl", "Polski"),
                new Language("sv", "Svenska"),
                new Language("da", "Dansk"),
                new Language("uk", "Українська"),
                new Language("ru", "Русский")
            ],
            "fi");
    }

    public initialize(): void {
        super.initialize(true);

        this.set(`_0`, { l: `fi`, v: `Etusivu` }, { l: `uk`, v: `Головна сторінка` }, { l: `sv`, v: `Framsida` }, { l: `ru`, v: `Главная страница` }, { l: `pl`, v: `PL: Frontpage` }, { l: `nb`, v: `NB: Frontpage` }, { l: `en`, v: `Frontpage` }, { l: `da`, v: `DA: Frontpage` },);
        this.set(`_1`, { l: `fi`, v: `Kirjaudu` }, { l: `uk`, v: `Увійти` }, { l: `sv`, v: `Logga in` }, { l: `ru`, v: `Войти` }, { l: `pl`, v: `Zaloguj sie` }, { l: `nb`, v: `NB: Login` }, { l: `en`, v: `Login` }, { l: `da`, v: `DA: Login` },);
        this.set(`_2`, { l: `fi`, v: `Hallinta` }, { l: `uk`, v: `Адміністратор` }, { l: `sv`, v: `Administration` }, { l: `ru`, v: `Администратор` }, { l: `pl`, v: `PL: Admin` }, { l: `nb`, v: `NB: Admin` }, { l: `en`, v: `Admin` }, { l: `da`, v: `DA: Admin` },);
        this.set(`_3`, { l: `fi`, v: `Tili` }, { l: `uk`, v: `Акаунт` }, { l: `sv`, v: `Konto` }, { l: `ru`, v: `Аккаунт` }, { l: `pl`, v: `PL: Account` }, { l: `nb`, v: `NB: Account` }, { l: `en`, v: `Account` }, { l: `da`, v: `DA: Account` },);
        this.set(`_4`, { l: `fi`, v: `Kirjaudu ulos` }, { l: `uk`, v: `Вийти` }, { l: `sv`, v: `Logga ut` }, { l: `ru`, v: `Выйти` }, { l: `pl`, v: `PL: Logout` }, { l: `nb`, v: `NB: Logout` }, { l: `en`, v: `Logout` }, { l: `da`, v: `DA: Logout` },);
        this.set(`_5`, { l: `fi`, v: `WeAre Solutions Oy Portal` }, { l: `uk`, v: `WeAre Solutions Oy Portal` }, { l: `sv`, v: `WeAre Solutions Oy Portal` }, { l: `ru`, v: `WeAre Solutions Oy Portal` }, { l: `pl`, v: `WeAre Solutions Oy Portal` }, { l: `nb`, v: `NB: WeAre Solutions Oy Portal` }, { l: `en`, v: `WeAre Solutions Oy Portal` }, { l: `da`, v: `DA: WeAre Solutions Oy Portal` },);
        this.set(`_6`, { l: `fi`, v: `Paikallinen konevuokrausportaali` }, { l: `uk`, v: `Портал оренди місцевого обладнання` }, { l: `sv`, v: `Lokal maskin uthyrnings portal` }, { l: `ru`, v: `Портал аренды местного оборудования` }, { l: `pl`, v: `PL: Local machine rental portal` }, { l: `nb`, v: `NB: Local machine rental portal` }, { l: `en`, v: `Local machine rental portal` }, { l: `da`, v: `DA: Local machine rental portal` },);
        this.set(`_7`, { l: `fi`, v: `Kirjaudu sisään` }, { l: `uk`, v: `Увійти` }, { l: `sv`, v: `Logga in` }, { l: `ru`, v: `Войти.` }, { l: `pl`, v: `Zaloguj sie` }, { l: `nb`, v: `NB: Log in` }, { l: `en`, v: `Log in` }, { l: `da`, v: `DA: Log in` },);
        this.set(`_8`, { l: `fi`, v: `Kirjaudu` }, { l: `uk`, v: `Увійти` }, { l: `sv`, v: `Logga in` }, { l: `ru`, v: `Войти` }, { l: `pl`, v: `Zaloguj sie` }, { l: `nb`, v: `NB: Login` }, { l: `en`, v: `Login` }, { l: `da`, v: `DA: Login` },);
        this.set(`_9`, { l: `fi`, v: `Office 365` }, { l: `uk`, v: `Office 365` }, { l: `sv`, v: `Office 365` }, { l: `ru`, v: `Office 365` }, { l: `pl`, v: `Office 365` }, { l: `nb`, v: `Office 365` }, { l: `en`, v: `Office 365` }, { l: `da`, v: `Office 365` },);
        this.set(`_A`, { l: `fi`, v: `Unohditko salasanasi?` }, { l: `uk`, v: `Забули пароль?` }, { l: `sv`, v: `Glömt lösenordet?` }, { l: `ru`, v: `Забыли пароль?` }, { l: `pl`, v: `PL: Forgot password?` }, { l: `nb`, v: `NB: Forgot password?` }, { l: `en`, v: `Forgot password?` }, { l: `da`, v: `DA: Forgot password?` },);
        this.set(`_B`, { l: `fi`, v: `Sähköposti` }, { l: `uk`, v: `Email` }, { l: `sv`, v: `Epost` }, { l: `ru`, v: `Email` }, { l: `pl`, v: `PL: Email` }, { l: `nb`, v: `NB: Email` }, { l: `en`, v: `Email` }, { l: `da`, v: `DA: Email` },);
        this.set(`_C`, { l: `fi`, v: `Linkki vanhentunut` }, { l: `uk`, v: `Строк дії посилання закінчився` }, { l: `sv`, v: `Länken har expirerat` }, { l: `ru`, v: `Срок действия ссылки истек` }, { l: `pl`, v: `PL: Link has expired` }, { l: `nb`, v: `NB: Link has expired` }, { l: `en`, v: `Link has expired` }, { l: `da`, v: `DA: Link has expired` },);
        this.set(`_D`, { l: `fi`, v: `Linkki vanhentunut` }, { l: `uk`, v: `Строк дії посилання закінчився` }, { l: `sv`, v: `Länken har expirerat` }, { l: `ru`, v: `Срок действия ссылки истек` }, { l: `pl`, v: `PL: Link has expired` }, { l: `nb`, v: `NB: Link has expired` }, { l: `en`, v: `Link has expired` }, { l: `da`, v: `DA: Link has expired` },);
        this.set(`_E`, { l: `fi`, v: `Unohditko salasanasi?` }, { l: `uk`, v: `Забули пароль?` }, { l: `sv`, v: `Glömt lösenordet?` }, { l: `ru`, v: `Забыли пароль?` }, { l: `pl`, v: `PL: Forgot password?` }, { l: `nb`, v: `NB: Forgot password?` }, { l: `en`, v: `Forgot password?` }, { l: `da`, v: `DA: Forgot password?` },);
        this.set(`_F`, { l: `fi`, v: `Ilmoittamaasi osoitteesen on lähetetty ohjeet salasanan palauttamiseksi. Palautettuasi salasanan, jatka kirjautumalla sisään. Mikäli et vastaanottanut viestiä, tarkista sähköpostilaatikkosi roskapostikansio.` }, { l: `uk`, v: `Повідомлення було надіслано на адресу, яку ви вказали на посилання для скидання пароля. Продовжуйте вхід після зміни пароля. Якщо ви не отримали повідомлення, будь ласка, перевірте папку зі спамом.` }, { l: `sv`, v: `Ett meddelande har skickats till adressen ni angav med en länk för att återställa lösenordet. Fortsätt med inloggningen efter lösenordet är ändrat. Om ni inte fått ett meddelande, kontrollera skräppost mappen i er e-post` }, { l: `ru`, v: `Уведомление было отправлено на адрес, который вы указали в ссылке для сброса пароля. Продолжите вход после смены пароля. Если вы не получили сообщение, пожалуйста, проверьте папку со спамом.` }, { l: `pl`, v: `PL: A notification has been sent to the address you provided with a link to reset your password. Continue signing in after changing your password. If you did not receive the message, please check your spam folder.` }, { l: `nb`, v: `NB: A notification has been sent to the address you provided with a link to reset your password. Continue signing in after changing your password. If you did not receive the message, please check your spam folder.` }, { l: `en`, v: `A notification has been sent to the address you provided with a link to reset your password. Continue signing in after changing your password. If you did not receive the message, please check your spam folder.` }, { l: `da`, v: `DA: A notification has been sent to the address you provided with a link to reset your password. Continue signing in after changing your password. If you did not receive the message, please check your spam folder.` },);
        this.set(`_10`, { l: `fi`, v: `Ilmoitusta ei voitu lähettää.\n        Ota yhteys järjestelmävalvojaan.` }, { l: `uk`, v: `Сповіщення не було відправлене на адресу, яку Ви вказали, з технічних причин.\nБудь даска, звʼяжіться з адміністратором.` }, { l: `sv`, v: `Aviseringen kunde inte skickas till addressen ni angett.\n      Ta kontakt med administratören.` }, { l: `ru`, v: `Уведомление не было отправлено по указанному вами адресу по техническим причинам.\nПожалуйста, свяжитесь с администратором.` }, { l: `pl`, v: `PL: A notification was not sent to the address you provided for some technical reasons.\n      Please contact administrator.` }, { l: `nb`, v: `NB: A notification was not sent to the address you provided for some technical reasons.\n      Please contact administrator.` }, { l: `en`, v: `A notification was not sent to the address you provided for some technical reasons.\n      Please contact administrator.` }, { l: `da`, v: `DA: A notification was not sent to the address you provided for some technical reasons.\n      Please contact administrator.` },);
        this.set(`_11`, { l: `fi`, v: `Lähetä` }, { l: `uk`, v: `Відправити` }, { l: `sv`, v: `Skicka` }, { l: `ru`, v: `Отправить` }, { l: `pl`, v: `PL: Send` }, { l: `nb`, v: `NB: Send` }, { l: `en`, v: `Send` }, { l: `da`, v: `DA: Send` },);
        this.set(`_12`, { l: `fi`, v: `Siirry kirjautumiseen` }, { l: `uk`, v: `Перейти до входу` }, { l: `sv`, v: `Gå till inloggning` }, { l: `ru`, v: `Перейти ко входу` }, { l: `pl`, v: `PL: Go to login` }, { l: `nb`, v: `NB: Go to login` }, { l: `en`, v: `Go to login` }, { l: `da`, v: `DA: Go to login` },);
        this.set(`_13`, { l: `fi`, v: `Ei ongelmaa. Ole hyvä, syötä "käyttäjätunnus" ja lähetämme sinulle ohjeet salasanan asettamiseen.` }, { l: `uk`, v: `Не біда. Будь ласка, введіьб своє імʼя користувача і ми надішлемо Вам інструкцію з відновлення паролю.` }, { l: `sv`, v: `Inga problem. Vänligen ange ert "användarnamn" och vi skickar instruktioner på hur ni återställer ert lösenord.` }, { l: `ru`, v: `Нет проблем. Пожалуйста, введите свое «имя пользователя», и мы пришлем вам инструкции по изменению пароля.` }, { l: `pl`, v: `PL: No problem. Please enter your "username" and we will send you instructions on how to reset your password.` }, { l: `nb`, v: `NB: No problem. Please enter your "username" and we will send you instructions on how to reset your password.` }, { l: `en`, v: `No problem. Please enter your "username" and we will send you instructions on how to reset your password.` }, { l: `da`, v: `DA: No problem. Please enter your "username" and we will send you instructions on how to reset your password.` },);
        this.set(`_14`, { l: `fi`, v: `Salasana` }, { l: `uk`, v: `Пароль` }, { l: `sv`, v: `Lösenord` }, { l: `ru`, v: `Пароль` }, { l: `pl`, v: `PL: Password` }, { l: `nb`, v: `NB: Password` }, { l: `en`, v: `Password` }, { l: `da`, v: `DA: Password` },);
        this.set(`_15`, { l: `fi`, v: `Kirjaudu sisään.` }, { l: `uk`, v: `Увійти` }, { l: `sv`, v: `Logga in.` }, { l: `ru`, v: `Войти.` }, { l: `pl`, v: `Zaloguj sie.` }, { l: `nb`, v: `NB: Log in.` }, { l: `en`, v: `Log in.` }, { l: `da`, v: `DA: Log in.` },);
        this.set(`_16`, { l: `fi`, v: `Kirjaudu käyttäjätunnuksellasi ja salasanallasi.` }, { l: `uk`, v: `Увійдіть під своїм ім'ям користувача та паролем.` }, { l: `sv`, v: `Logga in med ditt användarnamn och lösenord.` }, { l: `ru`, v: `Войдите под своим именем пользователя и паролем.` }, { l: `pl`, v: `PL: Log in with your username and password.` }, { l: `nb`, v: `NB: Log in with your username and password.` }, { l: `en`, v: `Log in with your username and password.` }, { l: `da`, v: `DA: Log in with your username and password.` },);
        this.set(`_17`, { l: `fi`, v: `Väärä käyttäjätunnus tai salasana.` }, { l: `uk`, v: `Невірне імʼя користувача чи пароль.` }, { l: `sv`, v: `Fel användarnamn eller lösenord.` }, { l: `ru`, v: `Неверное имя пользователя или пароль.` }, { l: `pl`, v: `PL: Invalid username or password.` }, { l: `nb`, v: `NB: Invalid username or password.` }, { l: `en`, v: `Invalid username or password.` }, { l: `da`, v: `DA: Invalid username or password.` },);
        this.set(`_18`, { l: `fi`, v: `Käyttäjätilisi on poistettu. Ota yhteyttä asiakastukeen.` }, { l: `uk`, v: `Ваш обдіковий запис було видалено. Звʼяжіться зі службою підтримки для відновлення доступу.` }, { l: `sv`, v: `Ditt konto har raderats, Ta kontakt med kundservicen.` }, { l: `ru`, v: `Ваш аккаунт был удален. Свяжитесь со службой поддержки для восстановления доступа.` }, { l: `pl`, v: `PL: Your account has been deleted. Contact support to restore your access.` }, { l: `nb`, v: `NB: Your account has been deleted. Contact support to restore your access.` }, { l: `en`, v: `Your account has been deleted. Contact support to restore your access.` }, { l: `da`, v: `DA: Your account has been deleted. Contact support to restore your access.` },);
        this.set(`_19`, { l: `fi`, v: `Liian monta yritystä kirjautua sisään. Yritä uudelleen myöhemmin.` }, { l: `uk`, v: `Забагато спроб увійти. Спробуйте знову пізніше.` }, { l: `sv`, v: `För många inloggnings försök, Försök igen senare.` }, { l: `ru`, v: `Слишком много попыток войти. Попробуйте снова позже.` }, { l: `pl`, v: `PL: Too many login attempts. Try again later.` }, { l: `nb`, v: `NB: Too many login attempts. Try again later.` }, { l: `en`, v: `Too many login attempts. Try again later.` }, { l: `da`, v: `DA: Too many login attempts. Try again later.` },);
        this.set(`_1A`, { l: `fi`, v: `Käyttäjätilisi on lukittu. Ota yhteyttä asiakastukeen.` }, { l: `uk`, v: `Ваш обліковий запис було заблоковано. Звʼяжіться зі службою підтримки для відновлення доступу.` }, { l: `sv`, v: `Ditt konto har låsts. Kontakta kundservice.` }, { l: `ru`, v: `Ваш аккаунт был заблокирован. Свяжитесь со службой поддержки для восстановления доступа.` }, { l: `pl`, v: `PL: Your account has been locked. Contact support to restore access.` }, { l: `nb`, v: `NB: Your account has been locked. Contact support to restore access.` }, { l: `en`, v: `Your account has been locked. Contact support to restore access.` }, { l: `da`, v: `DA: Your account has been locked. Contact support to restore access.` },);
        this.set(`_1B`, { l: `fi`, v: `Tapahtui virhe` }, { l: `uk`, v: `Виникла помилка` }, { l: `sv`, v: `Fel uppstod` }, { l: `ru`, v: `Произошла ошибка` }, { l: `pl`, v: `PL: Error occured` }, { l: `nb`, v: `NB: Error occured` }, { l: `en`, v: `Error occured` }, { l: `da`, v: `DA: Error occured` },);
        this.set(`_1C`, { l: `fi`, v: `Jos virhe toistuu, ole yhteydessä asiakaspalveluun.` }, { l: `uk`, v: `Якщо таке станеться знову, звʼяжіться зі службою підтримки.` }, { l: `sv`, v: `Om detta händer igen, kontakta kundservice.` }, { l: `ru`, v: `Если это повторится, обратитесь в службу поддержки.` }, { l: `pl`, v: `PL: If this happens again, contact support.` }, { l: `nb`, v: `NB: If this happens again, contact support.` }, { l: `en`, v: `If this happens again, contact support.` }, { l: `da`, v: `DA: If this happens again, contact support.` },);
        this.set(`_1D`, { l: `fi`, v: `Ota yhteyttä asiakaspalveluun` }, { l: `uk`, v: `Звʼязатися зі службою підтримки` }, { l: `sv`, v: `Kontakta kundservice` }, { l: `ru`, v: `Обратиться в службу поддержки` }, { l: `pl`, v: `PL: Contact support` }, { l: `nb`, v: `NB: Contact support` }, { l: `en`, v: `Contact support` }, { l: `da`, v: `DA: Contact support` },);
        this.set(`_1E`, { l: `fi`, v: `Viesti asiakaspalveluun` }, { l: `uk`, v: `Відправити повідомлення до служби підтримки.` }, { l: `sv`, v: `Meddelande till kundservice` }, { l: `ru`, v: `Отправить сообщение в службу поддержки.` }, { l: `pl`, v: `PL: Message to support team` }, { l: `nb`, v: `NB: Message to support team` }, { l: `en`, v: `Message to support team` }, { l: `da`, v: `DA: Message to support team` },);
        this.set(`_1F`, { l: `fi`, v: `Sähköposti` }, { l: `uk`, v: `Email` }, { l: `sv`, v: `E-post` }, { l: `ru`, v: `Email` }, { l: `pl`, v: `PL: Email` }, { l: `nb`, v: `NB: Email` }, { l: `en`, v: `Email` }, { l: `da`, v: `DA: Email` },);
        this.set(`_20`, { l: `fi`, v: `Puhelinnumero` }, { l: `uk`, v: `Номер телефону` }, { l: `sv`, v: `Telefonnumer` }, { l: `ru`, v: `Номер телефона` }, { l: `pl`, v: `PL: Phone number` }, { l: `nb`, v: `NB: Phone number` }, { l: `en`, v: `Phone number` }, { l: `da`, v: `DA: Phone number` },);
        this.set(`_21`, { l: `fi`, v: `Etunimi` }, { l: `uk`, v: `Ім'я` }, { l: `sv`, v: `Förnamn` }, { l: `ru`, v: `Имя` }, { l: `pl`, v: `PL: Firstname` }, { l: `nb`, v: `NB: Firstname` }, { l: `en`, v: `Firstname` }, { l: `da`, v: `DA: Firstname` },);
        this.set(`_22`, { l: `fi`, v: `Toinen nimi` }, { l: `uk`, v: `Середнє ім'я` }, { l: `sv`, v: `Mellannamn` }, { l: `ru`, v: `Среднее имя` }, { l: `pl`, v: `PL: Middle name` }, { l: `nb`, v: `NB: Middle name` }, { l: `en`, v: `Middle name` }, { l: `da`, v: `DA: Middle name` },);
        this.set(`_23`, { l: `fi`, v: `Sukunimi` }, { l: `uk`, v: `Прізвище` }, { l: `sv`, v: `Efternamn` }, { l: `ru`, v: `Фамилия` }, { l: `pl`, v: `PL: Lastname` }, { l: `nb`, v: `NB: Lastname` }, { l: `en`, v: `Lastname` }, { l: `da`, v: `DA: Lastname` },);
        this.set(`_24`, { l: `fi`, v: `Viesti` }, { l: `uk`, v: `Повідомлення` }, { l: `sv`, v: `Meddelande` }, { l: `ru`, v: `Сообщение` }, { l: `pl`, v: `PL: Message` }, { l: `nb`, v: `NB: Message` }, { l: `en`, v: `Message` }, { l: `da`, v: `DA: Message` },);
        this.set(`_25`, { l: `fi`, v: `Kieli` }, { l: `uk`, v: `Мова` }, { l: `sv`, v: `Språk` }, { l: `ru`, v: `Язык` }, { l: `pl`, v: `PL: Language` }, { l: `nb`, v: `NB: Language` }, { l: `en`, v: `Language` }, { l: `da`, v: `DA: Language` },);
        this.set(`_26`, { l: `fi`, v: `Rooli` }, { l: `uk`, v: `Роль` }, { l: `sv`, v: `Roll` }, { l: `ru`, v: `Роль` }, { l: `pl`, v: `PL: Role` }, { l: `nb`, v: `NB: Role` }, { l: `en`, v: `Role` }, { l: `da`, v: `DA: Role` },);
        this.set(`_27`, { l: `fi`, v: `Lähetä` }, { l: `uk`, v: `Відправити` }, { l: `sv`, v: `Skicka` }, { l: `ru`, v: `Отправить` }, { l: `pl`, v: `PL: Send` }, { l: `nb`, v: `NB: Send` }, { l: `en`, v: `Send` }, { l: `da`, v: `DA: Send` },);
        this.set(`_28`, { l: `fi`, v: `Tallenna` }, { l: `uk`, v: `Зберегти` }, { l: `sv`, v: `Spara` }, { l: `ru`, v: `Сохранить` }, { l: `pl`, v: `PL: Save` }, { l: `nb`, v: `NB: Save` }, { l: `en`, v: `Save` }, { l: `da`, v: `DA: Save` },);
        this.set(`_29`, { l: `fi`, v: `Yhteydenotto` }, { l: `uk`, v: `Підтримка` }, { l: `sv`, v: `Kontakt` }, { l: `ru`, v: `Поддержка` }, { l: `pl`, v: `PL: Support` }, { l: `nb`, v: `NB: Support` }, { l: `en`, v: `Support` }, { l: `da`, v: `DA: Support` },);
        this.set(`_2A`, { l: `fi`, v: `sunnuntai` }, { l: `uk`, v: `неділя` }, { l: `sv`, v: `söndag` }, { l: `ru`, v: `воскресенье` }, { l: `pl`, v: `niedziela` }, { l: `nb`, v: `søndag` }, { l: `en`, v: `Sunday` }, { l: `da`, v: `søndag` },);
        this.set(`_2B`, { l: `fi`, v: `maanantai` }, { l: `uk`, v: `понеділок` }, { l: `sv`, v: `måndag` }, { l: `ru`, v: `понедельник` }, { l: `pl`, v: `poniedziałek` }, { l: `nb`, v: `mandag` }, { l: `en`, v: `Monday` }, { l: `da`, v: `mandag` },);
        this.set(`_2C`, { l: `fi`, v: `tiistai` }, { l: `uk`, v: `вівторок` }, { l: `sv`, v: `tisdag` }, { l: `ru`, v: `вторник` }, { l: `pl`, v: `wtorek` }, { l: `nb`, v: `tirsdag` }, { l: `en`, v: `Tuesday` }, { l: `da`, v: `tirsdag` },);
        this.set(`_2D`, { l: `fi`, v: `keskiviikko` }, { l: `uk`, v: `середа` }, { l: `sv`, v: `onsdag` }, { l: `ru`, v: `среда` }, { l: `pl`, v: `środa` }, { l: `nb`, v: `onsdag` }, { l: `en`, v: `Wednesday` }, { l: `da`, v: `onsdag` },);
        this.set(`_2E`, { l: `fi`, v: `torstai` }, { l: `uk`, v: `четвер` }, { l: `sv`, v: `torsdag` }, { l: `ru`, v: `четверг` }, { l: `pl`, v: `czwartek` }, { l: `nb`, v: `torsdag` }, { l: `en`, v: `Thursday` }, { l: `da`, v: `torsdag` },);
        this.set(`_2F`, { l: `fi`, v: `perjantai` }, { l: `uk`, v: `п'ятниця` }, { l: `sv`, v: `fredag` }, { l: `ru`, v: `пятница` }, { l: `pl`, v: `piątek` }, { l: `nb`, v: `fredag` }, { l: `en`, v: `Friday` }, { l: `da`, v: `fredag` },);
        this.set(`_30`, { l: `fi`, v: `lauantai` }, { l: `uk`, v: `субота` }, { l: `sv`, v: `lördag` }, { l: `ru`, v: `суббота` }, { l: `pl`, v: `sobota` }, { l: `nb`, v: `lørdag` }, { l: `en`, v: `Saturday` }, { l: `da`, v: `lørdag` },);
        this.set(`_31`, { l: `fi`, v: `Tilin tiedot` }, { l: `uk`, v: `Мій аккаунт` }, { l: `sv`, v: `Mitt konto` }, { l: `ru`, v: `Мой аккаунт` }, { l: `pl`, v: `PL: My account` }, { l: `nb`, v: `NB: My account` }, { l: `en`, v: `My account` }, { l: `da`, v: `DA: My account` },);
        this.set(`_32`, { l: `fi`, v: ` ` }, { l: `uk`, v: ` ` }, { l: `sv`, v: ` ` }, { l: `pl`, v: ` ` }, { l: `en`, v: ` ` },);
        this.set(`_33`, { l: `fi`, v: `Tilin tiedot tallennettu` }, { l: `uk`, v: `Інформація про обліковий запис успішно оновлена` }, { l: `sv`, v: `Kontots information har uppdaterats` }, { l: `ru`, v: `Информация об учетной записи успешно обновлена` }, { l: `pl`, v: `PL: Account information updated successfully` }, { l: `nb`, v: `NB: Account information updated successfully` }, { l: `en`, v: `Account information updated successfully` }, { l: `da`, v: `DA: Account information updated successfully` },);
        this.set(`_34`, { l: `fi`, v: `Olen lukenut ja hyväksyn` }, { l: `uk`, v: `Я прочитав і приймаю` }, { l: `sv`, v: `Jag har läst och godkänner` }, { l: `ru`, v: `Я прочитал и принимаю` }, { l: `pl`, v: `PL: I have read and accept` }, { l: `nb`, v: `NB: I have read and accept` }, { l: `en`, v: `I have read and accept` }, { l: `da`, v: `DA: I have read and accept` },);
        this.set(`_35`, { l: `fi`, v: `Sinun on hyväksyttävä käyttöehdot ja tietosuojaseloste voidaksesi käyttää sovellusta` }, { l: `uk`, v: `Ви повинні прийняти умови використання та сповіщення про конфіденційність, щоб використовувати програму` }, { l: `sv`, v: `Du måste godkänna villkoren för användarvillkoren och sekretessmeddelande för att använda applikationen.` }, { l: `ru`, v: `Вы должны принять условия использования и уведомление о конфиденциальности, чтобы использовать приложение` }, { l: `pl`, v: `PL: You must accept terms of usage and privacy notice in order to use application` }, { l: `nb`, v: `NB: You must accept terms of usage and privacy notice in order to use application` }, { l: `en`, v: `You must accept terms of usage and privacy notice in order to use application` }, { l: `da`, v: `DA: You must accept terms of usage and privacy notice in order to use application` },);
        this.set(`_36`, { l: `fi`, v: `käyttöehdot` }, { l: `uk`, v: `Умови використання` }, { l: `sv`, v: `Användarvillkor` }, { l: `ru`, v: `условия использования` }, { l: `pl`, v: `PL: terms of use` }, { l: `nb`, v: `NB: terms of use` }, { l: `en`, v: `terms of use` }, { l: `da`, v: `DA: terms of use` },);
        this.set(`_37`, { l: `fi`, v: `ATHENAEUM APPLICATION TEMPLATE-SOVELLUKSEN KÄYTTÖEHDOT` }, { l: `uk`, v: `Athenaeum Application Template - УМОВИ ОБСЛУГОВУВАННЯ` }, { l: `sv`, v: `Athenaeum Application Template-APPLIKATIONENS ANVÄNDARVILLKOR` }, { l: `ru`, v: `Athenaeum Application Template - УСЛОВИЯ ОБСЛУЖИВАНИЯ` }, { l: `pl`, v: `PL: ATHENAEUM APPLICATION TEMPLATE-APPLICATIONS TERMS OF SERVICE` }, { l: `nb`, v: `NB: Athenaeum Application Template-APPLICATIONS TERMS OF SERVICE` }, { l: `en`, v: `Athenaeum Application Template-APPLICATIONS TERMS OF SERVICE` }, { l: `da`, v: `DA: Athenaeum Application Template-APPLICATIONS TERMS OF SERVICE` },);
        this.set(`_38`, { l: `fi`, v: `\n1.	Yleistä\n\nAthenaeum Application Template-sovelluksen (”Sovellus”) omistaa ja sen tarjoaa käyttöön WeAre Solutions Oy ("WeAre").\n\nAsentamalla sovelluksen ja/tai käyttämällä sovellusta Rekisteröity Asiakas tai Rekisteröitymätön Käyttäjä hyväksyy nämä käyttöehdot ("Käyttöehdot"). Mikäli Rekisteröity Asiakas tai Rekisteröitymätön Käyttäjä ei hyväksy näitä Käyttöehtoja, Rekisteröityneellä Asiakkaalla tai Rekisteröitymättöllä Käyttäjällä ei ole oikeutta asentaa, avata tai käyttää sovellusta.\n\nWeAre pidättää oikeuden muuttaa näitä Käyttöehtoja milloin tahansa ilman ennakkoilmoitusta. Rekisteröityneen Asiakkaan tai Rekisteröitymättömän Käyttäjän katsotaan hyväksyneen päivitetyt Käyttöehdot käyttämällä sovellusta Käyttöehtoihin tehdyn muutoksen jälkeen.\n\n2.	Athenaeum Application Template-sovellus\n\nSovellus on Rentan Työntekijöilleen (Rekisteröidyt Käyttäjät) ja Rekisteröidyille Asiakkailleen. Sovellusta on mahdollista käyttää joko WeAren työntekijänä (Rekisteröity Käyttäjä) tai vaihtoehtoisesti rekisteröityneenä Asiakkaana asiakaskohtaisella käyttöoikeudella ("Rekisteröity Asiakas").\n\n2.1 Rekisteröityneet Asiakkaat.\nRekisteröityminen Asiakkaaksi edellyttää olemassa olevaa asiakassuhdetta WeArean. WeArella on oikeus olla hyväksymättä rekisteröitymistä ja poistaa sovelluksen käyttöoikeus.\nRekisteröityneellä Asiakkaalla on mahdollisuus nähdä ja hyväksyä sovelluksen kautta hänen työmaitaan koskevia työraportteja sekä laskutusta.\n\n2.2 Rekisteröityneet Käyttäjät\nRekisteröityminen Sovellukseen edellyttää olemassa olevaa työsuhdetta WeArean. WeArella on oikeus olla hyväksymättä rekisteröitymistä ja purkaa sovelluksen käyttöoikeus.\n\nRekisteröityneellä Käyttäjällä on mahdollisuus suorittaa työnohjauksen kannalta vaadittuja toimenpiteitä sovelluksen kautta.\n\nSovelluksen moitteettoman toiminnan varmistamiseksi Rekisteröityneen Asiakkaan ja Rekisteröidyn Käyttäjän tulee huolehtia siitä, että hänellä on käytössä viimeisin sovellusversio.\n\n3.	Tuotevalikoma ja hinnasto\n\nSovelluksessa esitetty tuotevalikoima vastaa WeAren normaalia tuotevalikoimaa. Tuotevalikoima, tuotteiden saatavuus sekä hintatiedot voivat vaihdella toimipisteittäin. Esitetyt hinnat eivät sisällä arvonlisäveroa. Arvonlisävero lisätään hintoihin laskutuksen yhteydessä\n\nSopimusasiakkaiden asiakaskohtaiset hintatiedot esitetään Sovelluksessa. Hintojen esittämistä voidaan rajata käyttöoikeuksilla.\n\nWeAre ei vastaa Sovelluksessa esitettävien hinta- ja tuotetietojen tai muun aineiston mahdollisista virheistä, puutteista tai muista vioista.\n\n4.	Asiakaskohtaiset työraportit\n\n4.1 Asiakaskohtaisen työraportin muodostuminen\nRekisteröityjen Käyttäjien asiakkaan tilauksesta tekemä työ muodostaa järjestelmään työraportin.\n\n4.2 Asiakaskohtaisen työraportin käsittely\nRekisteröityneellä Asiakkaalla on mahdollisuus tarkastella häntä koskevia työraportteja sekä hyväksyä että hylätä suoritetun työn työraportteja. WeArella on oikeus laskuttaa työt hyväksytyn työraportin mukaisesti.\n\n5.	Asiakaskohtaiset laskut\n\n5.1	Asiakaskohtaisten laskujen tarkastelu\nRekisteröityneellä Asiakkaalla on sovelluksessa mahdollista tarkastella häntä koskevia laskuja. Mahdollisista virheellisistä laskuista tulee reklamoida WeAren ohjeistuksen mukaisesti.\n\n6.	Immateriaalioikeudet\n\nSovellus ja sen sisältö, mukaan lukien mm. tavaramerkit, toiminimet, tuotetiedot ja kuvat, ovat Rentan ja/tai sen yhteistyökumppanien omaisuutta, jota suojaavat mm. tekijänoikeuslaki sekä kansainväliset immateriaalioikeussopimukset. Kaikki oikeudet Sovellukseen ja sen sisältöön pidätetään. Nimenomaisesti todetaan, että Rekisteröitynyt Asiakas tai Rekisteröity Käyttäjä ei saa myöntää sovellukseen alilisenssiä, vuokrata, siirtää tai muuten jaella sovellusta tai sen käyttöoikeuksia muutoin kun miten näissä Käyttöehdoissa on sallittu.\n\nRekisteröityneellä Asiakkaalla tai Rekisteröityneellä Käyttäjällä ei ole oikeutta muuttaa, muunnella, poistaa, kopioida, julkaista, saattaa yleisön saataviin tai siirtää mitään immateriaalioikeuksien kohteita. Asiakkaan oikeus käyttää sovellusta rajoittuu ainoastaan näiden Käyttöehtojen mukaiseen käyttöön.\n\n7.	Käyttöoikeudet ja tunnukset\n\nRekisteröitynyt Asiakas hyväksyy itseään sitoviksi kaikki toimenpiteet, jotka on tehty Sovelluksen kautta Rekisteröityneen Asiakkaan tunnuksilla tai Rekisteröityneen Asiakkaan toimesta tai toimeksiannosta. Rekisteröityneen Asiakkaan tunnusten käyttö Sovelluksessa vastaa Rekisteröityneen Asiakkaan allekirjoitusta.\n\nRekisteröitynyt Asiakas on velvollinen säilyttämään tunnuksia huolellisesti. Mikäli Rekisteröitynyt Asiakas epäilee, että tunnukset tai salasana ovat joutuneet kolmannen osapuolen haltuun, tulee Rekisteröityneen Asiakkaan ilmoittaa siitä välittömästi Rentan yhteyshenkilölle. Yhteyshenkilö poistaa vanhat tunnukset ja avaa uudet. Rekisteröitynyt Asiakas vastaa kaikista käyttäjätunnuksellaan tehdyistä tilauksista sekä tunnuksien vaarantumisesta mahdollisesti aiheutuvista vahingoista.\n\nWeAre toimittaa Asiakkaalle tunnukset hyväksyttyään Rekisteröityneen Asiakkaan rekisteröitymisen.\n\nRekisteröityneellä Asiakkaalla ja Rekisteröityneellä Käyttäjällä on vastuu ryhtyä tarpeellisiin toimenpiteisiin, jos hän havaitsee tai hänen tietoonsa saatetaan, että joku käyttäjistä toimii näiden Käyttöehtojen vastaisesti. WeAre pidättää itsellään oikeuden lakkauttaa Rekisteröityneen Asiakkaan tai Rekisteröityneen Käyttäjän käyttöoikeuden, jos Rekisteröitynyt Asiakas tai Rekisteröitynyt Käyttäjä käyttää sovellusta näitä Käyttöehtojen vastaisesti.\n\n8.	Rentan vastuu\n\nSovellus sisältöineen tarjotaan Rekisteröityneelle Asiakkaalle ja Rekisteröityneelle Käyttäjälle ”sellaisena kuin se on”. WeAre ei vastaa Sovelluksessa välitettävän sisällön virheistä, puutteista tai muista vioista. WeAre ei takaa Sovelluksen saatavuutta eikä sen keskeytyksetöntä tai virheetöntä toimintaa. WeAre ei vastaa mistään kuluista, menetyksistä tai muista mahdollisista välittömistä tai välillisistä vahingoista, jotka saattavat aiheutua tämän Sovelluksen käyttämisestä, Sovelluksessa annetusta informaatiosta tai siitä, ettei Sovellus ole käytettävissä, jollei pakottavasta lainsäädännöstä muuta johdu. Joka tapauksessa Rentan vastuu on kuitenkin rajoitettu korkeintaan määrään, joka vastaa sovittua vuokrakaluston vuokraa ja/tai palvelun hintaa.\n\n9.	Evästeet\n\nWeAre käyttää Sovelluksessa evästeitä (ns. cookie-toiminto). Eväste on Sovelluksen käytön yhteydessä käyttäjän selaimeen tallennettava tekstitiedosto. Evästeet mahdollistavat esimerkiksi Sovelluksen käyttäjämäärien seurannan ja tiedon keräämisen siitä, miten ja milloin Sovellusta käytetään.\n\nRekisteröitynyt Asiakas ja Rekisteröitymätön Käyttäjä voi kytkeä pois evästeiden käytön selaimensa asetuksista. Lisätietoja selainkohtaisista käyttöohjeista saa selaimen valmistajalta. WeAre suosittelee evästeiden käyttöä Sovelluksessa parhaan mahdollisen käyttäjäkokemuksen saamiseksi.\n\n10.	Kolmansien osapuolien palvelut\n\nSovellus voi sisältää linkkejä kolmansien osapuolien omistamille tai ylläpitämille sivustoille. WeAre ei vastaa tällaisten kolmansien osapuolien sivustojen toiminnasta, sisällöstä, aiheuttamista välittömistä tai välillisistä vahingoista tai muista ominaisuuksista. Näille sivuille siirtyessään käyttäjän tulee hyväksyä näiden sivujen mahdolliset käyttöehdot ja tietosuojaseloste ennen käytön aloittamista.\n\n11.	Henkilötietojen käsittely\n\nWeAre käsittelee ja kerää Rekisteröityneiden Asiakkaiden henkilötietoja palvelujen toteuttamiseksi sekä asiakassuhteiden ylläpitämiseksi ja kehittämiseksi. Rentan tietosuojaselosteessa kuvataan henkilötietojen käsittelyä tarkemmin: https://www.weare.fi/en/privacy-policy-and-cookies\n\nRekisteröitymättömien Käyttäjien henkilötietoja ei kerätä.\n\n12.	Muut ehdot\n\nKonevuokraukseen ja palveluihin sovelletaan Rentan voimassaolevia vuokraehtoja. Vuosisopimusasiakkaiden kanssa noudatetaan vuosisopimusten mukaisia ehtoja. Asiakas sitoutuu jokaisen tilauksen yhteydessä voimassa oleviin toimitusehtoihin.\n\nWeAre saattaa muuttaa, päivittää, peruuttaa tai poistaa Sovelluksen, Sovelluksen sisältöä tai osia niistä harkintansa mukaan. Rekisteröityneen Asiakkaan tai Rekisteröityneen Käyttäjän tulee lopettaa Sovelluksen käyttäminen, jos Rekisteröitynyt Asiakas tai Rekisteröitynyt Käyttäjä ei hyväksy muutoksia Sovelluksen Käyttöehdoissa tai tietosuojaselosteessa.\n\nRekisteröityneen Asiakkaan ja Rekisteröitymättömän Käyttäjän tulee käyttää Sovellusta sen sovelluskaupan käyttöehtojen mukaisesti, josta on hankkinut Sovelluksen. Rekisteröitynyt Asiakas ja Rekisteröitynyt Käyttäjä vastaa kaikissa tapauksissa vahingoista, jotka ovat aiheutuneet hänen toimiessaan näiden Käyttöehtojen mukaisesti.\n\nRekisteröitynyt Asiakas ja Rekisteröitynyt Käyttäjä vastaa antamiensa tietojen oikeellisuudesta, käyttäjätunnuksensa ja salasanansa huolellisesta säilyttämisestä sekä laitteensa asianmukaisen tietoturvan järjestämisestä. Rekisteröitynyt Asiakas ja Rekisteröitynyt Käyttäjä vastaa kaikesta tunnuksillaan tapahtuvasta asioinnista Sovelluksessa.\n\nPalvelun käyttämiseen ja näihin ehtoihin sovelletaan Suomen lakia lukuun ottamatta sen lainvalintaa koskevia säännöksiä.\n\nOsapuolet pyrkivät ratkaisemaan erimielisyydet ensisijaisesti neuvotteluteitse. Mikäli sovintoratkaisuun ei päästä, erimielisyydet ratkaistaan Helsingin käräjäoikeudessa. Kuluttaja-asiakas voi viedä erimielisyyden myös kuluttajariitalautakunnan ratkaistavaksi.\n\n13.	Yhteystiedot\n\nJos sinulla on kysyttävää näistä Käyttöehdoista tai Sovelluksesta, ota yhteyttä:\n\nWeAre Sloutions Oy\nÄyritie 12C\n01510 Vantaa\nSuomi\ninfo@reapptor-apps.fi\nY-Tunnus 2976585-9\n    ` }, { l: `uk`, v: `1 Общие условия\n\nПриложение Athenaeum Application Template («Приложение») принадлежит и предоставляется WeAre Solutions Oy («WeAre»).\n\nУстанавливая Приложение и / или используя Приложение, Зарегистрированный Клиент или Незарегистрированный Пользователь соглашается с настоящими Условиями использования («Условия использования»). Если Зарегистрированный Клиент или Незарегистрированный Пользователь не принимает настоящие Условия использования, Зарегистрированный Клиент или Незарегистрированный Пользователь не имеет права устанавливать, открывать или использовать приложение.\n\nWeAre оставляет за собой право изменять настоящие Условия использования в любое время без предварительного уведомления. Зарегистрированный Клиент или Незарегистрированный Пользователь считается принявшим обновленные Условия использования, используя приложение после изменения Условий использования.\n\n2. Приложение Athenaeum Application Template\n\nПриложение предназначено для сотрудников WeAre (Зарегистрированных Пользователей) и Зарегистрированных Клиентов. Приложение можно использовать либо в качестве сотрудника WeAre (Зарегистрированный Пользователь), либо в качестве Зарегистрированного Клиента с лицензией для конкретного Клиента («Зарегистрированный Клиент»).\n\n2.1 Зарегистрированные Клиенты.\nДля регистрации в качестве Клиента требуются существующие клиентские отношения с WeAre. WeAre имеет право не принимать регистрацию и отозвать лицензию приложения.\n\nЗарегистрированный Клиент имеет возможность просматривать и утверждать отчеты о работе и выставление счетов для своих строительных площадок через приложение.\n\n2.2 Зарегистрированные Пользователи\nДля регистрации в Приложении требуются существующие трудовые отношения с WeAre. WeAre имеет право не принимать регистрацию и отозвать лицензию приложения.\n\nЗарегистрированный Пользователь имеет возможность выполнять действия, необходимые для контроля работы через приложение.\n\nЧтобы обеспечить правильную работу приложения, Зарегистрированный Клиент и Зарегистрированный Пользователь должны убедиться, что у них установлена ​​последняя версия приложения.\n\n3. Ассортимент продукции и прайс-лист\n\nАссортимент продукции, представленный в приложении, соответствует обычному ассортименту WeAre. Ассортимент продукции, наличие продукции и информация о ценах могут варьироваться в зависимости от региона. Цены не включают НДС, если не указано иное. НДС будет добавлен к ставкам при выставлении счета.\n\nИнформация о ценах для контрактных Клиентов представлена ​​в Приложении. Представление цен может быть ограничено правами доступа.\n\nWeAre не несет ответственности за любые ошибки, упущения или другие дефекты в цене и информации о продукте или других материалах, представленных в Приложении.\n\n4. Отчеты о работе с учетом требований Клиента\n\n4.1 Создание отчета о работе с учетом требований Клиента\nРабота, выполненная Зарегистрированными пользователями от имени клиента, формирует отчет о работе системы.\n\n4.2 Обработка отчета о работе для конкретного Клиента\nЗарегистрированный Клиент имеет возможность просматривать отчеты о проделанной работе, а также принимать и отклонять отчеты о проделанной работе. WeAre имеет право выставить счет за работу в соответствии с утвержденным отчетом о работе.\n\n5. Счета-фактуры для конкретных Клиентов.\n\n5.1 Просмотр счетов-фактур для конкретных Клиентов\nЗарегистрированный Клиент может просматривать в приложении счета, касающиеся его. Любые неверные счета должны быть отправлены повторно в соответствии с инструкциями WeAre.\n\n6. Права интеллектуальной собственности\n\nПриложение и его содержимое, включая, например, товарные знаки, торговые наименования, информация о продуктах и ​​изображения являются собственностью WeAre и / или ее партнеров и защищены авторским правом и международными соглашениями об интеллектуальной собственности. Все права на Приложение и его содержимое защищены. В прямой форме указано, что Зарегистрированный клиент или Зарегистрированный пользователь не может сублицензировать, сдавать в аренду, передавать или иным образом распространять Приложение или свои права на использование Приложения, за исключением случаев, разрешенных настоящими Условиями использования.\n\nЗарегистрированный Клиент или Зарегистрированный Пользователь не имеет права изменять, модифицировать, удалять, копировать, публиковать, делать общедоступными или передавать какие-либо права интеллектуальной собственности. Ваше право на использование приложения ограничено вашим использованием в соответствии с настоящими Условиями использования.\n\n7. Разрешения и права доступа\n\nЗарегистрированный Клиент принимает в качестве обязательных все меры, предпринятые через Приложение с учетными данными Зарегистрированного Клиента или от имени Зарегистрированного Клиента. Использование учетных данных Зарегистрированного Клиента в Приложении соответствует подписи Зарегистрированного Клиента.\n\nЗарегистрированный клиент обязан бережно хранить учетные данные. Если Зарегистрированный клиент подозревает, что учетные данные были принудительно переданы третьей стороне, Зарегистрированный клиент должен немедленно проинформировать контактное лицо WeAre о ситуации. Контактное лицо удаляет старые учетные данные и открывает новые. Зарегистрированный клиент несет ответственность за все заказы, размещенные с использованием его / ее имени пользователя, и за любой ущерб, который может возникнуть в результате компрометации учетных данных.\n\n8. Ответственность WeAre\n\nПриложение и его содержимое предоставляются Зарегистрированному клиенту и Зарегистрированному пользователю «как есть». WeAre не несет ответственности за какие-либо ошибки, упущения или другие дефекты в содержании, передаваемом в Приложении. WeAre не гарантирует доступность Приложения или его бесперебойную или безошибочную работу. WeAre не несет ответственности за какие-либо расходы, убытки или другие возможные прямые или косвенные убытки, которые могут возникнуть в результате использования этого Приложения, информации, представленной в Приложении, или недоступности Приложения, в соответствии с обязательным законодательством. В любом случае ответственность WeAre ограничена максимальной суммой, соответствующей согласованной арендной плате за оборудование и / или цене услуги.\n\n9. Файлы cookie\n\nWeAre использует файлы cookie в Приложении (так называемая функция cookie). Файл cookie - это текстовый файл, который сохраняется в браузере пользователя при использовании Приложения. Например, файлы cookie позволяют отслеживать количество пользователей Приложения и собирать информацию о том, как и когда используется Приложение.\n\nЗарегистрированный Клиент и Незарегистрированный Пользователь могут отключить использование файлов cookie в настройках своего браузера. Для получения дополнительных сведений об инструкциях для конкретного браузера обратитесь к разработчику вашего браузера. WeAre рекомендует использовать файлы cookie в Приложении, чтобы обеспечить максимальное удобство использования.\n\n10. Сторонние службы\n\nПриложение может содержать ссылки на сайты, принадлежащие третьим лицам или управляемые ими. WeAre не несет ответственности за работу, содержание, прямой или косвенный ущерб или другие особенности таких сторонних сайтов. Получая доступ к этим страницам, пользователь должен принять условия использования этих страниц и Заявление о конфиденциальности перед их использованием.\n\n11. Обработка личных данных\n\nWeAre обрабатывает и собирает персональные данные Зарегистрированных клиентов для реализации услуг, а также для поддержания и развития отношений с клиентами. В заявлении о конфиденциальности WeAre более подробно описывается обработка персональных данных: https://www.weare.fi/en/privacy-policy-and-cookies\n\nПерсональные данные незарегистрированных пользователей не собираются.\n\n12. Прочие условия\n\nДействующие условия аренды WeAre распространяются на аренду оборудования и услуги. Условия годовых контрактов соблюдаются с заказчиками годовых контрактов. Заказчик соглашается с условиями доставки, действующими для каждого заказа.\n\nWeAre может изменять, обновлять, отменять или удалять Приложение, его содержимое или его части по своему усмотрению. Зарегистрированный Клиент или Зарегистрированный Пользователь должен прекратить использование Приложения, если Зарегистрированный Клиент или Зарегистрированный Пользователь не принимает изменения в Условиях использования Приложения или в заявлении о конфиденциальности.\n\nЗарегистрированный Клиент и Незарегистрированный Пользователь должны использовать Приложение в соответствии с условиями использования магазина приложений, из которого они приобрели Приложение. Во всех случаях Зарегистрированный клиент и Зарегистрированный пользователь несут ответственность за ущерб, причиненный им в результате соблюдения им настоящих Условий использования.\n\nЗарегистрированный Клиент и Зарегистрированный Пользователь несут ответственность за точность предоставляемой информации, за бережное хранение своего имени пользователя и пароля и за надлежащую безопасность своего оборудования. Зарегистрированный Клиент и Зарегистрированный Пользователь несут ответственность за все транзакции в Приложении со своими учетными данными.\n\nИспользование сервиса и настоящие условия регулируются законодательством Финляндии, за исключением пункта о выборе права.\n\nСтороны будут стремиться разрешить свои разногласия, прежде всего, путем переговоров. Если мировое соглашение не будет достигнуто, споры будут разрешены в Окружном Суде Хельсинки. Клиент-Потребитель также может передать спор в Комиссию по Потребительским Спорам для разрешения.\n\n13. Контакты\n\nЕсли у вас есть какие-либо вопросы об этих Условиях использования или Приложении, пожалуйста, свяжитесь:\n\nWeAre Solutions Oy\nÄyritie 12C\n01510 Вантаа\nФинляндия\ninfo@reapptor-apps.fi\nНалоговый номер 2976585-9` }, { l: `sv`, v: `1	Common\n\nThe Athenaeum Application Template Application (the “Application”) is owned and provided by WeAre Solutions Oy (“WeAre”).\n\nBy installing the Application and / or using the Application, the Registered Customer or the Unregistered User agrees to these Terms of Use (the "Terms of Use"). If the Registered Customer or the Unregistered User does not accept these Terms of Use, the Registered Customer or the Unregistered User does not have the right to install, open or use the application.\n\nWeAre reserves the right to change these Terms of Use at any time without notice. A registered Customer or an Unregistered User shall be deemed to have accepted the updated Terms of Use by using the application after the change to the Terms of Use.\n\n2.	Athenaeum Application Template application\n\nThe application is for WeAren Employees (Registered Users) and Registered Customers. It is possible to use the application either as an employee of WeAre (Registered User) or alternatively as a registered Customer with a customer-specific license ("Registered Customer").\n\n2.1	Registered Customers.\nRegistering as a Customer requires an existing customer relationship with WeAre. WeAre has the right not to accept the registration and to revoke the license of the application.\n\nThe Registered Customer has the opportunity to view and approve work reports and invoicing for his construction sites through the application.\n\n2.2	Registered Users\nRegistration for the Application requires an existing employment relationship with WeAre. WeAre has the right not to accept the registration and to revoke the license of the application.\n\nThe Registered User has the opportunity to perform the actions required for work control through the application.\n\nTo ensure the proper operation of the application, the Registered Customer and the Registered User must ensure that they have the latest version of the application.\n\n3.	Product range and price list\n\nThe product range presented in the application corresponds to WeAre's normal product range. Product range, product availability and price information may vary from location to location. Prices do not include VAT unless stated otherwise. VAT will be added to the rates upon invoicing.\n\nCustomer-specific price information for contract customers is presented in the Application. The presentation of prices may be limited by access rights.\n\nWeAre is not responsible for any errors, omissions or other defects in the price and product information or other material presented in the Application.\n\n4.	Customer-Specific Work Reports\n\n4.1	Generation of a customer-specific work report\nThe work performed by the Registered Users on behalf of the customer forms a work report for the system.\n\n4.2	Processing a customer-specific work report\nThe Registered Customer has the opportunity to view the work reports concerning him or her and to accept and reject the work reports of the work performed. WeAre has the right to invoice the work in accordance with the approved work report.\n\n5.	Customer-specific invoices\n\n5.1	Viewing Customer-Specific Invoices\nIt is possible for a registered Customer to view invoices concerning him in the application. Any incorrect invoices must be reclamed in accordance with WeAre's instructions.\n\n6.	Intellectual Property Rights\n\nThe application and its content, including e.g. trademarks, trade names, product information and images are the property of WeAre and / or its partners, which are protected by e.g. copyright law and international intellectual property agreements. All rights to the Application and its content are reserved. It is expressly stated that the Registered Customer or the Registered User may not sublicense, rent, transfer or otherwise distribute the Application or its rights to use the Application except as permitted in these Terms of Use.\n\nThe Registered Customer or the Registered User shall not have the right to change, modify, delete, copy, publish, make available to the public or transfer any intellectual property rights. Your right to use the application is limited to your use in accordance with these Terms of Use.\n\n7.	Permissions and access rights\n\nThe Registered Customer accepts as binding all measures taken through the Application with the registered Customer's credentials or by or on behalf of the Registered Customer. The use of Registered Customer credentials in the Application corresponds to the Registered Customer's signature.\n\nThe Registered Customer is obliged to keep the credentials carefully stored. If the Registered Customer suspects that the credentials have been forced to possession of a third party, the Registered Customer shall immediately inform the contact person of WeAre about the situation. The contact person deletes the old credentials and opens the new ones. The Registered Customer is responsible for all orders placed with his / her username and for any damages that may result from compromising the credentials.\n\n8.	WeAren's responsibility\n\nThe application and its contents are provided to the Registered Customer and the Registered User “as is”. WeAre is not responsible for any errors, omissions or other defects in the content transmitted in the Application. WeAre does not guarantee the availability of the Application or its uninterrupted or error-free operation. WeAre shall not be liable for any costs, losses or other possible direct or indirect damages that may arise from the use of this Application, the information provided in the Application or the non-availability of the Application, subject to mandatory legislation. In any case, WeAre's liability is limited to a maximum amount corresponding to the agreed rental equipment rental and / or service price.\n\n9.	Cookies\n\nWeAre uses cookies in the Application (so-called cookie function). A cookie is a text file stored in the user's browser when using the Application. For example, cookies make it possible to monitor the number of users of the Application and to collect information on how and when the Application is used.\n\nThe Registered Customer and the Unregistered User can disable the use of cookies in their browser settings. For more information on browser-specific instructions, contact your browser developer. WeAre recommends the use of cookies in the Application in order to obtain the best possible user experience.\n\n10.	Third Party Services\n\nThe application may contain links to sites owned or operated by third parties. WeAre is not responsible for the operation, content, direct or indirect damages or other features of such third party sites. By accessing these pages, the user must accept the terms of use of these pages and the Privacy Statement before using them.\n\n11.	Processing of personal data\n\nWeAre processes and collects the personal data of Registered Customers in order to implement the services and to maintain and develop customer relationships. WeAre's privacy statement describes the processing of personal data in more detail: https://www.weare.fi/en/privacy-policy-and-cookies\n\nThe personal data of unregistered Users will not be collected.\n\n12.	Other Terms\n\nWeAre's valid rental terms apply to machine rental and services. The terms and conditions of the annual contracts are complied with with the customers of the annual contracts. The customer agrees to the delivery terms valid for each order.\n\nWeAre may change, update, cancel or delete the Application, the contents of the Application or portions thereof at its sole discretion. The Registered Customer or the Registered User must stop using the Application if the Registered Customer or the Registered User does not accept the changes in the Terms of Use of the Application or the privacy statement.\n\nThe Registered Customer and the Unregistered User must use the Application in accordance with the terms of use of the application store from which they have acquired the Application. In all cases, the Registered Customer and the Registered User shall be liable for damages caused by his / her compliance with these Terms of Use.\n\nThe Registered Customer and the Registered User are responsible for the accuracy of the information they provide, for the careful storage of their username and password, and for the proper security of their equipment. The Registered Customer and the Registered User are responsible for all transactions in the Application with their credentials.\n\nThe use of the service and these terms and conditions are governed by Finnish law, except for its choice of law provisions.\n\nThe parties shall endeavor to resolve their differences primarily through negotiations. If no amicable settlement is reached, the disputes will be settled in the Helsinki District Court. The consumer customer can also take the dispute to the Consumer Disputes Board for resolution.\n\n13.	Contact\n\nIf you have any questions about these Terms of Use or the Application, please contact:\n\nWeAre Solutions Oy\nÄyritie 12C\n01510 Vantaa\nFinland\ninfo@reapptor-apps.fi\nBusiness ID 2976585-9` }, { l: `ru`, v: `1 Общие условия\n\nПриложение Athenaeum Application Template («Приложение») принадлежит и предоставляется WeAre Solutions Oy («WeAre»).\n\nУстанавливая Приложение и / или используя Приложение, Зарегистрированный Клиент или Незарегистрированный Пользователь соглашается с настоящими Условиями использования («Условия использования»). Если Зарегистрированный Клиент или Незарегистрированный Пользователь не принимает настоящие Условия использования, Зарегистрированный Клиент или Незарегистрированный Пользователь не имеет права устанавливать, открывать или использовать приложение.\n\nWeAre оставляет за собой право изменять настоящие Условия использования в любое время без предварительного уведомления. Зарегистрированный Клиент или Незарегистрированный Пользователь считается принявшим обновленные Условия использования, используя приложение после изменения Условий использования.\n\n2. Приложение Athenaeum Application Template\n\nПриложение предназначено для сотрудников WeAre (Зарегистрированных Пользователей) и Зарегистрированных Клиентов. Приложение можно использовать либо в качестве сотрудника WeAre (Зарегистрированный Пользователь), либо в качестве Зарегистрированного Клиента с лицензией для конкретного Клиента («Зарегистрированный Клиент»).\n\n2.1 Зарегистрированные Клиенты.\nДля регистрации в качестве Клиента требуются существующие клиентские отношения с WeAre. WeAre имеет право не принимать регистрацию и отозвать лицензию приложения.\n\nЗарегистрированный Клиент имеет возможность просматривать и утверждать отчеты о работе и выставление счетов для своих строительных площадок через приложение.\n\n2.2 Зарегистрированные Пользователи\nДля регистрации в Приложении требуются существующие трудовые отношения с WeAre. WeAre имеет право не принимать регистрацию и отозвать лицензию приложения.\n\nЗарегистрированный Пользователь имеет возможность выполнять действия, необходимые для контроля работы через приложение.\n\nЧтобы обеспечить правильную работу приложения, Зарегистрированный Клиент и Зарегистрированный Пользователь должны убедиться, что у них установлена ​​последняя версия приложения.\n\n3. Ассортимент продукции и прайс-лист\n\nАссортимент продукции, представленный в приложении, соответствует обычному ассортименту WeAre. Ассортимент продукции, наличие продукции и информация о ценах могут варьироваться в зависимости от региона. Цены не включают НДС, если не указано иное. НДС будет добавлен к ставкам при выставлении счета.\n\nИнформация о ценах для контрактных Клиентов представлена ​​в Приложении. Представление цен может быть ограничено правами доступа.\n\nWeAre не несет ответственности за любые ошибки, упущения или другие дефекты в цене и информации о продукте или других материалах, представленных в Приложении.\n\n4. Отчеты о работе с учетом требований Клиента\n\n4.1 Создание отчета о работе с учетом требований Клиента\nРабота, выполненная Зарегистрированными пользователями от имени клиента, формирует отчет о работе системы.\n\n4.2 Обработка отчета о работе для конкретного Клиента\nЗарегистрированный Клиент имеет возможность просматривать отчеты о проделанной работе, а также принимать и отклонять отчеты о проделанной работе. WeAre имеет право выставить счет за работу в соответствии с утвержденным отчетом о работе.\n\n5. Счета-фактуры для конкретных Клиентов.\n\n5.1 Просмотр счетов-фактур для конкретных Клиентов\nЗарегистрированный Клиент может просматривать в приложении счета, касающиеся его. Любые неверные счета должны быть отправлены повторно в соответствии с инструкциями WeAre.\n\n6. Права интеллектуальной собственности\n\nПриложение и его содержимое, включая, например, товарные знаки, торговые наименования, информация о продуктах и ​​изображения являются собственностью WeAre и / или ее партнеров и защищены авторским правом и международными соглашениями об интеллектуальной собственности. Все права на Приложение и его содержимое защищены. В прямой форме указано, что Зарегистрированный клиент или Зарегистрированный пользователь не может сублицензировать, сдавать в аренду, передавать или иным образом распространять Приложение или свои права на использование Приложения, за исключением случаев, разрешенных настоящими Условиями использования.\n\nЗарегистрированный Клиент или Зарегистрированный Пользователь не имеет права изменять, модифицировать, удалять, копировать, публиковать, делать общедоступными или передавать какие-либо права интеллектуальной собственности. Ваше право на использование приложения ограничено вашим использованием в соответствии с настоящими Условиями использования.\n\n7. Разрешения и права доступа\n\nЗарегистрированный Клиент принимает в качестве обязательных все меры, предпринятые через Приложение с учетными данными Зарегистрированного Клиента или от имени Зарегистрированного Клиента. Использование учетных данных Зарегистрированного Клиента в Приложении соответствует подписи Зарегистрированного Клиента.\n\nЗарегистрированный клиент обязан бережно хранить учетные данные. Если Зарегистрированный клиент подозревает, что учетные данные были принудительно переданы третьей стороне, Зарегистрированный клиент должен немедленно проинформировать контактное лицо WeAre о ситуации. Контактное лицо удаляет старые учетные данные и открывает новые. Зарегистрированный клиент несет ответственность за все заказы, размещенные с использованием его / ее имени пользователя, и за любой ущерб, который может возникнуть в результате компрометации учетных данных.\n\n8. Ответственность WeAre\n\nПриложение и его содержимое предоставляются Зарегистрированному клиенту и Зарегистрированному пользователю «как есть». WeAre не несет ответственности за какие-либо ошибки, упущения или другие дефекты в содержании, передаваемом в Приложении. WeAre не гарантирует доступность Приложения или его бесперебойную или безошибочную работу. WeAre не несет ответственности за какие-либо расходы, убытки или другие возможные прямые или косвенные убытки, которые могут возникнуть в результате использования этого Приложения, информации, представленной в Приложении, или недоступности Приложения, в соответствии с обязательным законодательством. В любом случае ответственность WeAre ограничена максимальной суммой, соответствующей согласованной арендной плате за оборудование и / или цене услуги.\n\n9. Файлы cookie\n\nWeAre использует файлы cookie в Приложении (так называемая функция cookie). Файл cookie - это текстовый файл, который сохраняется в браузере пользователя при использовании Приложения. Например, файлы cookie позволяют отслеживать количество пользователей Приложения и собирать информацию о том, как и когда используется Приложение.\n\nЗарегистрированный Клиент и Незарегистрированный Пользователь могут отключить использование файлов cookie в настройках своего браузера. Для получения дополнительных сведений об инструкциях для конкретного браузера обратитесь к разработчику вашего браузера. WeAre рекомендует использовать файлы cookie в Приложении, чтобы обеспечить максимальное удобство использования.\n\n10. Сторонние службы\n\nПриложение может содержать ссылки на сайты, принадлежащие третьим лицам или управляемые ими. WeAre не несет ответственности за работу, содержание, прямой или косвенный ущерб или другие особенности таких сторонних сайтов. Получая доступ к этим страницам, пользователь должен принять условия использования этих страниц и Заявление о конфиденциальности перед их использованием.\n\n11. Обработка личных данных\n\nWeAre обрабатывает и собирает персональные данные Зарегистрированных клиентов для реализации услуг, а также для поддержания и развития отношений с клиентами. В заявлении о конфиденциальности WeAre более подробно описывается обработка персональных данных: https://www.weare.fi/en/privacy-policy-and-cookies\n\nПерсональные данные незарегистрированных пользователей не собираются.\n\n12. Прочие условия\n\nДействующие условия аренды WeAre распространяются на аренду оборудования и услуги. Условия годовых контрактов соблюдаются с заказчиками годовых контрактов. Заказчик соглашается с условиями доставки, действующими для каждого заказа.\n\nWeAre может изменять, обновлять, отменять или удалять Приложение, его содержимое или его части по своему усмотрению. Зарегистрированный Клиент или Зарегистрированный Пользователь должен прекратить использование Приложения, если Зарегистрированный Клиент или Зарегистрированный Пользователь не принимает изменения в Условиях использования Приложения или в заявлении о конфиденциальности.\n\nЗарегистрированный Клиент и Незарегистрированный Пользователь должны использовать Приложение в соответствии с условиями использования магазина приложений, из которого они приобрели Приложение. Во всех случаях Зарегистрированный клиент и Зарегистрированный пользователь несут ответственность за ущерб, причиненный им в результате соблюдения им настоящих Условий использования.\n\nЗарегистрированный Клиент и Зарегистрированный Пользователь несут ответственность за точность предоставляемой информации, за бережное хранение своего имени пользователя и пароля и за надлежащую безопасность своего оборудования. Зарегистрированный Клиент и Зарегистрированный Пользователь несут ответственность за все транзакции в Приложении со своими учетными данными.\n\nИспользование сервиса и настоящие условия регулируются законодательством Финляндии, за исключением пункта о выборе права.\n\nСтороны будут стремиться разрешить свои разногласия, прежде всего, путем переговоров. Если мировое соглашение не будет достигнуто, споры будут разрешены в Окружном Суде Хельсинки. Клиент-Потребитель также может передать спор в Комиссию по Потребительским Спорам для разрешения.\n\n13. Контакты\n\nЕсли у вас есть какие-либо вопросы об этих Условиях использования или Приложении, пожалуйста, свяжитесь:\n\nWeAre Solutions Oy\nÄyritie 12C\n01510 Вантаа\nФинляндия\ninfo@reapptor-apps.fi\nНалоговый номер 2976585-9` }, { l: `pl`, v: `PL:\n\n1	Common\n\nThe Athenaeum Application Template Application (the “Application”) is owned and provided by WeAre Solutions Oy Oy (“WeAre”).\n\nBy installing the Application and / or using the Application, the Registered Customer or the Unregistered User agrees to these Terms of Use (the "Terms of Use"). If the Registered Customer or the Unregistered User does not accept these Terms of Use, the Registered Customer or the Unregistered User does not have the right to install, open or use the application.\n\nWeAre reserves the right to change these Terms of Use at any time without notice. A registered Customer or an Unregistered User shall be deemed to have accepted the updated Terms of Use by using the application after the change to the Terms of Use.\n\n2.	Athenaeum Application Template application\n\nThe application is for WeAren Employees (Registered Users) and Registered Customers. It is possible to use the application either as an employee of WeAre (Registered User) or alternatively as a registered Customer with a customer-specific license ("Registered Customer").\n\n2.1	Registered Customers.\nRegistering as a Customer requires an existing customer relationship with WeAre. WeAre has the right not to accept the registration and to revoke the license of the application.\n\nThe Registered Customer has the opportunity to view and approve work reports and invoicing for his construction sites through the application.\n\n2.2	Registered Users\nRegistration for the Application requires an existing employment relationship with WeAre. WeAre has the right not to accept the registration and to revoke the license of the application.\n\nThe Registered User has the opportunity to perform the actions required for work control through the application.\n\nTo ensure the proper operation of the application, the Registered Customer and the Registered User must ensure that they have the latest version of the application.\n\n3.	Product range and price list\n\nThe product range presented in the application corresponds to WeAre's normal product range. Product range, product availability and price information may vary from location to location. Prices do not include VAT unless stated otherwise. VAT will be added to the rates upon invoicing.\n\nCustomer-specific price information for contract customers is presented in the Application. The presentation of prices may be limited by access rights.\n\nWeAre is not responsible for any errors, omissions or other defects in the price and product information or other material presented in the Application.\n\n4.	Customer-Specific Work Reports\n\n4.1	Generation of a customer-specific work report\nThe work performed by the Registered Users on behalf of the customer forms a work report for the system.\n\n4.2	Processing a customer-specific work report\nThe Registered Customer has the opportunity to view the work reports concerning him or her and to accept and reject the work reports of the work performed. WeAre has the right to invoice the work in accordance with the approved work report.\n\n5.	Customer-specific invoices\n\n5.1	Viewing Customer-Specific Invoices\nIt is possible for a registered Customer to view invoices concerning him in the application. Any incorrect invoices must be reclamed in accordance with WeAre's instructions.\n\n6.	Intellectual Property Rights\n\nThe application and its content, including e.g. trademarks, trade names, product information and images are the property of WeAre and / or its partners, which are protected by e.g. copyright law and international intellectual property agreements. All rights to the Application and its content are reserved. It is expressly stated that the Registered Customer or the Registered User may not sublicense, rent, transfer or otherwise distribute the Application or its rights to use the Application except as permitted in these Terms of Use.\n\nThe Registered Customer or the Registered User shall not have the right to change, modify, delete, copy, publish, make available to the public or transfer any intellectual property rights. Your right to use the application is limited to your use in accordance with these Terms of Use.\n\n7.	Permissions and access rights\n\nThe Registered Customer accepts as binding all measures taken through the Application with the registered Customer's credentials or by or on behalf of the Registered Customer. The use of Registered Customer credentials in the Application corresponds to the Registered Customer's signature.\n\nThe Registered Customer is obliged to keep the credentials carefully stored. If the Registered Customer suspects that the credentials have been forced to possession of a third party, the Registered Customer shall immediately inform the contact person of WeAre about the situation. The contact person deletes the old credentials and opens the new ones. The Registered Customer is responsible for all orders placed with his / her username and for any damages that may result from compromising the credentials.\n\n8.	WeAre's responsibility\n\nThe application and its contents are provided to the Registered Customer and the Registered User “as is”. WeAre is not responsible for any errors, omissions or other defects in the content transmitted in the Application. WeAre does not guarantee the availability of the Application or its uninterrupted or error-free operation. WeAre shall not be liable for any costs, losses or other possible direct or indirect damages that may arise from the use of this Application, the information provided in the Application or the non-availability of the Application, subject to mandatory legislation. In any case, WeAre's liability is limited to a maximum amount corresponding to the agreed rental equipment rental and / or service price.\n\n9.	Cookies\n\nWeAre uses cookies in the Application (so-called cookie function). A cookie is a text file stored in the user's browser when using the Application. For example, cookies make it possible to monitor the number of users of the Application and to collect information on how and when the Application is used.\n\nThe Registered Customer and the Unregistered User can disable the use of cookies in their browser settings. For more information on browser-specific instructions, contact your browser developer. WeAre recommends the use of cookies in the Application in order to obtain the best possible user experience.\n\n10.	Third Party Services\n\nThe application may contain links to sites owned or operated by third parties. WeAre is not responsible for the operation, content, direct or indirect damages or other features of such third party sites. By accessing these pages, the user must accept the terms of use of these pages and the Privacy Statement before using them.\n\n11.	Processing of personal data\n\nWeAre processes and collects the personal data of Registered Customers in order to implement the services and to maintain and develop customer relationships. WeAre's privacy statement describes the processing of personal data in more detail: https://www.weare.fi/en/privacy-policy-and-cookies\n\nThe personal data of unregistered Users will not be collected.\n\n12.	Other Terms\n\nWeAre's valid rental terms apply to machine rental and services. The terms and conditions of the annual contracts are complied with with the customers of the annual contracts. The customer agrees to the delivery terms valid for each order.\n\nWeAre may change, update, cancel or delete the Application, the contents of the Application or portions thereof at its sole discretion. The Registered Customer or the Registered User must stop using the Application if the Registered Customer or the Registered User does not accept the changes in the Terms of Use of the Application or the privacy statement.\n\nThe Registered Customer and the Unregistered User must use the Application in accordance with the terms of use of the application store from which they have acquired the Application. In all cases, the Registered Customer and the Registered User shall be liable for damages caused by his / her compliance with these Terms of Use.\n\nThe Registered Customer and the Registered User are responsible for the accuracy of the information they provide, for the careful storage of their username and password, and for the proper security of their equipment. The Registered Customer and the Registered User are responsible for all transactions in the Application with their credentials.\n\nThe use of the service and these terms and conditions are governed by Finnish law, except for its choice of law provisions.\n\nThe parties shall endeavor to resolve their differences primarily through negotiations. If no amicable settlement is reached, the disputes will be settled in the Helsinki District Court. The consumer customer can also take the dispute to the Consumer Disputes Board for resolution.\n\n13.	Contact\n\nIf you have any questions about these Terms of Use or the Application, please contact:\n\nWeAre Solutions Oy\nÄyritie 12C\n01510 Vantaa\nFinland\ninfo@reapptor-apps.fi\nBusiness ID 2976585-9` }, { l: `nb`, v: `NB: 1	Common\n\nThe Athenaeum Application Template Application (the “Application”) is owned and provided by WeAre Solutions Oy (“WeAre”).\n\nBy installing the Application and / or using the Application, the Registered Customer or the Unregistered User agrees to these Terms of Use (the "Terms of Use"). If the Registered Customer or the Unregistered User does not accept these Terms of Use, the Registered Customer or the Unregistered User does not have the right to install, open or use the application.\n\nWeAre reserves the right to change these Terms of Use at any time without notice. A registered Customer or an Unregistered User shall be deemed to have accepted the updated Terms of Use by using the application after the change to the Terms of Use.\n\n2.	Athenaeum Application Template application\n\nThe application is for WeAren Employees (Registered Users) and Registered Customers. It is possible to use the application either as an employee of WeAre (Registered User) or alternatively as a registered Customer with a customer-specific license ("Registered Customer").\n\n2.1	Registered Customers.\nRegistering as a Customer requires an existing customer relationship with WeAre. WeAre has the right not to accept the registration and to revoke the license of the application.\n\nThe Registered Customer has the opportunity to view and approve work reports and invoicing for his construction sites through the application.\n\n2.2	Registered Users\nRegistration for the Application requires an existing employment relationship with WeAre. WeAre has the right not to accept the registration and to revoke the license of the application.\n\nThe Registered User has the opportunity to perform the actions required for work control through the application.\n\nTo ensure the proper operation of the application, the Registered Customer and the Registered User must ensure that they have the latest version of the application.\n\n3.	Product range and price list\n\nThe product range presented in the application corresponds to WeAre's normal product range. Product range, product availability and price information may vary from location to location. Prices do not include VAT unless stated otherwise. VAT will be added to the rates upon invoicing.\n\nCustomer-specific price information for contract customers is presented in the Application. The presentation of prices may be limited by access rights.\n\nWeAre is not responsible for any errors, omissions or other defects in the price and product information or other material presented in the Application.\n\n4.	Customer-Specific Work Reports\n\n4.1	Generation of a customer-specific work report\nThe work performed by the Registered Users on behalf of the customer forms a work report for the system.\n\n4.2	Processing a customer-specific work report\nThe Registered Customer has the opportunity to view the work reports concerning him or her and to accept and reject the work reports of the work performed. WeAre has the right to invoice the work in accordance with the approved work report.\n\n5.	Customer-specific invoices\n\n5.1	Viewing Customer-Specific Invoices\nIt is possible for a registered Customer to view invoices concerning him in the application. Any incorrect invoices must be reclamed in accordance with WeAre's instructions.\n\n6.	Intellectual Property Rights\n\nThe application and its content, including e.g. trademarks, trade names, product information and images are the property of WeAre and / or its partners, which are protected by e.g. copyright law and international intellectual property agreements. All rights to the Application and its content are reserved. It is expressly stated that the Registered Customer or the Registered User may not sublicense, rent, transfer or otherwise distribute the Application or its rights to use the Application except as permitted in these Terms of Use.\n\nThe Registered Customer or the Registered User shall not have the right to change, modify, delete, copy, publish, make available to the public or transfer any intellectual property rights. Your right to use the application is limited to your use in accordance with these Terms of Use.\n\n7.	Permissions and access rights\n\nThe Registered Customer accepts as binding all measures taken through the Application with the registered Customer's credentials or by or on behalf of the Registered Customer. The use of Registered Customer credentials in the Application corresponds to the Registered Customer's signature.\n\nThe Registered Customer is obliged to keep the credentials carefully stored. If the Registered Customer suspects that the credentials have been forced to possession of a third party, the Registered Customer shall immediately inform the contact person of WeAre about the situation. The contact person deletes the old credentials and opens the new ones. The Registered Customer is responsible for all orders placed with his / her username and for any damages that may result from compromising the credentials.\n\n8.	WeAren's responsibility\n\nThe application and its contents are provided to the Registered Customer and the Registered User “as is”. WeAre is not responsible for any errors, omissions or other defects in the content transmitted in the Application. WeAre does not guarantee the availability of the Application or its uninterrupted or error-free operation. WeAre shall not be liable for any costs, losses or other possible direct or indirect damages that may arise from the use of this Application, the information provided in the Application or the non-availability of the Application, subject to mandatory legislation. In any case, WeAre's liability is limited to a maximum amount corresponding to the agreed rental equipment rental and / or service price.\n\n9.	Cookies\n\nWeAre uses cookies in the Application (so-called cookie function). A cookie is a text file stored in the user's browser when using the Application. For example, cookies make it possible to monitor the number of users of the Application and to collect information on how and when the Application is used.\n\nThe Registered Customer and the Unregistered User can disable the use of cookies in their browser settings. For more information on browser-specific instructions, contact your browser developer. WeAre recommends the use of cookies in the Application in order to obtain the best possible user experience.\n\n10.	Third Party Services\n\nThe application may contain links to sites owned or operated by third parties. WeAre is not responsible for the operation, content, direct or indirect damages or other features of such third party sites. By accessing these pages, the user must accept the terms of use of these pages and the Privacy Statement before using them.\n\n11.	Processing of personal data\n\nWeAre processes and collects the personal data of Registered Customers in order to implement the services and to maintain and develop customer relationships. WeAre's privacy statement describes the processing of personal data in more detail: https://www.weare.fi/en/privacy-policy-and-cookies\n\nThe personal data of unregistered Users will not be collected.\n\n12.	Other Terms\n\nWeAre's valid rental terms apply to machine rental and services. The terms and conditions of the annual contracts are complied with with the customers of the annual contracts. The customer agrees to the delivery terms valid for each order.\n\nWeAre may change, update, cancel or delete the Application, the contents of the Application or portions thereof at its sole discretion. The Registered Customer or the Registered User must stop using the Application if the Registered Customer or the Registered User does not accept the changes in the Terms of Use of the Application or the privacy statement.\n\nThe Registered Customer and the Unregistered User must use the Application in accordance with the terms of use of the application store from which they have acquired the Application. In all cases, the Registered Customer and the Registered User shall be liable for damages caused by his / her compliance with these Terms of Use.\n\nThe Registered Customer and the Registered User are responsible for the accuracy of the information they provide, for the careful storage of their username and password, and for the proper security of their equipment. The Registered Customer and the Registered User are responsible for all transactions in the Application with their credentials.\n\nThe use of the service and these terms and conditions are governed by Finnish law, except for its choice of law provisions.\n\nThe parties shall endeavor to resolve their differences primarily through negotiations. If no amicable settlement is reached, the disputes will be settled in the Helsinki District Court. The consumer customer can also take the dispute to the Consumer Disputes Board for resolution.\n\n13.	Contact\n\nIf you have any questions about these Terms of Use or the Application, please contact:\n\nWeAre Solutions Oy\nÄyritie 12C\n01510 Vantaa\nFinland\ninfo@reapptor-apps.fi\nBusiness ID 2976585-9` }, { l: `en`, v: `1	Common\n\nThe Athenaeum Application Template Application (the “Application”) is owned and provided by WeAre Solutions Oy (“WeAre”).\n\nBy installing the Application and / or using the Application, the Registered Customer or the Unregistered User agrees to these Terms of Use (the "Terms of Use"). If the Registered Customer or the Unregistered User does not accept these Terms of Use, the Registered Customer or the Unregistered User does not have the right to install, open or use the application.\n\nWeAre reserves the right to change these Terms of Use at any time without notice. A registered Customer or an Unregistered User shall be deemed to have accepted the updated Terms of Use by using the application after the change to the Terms of Use.\n\n2.	Athenaeum Application Template application\n\nThe application is for WeAren Employees (Registered Users) and Registered Customers. It is possible to use the application either as an employee of WeAre (Registered User) or alternatively as a registered Customer with a customer-specific license ("Registered Customer").\n\n2.1	Registered Customers.\nRegistering as a Customer requires an existing customer relationship with WeAre. WeAre has the right not to accept the registration and to revoke the license of the application.\n\nThe Registered Customer has the opportunity to view and approve work reports and invoicing for his construction sites through the application.\n\n2.2	Registered Users\nRegistration for the Application requires an existing employment relationship with WeAre. WeAre has the right not to accept the registration and to revoke the license of the application.\n\nThe Registered User has the opportunity to perform the actions required for work control through the application.\n\nTo ensure the proper operation of the application, the Registered Customer and the Registered User must ensure that they have the latest version of the application.\n\n3.	Product range and price list\n\nThe product range presented in the application corresponds to WeAre's normal product range. Product range, product availability and price information may vary from location to location. Prices do not include VAT unless stated otherwise. VAT will be added to the rates upon invoicing.\n\nCustomer-specific price information for contract customers is presented in the Application. The presentation of prices may be limited by access rights.\n\nWeAre is not responsible for any errors, omissions or other defects in the price and product information or other material presented in the Application.\n\n4.	Customer-Specific Work Reports\n\n4.1	Generation of a customer-specific work report\nThe work performed by the Registered Users on behalf of the customer forms a work report for the system.\n\n4.2	Processing a customer-specific work report\nThe Registered Customer has the opportunity to view the work reports concerning him or her and to accept and reject the work reports of the work performed. WeAre has the right to invoice the work in accordance with the approved work report.\n\n5.	Customer-specific invoices\n\n5.1	Viewing Customer-Specific Invoices\nIt is possible for a registered Customer to view invoices concerning him in the application. Any incorrect invoices must be reclamed in accordance with WeAre's instructions.\n\n6.	Intellectual Property Rights\n\nThe application and its content, including e.g. trademarks, trade names, product information and images are the property of WeAre and / or its partners, which are protected by e.g. copyright law and international intellectual property agreements. All rights to the Application and its content are reserved. It is expressly stated that the Registered Customer or the Registered User may not sublicense, rent, transfer or otherwise distribute the Application or its rights to use the Application except as permitted in these Terms of Use.\n\nThe Registered Customer or the Registered User shall not have the right to change, modify, delete, copy, publish, make available to the public or transfer any intellectual property rights. Your right to use the application is limited to your use in accordance with these Terms of Use.\n\n7.	Permissions and access rights\n\nThe Registered Customer accepts as binding all measures taken through the Application with the registered Customer's credentials or by or on behalf of the Registered Customer. The use of Registered Customer credentials in the Application corresponds to the Registered Customer's signature.\n\nThe Registered Customer is obliged to keep the credentials carefully stored. If the Registered Customer suspects that the credentials have been forced to possession of a third party, the Registered Customer shall immediately inform the contact person of WeAre about the situation. The contact person deletes the old credentials and opens the new ones. The Registered Customer is responsible for all orders placed with his / her username and for any damages that may result from compromising the credentials.\n\n8.	WeAren's responsibility\n\nThe application and its contents are provided to the Registered Customer and the Registered User “as is”. WeAre is not responsible for any errors, omissions or other defects in the content transmitted in the Application. WeAre does not guarantee the availability of the Application or its uninterrupted or error-free operation. WeAre shall not be liable for any costs, losses or other possible direct or indirect damages that may arise from the use of this Application, the information provided in the Application or the non-availability of the Application, subject to mandatory legislation. In any case, WeAre's liability is limited to a maximum amount corresponding to the agreed rental equipment rental and / or service price.\n\n9.	Cookies\n\nWeAre uses cookies in the Application (so-called cookie function). A cookie is a text file stored in the user's browser when using the Application. For example, cookies make it possible to monitor the number of users of the Application and to collect information on how and when the Application is used.\n\nThe Registered Customer and the Unregistered User can disable the use of cookies in their browser settings. For more information on browser-specific instructions, contact your browser developer. WeAre recommends the use of cookies in the Application in order to obtain the best possible user experience.\n\n10.	Third Party Services\n\nThe application may contain links to sites owned or operated by third parties. WeAre is not responsible for the operation, content, direct or indirect damages or other features of such third party sites. By accessing these pages, the user must accept the terms of use of these pages and the Privacy Statement before using them.\n\n11.	Processing of personal data\n\nWeAre processes and collects the personal data of Registered Customers in order to implement the services and to maintain and develop customer relationships. WeAre's privacy statement describes the processing of personal data in more detail: https://www.weare.fi/en/privacy-policy-and-cookies\n\nThe personal data of unregistered Users will not be collected.\n\n12.	Other Terms\n\nWeAre's valid rental terms apply to machine rental and services. The terms and conditions of the annual contracts are complied with with the customers of the annual contracts. The customer agrees to the delivery terms valid for each order.\n\nWeAre may change, update, cancel or delete the Application, the contents of the Application or portions thereof at its sole discretion. The Registered Customer or the Registered User must stop using the Application if the Registered Customer or the Registered User does not accept the changes in the Terms of Use of the Application or the privacy statement.\n\nThe Registered Customer and the Unregistered User must use the Application in accordance with the terms of use of the application store from which they have acquired the Application. In all cases, the Registered Customer and the Registered User shall be liable for damages caused by his / her compliance with these Terms of Use.\n\nThe Registered Customer and the Registered User are responsible for the accuracy of the information they provide, for the careful storage of their username and password, and for the proper security of their equipment. The Registered Customer and the Registered User are responsible for all transactions in the Application with their credentials.\n\nThe use of the service and these terms and conditions are governed by Finnish law, except for its choice of law provisions.\n\nThe parties shall endeavor to resolve their differences primarily through negotiations. If no amicable settlement is reached, the disputes will be settled in the Helsinki District Court. The consumer customer can also take the dispute to the Consumer Disputes Board for resolution.\n\n13.	Contact\n\nIf you have any questions about these Terms of Use or the Application, please contact:\n\nWeAre Solutions Oy\nÄyritie 12C\n01510 Vantaa\nFinland\ninfo@reapptor-apps.fi\nBusiness ID 2976585-9` }, { l: `da`, v: `1	Common\n\nThe Athenaeum Application Template Application (the “Application”) is owned and provided by WeAre Solutions Oy (“WeAre”).\n\nBy installing the Application and / or using the Application, the Registered Customer or the Unregistered User agrees to these Terms of Use (the "Terms of Use"). If the Registered Customer or the Unregistered User does not accept these Terms of Use, the Registered Customer or the Unregistered User does not have the right to install, open or use the application.\n\nWeAre reserves the right to change these Terms of Use at any time without notice. A registered Customer or an Unregistered User shall be deemed to have accepted the updated Terms of Use by using the application after the change to the Terms of Use.\n\n2.	Athenaeum Application Template application\n\nThe application is for WeAren Employees (Registered Users) and Registered Customers. It is possible to use the application either as an employee of WeAre (Registered User) or alternatively as a registered Customer with a customer-specific license ("Registered Customer").\n\n2.1	Registered Customers.\nRegistering as a Customer requires an existing customer relationship with WeAre. WeAre has the right not to accept the registration and to revoke the license of the application.\n\nThe Registered Customer has the opportunity to view and approve work reports and invoicing for his construction sites through the application.\n\n2.2	Registered Users\nRegistration for the Application requires an existing employment relationship with WeAre. WeAre has the right not to accept the registration and to revoke the license of the application.\n\nThe Registered User has the opportunity to perform the actions required for work control through the application.\n\nTo ensure the proper operation of the application, the Registered Customer and the Registered User must ensure that they have the latest version of the application.\n\n3.	Product range and price list\n\nThe product range presented in the application corresponds to WeAre's normal product range. Product range, product availability and price information may vary from location to location. Prices do not include VAT unless stated otherwise. VAT will be added to the rates upon invoicing.\n\nCustomer-specific price information for contract customers is presented in the Application. The presentation of prices may be limited by access rights.\n\nWeAre is not responsible for any errors, omissions or other defects in the price and product information or other material presented in the Application.\n\n4.	Customer-Specific Work Reports\n\n4.1	Generation of a customer-specific work report\nThe work performed by the Registered Users on behalf of the customer forms a work report for the system.\n\n4.2	Processing a customer-specific work report\nThe Registered Customer has the opportunity to view the work reports concerning him or her and to accept and reject the work reports of the work performed. WeAre has the right to invoice the work in accordance with the approved work report.\n\n5.	Customer-specific invoices\n\n5.1	Viewing Customer-Specific Invoices\nIt is possible for a registered Customer to view invoices concerning him in the application. Any incorrect invoices must be reclamed in accordance with WeAre's instructions.\n\n6.	Intellectual Property Rights\n\nThe application and its content, including e.g. trademarks, trade names, product information and images are the property of WeAre and / or its partners, which are protected by e.g. copyright law and international intellectual property agreements. All rights to the Application and its content are reserved. It is expressly stated that the Registered Customer or the Registered User may not sublicense, rent, transfer or otherwise distribute the Application or its rights to use the Application except as permitted in these Terms of Use.\n\nThe Registered Customer or the Registered User shall not have the right to change, modify, delete, copy, publish, make available to the public or transfer any intellectual property rights. Your right to use the application is limited to your use in accordance with these Terms of Use.\n\n7.	Permissions and access rights\n\nThe Registered Customer accepts as binding all measures taken through the Application with the registered Customer's credentials or by or on behalf of the Registered Customer. The use of Registered Customer credentials in the Application corresponds to the Registered Customer's signature.\n\nThe Registered Customer is obliged to keep the credentials carefully stored. If the Registered Customer suspects that the credentials have been forced to possession of a third party, the Registered Customer shall immediately inform the contact person of WeAre about the situation. The contact person deletes the old credentials and opens the new ones. The Registered Customer is responsible for all orders placed with his / her username and for any damages that may result from compromising the credentials.\n\n8.	WeAren's responsibility\n\nThe application and its contents are provided to the Registered Customer and the Registered User “as is”. WeAre is not responsible for any errors, omissions or other defects in the content transmitted in the Application. WeAre does not guarantee the availability of the Application or its uninterrupted or error-free operation. WeAre shall not be liable for any costs, losses or other possible direct or indirect damages that may arise from the use of this Application, the information provided in the Application or the non-availability of the Application, subject to mandatory legislation. In any case, WeAre's liability is limited to a maximum amount corresponding to the agreed rental equipment rental and / or service price.\n\n9.	Cookies\n\nWeAre uses cookies in the Application (so-called cookie function). A cookie is a text file stored in the user's browser when using the Application. For example, cookies make it possible to monitor the number of users of the Application and to collect information on how and when the Application is used.\n\nThe Registered Customer and the Unregistered User can disable the use of cookies in their browser settings. For more information on browser-specific instructions, contact your browser developer. WeAre recommends the use of cookies in the Application in order to obtain the best possible user experience.\n\n10.	Third Party Services\n\nThe application may contain links to sites owned or operated by third parties. WeAre is not responsible for the operation, content, direct or indirect damages or other features of such third party sites. By accessing these pages, the user must accept the terms of use of these pages and the Privacy Statement before using them.\n\n11.	Processing of personal data\n\nWeAre processes and collects the personal data of Registered Customers in order to implement the services and to maintain and develop customer relationships. WeAre's privacy statement describes the processing of personal data in more detail: https://www.weare.fi/en/privacy-policy-and-cookies\n\nThe personal data of unregistered Users will not be collected.\n\n12.	Other Terms\n\nWeAre's valid rental terms apply to machine rental and services. The terms and conditions of the annual contracts are complied with with the customers of the annual contracts. The customer agrees to the delivery terms valid for each order.\n\nWeAre may change, update, cancel or delete the Application, the contents of the Application or portions thereof at its sole discretion. The Registered Customer or the Registered User must stop using the Application if the Registered Customer or the Registered User does not accept the changes in the Terms of Use of the Application or the privacy statement.\n\nThe Registered Customer and the Unregistered User must use the Application in accordance with the terms of use of the application store from which they have acquired the Application. In all cases, the Registered Customer and the Registered User shall be liable for damages caused by his / her compliance with these Terms of Use.\n\nThe Registered Customer and the Registered User are responsible for the accuracy of the information they provide, for the careful storage of their username and password, and for the proper security of their equipment. The Registered Customer and the Registered User are responsible for all transactions in the Application with their credentials.\n\nThe use of the service and these terms and conditions are governed by Finnish law, except for its choice of law provisions.\n\nThe parties shall endeavor to resolve their differences primarily through negotiations. If no amicable settlement is reached, the disputes will be settled in the Helsinki District Court. The consumer customer can also take the dispute to the Consumer Disputes Board for resolution.\n\n13.	Contact\n\nIf you have any questions about these Terms of Use or the Application, please contact:\n\nWeAre Solutions Oy\nÄyritie 12C\n01510 Vantaa\nFinland\ninfo@reapptor-apps.fi\nBusiness ID 2976585-9` },);
        this.set(`_39`, { l: `fi`, v: `tietosuojaselosteen` }, { l: `uk`, v: `повідомлення про конфіденційність` }, { l: `sv`, v: `Sekretessmeddelande` }, { l: `ru`, v: `уведомление о конфиденциальности` }, { l: `pl`, v: `PL: privacy notice` }, { l: `nb`, v: `NB: privacy notice` }, { l: `en`, v: `privacy notice` }, { l: `da`, v: `DA: privacy notice` },);
        this.set(`_3A`, { l: `fi`, v: `ATHENAEUM APPLICATION TEMPLATE-SOVELLUKSEN TIETOSUOJASELOSTE` }, { l: `uk`, v: `TEMPLATE - ПОЛІТИКА КОНФІДЕНЦІЙНОСТІ` }, { l: `sv`, v: `ATHENAEUM APPLICATION TEMPLATE - APPLIKATIONENS SEKRETESSMEDDELANDE` }, { l: `ru`, v: `TEMPLATE - ПОЛИТИКА КОНФИДЕНЦИАЛЬНОСТИ` }, { l: `pl`, v: `PL: ATHENAEUM APPLICATION TEMPLATE-APPLICATIONS PRIVACY POLICY` }, { l: `nb`, v: `NB: TEMPLATE-APPLICATIONS PRIVACY POLICY` }, { l: `en`, v: `TEMPLATE-APPLICATIONS PRIVACY POLICY` }, { l: `da`, v: `DA: TEMPLATE-APPLICATIONS PRIVACY POLICY` },);
        this.set(`_3B`, { l: `fi`, v: `\nHenkilötietolaki 22.4.1999/523 10 ja 24 §\nLaadittu: 16.10.2019\n\n1.	Rekisterinpitäjä\nWeAre Solutions Oy\nY-tunnus: 2976585-9\nOsoite: Äyritie 12C, 01510 Vantaa Suomi\n\n2.	Rekisteriasioista vastaava henkilö ja/tai yhteyshenkilö\nTietohallintojohtaja Henri Vass\nPuhelinnumero: +358 45 138 1927 Sähköposti: henri.vass@reapptor-apps.fi\n\n3.	Rekisterin nimi\nWeAre Solutions Oy:n Athenaeum Application Template -sovelluksen käyttäjärekisteri.\n\n4.	Henkilötietojen käsittelyn tarkoitus\nWeAre Solutions Oy ja sen tytäryhtiöt käsittelevät henkilötietoja henkilön tunnistamisteen palvelussa, luottotietojen tarkastukseen, suoramarkkinointiin, asiakasviestintään, työsuhteen vaatimusten täyttämiseksi sekä laskutuksen ja henkilökohtaisen asiakaspalvelun mahdollistamiseen.\n\nLisäksi rekisterin sisältäminen henkilötietojen käsittely mahdollistaa palveluun kirjautumisen, palvelun tilaamisen ja sen tuottamisen sekä palvelun kehittämisen.\n\n5.	Rekisterin tietosisältö\nRekisterissä voidaan käsitellä seuraavia tietoja:\n•	Rekisteröidyn perustiedot\n        o	nimi\n        o	henkilötunnus\n        o	postiosoite\n        o	puhelinnumero\n        o	sähköpostiosoite\n        o	Asema yrityksessä\n        o	Rekisteröidyn suostumus suoramarkkinointiin\n        o	Yrityksen tiedot\n•	Asiakuuteen liittyvät tiedot\n        o	palveluhistoria\n        o	luottotietomerkinnät\n        o	muut asiakkaan syöttämät merkinnät\n•	Teknisen tiedot\n        o	Sijaintitiedot\n        o	IP-osoite\n        o	Laitteen tunnistetiedot\n        o	mainonta-ID\n        o	käyttöjärjestelmä\n        o	selaintyyppi\n        o	muita yksityiskohtia laitteistosta\n\n6.	Säännönmukaiset tietolähteet\nHenkilötietoja kerätään rekisteröidyltä itseltään sekä Intrum luottotietopalvelun kautta.\n\n7.	Säännönmukaiset tietojen luovutukset ja tietojen siirto EU:n tai Euroopan talousalueen ulkopuolelle\nTietoja ei luovuteta EU:n tai ETA-alueen ulkopuolelle.\n\n8.	Evästeiden käyttö verkkopalvelussa\nKäytämme verkkopalvelussa evästeitä. Eväste on pieni, käyttäjän tietokoneelle tallennettava tekstitiedosto, joka mahdollistaa palvelun turvallisen, tehokkaan ja käyttäjäystävällisen käytön.\n\nEvästeiden poiskytkeminen sekä poistaminen ovat mahdollisia selaimen asetuksissa.\n\n9.	Rekisterin suojauksen periaatteet\nRekisterin sisältämät henkilötiedot käsitellään aina luottamuksellisina. Rekisterin sisältämien tietojen käsittelyn periaatteet ovat tietoja käsittelevissä organisaatioissa ohjeistettu ja dokumentoitu.\n\nTietojärjestelmä on suojattu palomuurilla.\n\nVerkkosivustolla tietojen siirto suojataan SSL-suojatulla yhteydellä.\n\n10.	Rekisteröidyn kielto-oikeus\nRekisteröidyllä on oikeus kieltää rekisterinpitäjää käsittelemästä häntä itseään koskevia tietoja suoramainontaa, etämyyntiä ja muuta suoramarkkinointia sekä markkina- ja mielipidetutkimusta samoin kuin henkilömatrikkelia ja sukututkimusta varten. Kielto voidaan asettaa mobiilisovelluksen tai asiakasportaalin kautta.\n\n11.	Rekisteröidyn tarkastusoikeus\nRekisteröidyllä on oikeus tarkastaa rekisteriin tallennetut itseään koskevat tiedot ja saada niistä kopiot ilmaiseksi enintään kerran vuodessa.\n\nTarkastuspyyntö tulee tehdä sähköpostitse sellaisesta sähköpostiosoitteesta, joka voidaan rekisterin avulla varmistaa kuuluvan rekisteröidylle.\n\n12.	Tiedon korjaaminen\nRekisterinpitäjä oikaisee, poistaa tai täydentää rekisterissä olevan, käsittelyn tarkoituksen kannalta virheellisen, tarpeettoman, puutteellisen tai vanhentuneen henkilötiedon oma-aloitteisesti tai rekisteröidyn vaatimuksesta. Lisäksi henkilötietoja voidaan poistaa, mikäli asiakas väärinkäyttää palvelua tai harjoittaa palvelun avulla rikollista tai muuta kiellettyä toimintaa.` }, { l: `uk`, v: `Разделы 10 и 24 Закона о персональных данных 22.4.1999 / 523\nПодготовлено: 16.10.2019\n\n1.Регистратор\nWeAre Solutions Oy\nКод компании: 2976585-9\nАдрес: Äyritie 12C, 01510 Вантаа, Финляндия.\n\n2. Лицо, ответственное за регистрацию, и / или контактное лицо\nГенеральный директор Анри Васс\nТелефон: +358 45 138 1927\nПочта: henri.vass@reapptor-apps.fi\n\n3. Название реестра\nРеестр пользователей приложения Athenaeum Application Template от We Are Solutions Oy.\n\n4. Цель обработки персональных данных\nWeAre Solutions Oy и его дочерние компании обрабатывают персональные данные в службе личной идентификации, проверки кредитной информации, прямого маркетинга, общения с клиентами, чтобы соответствовать требованиям к трудоустройству, а также для выставления счетов и персонального обслуживания клиентов.\n\nКроме того, включение реестра в обработку персональных данных позволяет выполнять вход в службу, заказывать и производить услугу, а также развивать услугу.\n\n5. Информационное содержание реестра.\nВ реестре может обрабатываться следующая информация:\n• Основная информация о субъекте данных\n        о имя\n        o личный идентификационный номер\n        o почтовый адрес\n        o номер телефона\n        o адрес электронной почты\n        o Должность в компании\n        o Согласие данных, подлежащих прямому маркетингу\n•        Информация о компании\n        o информация о клиентах\n        o история обслуживания\n        o записи кредитных данных\n        o другие записи, введенные заказчиком\n•        Техническая информация\n        o информация о местонахождении\n        o IP-адрес\n        o Идентификация устройства\n        o рекламный идентификатор\n        o операционная система\n        o тип браузера\n        o другие детали оборудования\n\n6. Регулярные источники информации\nЛичная информация собирается от самого регистранта и через службу кредитной информации Intrum.\n\n7. Регулярная передача данных и передача данных за пределы ЕС или Европейской экономической зоны.\nДанные не будут разглашаться за пределами ЕС или ЕЭЗ.\n\n8. Использование файлов cookie в онлайн-сервисе.\nМы используем файлы cookie в онлайн-сервисе. Файл cookie - это небольшой текстовый файл, хранящийся на компьютере пользователя, который обеспечивает безопасное, эффективное и удобное использование службы.\n\nВы можете отключить и удалить файлы cookie в настройках своего браузера.\n\n9. Принципы безопасности реестра.\nПерсональные данные, содержащиеся в реестре, всегда будут считаться конфиденциальными. Принципы обработки данных, содержащихся в реестре, проинструктированы и задокументированы в организациях, обрабатывающих данные.\n\nИнформационная система защищена межсетевым экраном.\n\nНа веб-сайте передача данных защищена SSL-защищенным соединением.\n\n10. Право на запрет субъекта данных\nСубъект данных имеет право запретить контролеру обрабатывать относящиеся к нему персональные данные для прямой почтовой рассылки, дистанционных продаж и другого прямого маркетинга, а также для исследования рынка и общественного мнения, а также для личной регистрации и генеалогии. Запрет можно установить через мобильное приложение или клиентский портал.\n\n11. Право проверки субъекта данных\nСубъект данных имеет право проверять личные данные, хранящиеся в реестре, и получать их копии бесплатно до одного раза в год.\n\nЗапрос на подтверждение должен быть отправлен по электронной почте с адреса электронной почты, который может быть проверен регистром на принадлежность к субъекту данных.\n\n12. Исправление информации.\nКонтроллер исправляет, удаляет или дополняет персональные данные в реестре, которые являются неверными, ненужными, неполными или устаревшими, с целью обработки по собственной инициативе или по запросу субъекта данных. Кроме того, личные данные могут быть удалены, если клиент злоупотребляет сервисом или участвует в преступных или других запрещенных действиях с использованием сервиса.` }, { l: `sv`, v: `\n\nSections 10 and 24 of the Personal Data Act 22.4.1999 / 523\nPrepared: 16.10.2019\n\n1.	The Registrar\nWeAre Solutions Oy\nBusiness ID: 2976585-9\nAddress: Äyritie 12C, 01510 Vantaa Finland\n\n2.	The person responsible for registration and / or the contact person\nCEO Henri Vass\nPhone number: +358 45 138 1927\nEmail: henri.vass@reapptor-apps.fi\n\n3.	Name of the register\nUser register of WeAre Solutions Oy's Athenaeum Application Template application.\n\n4.	Purpose of the processing of personal data\nWeAre Solutions Oy and its subsidiaries process personal data in the personal identification service, credit information verification, direct marketing, customer communications, to meet employment requirements, and to enable invoicing and personal customer service.\n\nIn addition, the inclusion of the register in the processing of personal data enables logging in to the service, ordering and producing the service, and developing the service.\n\n5.	Information content of the register\nThe following information can be processed in the register:\n•	Basic information of the data subject\n        o	name\n        o	personal identification number\n        o	mail address\n        o	phone number\n        o	e-mail address\n        o	Position in the company\n        o	Consent of the data subject to direct marketing\n•	Company information\n        o	customer related information\n        o	service history\n        o	credit data entries\n        o	 other entries entered by the customer\n•	Technical information\n        o	location information\n        o	IP address\n        o	Device identification\n        o	advertising ID\n        o	operating system\n        o	browser type\n        o	other hardware details\n\n6. Regular sources of information\nPersonal information is collected from the registrant himself and through the Intrum credit information service.\n\n7. Regular data transfers and data transfers outside the EU or the European Economic Area\nThe data will not be disclosed outside the EU or the EEA.\n\n8. Use of cookies in the online service\nWe use cookies in the online service. A cookie is a small text file stored on a user's computer that enables safe, efficient and user-friendly use of the service.\n\nYou can disable and delete cookies in your browser settings.\n\n9. Registry Security Principles\nThe personal data contained in the register will always be treated as confidential. The principles of processing the data contained in the register are instructed and documented in the organizations processing the data.\n\nThe information system is protected by a firewall.\n\nOn the website, data transfer is secured with an SSL-secured connection.\n\n10. Right of prohibition of the data subject\nThe data subject shall have the right to prohibit the controller from processing personal data concerning him or her for direct mail, distance selling and other direct marketing, as well as for market and opinion research, as well as for personal registration and genealogy. The ban can be set via the mobile application or the customer portal.\n\n11. Right of inspection of the data subject\nThe data subject has the right to inspect the personal data stored in the register and to receive copies of it free of charge up to once a year.\n\nThe request for verification must be made by e-mail from an e-mail address that can be verified by the register to belong to the data subject.\n\n12. Correction of information\nThe controller shall correct, delete or supplement personal data in the register that are incorrect, unnecessary, incomplete or out of date for the purpose of processing on its own initiative or at the request of the data subject. In addition, personal data may be deleted if the customer misuses the service or engages in criminal or other prohibited activities using the service.` }, { l: `ru`, v: `Разделы 10 и 24 Закона о персональных данных 22.4.1999 / 523\nПодготовлено: 16.10.2019\n\n1.Регистратор\nWeAre Solutions Oy\nКод компании: 2976585-9\nАдрес: Äyritie 12C, 01510 Вантаа, Финляндия.\n\n2. Лицо, ответственное за регистрацию, и / или контактное лицо\nГенеральный директор Анри Васс\nТелефон: +358 45 138 1927\nПочта: henri.vass@reapptor-apps.fi\n\n3. Название реестра\nРеестр пользователей приложения Athenaeum Application Template от We Are Solutions Oy.\n\n4. Цель обработки персональных данных\nWeAre Solutions Oy и его дочерние компании обрабатывают персональные данные в службе личной идентификации, проверки кредитной информации, прямого маркетинга, общения с клиентами, чтобы соответствовать требованиям к трудоустройству, а также для выставления счетов и персонального обслуживания клиентов.\n\nКроме того, включение реестра в обработку персональных данных позволяет выполнять вход в службу, заказывать и производить услугу, а также развивать услугу.\n\n5. Информационное содержание реестра.\nВ реестре может обрабатываться следующая информация:\n• Основная информация о субъекте данных\n        о имя\n        o личный идентификационный номер\n        o почтовый адрес\n        o номер телефона\n        o адрес электронной почты\n        o Должность в компании\n        o Согласие данных, подлежащих прямому маркетингу\n•        Информация о компании\n        o информация о клиентах\n        o история обслуживания\n        o записи кредитных данных\n        o другие записи, введенные заказчиком\n•        Техническая информация\n        o информация о местонахождении\n        o IP-адрес\n        o Идентификация устройства\n        o рекламный идентификатор\n        o операционная система\n        o тип браузера\n        o другие детали оборудования\n\n6. Регулярные источники информации\nЛичная информация собирается от самого регистранта и через службу кредитной информации Intrum.\n\n7. Регулярная передача данных и передача данных за пределы ЕС или Европейской экономической зоны.\nДанные не будут разглашаться за пределами ЕС или ЕЭЗ.\n\n8. Использование файлов cookie в онлайн-сервисе.\nМы используем файлы cookie в онлайн-сервисе. Файл cookie - это небольшой текстовый файл, хранящийся на компьютере пользователя, который обеспечивает безопасное, эффективное и удобное использование службы.\n\nВы можете отключить и удалить файлы cookie в настройках своего браузера.\n\n9. Принципы безопасности реестра.\nПерсональные данные, содержащиеся в реестре, всегда будут считаться конфиденциальными. Принципы обработки данных, содержащихся в реестре, проинструктированы и задокументированы в организациях, обрабатывающих данные.\n\nИнформационная система защищена межсетевым экраном.\n\nНа веб-сайте передача данных защищена SSL-защищенным соединением.\n\n10. Право на запрет субъекта данных\nСубъект данных имеет право запретить контролеру обрабатывать относящиеся к нему персональные данные для прямой почтовой рассылки, дистанционных продаж и другого прямого маркетинга, а также для исследования рынка и общественного мнения, а также для личной регистрации и генеалогии. Запрет можно установить через мобильное приложение или клиентский портал.\n\n11. Право проверки субъекта данных\nСубъект данных имеет право проверять личные данные, хранящиеся в реестре, и получать их копии бесплатно до одного раза в год.\n\nЗапрос на подтверждение должен быть отправлен по электронной почте с адреса электронной почты, который может быть проверен регистром на принадлежность к субъекту данных.\n\n12. Исправление информации.\nКонтроллер исправляет, удаляет или дополняет персональные данные в реестре, которые являются неверными, ненужными, неполными или устаревшими, с целью обработки по собственной инициативе или по запросу субъекта данных. Кроме того, личные данные могут быть удалены, если клиент злоупотребляет сервисом или участвует в преступных или других запрещенных действиях с использованием сервиса.` }, { l: `pl`, v: `PL:\n\nSections 10 and 24 of the Personal Data Act 22.4.1999 / 523\nPrepared: 16.10.2019\n\n1.	The Registrar\nWeAre Solutions Oy\nBusiness ID: 2976585-9\nAddress: Äyritie 12C, 01510 Vantaa Finland\n\n2.	The person responsible for registration and / or the contact person\nCEO Henri Vass\nPhone number: +358 45 138 1927\nEmail: henri.vass@reapptor-apps.fi\n\n3.	Name of the register\nUser register of WeAre Solutions Oy's Athenaeum Application Template application.\n\n4.	Purpose of the processing of personal data\nWeAre Solutions Oy and its subsidiaries process personal data in the personal identification service, credit information verification, direct marketing, customer communications, to meet employment requirements, and to enable invoicing and personal customer service.\n\nIn addition, the inclusion of the register in the processing of personal data enables logging in to the service, ordering and producing the service, and developing the service.\n\n5.	Information content of the register\nThe following information can be processed in the register:\n•	Basic information of the data subject\n        o	name\n        o	personal identification number\n        o	mail address\n        o	phone number\n        o	e-mail address\n        o	Position in the company\n        o	Consent of the data subject to direct marketing\n•	Company information\n        o	customer related information\n        o	service history\n        o	credit data entries\n        o	 other entries entered by the customer\n•	Technical information\n        o	location information\n        o	IP address\n        o	Device identification\n        o	advertising ID\n        o	operating system\n        o	browser type\n        o	other hardware details\n\n6. Regular sources of information\nPersonal information is collected from the registrant himself and through the Intrum credit information service.\n\n7. Regular data transfers and data transfers outside the EU or the European Economic Area\nThe data will not be disclosed outside the EU or the EEA.\n\n8. Use of cookies in the online service\nWe use cookies in the online service. A cookie is a small text file stored on a user's computer that enables safe, efficient and user-friendly use of the service.\n\nYou can disable and delete cookies in your browser settings.\n\n9. Registry Security Principles\nThe personal data contained in the register will always be treated as confidential. The principles of processing the data contained in the register are instructed and documented in the organizations processing the data.\n\nThe information system is protected by a firewall.\n\nOn the website, data transfer is secured with an SSL-secured connection.\n\n10. Right of prohibition of the data subject\nThe data subject shall have the right to prohibit the controller from processing personal data concerning him or her for direct mail, distance selling and other direct marketing, as well as for market and opinion research, as well as for personal registration and genealogy. The ban can be set via the mobile application or the customer portal.\n\n11. Right of inspection of the data subject\nThe data subject has the right to inspect the personal data stored in the register and to receive copies of it free of charge up to once a year.\n\nThe request for verification must be made by e-mail from an e-mail address that can be verified by the register to belong to the data subject.\n\n12. Correction of information\nThe controller shall correct, delete or supplement personal data in the register that are incorrect, unnecessary, incomplete or out of date for the purpose of processing on its own initiative or at the request of the data subject. In addition, personal data may be deleted if the customer misuses the service or engages in criminal or other prohibited activities using the service.` }, { l: `nb`, v: `NB: Sections 10 and 24 of the Personal Data Act 22.4.1999 / 523\nPrepared: 16.10.2019\n\n1.	The Registrar\nWeAre Solutions Oy\nBusiness ID: 2976585-9\nAddress: Äyritie 12C, 01510 Vantaa Finland\n\n2.	The person responsible for registration and / or the contact person\nCEO Henri Vass\nPhone number: +358 45 138 1927\nEmail: henri.vass@reapptor-apps.fi\n\n3.	Name of the register\nUser register of We Are Solutions Oy's Athenaeum Application Template application.\n\n4.	Purpose of the processing of personal data\nWeAre Solutions Oy and its subsidiaries process personal data in the personal identification service, credit information verification, direct marketing, customer communications, to meet employment requirements, and to enable invoicing and personal customer service.\n\nIn addition, the inclusion of the register in the processing of personal data enables logging in to the service, ordering and producing the service, and developing the service.\n\n5.	Information content of the register\nThe following information can be processed in the register:\n•	Basic information of the data subject\n        o	name\n        o	personal identification number\n        o	mail address\n        o	phone number\n        o	e-mail address\n        o	Position in the company\n        o	Consent of the data subject to direct marketing\n•	Company information\n        o	customer related information\n        o	service history\n        o	credit data entries\n        o	 other entries entered by the customer\n•	Technical information\n        o	location information\n        o	IP address\n        o	Device identification\n        o	advertising ID\n        o	operating system\n        o	browser type\n        o	other hardware details\n\n6. Regular sources of information\nPersonal information is collected from the registrant himself and through the Intrum credit information service.\n\n7. Regular data transfers and data transfers outside the EU or the European Economic Area\nThe data will not be disclosed outside the EU or the EEA.\n\n8. Use of cookies in the online service\nWe use cookies in the online service. A cookie is a small text file stored on a user's computer that enables safe, efficient and user-friendly use of the service.\n\nYou can disable and delete cookies in your browser settings.\n\n9. Registry Security Principles\nThe personal data contained in the register will always be treated as confidential. The principles of processing the data contained in the register are instructed and documented in the organizations processing the data.\n\nThe information system is protected by a firewall.\n\nOn the website, data transfer is secured with an SSL-secured connection.\n\n10. Right of prohibition of the data subject\nThe data subject shall have the right to prohibit the controller from processing personal data concerning him or her for direct mail, distance selling and other direct marketing, as well as for market and opinion research, as well as for personal registration and genealogy. The ban can be set via the mobile application or the customer portal.\n\n11. Right of inspection of the data subject\nThe data subject has the right to inspect the personal data stored in the register and to receive copies of it free of charge up to once a year.\n\nThe request for verification must be made by e-mail from an e-mail address that can be verified by the register to belong to the data subject.\n\n12. Correction of information\nThe controller shall correct, delete or supplement personal data in the register that are incorrect, unnecessary, incomplete or out of date for the purpose of processing on its own initiative or at the request of the data subject. In addition, personal data may be deleted if the customer misuses the service or engages in criminal or other prohibited activities using the service.` }, { l: `en`, v: `Sections 10 and 24 of the Personal Data Act 22.4.1999 / 523\nPrepared: 16.10.2019\n\n1.	The Registrar\nWeAre Solutions Oy\nBusiness ID: 2976585-9\nAddress: Äyritie 12C, 01510 Vantaa Finland\n\n2.	The person responsible for registration and / or the contact person\nCEO Henri Vass\nPhone number: +358 45 138 1927\nEmail: henri.vass@reapptor-apps.fi\n\n3.	Name of the register\nUser register of We Are Solutions Oy's Athenaeum Application Template application.\n\n4.	Purpose of the processing of personal data\nWeAre Solutions Oy and its subsidiaries process personal data in the personal identification service, credit information verification, direct marketing, customer communications, to meet employment requirements, and to enable invoicing and personal customer service.\n\nIn addition, the inclusion of the register in the processing of personal data enables logging in to the service, ordering and producing the service, and developing the service.\n\n5.	Information content of the register\nThe following information can be processed in the register:\n•	Basic information of the data subject\n        o	name\n        o	personal identification number\n        o	mail address\n        o	phone number\n        o	e-mail address\n        o	Position in the company\n        o	Consent of the data subject to direct marketing\n•	Company information\n        o	customer related information\n        o	service history\n        o	credit data entries\n        o	 other entries entered by the customer\n•	Technical information\n        o	location information\n        o	IP address\n        o	Device identification\n        o	advertising ID\n        o	operating system\n        o	browser type\n        o	other hardware details\n\n6. Regular sources of information\nPersonal information is collected from the registrant himself and through the Intrum credit information service.\n\n7. Regular data transfers and data transfers outside the EU or the European Economic Area\nThe data will not be disclosed outside the EU or the EEA.\n\n8. Use of cookies in the online service\nWe use cookies in the online service. A cookie is a small text file stored on a user's computer that enables safe, efficient and user-friendly use of the service.\n\nYou can disable and delete cookies in your browser settings.\n\n9. Registry Security Principles\nThe personal data contained in the register will always be treated as confidential. The principles of processing the data contained in the register are instructed and documented in the organizations processing the data.\n\nThe information system is protected by a firewall.\n\nOn the website, data transfer is secured with an SSL-secured connection.\n\n10. Right of prohibition of the data subject\nThe data subject shall have the right to prohibit the controller from processing personal data concerning him or her for direct mail, distance selling and other direct marketing, as well as for market and opinion research, as well as for personal registration and genealogy. The ban can be set via the mobile application or the customer portal.\n\n11. Right of inspection of the data subject\nThe data subject has the right to inspect the personal data stored in the register and to receive copies of it free of charge up to once a year.\n\nThe request for verification must be made by e-mail from an e-mail address that can be verified by the register to belong to the data subject.\n\n12. Correction of information\nThe controller shall correct, delete or supplement personal data in the register that are incorrect, unnecessary, incomplete or out of date for the purpose of processing on its own initiative or at the request of the data subject. In addition, personal data may be deleted if the customer misuses the service or engages in criminal or other prohibited activities using the service.` }, { l: `da`, v: `Sections 10 and 24 of the Personal Data Act 22.4.1999 / 523\nPrepared: 16.10.2019\n\n1.	The Registrar\nWeAre Solutions Oy\nBusiness ID: 2976585-9\nAddress: Äyritie 12C, 01510 Vantaa Finland\n\n2.	The person responsible for registration and / or the contact person\nCEO Henri Vass\nPhone number: +358 45 138 1927\nEmail: henri.vass@reapptor-apps.fi\n\n3.	Name of the register\nUser register of We Are Solutions Oy's Athenaeum Application Template application.\n\n4.	Purpose of the processing of personal data\nWeAre Solutions Oy and its subsidiaries process personal data in the personal identification service, credit information verification, direct marketing, customer communications, to meet employment requirements, and to enable invoicing and personal customer service.\n\nIn addition, the inclusion of the register in the processing of personal data enables logging in to the service, ordering and producing the service, and developing the service.\n\n5.	Information content of the register\nThe following information can be processed in the register:\n•	Basic information of the data subject\n        o	name\n        o	personal identification number\n        o	mail address\n        o	phone number\n        o	e-mail address\n        o	Position in the company\n        o	Consent of the data subject to direct marketing\n•	Company information\n        o	customer related information\n        o	service history\n        o	credit data entries\n        o	 other entries entered by the customer\n•	Technical information\n        o	location information\n        o	IP address\n        o	Device identification\n        o	advertising ID\n        o	operating system\n        o	browser type\n        o	other hardware details\n\n6. Regular sources of information\nPersonal information is collected from the registrant himself and through the Intrum credit information service.\n\n7. Regular data transfers and data transfers outside the EU or the European Economic Area\nThe data will not be disclosed outside the EU or the EEA.\n\n8. Use of cookies in the online service\nWe use cookies in the online service. A cookie is a small text file stored on a user's computer that enables safe, efficient and user-friendly use of the service.\n\nYou can disable and delete cookies in your browser settings.\n\n9. Registry Security Principles\nThe personal data contained in the register will always be treated as confidential. The principles of processing the data contained in the register are instructed and documented in the organizations processing the data.\n\nThe information system is protected by a firewall.\n\nOn the website, data transfer is secured with an SSL-secured connection.\n\n10. Right of prohibition of the data subject\nThe data subject shall have the right to prohibit the controller from processing personal data concerning him or her for direct mail, distance selling and other direct marketing, as well as for market and opinion research, as well as for personal registration and genealogy. The ban can be set via the mobile application or the customer portal.\n\n11. Right of inspection of the data subject\nThe data subject has the right to inspect the personal data stored in the register and to receive copies of it free of charge up to once a year.\n\nThe request for verification must be made by e-mail from an e-mail address that can be verified by the register to belong to the data subject.\n\n12. Correction of information\nThe controller shall correct, delete or supplement personal data in the register that are incorrect, unnecessary, incomplete or out of date for the purpose of processing on its own initiative or at the request of the data subject. In addition, personal data may be deleted if the customer misuses the service or engages in criminal or other prohibited activities using the service.` },);
        this.set(`_3C`, { l: `fi`, v: `Käyttäjä, jolla on sama sähköposti- tai puhelinnumero, on jo olemassa.` }, { l: `uk`, v: `Користувач із такою самою адресою електронної пошти або номером телефону вже існує.` }, { l: `sv`, v: `Användare med samma e-post eller telefonnummer existerar redan` }, { l: `ru`, v: `Пользователь с таким же адресом электронной почты или номером телефона уже существует.` }, { l: `pl`, v: `PL: User with same email or phone number already exists.` }, { l: `nb`, v: `NB: User with same email or phone number already exists.` }, { l: `en`, v: `User with same email or phone number already exists.` }, { l: `da`, v: `DA: User with same email or phone number already exists.` },);
        this.set(`_3D`, { l: `fi`, v: `Kirjautuminen epäonnistui, käyttäjää ei löydy.` }, { l: `uk`, v: `Неможливо увійти, користувач не знайдено.` }, { l: `sv`, v: `Inloggningen misslyckades, avändaren hittades inte.` }, { l: `ru`, v: `Не удалось войти, пользователь не найден.` }, { l: `pl`, v: `PL: Login failed, user not found.` }, { l: `nb`, v: `NB: Login failed, user not found.` }, { l: `en`, v: `Login failed, user not found.` }, { l: `da`, v: `DA: Login failed, user not found.` },);
        this.set(`_3E`, { l: `fi`, v: `Kirjautuminen epäonnistui, ota yhteyttä asiakaspalveluun.` }, { l: `uk`, v: `Не вдалося увійти, зверніться до служби підтримки для вирішення цієї проблеми.` }, { l: `sv`, v: `Inloggningen misslyckades, kontakta kundtjänsten.` }, { l: `ru`, v: `Не удалось войти, обратитесь в службу поддержки для решения данной проблемы.` }, { l: `pl`, v: `PL: Login failed, contact support to solve the issue.` }, { l: `nb`, v: `NB: Login failed, contact support to solve the issue.` }, { l: `en`, v: `Login failed, contact support to solve the issue.` }, { l: `da`, v: `DA: Login failed, contact support to solve the issue.` },);
        this.set(`_3F`, { l: `fi`, v: `Käyttö estetty` }, { l: `uk`, v: `В доступі відмовлено` }, { l: `sv`, v: `Åtkomst nekad` }, { l: `ru`, v: `В доступе отказано` }, { l: `pl`, v: `Brak dostępu` }, { l: `nb`, v: `Ingen tilgang` }, { l: `en`, v: `Access denied` }, { l: `da`, v: `Ingen adgang` },);
        this.set(`_40`, { l: `fi`, v: `Asetus` }, { l: `uk`, v: `Налаштування` }, { l: `sv`, v: `Inställning` }, { l: `ru`, v: `Настройки` }, { l: `pl`, v: `PL: Setting` }, { l: `nb`, v: `NB: Setting` }, { l: `en`, v: `Setting` }, { l: `da`, v: `DA: Setting` },);
        this.set(`_41`, { l: `fi`, v: `Arvo` }, { l: `uk`, v: `Значення` }, { l: `sv`, v: `Värde` }, { l: `ru`, v: `Значение` }, { l: `pl`, v: `PL: Value` }, { l: `nb`, v: `NB: Value` }, { l: `en`, v: `Value` }, { l: `da`, v: `DA: Value` },);
        this.set(`_42`, { l: `fi`, v: `Käyttäjä {0} poistettu.` }, { l: `uk`, v: `Обліковий запис "{0}" успішно видалено.` }, { l: `sv`, v: `Användarkonto "{0}" raderat.` }, { l: `ru`, v: `Учетная запись {0} успешно удалена.` }, { l: `pl`, v: `PL: User account {0} deleted successfully.` }, { l: `nb`, v: `NB: User account {0} deleted successfully.` }, { l: `en`, v: `User account {0} deleted successfully.` }, { l: `da`, v: `DA: User account {0} deleted successfully.` },);
        this.set(`_43`, { l: `fi`, v: `Käyttäjätili "{0}" poistettu pysyvästi.` }, { l: `uk`, v: `Обліковий запис "{0}"був видалений назавжди.` }, { l: `sv`, v: `Användarkonto "{0}" raderat permanent.` }, { l: `ru`, v: `Учетная запись "{0}" была удалена навсегда.` }, { l: `pl`, v: `PL: User account "{0}" was permanently deleted.` }, { l: `nb`, v: `NB: User account "{0}" was permanently deleted.` }, { l: `en`, v: `User account "{0}" was permanently deleted.` }, { l: `da`, v: `DA: User account "{0}" was permanently deleted.` },);
        this.set(`_44`, { l: `fi`, v: `Käyttäjä {0} palautettu.` }, { l: `uk`, v: `Обліковий запис "{0}" успішно відновлений.` }, { l: `sv`, v: `Användarkonto "{0}" återställt.` }, { l: `ru`, v: `Учетная запись {0} успешно восстановлена.` }, { l: `pl`, v: `PL: User account {0} restored successfully.` }, { l: `nb`, v: `NB: User account {0} restored successfully.` }, { l: `en`, v: `User account {0} restored successfully.` }, { l: `da`, v: `DA: User account {0} restored successfully.` },);
        this.set(`_45`, { l: `fi`, v: `Lisää käyttäjä` }, { l: `uk`, v: `Додати користувача` }, { l: `sv`, v: `Lägg till användare` }, { l: `ru`, v: `Добавить пользователя` }, { l: `pl`, v: `PL: Add user` }, { l: `nb`, v: `NB: Add user` }, { l: `en`, v: `Add user` }, { l: `da`, v: `DA: Add user` },);
        this.set(`_46`, { l: `fi`, v: `Näytä poistetut` }, { l: `uk`, v: `Показати видаленні` }, { l: `sv`, v: `Visa raderade` }, { l: `ru`, v: `Показать удаленные` }, { l: `pl`, v: `PL: Show deleted` }, { l: `nb`, v: `NB: Show deleted` }, { l: `en`, v: `Show deleted` }, { l: `da`, v: `DA: Show deleted` },);
        this.set(`_47`, { l: `fi`, v: `Palauta` }, { l: `uk`, v: `Відновити` }, { l: `sv`, v: `Återställ` }, { l: `ru`, v: `Восстановить` }, { l: `pl`, v: `PL: Restore` }, { l: `nb`, v: `NB: Restore` }, { l: `en`, v: `Restore` }, { l: `da`, v: `DA: Restore` },);
        this.set(`_48`, { l: `fi`, v: `Poista` }, { l: `uk`, v: `Видалити` }, { l: `sv`, v: `Radera` }, { l: `ru`, v: `Удалить` }, { l: `pl`, v: `PL: Delete` }, { l: `nb`, v: `NB: Delete` }, { l: `en`, v: `Delete` }, { l: `da`, v: `DA: Delete` },);
        this.set(`_49`, { l: `fi`, v: `Avaa lukitus` }, { l: `uk`, v: `Розблокуввти` }, { l: `sv`, v: `Lås upp` }, { l: `ru`, v: `Разблокировать` }, { l: `pl`, v: `PL: Unlock` }, { l: `nb`, v: `NB: Unlock` }, { l: `en`, v: `Unlock` }, { l: `da`, v: `DA: Unlock` },);
        this.set(`_4A`, { l: `fi`, v: `Asetukset tallennettu` }, { l: `uk`, v: `Налаштування збережені` }, { l: `sv`, v: `Inställningar sparade` }, { l: `ru`, v: `Настройки сохранены` }, { l: `pl`, v: `PL: Settings saved` }, { l: `nb`, v: `NB: Settings saved` }, { l: `en`, v: `Settings saved` }, { l: `da`, v: `DA: Settings saved` },);
        this.set(`_4B`, { l: `fi`, v: `Käyttäjätilin "{0}" lukitus avattu.` }, { l: `uk`, v: `Обліковий запис "{0}" успішно розблокований.` }, { l: `sv`, v: `Användarkonto "{0}" upplåst.` }, { l: `ru`, v: `Учетная запись "{0}" успешно разблокирована.` }, { l: `pl`, v: `PL: User account "{0}" unlocked successfully.` }, { l: `nb`, v: `NB: User account "{0}" unlocked successfully.` }, { l: `en`, v: `User account "{0}" unlocked successfully.` }, { l: `da`, v: `DA: User account "{0}" unlocked successfully.` },);
        this.set(`_4C`, { l: `fi`, v: `Oletko varma, että haluat poistaa käyttäjätilin "{0}" lukituksen?` }, { l: `uk`, v: `Ви справді хочете розблокувати користувача "{0}"?` }, { l: `sv`, v: `Är du säker att du vill upplåsa användare "{0}"?` }, { l: `ru`, v: `Вы действительно хотите разблокировать пользователя "{0}"?` }, { l: `pl`, v: `PL: Are you sure you want to unlock user "{0}"?` }, { l: `nb`, v: `NB: Are you sure you want to unlock user "{0}"?` }, { l: `en`, v: `Are you sure you want to unlock user "{0}"?` }, { l: `da`, v: `DA: Are you sure you want to unlock user "{0}"?` },);
        this.set(`_4D`, { l: `fi`, v: `Oletko varma, että haluat poistaa käyttäjätilin "{0}"?` }, { l: `uk`, v: `Ви справді хочете видалити користувача "{0}"?` }, { l: `sv`, v: `Är du säker att du vill radera användare "{0}"?` }, { l: `ru`, v: `Вы действительно хотите удалить пользователя "{0}"?` }, { l: `pl`, v: `PL: Are you sure you want to delete user "{0}"?` }, { l: `nb`, v: `NB: Are you sure you want to delete user "{0}"?` }, { l: `en`, v: `Are you sure you want to delete user "{0}"?` }, { l: `da`, v: `DA: Are you sure you want to delete user "{0}"?` },);
        this.set(`_4E`, { l: `fi`, v: `Oletko varma, että haluat palauttaa käyttäjätilin "{0}"?` }, { l: `uk`, v: `Ви справді хочете відновити користувача "{0}"?` }, { l: `sv`, v: `Är du säker att du vill återställa användare "{0}"?` }, { l: `ru`, v: `Вы действительно хотите восстановить пользователя "{0}"?` }, { l: `pl`, v: `PL: Are you sure you want to restore user "{0}"?` }, { l: `nb`, v: `NB: Are you sure you want to restore user "{0}"?` }, { l: `en`, v: `Are you sure you want to restore user "{0}"?` }, { l: `da`, v: `DA: Are you sure you want to restore user "{0}"?` },);
        this.set(`_4F`, { l: `fi`, v: `Peruuta` }, { l: `uk`, v: `Скасувати` }, { l: `sv`, v: `Avbryt` }, { l: `ru`, v: `Отмена` }, { l: `pl`, v: `Anuluj` }, { l: `nb`, v: `Avbryt` }, { l: `en`, v: `Cancel` }, { l: `da`, v: `Annuller` },);
        this.set(`_50`, { l: `fi`, v: `Aseta uusi salasana tunnukselle` }, { l: `uk`, v: `Встановіть новий пароль для свого облікового запису` }, { l: `sv`, v: `Sätt ett nytt lösenord för ditt konto` }, { l: `ru`, v: `Установите новый пароль для своей учетной записи` }, { l: `pl`, v: `PL: Set new password for your account` }, { l: `nb`, v: `NB: Set new password for your account` }, { l: `en`, v: `Set new password for your account` }, { l: `da`, v: `DA: Set new password for your account` },);
        this.set(`_51`, { l: `fi`, v: `Salasana asetettu` }, { l: `uk`, v: `Пароль успішно змінено` }, { l: `sv`, v: `Lösenordet bytt` }, { l: `ru`, v: `Пароль успешно изменён` }, { l: `pl`, v: `PL: Password set successfully` }, { l: `nb`, v: `NB: Password set successfully` }, { l: `en`, v: `Password set successfully` }, { l: `da`, v: `DA: Password set successfully` },);
        this.set(`_52`, { l: `fi`, v: `Salasana asetettu. Sinun on hyväksyttävä käyttöehdot ja tietosuojaseloste voidaksesi käyttää sovellusta.` }, { l: `uk`, v: `Пароль успішно змінено. Ви повинні прийняти умови використання та сповіщення про конфіденційність, щоб використовувати програму.` }, { l: `sv`, v: `Lösenordet har angetts. Du måste godkänna användarvillkoren och sekretessmeddelande för att använda applikationen.` }, { l: `ru`, v: `Пароль успешно изменён. Вы должны принять условия использования и уведомление о конфиденциальности, чтобы использовать приложение.` }, { l: `pl`, v: `PL: Password set successfully. You must accept terms of usage and privacy notice in order to use application.` }, { l: `nb`, v: `NB: Password set successfully. You must accept terms of usage and privacy notice in order to use application.` }, { l: `en`, v: `Password set successfully. You must accept terms of usage and privacy notice in order to use application.` }, { l: `da`, v: `DA: Password set successfully. You must accept terms of usage and privacy notice in order to use application.` },);
        this.set(`_53`, { l: `fi`, v: `Vaihda salasana` }, { l: `uk`, v: `Змінити пароль` }, { l: `sv`, v: `Byt lösenord` }, { l: `ru`, v: `Cменить пароль` }, { l: `pl`, v: `PL: Change password` }, { l: `nb`, v: `NB: Change password` }, { l: `en`, v: `Change password` }, { l: `da`, v: `DA: Change password` },);
        this.set(`_54`, { l: `fi`, v: `Vaihda salasana` }, { l: `uk`, v: `Змінити пароль` }, { l: `sv`, v: `Byt lösenord` }, { l: `ru`, v: `Cменить пароль` }, { l: `pl`, v: `PL: Change password` }, { l: `nb`, v: `NB: Change password` }, { l: `en`, v: `Change password` }, { l: `da`, v: `DA: Change password` },);
        this.set(`_55`, { l: `fi`, v: `Väärä nykyinen salasana` }, { l: `uk`, v: `Невірний пароль` }, { l: `sv`, v: `Nuvarande lösenord är fel` }, { l: `ru`, v: `Неверный пароль` }, { l: `pl`, v: `PL: Wrong current password` }, { l: `nb`, v: `NB: Wrong current password` }, { l: `en`, v: `Wrong current password` }, { l: `da`, v: `DA: Wrong current password` },);
        this.set(`_56`, { l: `fi`, v: `Salasanassa pitää olla yksi erikoismerkki, yksi pieni kirjain ('a'-'z'), yksi iso kirjain ('A'-'Z'), yksi numero ja vähintään 8 merkkiä` }, { l: `uk`, v: `Пароль має містити цифри та літери, один символ нижнього регістру ('a'-'z'), один верхнього регістру ('A'-'Z'), одну цифру та бути принаймні 8 символів завдовжки.` }, { l: `sv`, v: `Lösenordet måste innehålla ett special tecken, en liten bokstav ('a'-'z'), en stor bokstav ('A'-'Z'), en nummer och minst 8 tecken` }, { l: `ru`, v: `В пароле должно быть не менее 8 символов, не менее 1 цифры , не менее 1 строчной буквы ('a'-'z'), не менее 1 прописной буквы ('A'-'Z'), не менее 1 не буквенно-цифрового символова ` }, { l: `pl`, v: `PL: Password must have one non alphanumeric character, one lowercase ('a'-'z') character, one uppercase ('A'-'Z') character, one number and be at least 8 characters long` }, { l: `nb`, v: `NB: Password must have one non alphanumeric character, one lowercase ('a'-'z') character, one uppercase ('A'-'Z') character, one number and be at least 8 characters long` }, { l: `en`, v: `Password must have one non alphanumeric character, one lowercase ('a'-'z') character, one uppercase ('A'-'Z') character, one number and be at least 8 characters long` }, { l: `da`, v: `DA: Password must have one non alphanumeric character, one lowercase ('a'-'z') character, one uppercase ('A'-'Z') character, one number and be at least 8 characters long` },);
        this.set(`_57`, { l: `fi`, v: `tammikuu` }, { l: `uk`, v: `січень` }, { l: `sv`, v: `januari` }, { l: `ru`, v: `январь` }, { l: `pl`, v: `styczeń` }, { l: `nb`, v: `januar` }, { l: `en`, v: `January` }, { l: `da`, v: `januar` },);
        this.set(`_58`, { l: `fi`, v: `helmikuu` }, { l: `uk`, v: `лютий` }, { l: `sv`, v: `februari` }, { l: `ru`, v: `февраль` }, { l: `pl`, v: `luty` }, { l: `nb`, v: `februar` }, { l: `en`, v: `February` }, { l: `da`, v: `februar` },);
        this.set(`_59`, { l: `fi`, v: `maaliskuu` }, { l: `uk`, v: `березень` }, { l: `sv`, v: `mars` }, { l: `ru`, v: `март` }, { l: `pl`, v: `marzec` }, { l: `nb`, v: `mars` }, { l: `en`, v: `March` }, { l: `da`, v: `marts` },);
        this.set(`_5A`, { l: `fi`, v: `huhtikuu` }, { l: `uk`, v: `квітень` }, { l: `sv`, v: `april` }, { l: `ru`, v: `апрель` }, { l: `pl`, v: `kwiecień` }, { l: `nb`, v: `april` }, { l: `en`, v: `April` }, { l: `da`, v: `april` },);
        this.set(`_5B`, { l: `fi`, v: `toukokuu` }, { l: `uk`, v: `травень` }, { l: `sv`, v: `maj` }, { l: `ru`, v: `май` }, { l: `pl`, v: `maj` }, { l: `nb`, v: `mai` }, { l: `en`, v: `May` }, { l: `da`, v: `maj` },);
        this.set(`_5C`, { l: `fi`, v: `kesäkuu` }, { l: `uk`, v: `червень` }, { l: `sv`, v: `juni` }, { l: `ru`, v: `июнь` }, { l: `pl`, v: `czerwiec` }, { l: `nb`, v: `juni` }, { l: `en`, v: `June` }, { l: `da`, v: `juni` },);
        this.set(`_5D`, { l: `fi`, v: `heinäkuu` }, { l: `uk`, v: `липень` }, { l: `sv`, v: `juli` }, { l: `ru`, v: `июль` }, { l: `pl`, v: `lipiec` }, { l: `nb`, v: `juli` }, { l: `en`, v: `July` }, { l: `da`, v: `juli` },);
        this.set(`_5E`, { l: `fi`, v: `elokuu` }, { l: `uk`, v: `серпень` }, { l: `sv`, v: `augusti` }, { l: `ru`, v: `август` }, { l: `pl`, v: `sierpień` }, { l: `nb`, v: `august` }, { l: `en`, v: `August` }, { l: `da`, v: `august` },);
        this.set(`_5F`, { l: `fi`, v: `syyskuu` }, { l: `uk`, v: `вересень` }, { l: `sv`, v: `september` }, { l: `ru`, v: `сентябрь` }, { l: `pl`, v: `wrzesień` }, { l: `nb`, v: `september` }, { l: `en`, v: `September` }, { l: `da`, v: `september` },);
        this.set(`_60`, { l: `fi`, v: `lokakuu` }, { l: `uk`, v: `жовтень` }, { l: `sv`, v: `oktober` }, { l: `ru`, v: `октябрь` }, { l: `pl`, v: `październik` }, { l: `nb`, v: `oktober` }, { l: `en`, v: `October` }, { l: `da`, v: `oktober` },);
        this.set(`_61`, { l: `fi`, v: `marraskuu` }, { l: `uk`, v: `листопад` }, { l: `sv`, v: `november` }, { l: `ru`, v: `ноябрь` }, { l: `pl`, v: `listopad` }, { l: `nb`, v: `november` }, { l: `en`, v: `November` }, { l: `da`, v: `november` },);
        this.set(`_62`, { l: `fi`, v: `joulukuu` }, { l: `uk`, v: `грудень` }, { l: `sv`, v: `december` }, { l: `ru`, v: `декабрь` }, { l: `pl`, v: `grudzień` }, { l: `nb`, v: `desember` }, { l: `en`, v: `December` }, { l: `da`, v: `december` },);
        this.set(`_63`, { l: `fi`, v: `Järjestelmävalvojat` }, { l: `uk`, v: `Адміністратори` }, { l: `sv`, v: `Administratörer` }, { l: `ru`, v: `Администраторы` }, { l: `pl`, v: `PL: Admins` }, { l: `nb`, v: `NB: Admins` }, { l: `en`, v: `Admins` }, { l: `da`, v: `DA: Admins` },);
        this.set(`_64`, { l: `fi`, v: `Aliurakoitsijat` }, { l: `uk`, v: `Субпідрядники` }, { l: `sv`, v: `Underleverantörer` }, { l: `ru`, v: `Субподрядчики` }, { l: `pl`, v: `PL: Subcontractors` }, { l: `nb`, v: `NB: Subcontractors` }, { l: `en`, v: `Subcontractors` }, { l: `da`, v: `DA: Subcontractors` },);
        this.set(`_65`, { l: `fi`, v: `Työmaa- ja yritysvalvojat` }, { l: `uk`, v: `Адміністратори сайту та бізнесу` }, { l: `sv`, v: `Byggplats- och affärsadministratörer` }, { l: `ru`, v: `Администраторы сайта и бизнеса` }, { l: `pl`, v: `PL: Site & business administrators` }, { l: `nb`, v: `NB: Site & business administrators` }, { l: `en`, v: `Site & business administrators` }, { l: `da`, v: `DA: Site & business administrators` },);
        this.set(`_66`, { l: `fi`, v: `Työnjohtajat` }, { l: `uk`, v: `Менеджери` }, { l: `sv`, v: `Chefer` }, { l: `ru`, v: `Менеджеры` }, { l: `pl`, v: `PL: Managers` }, { l: `nb`, v: `NB: Managers` }, { l: `en`, v: `Managers` }, { l: `da`, v: `DA: Managers` },);
        this.set(`_67`, { l: `fi`, v: `Yhteyshenkilöt` }, { l: `uk`, v: `Контактна особа` }, { l: `sv`, v: `Kontaktperson` }, { l: `ru`, v: `Контактные лица` }, { l: `pl`, v: `PL: Contact persons` }, { l: `nb`, v: `NB: Contact persons` }, { l: `en`, v: `Contact persons` }, { l: `da`, v: `DA: Contact persons` },);
        this.set(`_68`, { l: `fi`, v: `Työmaa johtajat & yhteyshenkilöt` }, { l: `uk`, v: `Менеджери на місцях та контактні особи` }, { l: `sv`, v: `Byggplats chefer & kontaktpersoner` }, { l: `ru`, v: `Менеджеры сайта и контактные лица` }, { l: `pl`, v: `PL: Site managers & contact persons` }, { l: `nb`, v: `NB: Site managers & contact persons` }, { l: `en`, v: `Site managers & contact persons` }, { l: `da`, v: `DA: Site managers & contact persons` },);
        this.set(`_69`, { l: `fi`, v: `Työntekijät` }, { l: `uk`, v: `Працівники` }, { l: `sv`, v: `Anställda` }, { l: `ru`, v: `Сотрудники` }, { l: `pl`, v: `PL: Employees` }, { l: `nb`, v: `NB: Employees` }, { l: `en`, v: `Employees` }, { l: `da`, v: `DA: Employees` },);
        this.set(`_6A`, { l: `fi`, v: `Pää asentajat, asentajat & kuljettajat` }, { l: `uk`, v: `Головні установники, установники та водії` }, { l: `sv`, v: `Huvud montörer, montörer & chaufförer` }, { l: `ru`, v: `Главные установщики, установщики и водители` }, { l: `pl`, v: `PL: Head mounters, mounters & drivers` }, { l: `nb`, v: `NB: Head mounters, mounters & drivers` }, { l: `en`, v: `Head mounters, mounters & drivers` }, { l: `da`, v: `DA: Head mounters, mounters & drivers` },);
        this.set(`_6B`, { l: `fi`, v: `Valitse rooli` }, { l: `uk`, v: `Обратіть роль` }, { l: `sv`, v: `Välj en roll` }, { l: `ru`, v: `Выберите роль` }, { l: `pl`, v: `PL: Choose a role` }, { l: `nb`, v: `NB: Choose a role` }, { l: `en`, v: `Choose a role` }, { l: `da`, v: `DA: Choose a role` },);
        this.set(`_6C`, { l: `fi`, v: `Yhteystiedot` }, { l: `uk`, v: `Контактні дані` }, { l: `sv`, v: `Kontakt information` }, { l: `ru`, v: `Контактная информация` }, { l: `pl`, v: `PL: Contact information` }, { l: `nb`, v: `NB: Contact information` }, { l: `en`, v: `Contact information` }, { l: `da`, v: `DA: Contact information` },);
        this.set(`_6D`, { l: `fi`, v: `Etusivu` }, { l: `uk`, v: `Титульна сторінка` }, { l: `sv`, v: `Framsida` }, { l: `ru`, v: `Главная страница` }, { l: `pl`, v: `PL: Frontpage` }, { l: `nb`, v: `NB: Frontpage` }, { l: `en`, v: `Frontpage` }, { l: `da`, v: `DA: Frontpage` },);
        this.set(`_6E`, { l: `fi`, v: `Tervetuloa Athenaeum Application Template etusivulle. Aloittaaksesi työpäivän, paina Kirjaudu sisään -painiketta.\n\nSisäänkirjautumisen jälkeen voit vaihtaa työmaata tai tehtävää työpäivän aikana.\n\nTyöpäiväsi päätyttyä, paina Kirjaudu ulos painiketta.` }, { l: `uk`, v: `Ласкаво просимо до особистого кабінету  Template Application, натисніть «Увійти», щоб почати ваш робочий день.\n\nПісля успішного входу можна змінити проект або взяти нове завдання з тієї ж сторінки.\n\nКоли ваш робочий день закінчиться, натисніть кнопку «Вийти».` }, { l: `sv`, v: `Välkommern till Template Application framsidan, tryck Logga in för att börja din arbetsdag.\n\nEfter lyckad inloggning kan du byta byggarbetsplats eller arbetsdagens uppgift från samma sida.\n\nNär din arbetsdag är slut, tryck Logga ut.` }, { l: `ru`, v: `Добро пожаловать в личный кабинет Template Application, нажмите «Войти» чтобы начать ваш рабочий день.\n\nПосле успешного входа вы можете сменить проект или взять новую задачу с той же страницы.\n\nКогда ваш рабочий день закончится, нажмите «Выйти».` }, { l: `pl`, v: `PL: Welcome to Template Application dashboard, press Sign-in to start Your workday.\n\nAfter successful login You can change construction site or pickup a new task from the same page.\n\nWhen your workday is finished press Sign-out to start checkout process.` }, { l: `nb`, v: `NB: Welcome to Template Application dashboard, press Sign-in to start Your workday.\n\nAfter successful login You can change construction site or pickup a new task from the same page.\n\nWhen your workday is finished press Sign-out to start checkout process.` }, { l: `en`, v: `Welcome to Template Application dashboard, press Sign-in to start Your workday.\n\nAfter successful login You can change construction site or pickup a new task from the same page.\n\nWhen your workday is finished press Sign-out to start checkout process.` }, { l: `da`, v: `DA: Welcome to Template Application dashboard, press Sign-in to start Your workday.\n\nAfter successful login You can change construction site or pickup a new task from the same page.\n\nWhen your workday is finished press Sign-out to start checkout process.` },);
        this.set(`_6F`, { l: `fi`, v: `Yhtään kutsua ei ole lähetetty.` }, { l: `uk`, v: `Запрошення не було відправлене` }, { l: `sv`, v: `Ingen inbjudan har skickats` }, { l: `ru`, v: `Приглашение не было отправлено` }, { l: `pl`, v: `PL: No invitations has been sent` }, { l: `nb`, v: `NB: No invitations has been sent` }, { l: `en`, v: `No invitations has been sent` }, { l: `da`, v: `DA: No invitations has been sent` },);
        this.set(`_70`, { l: `fi`, v: `Lähetä kutsu uudelleen` }, { l: `uk`, v: `Відправити запрошення знову` }, { l: `sv`, v: `Skicka inbjudan på nytt` }, { l: `ru`, v: `Повторно отправить пришлашение` }, { l: `pl`, v: `PL: Resend invitation` }, { l: `nb`, v: `NB: Resend invitation` }, { l: `en`, v: `Resend invitation` }, { l: `da`, v: `DA: Resend invitation` },);
        this.set(`_71`, { l: `fi`, v: `Aseta salasana uudelleen` }, { l: `uk`, v: `Скинути пароль` }, { l: `sv`, v: `Återställ lösenord` }, { l: `ru`, v: `Сбросить пароль` }, { l: `pl`, v: `PL: Reset password` }, { l: `nb`, v: `NB: Reset password` }, { l: `en`, v: `Reset password` }, { l: `da`, v: `DA: Reset password` },);
        this.set(`_72`, { l: `fi`, v: `Autentikointitapa` }, { l: `uk`, v: `Тип аутентифікації` }, { l: `sv`, v: `Autentikeringssätt` }, { l: `ru`, v: `Тип аутентификации` }, { l: `pl`, v: `PL: Authentication type` }, { l: `nb`, v: `NB: Authentication type` }, { l: `en`, v: `Authentication type` }, { l: `da`, v: `DA: Authentication type` },);
        this.set(`_73`, { l: `fi`, v: `Sähköposti` }, { l: `uk`, v: `Email` }, { l: `sv`, v: `E-post` }, { l: `ru`, v: `Email` }, { l: `pl`, v: `PL: Email` }, { l: `nb`, v: `NB: Email` }, { l: `en`, v: `Email` }, { l: `da`, v: `DA: Email` },);
        this.set(`_74`, { l: `fi`, v: `SMS` }, { l: `uk`, v: `SMS` }, { l: `sv`, v: `SMS` }, { l: `ru`, v: `SMS` }, { l: `pl`, v: `PL: SMS` }, { l: `nb`, v: `NB: SMS` }, { l: `en`, v: `SMS` }, { l: `da`, v: `DA: SMS` },);
        this.set(`_75`, { l: `fi`, v: `Kutsut` }, { l: `uk`, v: `Запрошення` }, { l: `sv`, v: `Inbjudningar` }, { l: `ru`, v: `Приглашения` }, { l: `pl`, v: `PL: Invitations` }, { l: `nb`, v: `NB: Invitations` }, { l: `en`, v: `Invitations` }, { l: `da`, v: `DA: Invitations` },);
        this.set(`_76`, { l: `fi`, v: `Oletko varma, että haluat uusia salasanan käyttäjätilille "{0}"?` }, { l: `uk`, v: `Ви справді хочете cкинути пароль користувача "{0}"?` }, { l: `sv`, v: `Är du säker att du vill återställa lösenordet för användare "{0}"?` }, { l: `ru`, v: `Вы действительно хотите сбросить пароль для пользователя "{0}"?` }, { l: `pl`, v: `PL: Are you sure you want to reset password for user "{0}"?` }, { l: `nb`, v: `NB: Are you sure you want to reset password for user "{0}"?` }, { l: `en`, v: `Are you sure you want to reset password for user "{0}"?` }, { l: `da`, v: `DA: Are you sure you want to reset password for user "{0}"?` },);
        this.set(`_77`, { l: `fi`, v: `Oletko varma, että haluat luoda käyttäjän "{0}"?` }, { l: `uk`, v: `Ви справді хочете запросити користувача "{0}"?` }, { l: `sv`, v: `Är du säker att du vill bjuda användare "{0}"?` }, { l: `ru`, v: `Вы действительно хотите пригласить пользователя "{0}"?` }, { l: `pl`, v: `PL: Are you sure you want to invite user "{0}"?` }, { l: `nb`, v: `NB: Are you sure you want to invite user "{0}"?` }, { l: `en`, v: `Are you sure you want to invite user "{0}"?` }, { l: `da`, v: `DA: Are you sure you want to invite user "{0}"?` },);
        this.set(`_78`, { l: `fi`, v: `Käyttäjätilillä "{0}" ei ole salasanaa.` }, { l: `uk`, v: `Пароль до облікового запису "{0}" відсутній.` }, { l: `sv`, v: `Användarkontot "{0}" har inte ett lösenord.` }, { l: `ru`, v: `Пароль для учетной записи "{0}" отсутствует.` }, { l: `pl`, v: `PL: User account "{0}" does not have a password.` }, { l: `nb`, v: `NB: User account "{0}" does not have a password.` }, { l: `en`, v: `User account "{0}" does not have a password.` }, { l: `da`, v: `DA: User account "{0}" does not have a password.` },);
        this.set(`_79`, { l: `fi`, v: `Luonut` }, { l: `uk`, v: `Створений` }, { l: `sv`, v: `Skapad av` }, { l: `ru`, v: `Создан` }, { l: `pl`, v: `Created by` }, { l: `nb`, v: `NB: Created by` }, { l: `en`, v: `Created by` }, { l: `da`, v: `DA: Created by` },);
        this.set(`_7A`, { l: `fi`, v: `Tyyppi` }, { l: `uk`, v: `Тип` }, { l: `sv`, v: `Typ` }, { l: `ru`, v: `Тип` }, { l: `pl`, v: `Type` }, { l: `nb`, v: `NB: Type` }, { l: `en`, v: `Type` }, { l: `da`, v: `DA: Type` },);
        this.set(`_7B`, { l: `fi`, v: `Luotu` }, { l: `uk`, v: `Створений` }, { l: `sv`, v: `Skapad` }, { l: `ru`, v: `Создано` }, { l: `pl`, v: `PL: Created at` }, { l: `nb`, v: `NB: Created at` }, { l: `en`, v: `Created at` }, { l: `da`, v: `DA: Created at` },);
        this.set(`_7C`, { l: `fi`, v: `Umpeutuu` }, { l: `uk`, v: `Дійсний до` }, { l: `sv`, v: `Går ut` }, { l: `ru`, v: `Истекает` }, { l: `pl`, v: `Expires at` }, { l: `nb`, v: `NB: Expires at` }, { l: `en`, v: `Expires at` }, { l: `da`, v: `DA: Expires at` },);
        this.set(`_7D`, { l: `fi`, v: `Käsitelty` }, { l: `uk`, v: `Оброблено` }, { l: `sv`, v: `Behandlat` }, { l: `ru`, v: `Обработано` }, { l: `pl`, v: `Processed At` }, { l: `nb`, v: `NB: Processed At` }, { l: `en`, v: `Processed At` }, { l: `da`, v: `DA: Processed At` },);
        this.set(`_7E`, { l: `fi`, v: `Uudelleenkäytettävä` }, { l: `uk`, v: `Придатний до повторного використання` }, { l: `sv`, v: `Återanvändbar` }, { l: `ru`, v: `Повторное использование` }, { l: `pl`, v: `Reusable` }, { l: `nb`, v: `NB: Reusable` }, { l: `en`, v: `Reusable` }, { l: `da`, v: `DA: Reusable` },);
        this.set(`_7F`, { l: `fi`, v: `Autentikointitapa` }, { l: `uk`, v: `Тип авторизації` }, { l: `sv`, v: `Autentikeringssätt` }, { l: `ru`, v: `Тип авторизации` }, { l: `pl`, v: `Auth type` }, { l: `nb`, v: `NB: Auth type` }, { l: `en`, v: `Auth type` }, { l: `da`, v: `DA: Auth type` },);
        this.set(`_80`, { l: `fi`, v: `Käyttäjätili "{0}" tallennettu.` }, { l: `uk`, v: `Обліковий запис "{0}" успішно збережено.` }, { l: `sv`, v: `Användarkonto "{0}" sparat.` }, { l: `ru`, v: `Учетная запись "{0}" успешно сохранена.` }, { l: `pl`, v: `PL: User account "{0}" saved successfully.` }, { l: `nb`, v: `NB: User account "{0}" saved successfully.` }, { l: `en`, v: `User account "{0}" saved successfully.` }, { l: `da`, v: `DA: User account "{0}" saved successfully.` },);
        this.set(`_81`, { l: `fi`, v: `Käyttäjätili "{0}" on jo olemassa.` }, { l: `uk`, v: `Обліковий запис "{0}" вже існує.` }, { l: `sv`, v: `Användarkonto "{0}" existerar redan.` }, { l: `ru`, v: `Учетная запись "{0}" уже существует.` }, { l: `pl`, v: `PL: User account "{0}" already exist.` }, { l: `nb`, v: `NB: User account "{0}" already exist.` }, { l: `en`, v: `User account "{0}" already exist.` }, { l: `da`, v: `DA: User account "{0}" already exist.` },);
        this.set(`_82`, { l: `fi`, v: `Valttikortti-id "{0}" on jo lisätty toiselle käyttäjälle.` }, { l: `uk`, v: `Ідентифікаційний номер робочої картки "{0}" вже зареєстрований для інщого облікового запису.` }, { l: `sv`, v: `Arbets ID-kort "{0}" är redan registrerat för ett annat konto.` }, { l: `ru`, v: `Идентификационный номер рабочей карты "{0}" уже зарегистрирован для другой учетной записи.` }, { l: `pl`, v: `PL: Work card id "{0}" is already registered for another user account.` }, { l: `nb`, v: `NB: Work card id "{0}" is already registered for another user account.` }, { l: `en`, v: `Work card id "{0}" is already registered for another user account.` }, { l: `da`, v: `DA: Work card id "{0}" is already registered for another user account.` },);
        this.set(`_83`, { l: `fi`, v: `Puhelinnumero on virheellinen.` }, { l: `uk`, v: `Невірний номер телефону.` }, { l: `sv`, v: `Telefonnummret är ogiltigt.` }, { l: `ru`, v: `Неверный номер телефона.` }, { l: `pl`, v: `PL: Phone number is invalid.` }, { l: `nb`, v: `NB: Phone number is invalid.` }, { l: `en`, v: `Phone number is invalid.` }, { l: `da`, v: `DA: Phone number is invalid.` },);
        this.set(`_84`, { l: `fi`, v: `Sähköposti tai puhelinnumero` }, { l: `uk`, v: `Email або номер телефону` }, { l: `sv`, v: `E-post eller telefonnummer` }, { l: `ru`, v: `Email или номер телефона` }, { l: `pl`, v: `PL: Email or phone number` }, { l: `nb`, v: `NB: Email or phone number` }, { l: `en`, v: `Email or phone number` }, { l: `da`, v: `DA: Email or phone number` },);
        this.set(`_85`, { l: `fi`, v: `Kutsu` }, { l: `uk`, v: `Запрошення` }, { l: `sv`, v: `Inbjudan` }, { l: `ru`, v: `Приглашение` }, { l: `pl`, v: `PL: Invitation` }, { l: `nb`, v: `NB: Invitation` }, { l: `en`, v: `Invitation` }, { l: `da`, v: `DA: Invitation` },);
        this.set(`_86`, { l: `fi`, v: `Aseta uusi salasana` }, { l: `uk`, v: `Скинути пароль` }, { l: `sv`, v: `Återställ lösenord` }, { l: `ru`, v: `Сбросить пароль` }, { l: `pl`, v: `PL: Reset password` }, { l: `nb`, v: `NB: Reset password` }, { l: `en`, v: `Reset password` }, { l: `da`, v: `DA: Reset password` },);
        this.set(`_87`, { l: `fi`, v: `Unohditko salasanan` }, { l: `uk`, v: `Забув пароль` }, { l: `sv`, v: `Glömt lösenord?` }, { l: `ru`, v: `Забыл пароль` }, { l: `pl`, v: `PL: Forgot password` }, { l: `nb`, v: `NB: Forgot password` }, { l: `en`, v: `Forgot password` }, { l: `da`, v: `DA: Forgot password` },);
        this.set(`_88`, { l: `fi`, v: `Oletko varma, että haluat tyhjätä tehdyt muutokset?` }, { l: `uk`, v: `Ви справді хочете відкотити незбережені зміни?` }, { l: `sv`, v: `Är du säker att du vill återställa osparade förändringar?` }, { l: `ru`, v: `Вы действительно хотите отменить несохраненные изменения?` }, { l: `pl`, v: `PL: Are you sure that you want to rollback unsaved changes?` }, { l: `nb`, v: `NB: Are you sure that you want to rollback unsaved changes?` }, { l: `en`, v: `Are you sure that you want to rollback unsaved changes?` }, { l: `da`, v: `DA: Are you sure that you want to rollback unsaved changes?` },);
        this.set(`_89`, { l: `fi`, v: `Asenna` }, { l: `uk`, v: `Встановити` }, { l: `sv`, v: `Installera` }, { l: `ru`, v: `Установить` }, { l: `pl`, v: `PL: Install` }, { l: `nb`, v: `NB: Install` }, { l: `en`, v: `Install` }, { l: `da`, v: `DA: Install` },);
        this.set(`_8A`, { l: `fi`, v: `Lisää sovellus aloitusnäytölle` }, { l: `uk`, v: `Додати застосунок на домашній екран` }, { l: `sv`, v: `Lägg till applikation på framsidan` }, { l: `ru`, v: `Добавить приложение на домашний экран` }, { l: `pl`, v: `PL: Add application to the home screen` }, { l: `nb`, v: `NB: Add application to the home screen` }, { l: `en`, v: `Add application to the home screen` }, { l: `da`, v: `DA: Add application to the home screen` },);
        this.set(`_8B`, { l: `fi`, v: `Asiakkuudet` }, { l: `uk`, v: `Контракти організації` }, { l: `sv`, v: `Kundförhållande` }, { l: `ru`, v: `Контракты организации` }, { l: `pl`, v: `PL: Organization Contracts` }, { l: `nb`, v: `NB: Organization Contracts` }, { l: `en`, v: `Organization Contracts` }, { l: `da`, v: `DA: Organization Contracts` },);
        this.set(`_8C`, { l: `fi`, v: `Työtilaukset` }, { l: `uk`, v: `Наряди на роботу` }, { l: `sv`, v: `Arbetsbeställningar` }, { l: `ru`, v: `Наряды на работу` }, { l: `pl`, v: `PL: Work orders` }, { l: `nb`, v: `NB: Work orders` }, { l: `en`, v: `Work orders` }, { l: `da`, v: `DA: Work orders` },);
        this.set(`_8D`, { l: `fi`, v: `Tämä on WeAre Taskin etusivu. Etusivulta löydät pikanäppäimet kaikille tarvitsemillesi toiminnoille rooliisi perustuen. Mikäli sinulla on kysymyksiä sovelluksen käytöstä, ota yhteyttä pääkäyttäjään.` }, { l: `uk`, v: `Це сторінка Dashboard з віджетами відповідно до Вашої ролі доступу.` }, { l: `sv`, v: `Det här är framsidan med widgets baserat på din åtkomstroll` }, { l: `ru`, v: `Это страница личного кабинета с виджетами, в соответствии с вашей ролью доступа.` }, { l: `pl`, v: `PL: This is Dashboard page with widgets based on Your access role.` }, { l: `nb`, v: `NB: This is Dashboard page with widgets based on Your access role.` }, { l: `en`, v: `This is Dashboard page with widgets based on Your access role.` }, { l: `da`, v: `DA: This is Dashboard page with widgets based on Your access role.` },);
        this.set(`_8E`, { l: `fi`, v: `Viestisi on lähetetty asiakaspalveluun.` }, { l: `uk`, v: `Ваш запит було відправлено в службу підтримки.` }, { l: `sv`, v: `Er förfrågan har skickats till supporten.` }, { l: `ru`, v: `Ваш запрос был отправлен в службу поддержки. ` }, { l: `pl`, v: `PL: Your request was sent to support team.` }, { l: `nb`, v: `NB: Your request was sent to support team.` }, { l: `en`, v: `Your request was sent to support team.` }, { l: `da`, v: `DA: Your request was sent to support team.` },);
        this.set(`_8F`, { l: `fi`, v: `Pyyntösi tunnuksella "{0}" on lähetetty tuelle.` }, { l: `uk`, v: `Ваш запит "{0}" було відправлено в службу підтримки.` }, { l: `sv`, v: `Er förfrågan med id "{0}" har skickats till supporten.` }, { l: `ru`, v: `Ваш запрос "{0}" был отправлен в службу поддержки.` }, { l: `pl`, v: `PL: Your request with id "{0}" was sent to support team.` }, { l: `nb`, v: `NB: Your request with id "{0}" was sent to support team.` }, { l: `en`, v: `Your request with id "{0}" was sent to support team.` }, { l: `da`, v: `DA: Your request with id "{0}" was sent to support team.` },);
        this.set(`_90`, { l: `fi`, v: `Järjestelmävalvojan hallinta` }, { l: `uk`, v: `Меню управління адміністратора` }, { l: `sv`, v: `Admin hanterings meny` }, { l: `ru`, v: `Меню управления администратора` }, { l: `pl`, v: `Admin håndtering` }, { l: `nb`, v: `NB: Admin management` }, { l: `en`, v: `Admin management` }, { l: `da`, v: `DA: Admin management` },);
        this.set(`_91`, { l: `fi`, v: `Käyttäjien hallinta` }, { l: `uk`, v: `Управління користувачами` }, { l: `sv`, v: `Användarhantering` }, { l: `ru`, v: `Управление пользователями` }, { l: `pl`, v: `PL: User management` }, { l: `nb`, v: `NB: User management` }, { l: `en`, v: `User management` }, { l: `da`, v: `DA: User management` },);
        this.set(`_92`, { l: `fi`, v: `Näytä vanhentuneet` }, { l: `uk`, v: `Показати минулі` }, { l: `sv`, v: `Visa Utgångna` }, { l: `ru`, v: `Показать истекшие` }, { l: `pl`, v: `PL: Show expired` }, { l: `nb`, v: `NB: Show expired` }, { l: `en`, v: `Show expired` }, { l: `da`, v: `DA: Show expired` },);
        this.set(`_93`, { l: `fi`, v: `Asetukset` }, { l: `uk`, v: `Налаштавання застосунка` }, { l: `sv`, v: `Inställningar` }, { l: `ru`, v: `Настройки приложения` }, { l: `pl`, v: `PL: Application settings` }, { l: `nb`, v: `NB: Application settings` }, { l: `en`, v: `Application settings` }, { l: `da`, v: `DA: Application settings` },);
        this.set(`_94`, { l: `fi`, v: `RTP asentaja` }, { l: `uk`, v: `Інсталятор RTP` }, { l: `sv`, v: `RTP montör` }, { l: `ru`, v: `Установщик RTP` }, { l: `pl`, v: `PL: RTP mounter` }, { l: `nb`, v: `NB: RTP mounter` }, { l: `en`, v: `RTP mounter` }, { l: `da`, v: `DA: RTP mounter` },);
        this.set(`_95`, { l: `fi`, v: `Administrator` }, { l: `uk`, v: `Адміністратор` }, { l: `sv`, v: `Aadministratör` }, { l: `ru`, v: `Администратор` }, { l: `pl`, v: `PL: admin` }, { l: `nb`, v: `NB: Admin` }, { l: `en`, v: `Admin` }, { l: `da`, v: `DA: Admin` },);
        this.set(`_96`, { l: `fi`, v: `Yhteyshenkilö` }, { l: `uk`, v: `Контактна особа` }, { l: `sv`, v: `Kontakt person` }, { l: `ru`, v: `Контактное лицо` }, { l: `pl`, v: `PL: Contact Person` }, { l: `nb`, v: `NB: Contact Person` }, { l: `en`, v: `Contact Person` }, { l: `da`, v: `DA: Contact Person` },);
        this.set(`_97`, { l: `fi`, v: `Ylempi työnjohtaja` }, { l: `uk`, v: `Бізнес менеджер` }, { l: `sv`, v: `Affärschef` }, { l: `ru`, v: `Бизнес менеджер` }, { l: `pl`, v: `PL: Business Manager` }, { l: `nb`, v: `NB: Business Manager` }, { l: `en`, v: `Business Manager` }, { l: `da`, v: `DA: Business Manager` },);
        this.set(`_98`, { l: `fi`, v: `Työnjohtaja` }, { l: `uk`, v: `Менеджер` }, { l: `sv`, v: `Chef` }, { l: `ru`, v: `Менеджер` }, { l: `pl`, v: `PL: Manager` }, { l: `nb`, v: `NB: Manager` }, { l: `en`, v: `Manager` }, { l: `da`, v: `DA: Manager` },);
        this.set(`_99`, { l: `fi`, v: `Tyhjennä Redis välimuisti` }, { l: `uk`, v: `Очистити кеш Redis` }, { l: `sv`, v: `Töm Redis Cache` }, { l: `ru`, v: `Очистить кэш Redis` }, { l: `pl`, v: `PL: Clear Redis Cache` }, { l: `nb`, v: `NB: Clear Redis Cache` }, { l: `en`, v: `Clear Redis Cache` }, { l: `da`, v: `DA: Clear Redis Cache` },);
        this.set(`_9A`, { l: `fi`, v: `Oletko varma, että haluat tyhjentää Redis välimuistin ja istunnon?` }, { l: `uk`, v: `Ви справді хочете очистити кеш та сесію Redis.` }, { l: `sv`, v: `Är du säker at du vill tömma Redis Cache och sessionen?` }, { l: `ru`, v: `Вы уверены, что хотите очистить кэш и сессию Redis?` }, { l: `pl`, v: `PL: Are you sure you want to clear Redis cache and session?` }, { l: `nb`, v: `NB: Are you sure you want to clear Redis cache and session?` }, { l: `en`, v: `Are you sure you want to clear Redis cache and session?` }, { l: `da`, v: `DA: Are you sure you want to clear Redis cache and session?` },);
        this.set(`_9B`, { l: `fi`, v: `Lopeta käyttäjäistunnot` }, { l: `uk`, v: `Очистити сесію користувачів` }, { l: `sv`, v: `Avsluta användarsessioner` }, { l: `ru`, v: `Сбросить пользовательские сессии` }, { l: `pl`, v: `PL: Drop Users Sessions` }, { l: `nb`, v: `NB: Drop Users Sessions` }, { l: `en`, v: `Drop Users Sessions` }, { l: `da`, v: `DA: Drop Users Sessions` },);
        this.set(`_9C`, { l: `fi`, v: `Oletko varma, että haluat lopettaa kaikki käyttäjäistunnot, käyttäjien täytyy kirjautua sisään uudestaan?` }, { l: `uk`, v: `Ви справді хочете очистити сесію всіх користувачів, користувачу доведеться зайти заново.` }, { l: `sv`, v: `Är du säker att du vill avsluta alla användarsessioner, användare måste logga in på nytt.` }, { l: `ru`, v: `Вы уверены, что хотите сбросить все пользовательские сессии, пользователю придется зайти заного?` }, { l: `pl`, v: `PL: Are you sure you want to drop all user session, user will need to re-login?` }, { l: `nb`, v: `NB: Are you sure you want to drop all user session, user will need to re-login?` }, { l: `en`, v: `Are you sure you want to drop all user session, user will need to re-login?` }, { l: `da`, v: `DA: Are you sure you want to drop all user session, user will need to re-login?` },);
        this.set(`_9D`, { l: `fi`, v: `Sähköposti testi` }, { l: `uk`, v: `Тестувати електронну пошту.` }, { l: `sv`, v: `Test e-post` }, { l: `ru`, v: `Email тест` }, { l: `pl`, v: `PL: Test Email` }, { l: `nb`, v: `NB: Test Email` }, { l: `en`, v: `Test Email` }, { l: `da`, v: `DA: Test Email` },);
        this.set(`_9E`, { l: `fi`, v: `Sähköposti testi epäonnistui.\nVirhe:\n{0}` }, { l: `uk`, v: `Тестування електронної пошти провалилося.\nПомилка:\n{0}` }, { l: `sv`, v: `E-mail test misslyckades.\nFel:\n{0}` }, { l: `ru`, v: `Email тест провален\nОшибка:\n{0}` }, { l: `pl`, v: `PL: Email test failed.\nError:\n{0}` }, { l: `nb`, v: `NB: Email test failed.\nError:\n{0}` }, { l: `en`, v: `Email test failed.\nError:\n{0}` }, { l: `da`, v: `DA: Email test failed.\nError:\n{0}` },);
        this.set(`_9F`, { l: `fi`, v: `Sähköposti lähetetty onnistuneesti.` }, { l: `uk`, v: `Електронного листа успішно відправленно.` }, { l: `sv`, v: `E-post skickat` }, { l: `ru`, v: `Email успешно отправлен.` }, { l: `pl`, v: `PL: Email successfully sent.` }, { l: `nb`, v: `NB: Email successfully sent.` }, { l: `en`, v: `Email successfully sent.` }, { l: `da`, v: `DA: Email successfully sent.` },);
        this.set(`_A0`, { l: `fi`, v: `Testi Pdf` }, { l: `uk`, v: `Тестувати Pdf` }, { l: `sv`, v: `Test Pdf` }, { l: `ru`, v: `Pdf тест` }, { l: `pl`, v: `PL: Test Pdf` }, { l: `nb`, v: `NB: Test Pdf` }, { l: `en`, v: `Test Pdf` }, { l: `da`, v: `DA: Test Pdf` },);
        this.set(`_A1`, { l: `fi`, v: `Pdf testi epäonnistui.\nPdf versio: "{0}".\nVirhe:\n{1}` }, { l: `uk`, v: `Тестування Pdf провалилося.\nВерсія Pdf: "{0}".\nПомилка: :\n{1}` }, { l: `sv`, v: `Pdf test misslyckades.\nPdf version "{0}".\nFel:\n{1}` }, { l: `ru`, v: `Pdf тест провален.\nВерсия Pdf: "{0}".\nОшибка:\n{1}` }, { l: `pl`, v: `PL: Pdf test failed.\nPdf version: "{0}".\nError:\n{1}` }, { l: `nb`, v: `NB: Pdf test failed.\nPdf version: "{0}".\nError:\n{1}` }, { l: `en`, v: `Pdf test failed.\nPdf version: "{0}".\nError:\n{1}` }, { l: `da`, v: `DA: Pdf test failed.\nPdf version: "{0}".\nError:\n{1}` },);
        this.set(`_A2`, { l: `fi`, v: `Pdf versio: "{0}".` }, { l: `uk`, v: `Pdf версія: "{0}".` }, { l: `sv`, v: `Pdf version: "{0}".` }, { l: `ru`, v: `Версия Pdf: "{0}".` }, { l: `pl`, v: `PL: Pdf version: "{0}".` }, { l: `nb`, v: `NB: Pdf version: "{0}".` }, { l: `en`, v: `Pdf version: "{0}".` }, { l: `da`, v: `DA: Pdf version: "{0}".` },);
        this.set(`_A3`, { l: `fi`, v: `SMS testi` }, { l: `uk`, v: `Тестувати SMS` }, { l: `sv`, v: `Test SMS` }, { l: `ru`, v: `SMS тест` }, { l: `pl`, v: `PL: Test SMS` }, { l: `nb`, v: `NB: Test SMS` }, { l: `en`, v: `Test SMS` }, { l: `da`, v: `DA: Test SMS` },);
        this.set(`_A4`, { l: `fi`, v: `Sms testi epäonnistui.\nError:\n{0}` }, { l: `uk`, v: `Тестування SMS провалилося.\nПомилка:\n{0}` }, { l: `sv`, v: `SMS test misslyckades.\nFel:\n{0}` }, { l: `ru`, v: `SMS тест провален.\nОшибка:\n{0}` }, { l: `pl`, v: `PL: Sms test failed.\nError:\n{0}` }, { l: `nb`, v: `NB: Sms test failed.\nError:\n{0}` }, { l: `en`, v: `Sms test failed.\nError:\n{0}` }, { l: `da`, v: `DA: Sms test failed.\nError:\n{0}` },);
        this.set(`_A5`, { l: `fi`, v: `Sms lähetetty onnistuneesti.` }, { l: `uk`, v: `SMS успішно відправленно.` }, { l: `sv`, v: `SMS har skickats` }, { l: `ru`, v: `SMS успешно отправлено.` }, { l: `pl`, v: `PL: Sms successfully sent.` }, { l: `nb`, v: `NB: Sms successfully sent.` }, { l: `en`, v: `Sms successfully sent.` }, { l: `da`, v: `DA: Sms successfully sent.` },);
        this.set(`_A6`, { l: `fi`, v: `Admin konsoli` }, { l: `uk`, v: `Консоль адміністратора` }, { l: `sv`, v: `Admin konsol` }, { l: `ru`, v: `Консоль администратора` }, { l: `pl`, v: `PL: Admin console` }, { l: `nb`, v: `NB: Admin console` }, { l: `en`, v: `Admin console` }, { l: `da`, v: `DA: Admin console` },);
        this.set(`_A7`, { l: `fi`, v: `Sähköpostiosoite pitäisi olla oikeassa muodossa` }, { l: `uk`, v: `Email має бути коректним.` }, { l: `sv`, v: `Epost måste vara korrekt format` }, { l: `ru`, v: `Email должен быть корректным.` }, { l: `pl`, v: `PL: Email must be a proper email form` }, { l: `nb`, v: `NB: Email must be a proper email form` }, { l: `en`, v: `Email must be a proper email form` }, { l: `da`, v: `DA: Email must be a proper email form` },);
        this.set(`_A8`, { l: `fi`, v: `Salasanassa pitää olla vähintään 8 merkkiä, yksi iso kirjain ja yksi erikoismerkki` }, { l: `uk`, v: `Пароль має містити цифри та літери, один символ нижнього регістру ('a'-'z'), один верхнього регістру ('A'-'Z'), одну цифру та бути принаймні 8 символів завдовжки.` }, { l: `sv`, v: `Lösenordet måste innehålla minst 8 tecken, en stor bokstav och ett special märke` }, { l: `ru`, v: `В пароле должно быть не менее 8 символов, не менее 1 цифры , не менее 1 строчной буквы ('A'-'Z') , не менее 1 прописной буквы ('a'-'z') , не менее 1 не буквенно-цифрового символа.` }, { l: `pl`, v: `PL: Password must contain at least 1 lowercase, 1 uppercase character, 1 special character and be at least 8 characters long` }, { l: `nb`, v: `NB: Password must contain at least 1 lowercase, 1 uppercase character, 1 special character and be at least 8 characters long` }, { l: `en`, v: `Password must contain at least 1 lowercase, 1 uppercase character, 1 special character and be at least 8 characters long` }, { l: `da`, v: `DA: Password must contain at least 1 lowercase, 1 uppercase character, 1 special character and be at least 8 characters long` },);
        this.set(`_A9`, { l: `fi`, v: `Tarkista numero.` }, { l: `uk`, v: `Некоректний номер телефону.` }, { l: `sv`, v: `Felaktigt telefonnummer.` }, { l: `ru`, v: `Некорректный номер телефона.` }, { l: `pl`, v: `PL: Incorrect phone number.` }, { l: `nb`, v: `NB: Incorrect phone number.` }, { l: `en`, v: `Incorrect phone number.` }, { l: `da`, v: `DA: Incorrect phone number.` },);
        this.set(`_AA`, { l: `fi`, v: `{0} on pakollinen` }, { l: `uk`, v: `Потрібно {0}` }, { l: `sv`, v: `{0} krävs` }, { l: `ru`, v: `Требуется {0}` }, { l: `pl`, v: `PL: {0} is required` }, { l: `nb`, v: `NB: {0} is required` }, { l: `en`, v: `{0} is required` }, { l: `da`, v: `DA: {0} is required` },);
        this.set(`_AB`, { l: `fi`, v: `Arvo pitää olla välistä {0} - {1}.` }, { l: `uk`, v: `Значення має бути в діапазоні {0} - {1}.` }, { l: `sv`, v: `Värdet måste ligga inom intervallet {0} - {1}.` }, { l: `ru`, v: `Значение должно быть в диапазоне {0} - {1}.` }, { l: `pl`, v: `PL: Value must be in range {0} - {1}.` }, { l: `nb`, v: `NB: Value must be in range {0} - {1}.` }, { l: `en`, v: `Value must be in range {0} - {1}.` }, { l: `da`, v: `DA: Value must be in range {0} - {1}.` },);
        this.set(`_AC`, { l: `fi`, v: `Teksti on lian lyhyt` }, { l: `uk`, v: `Текст надто короткий` }, { l: `sv`, v: `Texten är för kort` }, { l: `ru`, v: `Текст слишком короткий` }, { l: `pl`, v: `PL: Text is too short` }, { l: `nb`, v: `NB: Text is too short` }, { l: `en`, v: `Text is too short` }, { l: `da`, v: `DA: Text is too short` },);
        this.set(`_AD`, { l: `fi`, v: `Virheellinen URL-osoite` }, { l: `uk`, v: `Неправильний URL формат.` }, { l: `sv`, v: `Felaktigt URL-format.` }, { l: `ru`, v: `Некорректный URL формат.` }, { l: `pl`, v: `PL: Incorrect URL format.` }, { l: `nb`, v: `NB: Incorrect URL format.` }, { l: `en`, v: `Incorrect URL format.` }, { l: `da`, v: `DA: Incorrect URL format.` },);
        this.set(`_AE`, { l: `fi`, v: `Toimenpide` }, { l: `uk`, v: `Дії` }, { l: `sv`, v: `Åtgärder` }, { l: `ru`, v: `Действия` }, { l: `pl`, v: `Działania` }, { l: `nb`, v: `NB: Actions` }, { l: `en`, v: `Actions` }, { l: `da`, v: `DA: Actions` },);
        this.set(`_AF`, { l: `fi`, v: `Tallenna` }, { l: `uk`, v: `Зберегти` }, { l: `sv`, v: `Spara` }, { l: `ru`, v: `Сохранить` }, { l: `pl`, v: `Zapisz` }, { l: `nb`, v: `Lagre` }, { l: `en`, v: `Save` }, { l: `da`, v: `Gemme` },);
        this.set(`_B0`, { l: `fi`, v: `Takaisin` }, { l: `uk`, v: `Назад` }, { l: `sv`, v: `Tillbaka` }, { l: `ru`, v: `Назад` }, { l: `pl`, v: `Plecy` }, { l: `nb`, v: `Tilbake` }, { l: `en`, v: `Back` }, { l: `da`, v: `Tilbage` },);
        this.set(`_B1`, { l: `fi`, v: `Lataa uudelleen` }, { l: `uk`, v: `Оновити` }, { l: `sv`, v: `Ladda om` }, { l: `ru`, v: `Обновить` }, { l: `pl`, v: `PL: Reload` }, { l: `nb`, v: `Last på nytt` }, { l: `en`, v: `Reload` }, { l: `da`, v: `DA: Reload` },);
        this.set(`_B2`, { l: `fi`, v: `Etsi` }, { l: `uk`, v: `Пошук` }, { l: `sv`, v: `Sök` }, { l: `ru`, v: `Поиск` }, { l: `pl`, v: `Szukaj` }, { l: `nb`, v: `Sök` }, { l: `en`, v: `Search` }, { l: `da`, v: `Søg` },);
        this.set(`_B3`, { l: `fi`, v: `Poista` }, { l: `uk`, v: `Видалити` }, { l: `sv`, v: `Radera` }, { l: `ru`, v: `Удалить` }, { l: `pl`, v: `Kasować` }, { l: `nb`, v: `Slett` }, { l: `en`, v: `Delete` }, { l: `da`, v: `Slet` },);
        this.set(`_B4`, { l: `fi`, v: `Palauta` }, { l: `uk`, v: `Відновити` }, { l: `sv`, v: `Återställ` }, { l: `ru`, v: `Восстановить` }, { l: `pl`, v: `PL: Restore` }, { l: `nb`, v: `Gjennopprett` }, { l: `en`, v: `Restore` }, { l: `da`, v: `Nulstil ` },);
        this.set(`_B5`, { l: `fi`, v: `Muokkaa` }, { l: `uk`, v: `Правити` }, { l: `sv`, v: `Redigera` }, { l: `ru`, v: `Изменить` }, { l: `pl`, v: `Edytować` }, { l: `nb`, v: `Redigere` }, { l: `en`, v: `Edit` }, { l: `da`, v: `Redigere` },);
        this.set(`_B6`, { l: `fi`, v: `Lisää` }, { l: `uk`, v: `Додати` }, { l: `sv`, v: `Lägg till` }, { l: `ru`, v: `Добавить` }, { l: `pl`, v: `Dodaj` }, { l: `nb`, v: `Legg til` }, { l: `en`, v: `Add` }, { l: `da`, v: `Tilføj` },);
        this.set(`_B7`, { l: `fi`, v: `Osoite` }, { l: `uk`, v: `Адресса` }, { l: `sv`, v: `Adress` }, { l: `ru`, v: `Адрес` }, { l: `pl`, v: `Adres` }, { l: `nb`, v: `Adresse` }, { l: `en`, v: `Address` }, { l: `da`, v: `Adresse` },);
        this.set(`_B8`, { l: `fi`, v: `Aktivoida` }, { l: `uk`, v: `Активувати` }, { l: `sv`, v: `Aktivera` }, { l: `ru`, v: `Активировать` }, { l: `pl`, v: `PL: Activate` }, { l: `nb`, v: `NB: Activate` }, { l: `en`, v: `Activate` }, { l: `da`, v: `DA: Activate` },);
        this.set(`_B9`, { l: `fi`, v: `Poista käytöstä` }, { l: `uk`, v: `Деактивувати` }, { l: `sv`, v: `Avaktivera` }, { l: `ru`, v: `Деактивировать` }, { l: `pl`, v: `PL: Deactivate` }, { l: `nb`, v: `NB: Deactivate` }, { l: `en`, v: `Deactivate` }, { l: `da`, v: `DA: Deactivate` },);
        this.set(`_BA`, { l: `fi`, v: `Seuraava` }, { l: `uk`, v: `Далі` }, { l: `sv`, v: `Nästa` }, { l: `ru`, v: `Далее` }, { l: `pl`, v: `Następny` }, { l: `nb`, v: `Neste` }, { l: `en`, v: `Next` }, { l: `da`, v: `Næste` },);
        this.set(`_BB`, { l: `fi`, v: `Päivämäärä` }, { l: `uk`, v: `Дата` }, { l: `sv`, v: `Datum` }, { l: `ru`, v: `Дата` }, { l: `pl`, v: `Data` }, { l: `nb`, v: `Dato` }, { l: `en`, v: `Date` }, { l: `da`, v: `Dato` },);
        this.set(`_BC`, { l: `fi`, v: `Ladataan..` }, { l: `uk`, v: `Завантаження...` }, { l: `sv`, v: `Laddar..` }, { l: `ru`, v: `Загрузка...` }, { l: `pl`, v: `Ładowanie...` }, { l: `nb`, v: `Laster…` }, { l: `en`, v: `Loading..` }, { l: `da`, v: `Indlæser...` },);
        this.set(`_BD`, { l: `fi`, v: `Nimi` }, { l: `uk`, v: `I'мя` }, { l: `sv`, v: `Namn` }, { l: `ru`, v: `Имя` }, { l: `pl`, v: `Nazwa` }, { l: `nb`, v: `Navn` }, { l: `en`, v: `Name` }, { l: `da`, v: `Navn` },);
        this.set(`_BE`, { l: `fi`, v: `Ei tietoja` }, { l: `uk`, v: `Немає даних` }, { l: `sv`, v: `Ingen data` }, { l: `ru`, v: `Нет данных` }, { l: `pl`, v: `Brak danych` }, { l: `nb`, v: `Ingen data` }, { l: `en`, v: `No data` }, { l: `da`, v: `Ingen data` },);
        this.set(`_BF`, { l: `fi`, v: `ALV-numero` }, { l: `uk`, v: `ІПН` }, { l: `sv`, v: `MOMS-nummer` }, { l: `ru`, v: `ИНН` }, { l: `pl`, v: `NIP` }, { l: `nb`, v: `MVA-nummer` }, { l: `en`, v: `VAT id` }, { l: `da`, v: `CVR-nummer` },);
        this.set(`_C0`, { l: `fi`, v: `Y-tunnus` }, { l: `uk`, v: `Податковий номер` }, { l: `sv`, v: `FO-nummer` }, { l: `ru`, v: `Налоговый номер` }, { l: `pl`, v: `REGON` }, { l: `nb`, v: `NB: Business Id` }, { l: `en`, v: `Business Id` }, { l: `da`, v: `DA: Business Id` },);
        this.set(`_C1`, { l: `fi`, v: `Hyväksy` }, { l: `uk`, v: `Прийняти` }, { l: `sv`, v: `Godkänn` }, { l: `ru`, v: `Принять` }, { l: `pl`, v: `Zaakceptuj` }, { l: `nb`, v: `Godta` }, { l: `en`, v: `Accept` }, { l: `da`, v: `Godkend` },);
        this.set(`_C2`, { l: `fi`, v: `Kaupunki` }, { l: `uk`, v: `Мiсто` }, { l: `sv`, v: `Stad` }, { l: `ru`, v: `Город` }, { l: `pl`, v: `Miejscowość` }, { l: `nb`, v: `By` }, { l: `en`, v: `City` }, { l: `da`, v: `By` },);
        this.set(`_C3`, { l: `fi`, v: `Sulje` }, { l: `uk`, v: `Закрити` }, { l: `sv`, v: `Stäng` }, { l: `ru`, v: `Закрыть` }, { l: `pl`, v: `Zamknij` }, { l: `nb`, v: `Avslutt` }, { l: `en`, v: `Close` }, { l: `da`, v: `Luk` },);
        this.set(`_C4`, { l: `fi`, v: `Lisätiedot` }, { l: `uk`, v: `Інформація` }, { l: `sv`, v: `Mer information` }, { l: `ru`, v: `Информация` }, { l: `pl`, v: `Informacja` }, { l: `nb`, v: `Informasjon` }, { l: `en`, v: `Information` }, { l: `da`, v: `Yderligere information` },);
        this.set(`_C5`, { l: `fi`, v: `Yhtiö` }, { l: `uk`, v: `Компанія` }, { l: `sv`, v: `Företag` }, { l: `ru`, v: `Компания` }, { l: `pl`, v: `Firma` }, { l: `nb`, v: `Selskap` }, { l: `en`, v: `Company` }, { l: `da`, v: `Virksomhed` },);
        this.set(`_C6`, { l: `fi`, v: `Asiakas` }, { l: `uk`, v: `Клієнт` }, { l: `sv`, v: `Kund` }, { l: `ru`, v: `Клиент` }, { l: `pl`, v: `Klient` }, { l: `nb`, v: `Kunde` }, { l: `en`, v: `Customer` }, { l: `da`, v: `Kunde` },);
        this.set(`_C7`, { l: `fi`, v: `Lukumäärä` }, { l: `uk`, v: `Кількість` }, { l: `sv`, v: `Nummer` }, { l: `ru`, v: `Количество` }, { l: `pl`, v: `Policz` }, { l: `nb`, v: `Nummer` }, { l: `en`, v: `Count` }, { l: `da`, v: `Nummer` },);
        this.set(`_C8`, { l: `fi`, v: `Luo` }, { l: `uk`, v: `Створити` }, { l: `sv`, v: `Skapa` }, { l: `ru`, v: `Создать` }, { l: `pl`, v: `Utwórz` }, { l: `nb`, v: `Opprett` }, { l: `en`, v: `Create` }, { l: `da`, v: `Opret` },);
        this.set(`_C9`, { l: `fi`, v: `päivä` }, { l: `uk`, v: `День` }, { l: `sv`, v: `dag` }, { l: `ru`, v: `День` }, { l: `pl`, v: `dzień` }, { l: `nb`, v: `dag` }, { l: `en`, v: `day` }, { l: `da`, v: `dag` },);
        this.set(`_CA`, { l: `fi`, v: `Kuvaus` }, { l: `uk`, v: `Опис` }, { l: `sv`, v: `Beskrivning` }, { l: `ru`, v: `Описание` }, { l: `pl`, v: `Opis` }, { l: `nb`, v: `Beskrivelse` }, { l: `en`, v: `Description` }, { l: `da`, v: `Beskrivelse` },);
        this.set(`_CB`, { l: `fi`, v: `Sähköposti` }, { l: `uk`, v: `Email` }, { l: `sv`, v: `E-post` }, { l: `ru`, v: `Email` }, { l: `pl`, v: `Email kontaktowy` }, { l: `nb`, v: `E-post` }, { l: `en`, v: `Email` }, { l: `da`, v: `E-mail` },);
        this.set(`_CC`, { l: `fi`, v: `Virhe` }, { l: `uk`, v: `Помилка` }, { l: `sv`, v: `Fel` }, { l: `ru`, v: `Ошибка` }, { l: `pl`, v: `Błąd` }, { l: `nb`, v: `Feil` }, { l: `en`, v: `Error` }, { l: `da`, v: `Fejl` },);
        this.set(`_CD`, { l: `fi`, v: `Suosikit` }, { l: `uk`, v: `Збережене` }, { l: `sv`, v: `Favoriter` }, { l: `ru`, v: `Избранное` }, { l: `pl`, v: `Ulubione` }, { l: `nb`, v: `Favoritter` }, { l: `en`, v: `Favorites` }, { l: `da`, v: `Favoritter` },);
        this.set(`_CE`, { l: `fi`, v: `Etunimi` }, { l: `uk`, v: `I'мя` }, { l: `sv`, v: `Förnamn` }, { l: `ru`, v: `Имя` }, { l: `pl`, v: `Imię` }, { l: `nb`, v: `Fornavn` }, { l: `en`, v: `First name` }, { l: `da`, v: `Fornavn` },);
        this.set(`_CF`, { l: `fi`, v: `Sukunimi` }, { l: `uk`, v: `Прiзвище` }, { l: `sv`, v: `Efternamn` }, { l: `ru`, v: `Фамилия` }, { l: `pl`, v: `Nazwisko` }, { l: `nb`, v: `Etternavn` }, { l: `en`, v: `Last name` }, { l: `da`, v: `Efternavn` },);
        this.set(`_D0`, { l: `fi`, v: `Kirjaudu` }, { l: `uk`, v: `Увійти` }, { l: `sv`, v: `Logga in` }, { l: `ru`, v: `Войти` }, { l: `pl`, v: `Zaloguj sie` }, { l: `nb`, v: `Logg Inn` }, { l: `en`, v: `Login` }, { l: `da`, v: `Log på` },);
        this.set(`_D1`, { l: `fi`, v: `Viesti` }, { l: `uk`, v: `Повідомлення` }, { l: `sv`, v: `Meddelande` }, { l: `ru`, v: `Сообщение` }, { l: `pl`, v: `Wiadomość` }, { l: `nb`, v: `Melding` }, { l: `en`, v: `Message` }, { l: `da`, v: `Meddelelse` },);
        this.set(`_D2`, { l: `fi`, v: `kuukausi` }, { l: `uk`, v: `місяць` }, { l: `sv`, v: `månad` }, { l: `ru`, v: `месяц` }, { l: `pl`, v: `miesiąc` }, { l: `nb`, v: `måned` }, { l: `en`, v: `month` }, { l: `da`, v: `måned` },);
        this.set(`_D3`, { l: `fi`, v: `Salasana` }, { l: `uk`, v: `Пароль` }, { l: `sv`, v: `Lösenord` }, { l: `ru`, v: `Пароль` }, { l: `pl`, v: `Hasło` }, { l: `nb`, v: `Passord` }, { l: `en`, v: `Password` }, { l: `da`, v: `Adgangskode` },);
        this.set(`_D4`, { l: `fi`, v: `Puhelinnumero` }, { l: `uk`, v: `Номер телефону` }, { l: `sv`, v: `Telefonnummer` }, { l: `ru`, v: `Номер телефона` }, { l: `pl`, v: `Nr telefonu` }, { l: `nb`, v: `Telefonnummer` }, { l: `en`, v: `Phone number` }, { l: `da`, v: `Telefonnummer` },);
        this.set(`_D5`, { l: `fi`, v: `Postinumero` }, { l: `uk`, v: `Поштовий індекс` }, { l: `sv`, v: `Postnummer` }, { l: `ru`, v: `Почтовый индекс` }, { l: `pl`, v: `Kod pocztowy` }, { l: `nb`, v: `Postnummer` }, { l: `en`, v: `Postal code` }, { l: `da`, v: `Postnummer` },);
        this.set(`_D6`, { l: `fi`, v: `Hylkää` }, { l: `uk`, v: `Відхилити` }, { l: `sv`, v: `Avvisa` }, { l: `ru`, v: `Отклонить` }, { l: `pl`, v: `Odrzucić` }, { l: `nb`, v: `Avvise` }, { l: `en`, v: `Reject` }, { l: `da`, v: `Afvise` },);
        this.set(`_D7`, { l: `fi`, v: `Lähetä` }, { l: `uk`, v: `Відправити` }, { l: `sv`, v: `Skicka` }, { l: `ru`, v: `Отправить` }, { l: `pl`, v: `Wyślij` }, { l: `nb`, v: `Send` }, { l: `en`, v: `Send` }, { l: `da`, v: `Send` },);
        this.set(`_D8`, { l: `fi`, v: `viikko` }, { l: `uk`, v: `тиждень` }, { l: `sv`, v: `vecka` }, { l: `ru`, v: `неделя` }, { l: `pl`, v: `tydzień` }, { l: `nb`, v: `uke` }, { l: `en`, v: `week` }, { l: `da`, v: `uge` },);
        this.set(`_D9`, { l: `fi`, v: `Mistä` }, { l: `uk`, v: `З` }, { l: `sv`, v: `Från` }, { l: `ru`, v: `С` }, { l: `pl`, v: `Z` }, { l: `nb`, v: `NB: From` }, { l: `en`, v: `From` }, { l: `da`, v: `DA: From` },);
        this.set(`_DA`, { l: `fi`, v: `Mihin` }, { l: `uk`, v: `До` }, { l: `sv`, v: `Till` }, { l: `ru`, v: `По` }, { l: `pl`, v: `Do` }, { l: `nb`, v: `NB: To` }, { l: `en`, v: `To` }, { l: `da`, v: `DA: To` },);
        this.set(`_DB`, { l: `fi`, v: `Lataa` }, { l: `uk`, v: `Завантажити` }, { l: `sv`, v: `Ladda ner` }, { l: `ru`, v: `Загрузить` }, { l: `pl`, v: `Pobierz` }, { l: `nb`, v: `Last ned` }, { l: `en`, v: `Download` }, { l: `da`, v: `Download` },);
        this.set(`_DC`, { l: `fi`, v: `Esikatsele` }, { l: `uk`, v: `Переглянути` }, { l: `sv`, v: `Förhandsvisning` }, { l: `ru`, v: `Предпросмотр` }, { l: `pl`, v: `Podgląd` }, { l: `nb`, v: `Forhåndsvisning` }, { l: `en`, v: `Preview` }, { l: `da`, v: `Eksempel` },);
        this.set(`_DD`, { l: `fi`, v: `Käyttäjänimi` }, { l: `uk`, v: `Iм'я користувача` }, { l: `sv`, v: `Användarnamn` }, { l: `ru`, v: `Имя пользователя` }, { l: `pl`, v: `PL: Username` }, { l: `nb`, v: `NB: Username` }, { l: `en`, v: `Username` }, { l: `da`, v: `DA: Username` },);
        this.set(`_DE`, { l: `fi`, v: `Kieltäydy` }, { l: `uk`, v: `Відхилити` }, { l: `sv`, v: `Avslå` }, { l: `ru`, v: `Отклонить` }, { l: `pl`, v: `PL: Decline` }, { l: `nb`, v: `NB: Decline` }, { l: `en`, v: `Decline` }, { l: `da`, v: `DA: Decline` },);
        this.set(`_DF`, { l: `fi`, v: `Suomi` }, { l: `uk`, v: `Фінляндія` }, { l: `sv`, v: `Finland` }, { l: `ru`, v: `Финляндия` }, { l: `pl`, v: `Finlandia` }, { l: `nb`, v: `Finland` }, { l: `en`, v: `Finland` }, { l: `da`, v: `Finland` },);
        this.set(`_E0`, { l: `fi`, v: `Ruotsi` }, { l: `uk`, v: `Швеція` }, { l: `sv`, v: `Sverige` }, { l: `ru`, v: `Швеция` }, { l: `pl`, v: `Szwecja` }, { l: `nb`, v: `Sverige` }, { l: `en`, v: `Sweden` }, { l: `da`, v: `Sverige` },);
        this.set(`_E1`, { l: `fi`, v: `Norja` }, { l: `uk`, v: `Норвегія` }, { l: `sv`, v: `Norge` }, { l: `ru`, v: `Норвегия` }, { l: `pl`, v: `Norwegia` }, { l: `nb`, v: `Norge` }, { l: `en`, v: `Norway` }, { l: `da`, v: `Norge` },);
        this.set(`_E2`, { l: `fi`, v: `Tanska` }, { l: `uk`, v: `Данія` }, { l: `sv`, v: `Danmark` }, { l: `ru`, v: `Дания` }, { l: `pl`, v: `Dania` }, { l: `nb`, v: `Danmark` }, { l: `en`, v: `Denmark` }, { l: `da`, v: `Danmark` },);
        this.set(`_E3`, { l: `fi`, v: `Puola` }, { l: `uk`, v: `Польща` }, { l: `sv`, v: `Polen` }, { l: `ru`, v: `Польша` }, { l: `pl`, v: `Polska` }, { l: `nb`, v: `Polen` }, { l: `en`, v: `Poland` }, { l: `da`, v: `Polen` },);
        this.set(`_E4`, { l: `fi`, v: `Venäjä` }, { l: `uk`, v: `Росія` }, { l: `sv`, v: `Ryssland` }, { l: `ru`, v: `Россия` }, { l: `pl`, v: `Rosja` }, { l: `nb`, v: `Russland` }, { l: `en`, v: `Russia` }, { l: `da`, v: `Rusland` },);
        this.set(`_E5`, { l: `fi`, v: `Ukraina` }, { l: `uk`, v: `Україна` }, { l: `sv`, v: `Ukraina` }, { l: `ru`, v: `Украина` }, { l: `pl`, v: `Ukraina` }, { l: `nb`, v: `Ukraina` }, { l: `en`, v: `Ukraine` }, { l: `da`, v: `Ukraine` },);
        this.set(`_E6`, { l: `fi`, v: `Käyttäjien hallinta & asetukset` }, { l: `uk`, v: `Керування користувачами та налаштування` }, { l: `sv`, v: `Användar hantering och inställningar` }, { l: `ru`, v: `Управление пользователями и настройки` }, { l: `pl`, v: `PL: User management & settings` }, { l: `nb`, v: `NB: User management & settings` }, { l: `en`, v: `User management & settings` }, { l: `da`, v: `DA: User management & settings` },);
        this.set(`_E7`, { l: `fi`, v: `Ota yhteyttä asiakaspalveluun` }, { l: `uk`, v: `Звʼязатися зі службою підтримки` }, { l: `sv`, v: `Kontakta kundservice` }, { l: `ru`, v: `Связаться со службой поддержки` }, { l: `pl`, v: `PL: Contact support` }, { l: `nb`, v: `NB: Contact support` }, { l: `en`, v: `Contact support` }, { l: `da`, v: `DA: Contact support` },);
        this.set(`_E8`, { l: `fi`, v: `Yhdysvallat` }, { l: `uk`, v: `Сполучені Штати` }, { l: `sv`, v: `Förenta staterna` }, { l: `ru`, v: `Соединенные Штаты` }, { l: `pl`, v: `Stany Zjednoczone` }, { l: `nb`, v: `Forente stater` }, { l: `en`, v: `United States` }, { l: `da`, v: `Forenede Stater` },);
        this.set(`_E9`, { l: `fi`, v: `Ei verkkoyhteyttä` }, { l: `sv`, v: `Off-line` }, { l: `en`, v: `Offline` },);
        this.set(`_EA`, { l: `fi`, v: `Et ole yhteydessä verkkoon. Kokeile myöhemmin uudelleen tai tarkista Internet-yhteytesi tila.` }, { l: `sv`, v: `Du är inte ansluten till nätverket. Försök igen senare eller kontrollera statusen för din internetanslutning.` }, { l: `en`, v: `You are offline. Try again later or check your internet connection. If you are working from a mobile device, check your Internet or WiFi settings.` },);
        this.set(`_EB`, { l: `fi`, v: `Näytä lisää` }, { l: `sv`, v: `Visa mer` }, { l: `en`, v: `Show More` },);
        this.set(`_EC`, { l: `fi`, v: `Ei ilmoituksia` }, { l: `sv`, v: `Inga aviseringar` }, { l: `en`, v: `No notifications` },);
        this.set(`_ED`, { l: `fi`, v: `Ilmoitukset` }, { l: `sv`, v: `Aviseringar` }, { l: `en`, v: `Notifications` },);
        this.set(`_EE`, { l: `fi`, v: `FI: There is already an account with the given phone number. Please, specify a different phone number.` }, { l: `en`, v: `There is already an account with the given phone number. Please, specify a different phone number.` },);
        this.set(`_EF`, { l: `fi`, v: `FI: There is already an account with the given email. Please, specify a different email.` }, { l: `en`, v: `There is already an account with the given email. Please, specify a different email.` },);
        this.set(`_F0`, { l: `fi`, v: `Ajanvaraus` }, { l: `sv`, v: `Tidsbokning` },);
        this.set(`_F1`, { l: `fi`, v: `Asiantuntijat` }, { l: `sv`, v: `Specialister` },);
        this.set(`_F2`, { l: `fi`, v: `Palvelut` }, { l: `sv`, v: `Tjänster` },);
        this.set(`_F3`, { l: `fi`, v: `Erikoisklinikat` }, { l: `sv`, v: `Specialkliniker` },);
        this.set(`_F4`, { l: `fi`, v: `Työterveys` }, { l: `sv`, v: `Företagshälsovård` },);
        this.set(`_F5`, { l: `fi`, v: `Hinnasto` }, { l: `sv`, v: `Prislista` },);
        this.set(`_F6`, { l: `fi`, v: `Yritys` }, { l: `sv`, v: `Företaget` },);
        this.set(`_F7`, { l: `fi`, v: `Ajanvaraus` }, { l: `sv`, v: `Tidsbokning` },);
        this.set(`_F8`, { l: `fi`, v: `Asiantuntijat` }, { l: `sv`, v: `Specialister` },);
        this.set(`_F9`, { l: `fi`, v: `Palvelut` }, { l: `sv`, v: `Tjänster` },);
        this.set(`_FA`, { l: `fi`, v: `Erikoisklinikat` }, { l: `sv`, v: `Specialistkliniker` },);
        this.set(`_FB`, { l: `fi`, v: `Työterveys` }, { l: `sv`, v: `Företagshälsovård` },);
        this.set(`_FC`, { l: `fi`, v: `Hinnasto` }, { l: `sv`, v: `Prislista` },);
        this.set(`_FD`, { l: `fi`, v: `Yritys` }, { l: `sv`, v: `Företaget` },);
        this.set(`_FE`, { l: `fi`, v: `Tervetuloa Lääkärikeskus Fenixiin!` }, { l: `sv`, v: `Välkommen till Läkarcentral Fenix!` },);
        this.set(`_FF`, { l: `fi`, v: `Varaa aika verkossa` }, { l: `sv`, v: `Boka tid online` },);
        this.set(`_100`, { l: `fi`, v: `Soita meille` }, { l: `sv`, v: `Ring oss` },);
        this.set(`_101`, { l: `fi`, v: `DigiFenix Etävastaanotto` }, { l: `sv`, v: `DigiFenix Distansmottagning` },);
        this.set(`_102`, { l: `fi`, v: `Työterveyshuollon ajanvaraus` }, { l: `sv`, v: `Bokning av företagshälsovårdstid` },);
        this.set(`_103`, { l: `fi`, v: `Etsi erikoisalaa, lääkäriä` }, { l: `sv`, v: `Sök specialområde, läkare` },);
        this.set(`_104`, { l: `fi`, v: `Toimipiste` }, { l: `sv`, v: `Verksamhetsställe` },);
        this.set(`_105`, { l: `fi`, v: `Tänään` }, { l: `sv`, v: `Idag` },);
        this.set(`_106`, { l: `fi`, v: `Varaa aika` }, { l: `sv`, v: `Boka en tid` },);
        this.set(`_107`, { l: `fi`, v: `Heti vapaat ajat` }, { l: `sv`, v: `Lediga tider direkt` },);
        this.set(`_108`, { l: `fi`, v: `Erikoisala` }, { l: `sv`, v: `Specialområde` },);
        this.set(`_109`, { l: `fi`, v: `Ei vapaita aikoja` }, { l: `sv`, v: `Inga tillgängliga tider` },);
        this.set(`_10A`, { l: `fi`, v: `Näytä lisää aikoja` }, { l: `sv`, v: `Visa fler tider` },);
        this.set(`_10B`, { l: `fi`, v: `Näytä lisää` }, { l: `sv`, v: `Visa mer` },);
        this.set(`_10C`, { l: `fi`, v: `Näytä kaikki` }, { l: `sv`, v: `Visa allt` },);
        this.set(`_10D`, { l: `fi`, v: `Lue lisää` }, { l: `sv`, v: `Läs mer` },);
        this.set(`_10E`, { l: `fi`, v: `Ajankohtaista` }, { l: `sv`, v: `Aktuellt` },);
        this.set(`_10F`, { l: `fi`, v: `Näytä vähemmän` }, { l: `sv`, v: `Visa mindre` },);
        this.set(`_110`, { l: `fi`, v: `Katso Facebookissa` }, { l: `sv`, v: `Se på Facebook` },);
        this.set(`_111`, { l: `fi`, v: `Sosiaalinen media` }, { l: `sv`, v: `Social media` },);
        this.set(`_112`, { l: `fi`, v: `Ajanvarauksen peruutus` }, { l: `sv`, v: `Avbokning av tid` },);
        this.set(`_113`, { l: `fi`, v: `Hoitava asiantuntija` }, { l: `sv`, v: `Vårdande expert` },);
        this.set(`_114`, { l: `fi`, v: `Hae aikoja välillä` }, { l: `sv`, v: `Välj datum` },);
        this.set(`_115`, { l: `fi`, v: `Valitse aikaväli` }, { l: `sv`, v: `Välj klockslag` },);
        this.set(`_116`, { l: `fi`, v: `Kaikki asiantuntijat` }, { l: `sv`, v: `Alla experter` },);
        this.set(`_117`, { l: `fi`, v: `Kaikki erikoisalat` }, { l: `sv`, v: `Alla specialområdes` },);
        this.set(`_118`, { l: `fi`, v: `Kaikki toimipisteet` }, { l: `sv`, v: `Alla verksamhetsställen` },);
        this.set(`_119`, { l: `fi`, v: `Siirry ajanvaraukseen` }, { l: `sv`, v: `Gå till tidsbokning` },);
        this.set(`_11A`, { l: `fi`, v: `Toimipisteet` }, { l: `sv`, v: `Platser` },);
        this.set(`_11B`, { l: `fi`, v: `Puhelinajanvaraus auki aukioloaikojen mukaisesti` }, { l: `sv`, v: `Telefontidsbokning öppen enligt öppettiderna` },);
        this.set(`_11C`, { l: `fi`, v: `Henkilötunnus` }, { l: `sv`, v: `Personnummer` },);
        this.set(`_11D`, { l: `fi`, v: `Työterveyden asiakkuutta ei löytynyt` }, { l: `sv`, v: `Det gick inte att hitta arbetslivshälsovårdens kundrelation` },);
        this.set(`_11E`, { l: `fi`, v: `Aika varattu` }, { l: `sv`, v: `Tid bokad` },);
        this.set(`_11F`, { l: `fi`, v: `Rekisteröi käyttäjätunnus` }, { l: `sv`, v: `Registrera ett användarnamn` },);
        this.set(`_120`, { l: `fi`, v: `Kirjaudu sisään` }, { l: `sv`, v: `Logga in` },);
        this.set(`_121`, { l: `fi`, v: `Ajanvarauksen vahvistaminen` }, { l: `sv`, v: `Bekräfta bokningen` },);
        this.set(`_122`, { l: `fi`, v: `Luo tunnus` }, { l: `sv`, v: `Skapa ett konto` },);
        this.set(`_123`, { l: `fi`, v: `Haluatko antaa jotain lisätietoja varaukseen liittyen (esim: tulosyy)?` }, { l: `sv`, v: `Vill du ange tilläggsuppgifter gällande bokningen? (t.ex. orsaken)` },);
        this.set(`_124`, { l: `fi`, v: `Vahvista varaus` }, { l: `sv`, v: `Bekräfta bokningen` },);
        this.set(`_125`, { l: `fi`, v: `Oletko ensimmäistä kertaa käyttämässä ajanvaraustamme? Luo itsellesi tai lapsellesi tunnukset` }, { l: `sv`, v: `Är det första gången du använder vår tidsbokning? Skapa ett konto åt dig själv eller åt ditt barn` },);
        this.set(`_126`, { l: `fi`, v: `Omat tietosi:` }, { l: `sv`, v: `Egna uppgifter:` },);
        this.set(`_127`, { l: `fi`, v: `Varauksen tiedot:` }, { l: `sv`, v: `Bokningens uppgifter:` },);
        this.set(`_128`, { l: `fi`, v: `Asiantuntijan nimi:` }, { l: `sv`, v: `Specialistens namn:` },);
        this.set(`_129`, { l: `fi`, v: `Päivämäärä:` }, { l: `sv`, v: `Datum:` },);
        this.set(`_12A`, { l: `fi`, v: `Kellonaika:` }, { l: `sv`, v: `Tid:` },);
        this.set(`_12B`, { l: `fi`, v: `Kiitos, aika varattu koodilla {0}.\n\nOtathan ylös varauksesi tiedot:` }, { l: `sv`, v: `Tack, tid bokad med kod {0}.\n\nVänligen skriva upp bokningsuppgifterna:` },);
        this.set(`_12C`, { l: `fi`, v: `Yhteydenottolomake` }, { l: `sv`, v: `Kontaktformulär` },);
        this.set(`_12D`, { l: `fi`, v: `Voit myös hyödyntää sähköistä ajanvarausjärjestelmäämme.` }, { l: `sv`, v: `Du kan också dra nytta av vårt elektroniska tidsbokningssystem.` },);
        this.set(`_12E`, { l: `fi`, v: `MA, KE, TO` }, { l: `sv`, v: `MÅ, ON, TO` },);
        this.set(`_12F`, { l: `fi`, v: `TI, PE` }, { l: `sv`, v: `TI, FR` },);
        this.set(`_130`, { l: `fi`, v: `LA` }, { l: `sv`, v: `LÖ` },);
        this.set(`_131`, { l: `fi`, v: `Puh.` }, { l: `sv`, v: `Tel.` },);
        this.set(`_132`, { l: `fi`, v: `Kaikki Aukioloajat` }, { l: `sv`, v: `Alla öppettider` },);
        this.set(`_133`, { l: `fi`, v: `Kirjaudu sisään peruuttaaksesi ajan` }, { l: `sv`, v: `Logga in för att avboka en tid` },);
        this.set(`_134`, { l: `fi`, v: `Kirjoita peruutettavan ajan tunnus` }, { l: `sv`, v: `Ange ID för den tid du vill avbryta` },);
        this.set(`_135`, { l: `fi`, v: `Aikaa ei löydy` }, { l: `sv`, v: `Hittar inte bokning` },);
        this.set(`_136`, { l: `fi`, v: `Hae tiedot` }, { l: `sv`, v: `Få informationen` },);
        this.set(`_137`, { l: `fi`, v: `Varauksen tiedot` }, { l: `sv`, v: `Bokningsdetaljer` },);
        this.set(`_138`, { l: `fi`, v: `Asiantuntija` }, { l: `sv`, v: `Specialist` },);
        this.set(`_139`, { l: `fi`, v: `Erikoisala` }, { l: `sv`, v: `Specialitet` },);
        this.set(`_13A`, { l: `fi`, v: `Aika` }, { l: `sv`, v: `Tid` },);
        this.set(`_13B`, { l: `fi`, v: `Ajan peruutus onnistui` }, { l: `sv`, v: `Avbokningen lyckades` },);
        this.set(`_13C`, { l: `fi`, v: `Peruuta valittu aika` }, { l: `sv`, v: `Avbryt vald tid` },);
        this.set(`_13D`, { l: `fi`, v: `Ajanvarauksen tunnus` }, { l: `sv`, v: `Utnämnings-ID` },);
        this.set(`_13E`, { l: `fi`, v: `Työterveyshuollon tiimiimme kuuluvat:` }, { l: `sv`, v: `Vårt team i företagshälsovården består av:` },);
        this.set(`_13F`, { l: `fi`, v: `Ajankohtaista` }, { l: `sv`, v: `Aktuellt` },);
        this.set(`_140`, { l: `fi`, v: `Työpaikat` }, { l: `sv`, v: `Jobb` },);
        this.set(`_141`, { l: `fi`, v: `Työpaikat` }, { l: `sv`, v: `Jobb` },);
        this.set(`_142`, { l: `fi`, v: `Ajan peruuttaminen epäonnistui. Ongelman toistuessa ota yhteyttä asiakastukeen ongelman selvittämiseksi.` }, { l: `sv`, v: `Det gick inte att avboka ett möte. Om problemet återkommer, kontakta kundsupport för att lösa problemet.` },);
        this.set(`_143`, { l: `fi`, v: `Kirjautuminen epäonnistui, ota yhteyttä asiakaspalveluun.` }, { l: `sv`, v: `Avbokningen misslyckades. Om problemet upprepas, kontakta kundsupport för att lösa problemet` },);
        this.set(`_144`, { l: `fi`, v: `Avoimet työpaikat` }, { l: `sv`, v: `Öppna jobb` },);
        this.set(`_145`, { l: `fi`, v: `Ei avoimia paikkoja tällä hetkellä.` }, { l: `sv`, v: `Inga lediga platser för tillfället.` },);
        this.set(`_146`, { l: `fi`, v: `Kiinnostuitko? Lähetä hakemuksesi osoitteeseen` }, { l: `sv`, v: `Intresserad? Skicka din ansökan till adressen` },);
        this.set(`_147`, { l: `fi`, v: ` Lisää hakemuksesi liitteeksi CV sekä halutessasi muita hakemustasi tukevia dokumentteja.` }, { l: `sv`, v: `Bifoga ditt CV och eventuella andra dokument som stöder din ansökan.` },);
        this.set(`_148`, { l: `fi`, v: `Blogipostauksia ei saatavilla. Tarkista tilanne myöhemmin uudestaan!` }, { l: `sv`, v: `Inga blogginlägg tillgängliga. Kontrollera situationen igen senare!` },);
        this.set(`_149`, { l: `fi`, v: `Punkkirokote 55€` }, { l: `sv`, v: `Fästingvaccin 55€` },);
        this.set(`_14A`, { l: `fi`, v: `Nyt punkkirokote meiltä, ajanvaraus auki puh. 020 144 1511 sekä myös walk in-rokotus! Rokotus ja\n                                injektio yhteensä 55 €.` }, { l: `sv`, v: `Just nu fästingvaccin från oss, bokning öppen på telefonnummer 020 144 1511. Vaccination och injektion totalt 55€.` },);
        this.set(`_14B`, { l: `fi`, v: `Henkilötunnus on jo rekisteröity` }, { l: `sv`, v: `Personnumret är redan registrerat` },);
        this.set(`_14C`, { l: `fi`, v: `Tarkista henkilötunnus` }, { l: `sv`, v: `Kolla personnumret` },);
        this.set(`_14D`, { l: `fi`, v: `Rekisteröityminen ei onnistunut. Ole hyvä ja ota yhteys tukeen ongelman toistuessa` }, { l: `sv`, v: `Registreringen misslyckades. Kontakta supporten om problemet återkommer.` },);
        this.set(`_14E`, { l: `fi`, v: `Tunnuksellasi on varattu jo olemassa olevia aikoja. Uuden ajan varaus ei onnistu.` }, { l: `sv`, v: `Redan befintliga tider har bokats med ditt personnummer. Det går inte att boka en ny tid.` },);
        this.set(`_14F`, { l: `fi`, v: `Ajanvaraus ei juuri nyt onnistunut. Yritä uudelleen ja ongelman jatkuessa ole hyvä ja ota yhteys asiakaspalveluun` }, { l: `sv`, v: `Utnämningen var inte framgångsrik just nu. Försök igen och kontakta kundtjänst om problemet kvarstår` },);
        this.set(`_150`, { l: `fi`, v: `Ajanvaraus on estetty` }, { l: `sv`, v: `Bokning av möten har spärrats` },);
        this.set(`_151`, { l: `fi`, v: `Ajanvaraus epäonnistui. Aikaa ei voida varata menneisyyteen.` }, { l: `sv`, v: `Utnämningen lyckades inte. Tid kan inte reserveras för det förflutna.` },);
        this.set(`_152`, { l: `fi`, v: `Ajanvaraus ei onnistunut. Ole hyvä ja ota yhteys tukeen ongelman toistuessa.` }, { l: `sv`, v: `Utnämningen lyckades inte. Kontakta supporten om problemet återkommer.` },);
        this.set(`_153`, { l: `fi`, v: `Aika` }, { l: `uk`, v: `UK: Time` }, { l: `sv`, v: `Tid` }, { l: `ru`, v: `RU: Time` }, { l: `pl`, v: `PL: Time` }, { l: `nb`, v: `NB: Time` }, { l: `en`, v: `Time` }, { l: `da`, v: `DA: Time` },);
        this.set(`_154`, { l: `fi`, v: `Siirry palveluun` }, { l: `sv`, v: `Gå till tjänsten` },);
        this.set(`_155`, { l: `fi`, v: `Liitteet` }, { l: `sv`, v: `Bilagor` },);
        this.set(`_156`, { l: `fi`, v: `Hakemus lähetetty, kiitos! Olemme sinuun yhteydessä mahdollisimman pian.` }, { l: `sv`, v: `Ansökan skickad, tack! Vi kommer att kontakta dig så snart som möjligt.` },);
        this.set(`_157`, { l: `fi`, v: `Lähetä hakemus` }, { l: `sv`, v: `Skicka din ansökan` },);
        this.set(`_158`, { l: `fi`, v: `Lähetä hakemus` }, { l: `sv`, v: `Skicka din ansökan` },);
        this.set(`_159`, { l: `fi`, v: `Voit lisätä liitteiksi CV:n lisäksi myös muita hakemustasi tukevia dokumentteja.` }, { l: `sv`, v: `Utöver ditt CV kan du även lägga till andra styrkande handlingar till din ansökan som bilagor.` },);
        this.set(`_15A`, { l: `fi`, v: `Kerro lyhyesti itsestäsi ja miksi haet kyseistä työtehtävää.` }, { l: `sv`, v: `Berätta kort om dig själv och varför du söker jobbet i fråga.` },);
        this.set(`_15B`, { l: `fi`, v: `Suurin sallittu tiedostokoko on 2mb, sallitut tiedostomuodot .pdf, .doc ja .docx.` }, { l: `sv`, v: `Den största tillåtna filstorleken är 2 MB, tillåtna filformat är .pdf, .doc och .docx.` },);
        this.set(`_15C`, { l: `fi`, v: `Lähetä avoin hakemus` }, { l: `sv`, v: `Skicka öppen ansökan` },);
        this.set(`_15D`, { l: `fi`, v: `Avoin hakemus` }, { l: `sv`, v: `Öppen ansökan` },);
        this.set(`_15E`, { l: `fi`, v: `Aika jonka koitit varata on jo varattu. Ole hyvä ja yritä varata toinen aika. Ongelman toistuessa ota yhteyttä asiakaspalveluun.` }, { l: `sv`, v: `Tiden du försökte boka är redan upptagen. Försök att boka en annan tid. Om problemet fortsätter, kontakta kundtjänst.` },);
        this.set(`_15F`, { l: `fi`, v: `Aukioloajat` }, { l: `sv`, v: `Öppettider` },);
        this.set(`_160`, { l: `fi`, v: `Työterveyshuollon asiakkaat voivat varata sairaanhoidollisissa asioissa ajan myös yleislääkärille.` }, { l: `sv`, v: `Företagshälsovårdens kunder kan i sjukvårdsärenden också boka tid till en allmänläkare.` },);
        this.set(`_161`, { l: `fi`, v: `Ajanvaraus Kela 65 -vastaanotoille on avoinna.` }, { l: `sv`, v: `Tidsbokningen till  FPA 65-mottagningen är öppen.` },);
        this.set(`_162`, { l: `fi`, v: `Varaa aika soittamalla: \n- Porvoo: 020 144 1511\n- Loviisa: 020 144 1514 \n\nKun soitat, **mainitsethan, että kyseessä on valinnanvapauskokeiluun liittyvä vastaanotto.** \n\nHuomioithan, että **kaikki lääkärimme eivät ole mukana valinnanvapauskokeilussa.** \n\nLue lisää Kela 65 valinnanvapauskokeilusta [tästä](https://www.laakarikeskusfenix.fi/ServicePageView?type=service&id=65)` }, { l: `sv`, v: `Boka tid per telefon via vårt allmänna tidsbokningsnummer: \n- Borgå: 020 144 1511\n- Lovisa: 020 144 1514 \n\nNär du ringer, **vänligen nämn att det gäller en mottagning som är kopplad till FPA 65-valfrihetsförsöket.**\n\n**Observera att alla våra läkare inte deltar i valfrihetsförsöket.**\n\n[Läs mer om FPA valfrihetsförsöket här](https://www.laakarikeskusfenix.fi/ServicePageView?id=66&type=service)` },);
        this.set(`_163`, { l: `fi`, v: `Sopimuksen mukaan` }, { l: `sv`, v: `Enligt avtal` },);
        this.set(`_164`, { l: `fi`, v: `Kirjoittanut` }, { l: `sv`, v: `Skriven av` },);
        this.set(`_165`, { l: `fi`, v: `Lue koko artikkeli` }, { l: `sv`, v: `Läs hela artikeln` },);
        this.set(`_166`, { l: `fi`, v: `Lataa lisää` }, { l: `sv`, v: `Ladda ner mer` },);
        this.set(`_167`, { l: `fi`, v: `Puhelinvastaanottoajat` }, { l: `sv`, v: `Telefonmottagning` },);
        this.set(`_168`, { l: `fi`, v: `Ajankohtaisia kirjoituksia tulossa pian.` }, { l: `sv`, v: `Nyliga artiklar kommer snart.` },);
        this.set(`_169`, { l: `fi`, v: `Sähköposti uudestaan` }, { l: `sv`, v: `E-post igen` },);
        this.set(`_16A`, { l: `fi`, v: `Puuttuva sähköpostiosoite` }, { l: `sv`, v: `E-postadress saknas` },);
        this.set(`_16B`, { l: `fi`, v: `Sähköpostiosoitteen päivittäminen epäonnistui, ole hyvä ja yritä uudestaan. Ongelman toistuessa ota yhteyttä asiakaspalveluun.` }, { l: `sv`, v: `Det gick inte att uppdatera e-postadressen, försök igen. Om problemet återkommer, kontakta kundtjänst.` },);
        this.set(`_16C`, { l: `fi`, v: `Tiliisi ei ole liitetty sähköpostiosoitetta. Syötä sähköpostiosoitteesi jatkaaksesi ajanvarausta.` }, { l: `sv`, v: `Det finns ingen e-postadress kopplad till ditt konto. Ange din e-postadress för att fortsätta boka.` },);
        this.set(`_16D`, { l: `fi`, v: `Syötetty sähköpostiosoite ei ole validi.` }, { l: `sv`, v: `Den angivna e-postadressen är ogiltigt.` },);
        this.set(`_16E`, { l: `fi`, v: `Syötetyt sähköpostiosoitteet eivät täsmää.` }, { l: `sv`, v: `De angivna e-postadresserna stämmer inte överens.` },);
        this.set(`_16F`, { l: `fi`, v: `Haluatko peruuttaa varatun ajan?` }, { l: `sv`, v: `Vill du avboka en bokad tid?` },);
        this.set(`_170`, { l: `fi`, v: `-tiimiin kuuluvat:` }, { l: `sv`, v: `-teamet inkluderar:` },);
        this.set(`_171`, { l: `fi`, v: `Suositut palvelut` }, { l: `sv`, v: `Ofta använda tjänster` },);
        this.set(`_172`, { l: `fi`, v: `Kaikki palvelut (aakkosittain)` }, { l: `sv`, v: `Alla tjänster (i alfabetisk ordning)` },);
        this.set(`_173`, { l: `fi`, v: `Puuttuva tieto` }, { l: `sv`, v: `Saknad information` },);
        this.set(`_174`, { l: `fi`, v: `Kesto:` }, { l: `sv`, v: `Varaktighet:` },);
        this.set(`_175`, { l: `fi`, v: `Ala:` }, { l: `sv`, v: `Område:` },);
        this.set(`_176`, { l: `fi`, v: `Toimipiste:` }, { l: `sv`, v: `Plats:` },);
        this.set(`_177`, { l: `fi`, v: `Lääkärikeskus Fenix` }, { l: `sv`, v: `Läkarcentral Fenix` },);
        this.set(`_178`, { l: `fi`, v: `Tarkista että tietosi ovat ajan tasalla. Mikäli huomaat että tietosi eivät ole oikein, korjaa tiedot ennen varauksen vahvistamista.` }, { l: `sv`, v: `Kontrollera att din information är uppdaterad. Om du märker att dina uppgifter är felaktiga, korrigera informationen innan du bekräftar bokningen.` },);
        this.set(`_179`, { l: `fi`, v: `Muokkaa omia yhteystietoja` }, { l: `sv`, v: `Redigera din kontaktinformation` },);
        this.set(`_17A`, { l: `fi`, v: `Puhelinnumero uudelleen` }, { l: `sv`, v: `Telefonnumer igen` },);
        this.set(`_17B`, { l: `fi`, v: `Yhteystietojen päivittäminen epäonnistui, ole hyvä ja yritä uudestaan. Ongelman toistuessa ota yhteyttä asiakaspalveluun.` }, { l: `sv`, v: `Det gick inte att spara kontaktinformation, försök igen. Om problemet återkommer, kontakta kundtjänst.` },);
        this.set(`_17C`, { l: `fi`, v: `Syötetyt puhelinnumerot eivät täsmää.` }, { l: `sv`, v: `De angivna telefonnumren stämmer inte överens.` },);
        this.set(`_17D`, { l: `fi`, v: `Syötetty puhelinnumero ei ole validi.` }, { l: `sv`, v: `Det angivna telefonnumret är ogiltigt.` },);
        this.set(`_17E`, { l: `fi`, v: `Yhteystietosi ovat puutteelliset. Lisää tietoihisi sekä sähköpostiosoite että puhelinnumero viimeistelläksesi varauksesi.` }, { l: `sv`, v: `Din kontaktinformation är ofullständig. Lägg till både en e-postadress och ett telefonnummer till din information för att slutföra din bokning.` },);
        this.set(`_17F`, { l: `fi`, v: `Huomasimme, että et ole jättänyt yhteystietoja (sähköposti tai puhelinnumero), joita tarvitsemme mahdollisten muutosten tai lisätietojen toimittamista varten.` }, { l: `sv`, v: `Vi har märkt att du inte har lämnat kontaktinformation (e-post eller telefonnummer) som vi behöver för att tillhandahålla eventuella ändringar eller ytterligare information.` },);
        this.set(`_180`, { l: `fi`, v: `Ole hyvä ja täytä tiedot jotta voimme jatkaa varauksesi viimeistelyssä.` }, { l: `sv`, v: `Vänligen fyll i informationen så att vi kan fortsätta slutföra din bokning.` },);
        this.set(`_181`, { l: `fi`, v: `Yhteystiedot puuttuvat` }, { l: `sv`, v: `Kontaktinformation saknas` },);
        this.set(`_182`, { l: `fi`, v: `Kiitos, puhelinaika varattu koodilla {0}.\n\nOtathan ylös varauksesi tiedot:` }, { l: `sv`, v: `Tack, tid bokad med kod {0}.\n\nVänligen skriva upp bokningsuppgifterna:` },);
        this.set(`_183`, { l: `fi`, v: `Asiointiohjeet` }, { l: `sv`, v: `Instruktioner` },);
        this.set(`_184`, { l: `fi`, v: `Ota yhteyttä` }, { l: `sv`, v: `Kontakta oss` },);
        this.set(`_185`, { l: `fi`, v: `Influenssarokotusajat` }, { l: `sv`, v: `Influensavaccinationer` },);
        this.set(`_186`, { l: `fi`, v: `Tietosuojaseloste` }, { l: `sv`, v: `Integritetspolicy` },);
        this.set(`_187`, { l: `fi`, v: `Käyttöehdot` }, { l: `sv`, v: `Användarvillkor` },);
        this.set(`_188`, { l: `fi`, v: `DigiFenix` }, { l: `sv`, v: `DigiFenix` },);
        this.set(`_189`, { l: `fi`, v: `DigiFenix` }, { l: `sv`, v: `DigiFenix` },);
        this.set(`_18A`, { l: `fi`, v: `DigiFenix verkossa` }, { l: `sv`, v: `DigiFenix ​​online` },);
        this.set(`_18B`, { l: `fi`, v: `Haku` }, { l: `sv`, v: `Söka` },);
        this.set(`_18C`, { l: `fi`, v: `Suodata hakutuloksia` }, { l: `sv`, v: `Filtrera sökresultat` },);
        this.set(`_18D`, { l: `fi`, v: `Asiantuntija` }, { l: `sv`, v: `Specialist` },);
        this.set(`_18E`, { l: `fi`, v: `Palvelu` }, { l: `sv`, v: `Tjänst` },);
        this.set(`_18F`, { l: `fi`, v: `Klinikka` }, { l: `sv`, v: `Klinik` },);
        this.set(`_190`, { l: `fi`, v: `Palveluseteli` }, { l: `sv`, v: `Servicesedel` },);
        this.set(`_191`, { l: `fi`, v: `Erikoisala` }, { l: `sv`, v: `Specialitet` },);
        this.set(`_192`, { l: `fi`, v: `Toimipisteet` }, { l: `sv`, v: `Platser` },);
        this.set(`_193`, { l: `fi`, v: `Erikoisalat` }, { l: `sv`, v: `Specialfält` },);
        this.set(`_194`, { l: `fi`, v: `Palvelusetelit` }, { l: `sv`, v: `Servicesedlar` },);
        this.set(`_195`, { l: `fi`, v: `Kaikki tulokset` }, { l: `sv`, v: `Alla resultat` },);
        this.set(`_196`, { l: `fi`, v: `Ei tuloksia` }, { l: `sv`, v: `Inga resultat` },);
        this.set(`_197`, { l: `fi`, v: `Hae sivuilta` }, { l: `sv`, v: `Sök på sajten` },);
        this.set(`_198`, { l: `fi`, v: `hakutulosta` }, { l: `sv`, v: `sökresultat` },);
        this.set(`_199`, { l: `fi`, v: `Löydettiin` }, { l: `sv`, v: `Hittades` },);
        this.set(`_19A`, { l: `fi`, v: `Hakutoiminto ei ole juuri nyt saatavilla, yritä myöhemmin uudestaan.` }, { l: `sv`, v: `Sökfunktionen är inte tillgänglig just nu, försök igen senare.` },);
        this.set(`_19B`, { l: `fi`, v: `Hae` }, { l: `sv`, v: `Sök` },);
        this.set(`_19C`, { l: `fi`, v: `Lastenlääkäreiden ajat` }, { l: `sv`, v: `Barnläkartider` },);
        this.set(`_19D`, { l: `fi`, v: `Pyydä tarjous` }, { l: `sv`, v: `Begär en offert` },);
        this.set(`_19E`, { l: `fi`, v: `Nimi` }, { l: `sv`, v: `Namn` },);
        this.set(`_19F`, { l: `fi`, v: `Yrityksen nimi` }, { l: `sv`, v: `Företagsnamn` },);
        this.set(`_1A0`, { l: `fi`, v: `Pyydä tarjous työterveydestä` }, { l: `sv`, v: `Begär offert för företagshälsovård` },);
        this.set(`_1A1`, { l: `fi`, v: `Pyydä tarjous` }, { l: `sv`, v: `Begär en offert` },);
        this.set(`_1A2`, { l: `fi`, v: `Varauksesi on alle 12h päässä. Ota yhteyttä asiakaspalveluun peruaksesi ajan.` }, { l: `sv`, v: `Din bokning är mindre än 12 timmar bort. Kontakta kundtjänst för att avboka ditt möte.` },);
        this.set(`_1A3`, { l: `fi`, v: `Asiakkaamme kertovat` }, { l: `sv`, v: `Våra kunder säger` },);
        this.set(`_1A4`, { l: `fi`, v: `Anna palautetta` }, { l: `sv`, v: `Ge feedback` },);
        this.set(`_1A5`, { l: `fi`, v: `Varauksesi on alle 24h päässä. Ota yhteyttä asiakaspalveluun peruaksesi ajan.` }, { l: `sv`, v: `Din bokning är mindre än 24 timmar bort. Kontakta kundtjänst för att avboka ditt möte.` },);
        this.set(`_1A6`, { l: `fi`, v: `Valitse maksaja tai palvelu` }, { l: `sv`, v: `Välj betalare eller tjänst` },);
        this.set(`_1A7`, { l: `fi`, v: `Yksityisasiointi` }, { l: `sv`, v: `Privata tjänster` },);
        this.set(`_1A8`, { l: `fi`, v: `Kela65-asiointi` }, { l: `sv`, v: `Kela65-tjänster` },);
        this.set(`_1A9`, { l: `fi`, v: `Työterveysasiointi` }, { l: `sv`, v: `Företagshälsovårdstjänster` },);
        this.set(`_1AA`, { l: `fi`, v: `Kela65` }, { l: `sv`, v: `Kela65` },);
        this.set(`_1AB`, { l: `fi`, v: `Kela65:n ajat` }, { l: `sv`, v: `Tider för Kela65` },);
        this.set(`_1AC`, { l: `fi`, v: `Aukioloajat` }, { l: `sv`, v: `Öppettider` },);
        this.set(`_1AD`, { l: `fi`, v: `Digifenixin kautta voit myös varata ajan.` }, { l: `sv`, v: `Du kan också boka en tid via Digifenix.` },);
        this.set(`_1AE`, { l: `fi`, v: `Laskutus` }, { l: `sv`, v: `Fakturering` },);
        this.set(`_1AF`, { l: `fi`, v: `98` }, { l: `sv`, v: `99` },);
        this.set(`_1B0`, { l: `fi`, v: `Pikalinkit` }, { l: `sv`, v: `Snabblänkar` },);
        this.set(`_1B1`, { l: `fi`, v: `Toimipisteet` }, { l: `sv`, v: `Verksamhetsställen` },);
        this.set(`_1B2`, { l: `fi`, v: `Lataa DigiFenix sovellus:` }, { l: `sv`, v: `Ladda ner DigiFenix-appen:` },);
        this.set(`_1B3`, { l: `fi`, v: `Katso poikkeavat aukioloajat täältä` }, { l: `sv`, v: `Kolla avvikande öppettider här` },);
        this.set(`_1B4`, { l: `fi`, v: `Uutiskirjeet` }, { l: `sv`, v: `Nyhetsbrev` },);
        this.set(`_1B5`, { l: `fi`, v: `Yleinen` }, { l: `sv`, v: `Allmänt` },);
        this.set(`_1B6`, { l: `fi`, v: `Työterveyshuolto` }, { l: `sv`, v: `Företagshälsovård` },);
        this.set(`_1B7`, { l: `fi`, v: `Tilaa uutiskirje` }, { l: `sv`, v: `Prenumerera på nyhetsbrevet` },);
        this.set(`_1B8`, { l: `fi`, v: `Hoitava asiantuntija` }, { l: `sv`, v: `Behandlande expert` },);
        this.set(`_1B9`, { l: `fi`, v: `Aika` }, { l: `sv`, v: `Tid` },);
        this.set(`_1BA`, { l: `fi`, v: `Paikka` }, { l: `sv`, v: `Plats` },);
        this.set(`_1BB`, { l: `fi`, v: `Tarvitset varauksen tunnuksen, jos haluat peruuttaa ajanvarauksen sähköisesti.\n\nJos olet antanut meille sähköpostiosoitteesi, lähetämme sinulle varauksesta vahvistuksen sähköpostiin.` }, { l: `sv`, v: `Du behöver bokningskoden om du vill avboka din bokning elektroniskt.\n\nOm du har angett din e-postadress skickar vi dig en bekräftelse om bokningen per e-post.` },);
        this.set(`_1BC`, { l: `fi`, v: `Päivämäärä` }, { l: `sv`, v: `Datum` },);
        this.set(`_1BD`, { l: `fi`, v: `Haluatko tilata Fenixin uutiskirjeen?` }, { l: `sv`, v: `Vill du prenumerera på Fenix nyhetsbrev?` },);
        this.set(`_1BE`, { l: `fi`, v: `Tilaa tästä` }, { l: `sv`, v: `Prenumerera här` },);
        this.set(`_1BF`, { l: `fi`, v: `Toimipiste` }, { l: `sv`, v: `Verksamhetsplats` },);
    }

    /**
    /* "TopNav.Frontpage" (Frontpage)
    /* "Localizer.topNavFrontpage"
    /* "Localizer.topNavFrontpageLanguageItemName"
    */
    public get topNavFrontpage() : string {
        return this.get(`_0`);
    }

    /**
    /* "TopNav.Login" (Login)
    /* "Localizer.topNavLogin"
    /* "Localizer.topNavLoginLanguageItemName"
    */
    public get topNavLogin() : string {
        return this.get(`_1`);
    }

    /**
    /* "TopNav.Admin" (Admin)
    /* "Localizer.topNavAdmin"
    /* "Localizer.topNavAdminLanguageItemName"
    */
    public get topNavAdmin() : string {
        return this.get(`_2`);
    }

    /**
    /* "TopNav.Account" (Account)
    /* "Localizer.topNavAccount"
    /* "Localizer.topNavAccountLanguageItemName"
    */
    public get topNavAccount() : string {
        return this.get(`_3`);
    }

    /**
    /* "TopNav.Logout" (Logout)
    /* "Localizer.topNavLogout"
    /* "Localizer.topNavLogoutLanguageItemName"
    */
    public get topNavLogout() : string {
        return this.get(`_4`);
    }

    /**
    /* "Widget.WeAreLink.Label" (WeAre Solutions Oy Portal)
    /* "Localizer.widgetWeAreLinkLabel"
    /* "Localizer.widgetWeAreLinkLabelLanguageItemName"
    */
    public get widgetWeAreLinkLabel() : string {
        return this.get(`_5`);
    }

    /**
    /* "Widget.WeAreLink.Description" (Local machine rental portal)
    /* "Localizer.widgetWeAreLinkDescription"
    /* "Localizer.widgetWeAreLinkDescriptionLanguageItemName"
    */
    public get widgetWeAreLinkDescription() : string {
        return this.get(`_6`);
    }

    /**
    /* "Widget.Login.Description" (Log in)
    /* "Localizer.widgetLoginDescription"
    /* "Localizer.widgetLoginDescriptionLanguageItemName"
    */
    public get widgetLoginDescription() : string {
        return this.get(`_7`);
    }

    /**
    /* "LoginPage.LoginButton" (Login)
    /* "Localizer.loginPageLoginButton"
    /* "Localizer.loginPageLoginButtonLanguageItemName"
    */
    public get loginPageLoginButton() : string {
        return this.get(`_8`);
    }

    /**
    /* "LoginPage.SsoButton" (Office 365)
    /* "Localizer.loginPageSsoButton"
    /* "Localizer.loginPageSsoButtonLanguageItemName"
    */
    public get loginPageSsoButton() : string {
        return this.get(`_9`);
    }

    /**
    /* "LoginPage.ForgotPasswordButton" (Forgot password?)
    /* "Localizer.loginPageForgotPasswordButton"
    /* "Localizer.loginPageForgotPasswordButtonLanguageItemName"
    */
    public get loginPageForgotPasswordButton() : string {
        return this.get(`_A`);
    }

    /**
    /* "LoginPage.EmailInput" (Email)
    /* "Localizer.loginPageEmailInput"
    /* "Localizer.loginPageEmailInputLanguageItemName"
    */
    public get loginPageEmailInput() : string {
        return this.get(`_B`);
    }

    /**
    /* "Link.Expired" (Link has expired)
    /* "Localizer.linkExpired"
    /* "Localizer.linkExpiredLanguageItemName"
    */
    public get linkExpired() : string {
        return this.get(`_C`);
    }

    /**
    /* "Link.Used" (Link has expired)
    /* "Localizer.linkUsed"
    /* "Localizer.linkUsedLanguageItemName"
    */
    public get linkUsed() : string {
        return this.get(`_D`);
    }

    /**
    /* "ForgotPasswordPage.PageTitle" (Forgot password?)
    /* "Localizer.forgotPasswordPagePageTitle"
    /* "Localizer.forgotPasswordPagePageTitleLanguageItemName"
    */
    public get forgotPasswordPagePageTitle() : string {
        return this.get(`_E`);
    }

    /**
    /* "ForgotPasswordPage.SuccessMessage" (A notification has been sent to the address you provided with a link to reset your password. Continue signing in after changing your password. If you did not receive the message, please check your spam folder.)
    /* "Localizer.forgotPasswordPageSuccessMessage"
    /* "Localizer.forgotPasswordPageSuccessMessageLanguageItemName"
    */
    public get forgotPasswordPageSuccessMessage() : string {
        return this.get(`_F`);
    }

    /**
    /* "ForgotPasswordPage.FailedMessage" (A notification was not sent to the address you provided for some technical reasons.\n      Please contact administrator.)
    /* "Localizer.forgotPasswordPageFailedMessage"
    /* "Localizer.forgotPasswordPageFailedMessageLanguageItemName"
    */
    public get forgotPasswordPageFailedMessage() : string {
        return this.get(`_10`);
    }

    /**
    /* "ForgotPasswordPage.ResetButton" (Send)
    /* "Localizer.forgotPasswordPageResetButton"
    /* "Localizer.forgotPasswordPageResetButtonLanguageItemName"
    */
    public get forgotPasswordPageResetButton() : string {
        return this.get(`_11`);
    }

    /**
    /* "ForgotPasswordPage.LoginButton" (Go to login)
    /* "Localizer.forgotPasswordPageLoginButton"
    /* "Localizer.forgotPasswordPageLoginButtonLanguageItemName"
    */
    public get forgotPasswordPageLoginButton() : string {
        return this.get(`_12`);
    }

    /**
    /* "ForgotPasswordPage.HelpText" (No problem. Please enter your "username" and we will send you instructions on how to reset your password.)
    /* "Localizer.forgotPasswordPageHelpText"
    /* "Localizer.forgotPasswordPageHelpTextLanguageItemName"
    */
    public get forgotPasswordPageHelpText() : string {
        return this.get(`_13`);
    }

    /**
    /* "LoginPage.PasswordInput" (Password)
    /* "Localizer.loginPagePasswordInput"
    /* "Localizer.loginPagePasswordInputLanguageItemName"
    */
    public get loginPagePasswordInput() : string {
        return this.get(`_14`);
    }

    /**
    /* "LoginPage.Title" (Log in.)
    /* "Localizer.loginPageTitle"
    /* "Localizer.loginPageTitleLanguageItemName"
    */
    public get loginPageTitle() : string {
        return this.get(`_15`);
    }

    /**
    /* "LoginPage.Subtitle" (Log in with your username and password.)
    /* "Localizer.loginPageSubtitle"
    /* "Localizer.loginPageSubtitleLanguageItemName"
    */
    public get loginPageSubtitle() : string {
        return this.get(`_16`);
    }

    /**
    /* "Enum.LoginResultStatus.NotFound" (Invalid username or password.)
    /* "Localizer.enumLoginResultStatusNotFound"
    /* "Localizer.enumLoginResultStatusNotFoundLanguageItemName"
    */
    public get enumLoginResultStatusNotFound() : string {
        return this.get(`_17`);
    }

    /**
    /* "Enum.LoginResultStatus.Deleted" (Your account has been deleted. Contact support to restore your access.)
    /* "Localizer.enumLoginResultStatusDeleted"
    /* "Localizer.enumLoginResultStatusDeletedLanguageItemName"
    */
    public get enumLoginResultStatusDeleted() : string {
        return this.get(`_18`);
    }

    /**
    /* "Enum.LoginResultStatus.Locked" (Too many login attempts. Try again later.)
    /* "Localizer.enumLoginResultStatusLocked"
    /* "Localizer.enumLoginResultStatusLockedLanguageItemName"
    */
    public get enumLoginResultStatusLocked() : string {
        return this.get(`_19`);
    }

    /**
    /* "Enum.LoginResultStatus.Security" (Your account has been locked. Contact support to restore access.)
    /* "Localizer.enumLoginResultStatusSecurity"
    /* "Localizer.enumLoginResultStatusSecurityLanguageItemName"
    */
    public get enumLoginResultStatusSecurity() : string {
        return this.get(`_1A`);
    }

    /**
    /* "ErrorPage.Title" (Error occured)
    /* "Localizer.errorPageTitle"
    /* "Localizer.errorPageTitleLanguageItemName"
    */
    public get errorPageTitle() : string {
        return this.get(`_1B`);
    }

    /**
    /* "ErrorPage.ErrorMessage" (If this happens again, contact support.)
    /* "Localizer.errorPageErrorMessage"
    /* "Localizer.errorPageErrorMessageLanguageItemName"
    */
    public get errorPageErrorMessage() : string {
        return this.get(`_1C`);
    }

    /**
    /* "ErrorPage.ContactSupport" (Contact support)
    /* "Localizer.errorPageContactSupport"
    /* "Localizer.errorPageContactSupportLanguageItemName"
    */
    public get errorPageContactSupport() : string {
        return this.get(`_1D`);
    }

    /**
    /* "ContactSupportPage.Title" (Message to support team)
    /* "Localizer.contactSupportPageTitle"
    /* "Localizer.contactSupportPageTitleLanguageItemName"
    */
    public get contactSupportPageTitle() : string {
        return this.get(`_1E`);
    }

    /**
    /* "Form.Input.Email" (Email)
    /* "Localizer.formInputEmail"
    /* "Localizer.formInputEmailLanguageItemName"
    */
    public get formInputEmail() : string {
        return this.get(`_1F`);
    }

    /**
    /* "Form.Input.Phone" (Phone number)
    /* "Localizer.formInputPhone"
    /* "Localizer.formInputPhoneLanguageItemName"
    */
    public get formInputPhone() : string {
        return this.get(`_20`);
    }

    /**
    /* "Form.Input.Firstname" (Firstname)
    /* "Localizer.formInputFirstname"
    /* "Localizer.formInputFirstnameLanguageItemName"
    */
    public get formInputFirstname() : string {
        return this.get(`_21`);
    }

    /**
    /* "Form.Input.Middlename" (Middle name)
    /* "Localizer.formInputMiddlename"
    /* "Localizer.formInputMiddlenameLanguageItemName"
    */
    public get formInputMiddlename() : string {
        return this.get(`_22`);
    }

    /**
    /* "Form.Input.Lastname" (Lastname)
    /* "Localizer.formInputLastname"
    /* "Localizer.formInputLastnameLanguageItemName"
    */
    public get formInputLastname() : string {
        return this.get(`_23`);
    }

    /**
    /* "Form.Input.Message" (Message)
    /* "Localizer.formInputMessage"
    /* "Localizer.formInputMessageLanguageItemName"
    */
    public get formInputMessage() : string {
        return this.get(`_24`);
    }

    /**
    /* "Form.Input.Language" (Language)
    /* "Localizer.formInputLanguage"
    /* "Localizer.formInputLanguageLanguageItemName"
    */
    public get formInputLanguage() : string {
        return this.get(`_25`);
    }

    /**
    /* "Form.Input.Role" (Role)
    /* "Localizer.formInputRole"
    /* "Localizer.formInputRoleLanguageItemName"
    */
    public get formInputRole() : string {
        return this.get(`_26`);
    }

    /**
    /* "Form.Send" (Send)
    /* "Localizer.formSend"
    /* "Localizer.formSendLanguageItemName"
    */
    public get formSend() : string {
        return this.get(`_27`);
    }

    /**
    /* "Form.Save" (Save)
    /* "Localizer.formSave"
    /* "Localizer.formSaveLanguageItemName"
    */
    public get formSave() : string {
        return this.get(`_28`);
    }

    /**
    /* "TopNav.ContactSupport" (Support)
    /* "Localizer.topNavContactSupport"
    /* "Localizer.topNavContactSupportLanguageItemName"
    */
    public get topNavContactSupport() : string {
        return this.get(`_29`);
    }

    /**
    /* "DayOfWeek.Sunday" (Sunday)
    /* "Localizer.dayOfWeekSunday"
    /* "Localizer.dayOfWeekSundayLanguageItemName"
    */
    public get dayOfWeekSunday() : string {
        return this.get(`_2A`);
    }

    /**
    /* "DayOfWeek.Monday" (Monday)
    /* "Localizer.dayOfWeekMonday"
    /* "Localizer.dayOfWeekMondayLanguageItemName"
    */
    public get dayOfWeekMonday() : string {
        return this.get(`_2B`);
    }

    /**
    /* "DayOfWeek.Tuesday" (Tuesday)
    /* "Localizer.dayOfWeekTuesday"
    /* "Localizer.dayOfWeekTuesdayLanguageItemName"
    */
    public get dayOfWeekTuesday() : string {
        return this.get(`_2C`);
    }

    /**
    /* "DayOfWeek.Wednesday" (Wednesday)
    /* "Localizer.dayOfWeekWednesday"
    /* "Localizer.dayOfWeekWednesdayLanguageItemName"
    */
    public get dayOfWeekWednesday() : string {
        return this.get(`_2D`);
    }

    /**
    /* "DayOfWeek.Thursday" (Thursday)
    /* "Localizer.dayOfWeekThursday"
    /* "Localizer.dayOfWeekThursdayLanguageItemName"
    */
    public get dayOfWeekThursday() : string {
        return this.get(`_2E`);
    }

    /**
    /* "DayOfWeek.Friday" (Friday)
    /* "Localizer.dayOfWeekFriday"
    /* "Localizer.dayOfWeekFridayLanguageItemName"
    */
    public get dayOfWeekFriday() : string {
        return this.get(`_2F`);
    }

    /**
    /* "DayOfWeek.Saturday" (Saturday)
    /* "Localizer.dayOfWeekSaturday"
    /* "Localizer.dayOfWeekSaturdayLanguageItemName"
    */
    public get dayOfWeekSaturday() : string {
        return this.get(`_30`);
    }

    /**
    /* "MyAccountPage.Title" (My account)
    /* "Localizer.myAccountPageTitle"
    /* "Localizer.myAccountPageTitleLanguageItemName"
    */
    public get myAccountPageTitle() : string {
        return this.get(`_31`);
    }

    /**
    /* "MyAccountPage.Subtitle" ( )
    /* "Localizer.myAccountPageSubtitle"
    /* "Localizer.myAccountPageSubtitleLanguageItemName"
    */
    public get myAccountPageSubtitle() : string {
        return this.get(`_32`);
    }

    /**
    /* "MyAccountPage.DataSaved" (Account information updated successfully)
    /* "Localizer.myAccountPageDataSaved"
    /* "Localizer.myAccountPageDataSavedLanguageItemName"
    */
    public get myAccountPageDataSaved() : string {
        return this.get(`_33`);
    }

    /**
    /* "MyAccountPage.Acceptance" (I have read and accept)
    /* "Localizer.myAccountPageAcceptance"
    /* "Localizer.myAccountPageAcceptanceLanguageItemName"
    */
    public get myAccountPageAcceptance() : string {
        return this.get(`_34`);
    }

    /**
    /* "MyAccountPage.Acceptance.Required" (You must accept terms of usage and privacy notice in order to use application)
    /* "Localizer.myAccountPageAcceptanceRequired"
    /* "Localizer.myAccountPageAcceptanceRequiredLanguageItemName"
    */
    public get myAccountPageAcceptanceRequired() : string {
        return this.get(`_35`);
    }

    /**
    /* "MyAccountPage.Acceptance.Terms" (terms of use)
    /* "Localizer.myAccountPageAcceptanceTerms"
    /* "Localizer.myAccountPageAcceptanceTermsLanguageItemName"
    */
    public get myAccountPageAcceptanceTerms() : string {
        return this.get(`_36`);
    }

    /**
    /* "MyAccountPage.Acceptance.Terms.Title" (Athenaeum Application Template-APPLICATIONS TERMS OF SERVICE)
    /* "Localizer.myAccountPageAcceptanceTermsTitle"
    /* "Localizer.myAccountPageAcceptanceTermsTitleLanguageItemName"
    */
    public get myAccountPageAcceptanceTermsTitle() : string {
        return this.get(`_37`);
    }

    /**
    /* "MyAccountPage.Acceptance.Terms.Content" (1	Common\n\nThe Athenaeum Application Template Application (the “Application”) is owned and provided by WeAre Solutions Oy (“WeAre”).\n\nBy installing the Application and / or using the Application, the Registered Customer or the Unregistered User agrees to these Terms of Use (the "Terms of Use"). If the Registered Customer or the Unregistered User does not accept these Terms of Use, the Registered Customer or the Unregistered User does not have the right to install, open or use the application.\n\nWeAre reserves the right to change these Terms of Use at any time without notice. A registered Customer or an Unregistered User shall be deemed to have accepted the updated Terms of Use by using the application after the change to the Terms of Use.\n\n2.	Athenaeum Application Template application\n\nThe application is for WeAren Employees (Registered Users) and Registered Customers. It is possible to use the application either as an employee of WeAre (Registered User) or alternatively as a registered Customer with a customer-specific license ("Registered Customer").\n\n2.1	Registered Customers.\nRegistering as a Customer requires an existing customer relationship with WeAre. WeAre has the right not to accept the registration and to revoke the license of the application.\n\nThe Registered Customer has the opportunity to view and approve work reports and invoicing for his construction sites through the application.\n\n2.2	Registered Users\nRegistration for the Application requires an existing employment relationship with WeAre. WeAre has the right not to accept the registration and to revoke the license of the application.\n\nThe Registered User has the opportunity to perform the actions required for work control through the application.\n\nTo ensure the proper operation of the application, the Registered Customer and the Registered User must ensure that they have the latest version of the application.\n\n3.	Product range and price list\n\nThe product range presented in the application corresponds to WeAre's normal product range. Product range, product availability and price information may vary from location to location. Prices do not include VAT unless stated otherwise. VAT will be added to the rates upon invoicing.\n\nCustomer-specific price information for contract customers is presented in the Application. The presentation of prices may be limited by access rights.\n\nWeAre is not responsible for any errors, omissions or other defects in the price and product information or other material presented in the Application.\n\n4.	Customer-Specific Work Reports\n\n4.1	Generation of a customer-specific work report\nThe work performed by the Registered Users on behalf of the customer forms a work report for the system.\n\n4.2	Processing a customer-specific work report\nThe Registered Customer has the opportunity to view the work reports concerning him or her and to accept and reject the work reports of the work performed. WeAre has the right to invoice the work in accordance with the approved work report.\n\n5.	Customer-specific invoices\n\n5.1	Viewing Customer-Specific Invoices\nIt is possible for a registered Customer to view invoices concerning him in the application. Any incorrect invoices must be reclamed in accordance with WeAre's instructions.\n\n6.	Intellectual Property Rights\n\nThe application and its content, including e.g. trademarks, trade names, product information and images are the property of WeAre and / or its partners, which are protected by e.g. copyright law and international intellectual property agreements. All rights to the Application and its content are reserved. It is expressly stated that the Registered Customer or the Registered User may not sublicense, rent, transfer or otherwise distribute the Application or its rights to use the Application except as permitted in these Terms of Use.\n\nThe Registered Customer or the Registered User shall not have the right to change, modify, delete, copy, publish, make available to the public or transfer any intellectual property rights. Your right to use the application is limited to your use in accordance with these Terms of Use.\n\n7.	Permissions and access rights\n\nThe Registered Customer accepts as binding all measures taken through the Application with the registered Customer's credentials or by or on behalf of the Registered Customer. The use of Registered Customer credentials in the Application corresponds to the Registered Customer's signature.\n\nThe Registered Customer is obliged to keep the credentials carefully stored. If the Registered Customer suspects that the credentials have been forced to possession of a third party, the Registered Customer shall immediately inform the contact person of WeAre about the situation. The contact person deletes the old credentials and opens the new ones. The Registered Customer is responsible for all orders placed with his / her username and for any damages that may result from compromising the credentials.\n\n8.	WeAren's responsibility\n\nThe application and its contents are provided to the Registered Customer and the Registered User “as is”. WeAre is not responsible for any errors, omissions or other defects in the content transmitted in the Application. WeAre does not guarantee the availability of the Application or its uninterrupted or error-free operation. WeAre shall not be liable for any costs, losses or other possible direct or indirect damages that may arise from the use of this Application, the information provided in the Application or the non-availability of the Application, subject to mandatory legislation. In any case, WeAre's liability is limited to a maximum amount corresponding to the agreed rental equipment rental and / or service price.\n\n9.	Cookies\n\nWeAre uses cookies in the Application (so-called cookie function). A cookie is a text file stored in the user's browser when using the Application. For example, cookies make it possible to monitor the number of users of the Application and to collect information on how and when the Application is used.\n\nThe Registered Customer and the Unregistered User can disable the use of cookies in their browser settings. For more information on browser-specific instructions, contact your browser developer. WeAre recommends the use of cookies in the Application in order to obtain the best possible user experience.\n\n10.	Third Party Services\n\nThe application may contain links to sites owned or operated by third parties. WeAre is not responsible for the operation, content, direct or indirect damages or other features of such third party sites. By accessing these pages, the user must accept the terms of use of these pages and the Privacy Statement before using them.\n\n11.	Processing of personal data\n\nWeAre processes and collects the personal data of Registered Customers in order to implement the services and to maintain and develop customer relationships. WeAre's privacy statement describes the processing of personal data in more detail: https://www.weare.fi/en/privacy-policy-and-cookies\n\nThe personal data of unregistered Users will not be collected.\n\n12.	Other Terms\n\nWeAre's valid rental terms apply to machine rental and services. The terms and conditions of the annual contracts are complied with with the customers of the annual contracts. The customer agrees to the delivery terms valid for each order.\n\nWeAre may change, update, cancel or delete the Application, the contents of the Application or portions thereof at its sole discretion. The Registered Customer or the Registered User must stop using the Application if the Registered Customer or the Registered User does not accept the changes in the Terms of Use of the Application or the privacy statement.\n\nThe Registered Customer and the Unregistered User must use the Application in accordance with the terms of use of the application store from which they have acquired the Application. In all cases, the Registered Customer and the Registered User shall be liable for damages caused by his / her compliance with these Terms of Use.\n\nThe Registered Customer and the Registered User are responsible for the accuracy of the information they provide, for the careful storage of their username and password, and for the proper security of their equipment. The Registered Customer and the Registered User are responsible for all transactions in the Application with their credentials.\n\nThe use of the service and these terms and conditions are governed by Finnish law, except for its choice of law provisions.\n\nThe parties shall endeavor to resolve their differences primarily through negotiations. If no amicable settlement is reached, the disputes will be settled in the Helsinki District Court. The consumer customer can also take the dispute to the Consumer Disputes Board for resolution.\n\n13.	Contact\n\nIf you have any questions about these Terms of Use or the Application, please contact:\n\nWeAre Solutions Oy\nÄyritie 12C\n01510 Vantaa\nFinland\ninfo@reapptor-apps.fi\nBusiness ID 2976585-9)
    /* "Localizer.myAccountPageAcceptanceTermsContent"
    /* "Localizer.myAccountPageAcceptanceTermsContentLanguageItemName"
    */
    public get myAccountPageAcceptanceTermsContent() : string {
        return this.get(`_38`);
    }

    /**
    /* "MyAccountPage.Acceptance.PrivacyNotice" (privacy notice)
    /* "Localizer.myAccountPageAcceptancePrivacyNotice"
    /* "Localizer.myAccountPageAcceptancePrivacyNoticeLanguageItemName"
    */
    public get myAccountPageAcceptancePrivacyNotice() : string {
        return this.get(`_39`);
    }

    /**
    /* "MyAccountPage.Acceptance.PrivacyNotice.Title" (TEMPLATE-APPLICATIONS PRIVACY POLICY)
    /* "Localizer.myAccountPageAcceptancePrivacyNoticeTitle"
    /* "Localizer.myAccountPageAcceptancePrivacyNoticeTitleLanguageItemName"
    */
    public get myAccountPageAcceptancePrivacyNoticeTitle() : string {
        return this.get(`_3A`);
    }

    /**
    /* "MyAccountPage.Acceptance.PrivacyNotice.Content" (Sections 10 and 24 of the Personal Data Act 22.4.1999 / 523\nPrepared: 16.10.2019\n\n1.	The Registrar\nWeAre Solutions Oy\nBusiness ID: 2976585-9\nAddress: Äyritie 12C, 01510 Vantaa Finland\n\n2.	The person responsible for registration and / or the contact person\nCEO Henri Vass\nPhone number: +358 45 138 1927\nEmail: henri.vass@reapptor-apps.fi\n\n3.	Name of the register\nUser register of We Are Solutions Oy's Athenaeum Application Template application.\n\n4.	Purpose of the processing of personal data\nWeAre Solutions Oy and its subsidiaries process personal data in the personal identification service, credit information verification, direct marketing, customer communications, to meet employment requirements, and to enable invoicing and personal customer service.\n\nIn addition, the inclusion of the register in the processing of personal data enables logging in to the service, ordering and producing the service, and developing the service.\n\n5.	Information content of the register\nThe following information can be processed in the register:\n•	Basic information of the data subject\n        o	name\n        o	personal identification number\n        o	mail address\n        o	phone number\n        o	e-mail address\n        o	Position in the company\n        o	Consent of the data subject to direct marketing\n•	Company information\n        o	customer related information\n        o	service history\n        o	credit data entries\n        o	 other entries entered by the customer\n•	Technical information\n        o	location information\n        o	IP address\n        o	Device identification\n        o	advertising ID\n        o	operating system\n        o	browser type\n        o	other hardware details\n\n6. Regular sources of information\nPersonal information is collected from the registrant himself and through the Intrum credit information service.\n\n7. Regular data transfers and data transfers outside the EU or the European Economic Area\nThe data will not be disclosed outside the EU or the EEA.\n\n8. Use of cookies in the online service\nWe use cookies in the online service. A cookie is a small text file stored on a user's computer that enables safe, efficient and user-friendly use of the service.\n\nYou can disable and delete cookies in your browser settings.\n\n9. Registry Security Principles\nThe personal data contained in the register will always be treated as confidential. The principles of processing the data contained in the register are instructed and documented in the organizations processing the data.\n\nThe information system is protected by a firewall.\n\nOn the website, data transfer is secured with an SSL-secured connection.\n\n10. Right of prohibition of the data subject\nThe data subject shall have the right to prohibit the controller from processing personal data concerning him or her for direct mail, distance selling and other direct marketing, as well as for market and opinion research, as well as for personal registration and genealogy. The ban can be set via the mobile application or the customer portal.\n\n11. Right of inspection of the data subject\nThe data subject has the right to inspect the personal data stored in the register and to receive copies of it free of charge up to once a year.\n\nThe request for verification must be made by e-mail from an e-mail address that can be verified by the register to belong to the data subject.\n\n12. Correction of information\nThe controller shall correct, delete or supplement personal data in the register that are incorrect, unnecessary, incomplete or out of date for the purpose of processing on its own initiative or at the request of the data subject. In addition, personal data may be deleted if the customer misuses the service or engages in criminal or other prohibited activities using the service.)
    /* "Localizer.myAccountPageAcceptancePrivacyNoticeContent"
    /* "Localizer.myAccountPageAcceptancePrivacyNoticeContentLanguageItemName"
    */
    public get myAccountPageAcceptancePrivacyNoticeContent() : string {
        return this.get(`_3B`);
    }

    /**
    /* "MyAccountPage.UserAlreadyExists" (User with same email or phone number already exists.)
    /* "Localizer.myAccountPageUserAlreadyExists"
    /* "Localizer.myAccountPageUserAlreadyExistsLanguageItemName"
    */
    public get myAccountPageUserAlreadyExists() : string {
        return this.get(`_3C`);
    }

    /**
    /* "LoginPage.Sso.UserNotFound" (Login failed, user not found.)
    /* "Localizer.loginPageSsoUserNotFound"
    /* "Localizer.loginPageSsoUserNotFoundLanguageItemName"
    */
    public get loginPageSsoUserNotFound() : string {
        return this.get(`_3D`);
    }

    /**
    /* "LoginPage.Sso.Failed" (Login failed, contact support to solve the issue.)
    /* "Localizer.loginPageSsoFailed"
    /* "Localizer.loginPageSsoFailedLanguageItemName"
    */
    public get loginPageSsoFailed() : string {
        return this.get(`_3E`);
    }

    /**
    /* "Generic.AccessDenied" (Access denied)
    /* "Localizer.genericAccessDenied"
    /* "Localizer.genericAccessDeniedLanguageItemName"
    */
    public get genericAccessDenied() : string {
        return this.get(`_3F`);
    }

    /**
    /* "Admin.SettingsKey" (Setting)
    /* "Localizer.adminSettingsKey"
    /* "Localizer.adminSettingsKeyLanguageItemName"
    */
    public get adminSettingsKey() : string {
        return this.get(`_40`);
    }

    /**
    /* "Admin.SettingsValue" (Value)
    /* "Localizer.adminSettingsValue"
    /* "Localizer.adminSettingsValueLanguageItemName"
    */
    public get adminSettingsValue() : string {
        return this.get(`_41`);
    }

    /**
    /* "Admin.UserDeleted" (User account {0} deleted successfully.)
    /* "Localizer.adminUserDeleted"
    /* "Localizer.adminUserDeletedLanguageItemName"
    */
    public get adminUserDeleted() : string {
        return this.get(`_42`);
    }

    /**
    /* "Admin.UserDeletedPermanently" (User account "{0}" was permanently deleted.)
    /* "Localizer.adminUserDeletedPermanently"
    /* "Localizer.adminUserDeletedPermanentlyLanguageItemName"
    */
    public get adminUserDeletedPermanently() : string {
        return this.get(`_43`);
    }

    /**
    /* "Admin.UserRestored" (User account {0} restored successfully.)
    /* "Localizer.adminUserRestored"
    /* "Localizer.adminUserRestoredLanguageItemName"
    */
    public get adminUserRestored() : string {
        return this.get(`_44`);
    }

    /**
    /* "Admin.AddUser" (Add user)
    /* "Localizer.adminAddUser"
    /* "Localizer.adminAddUserLanguageItemName"
    */
    public get adminAddUser() : string {
        return this.get(`_45`);
    }

    /**
    /* "Admin.ShowDeleted" (Show deleted)
    /* "Localizer.adminShowDeleted"
    /* "Localizer.adminShowDeletedLanguageItemName"
    */
    public get adminShowDeleted() : string {
        return this.get(`_46`);
    }

    /**
    /* "Admin.Button.Restore" (Restore)
    /* "Localizer.adminButtonRestore"
    /* "Localizer.adminButtonRestoreLanguageItemName"
    */
    public get adminButtonRestore() : string {
        return this.get(`_47`);
    }

    /**
    /* "Admin.Button.Delete" (Delete)
    /* "Localizer.adminButtonDelete"
    /* "Localizer.adminButtonDeleteLanguageItemName"
    */
    public get adminButtonDelete() : string {
        return this.get(`_48`);
    }

    /**
    /* "Admin.Button.Unlock" (Unlock)
    /* "Localizer.adminButtonUnlock"
    /* "Localizer.adminButtonUnlockLanguageItemName"
    */
    public get adminButtonUnlock() : string {
        return this.get(`_49`);
    }

    /**
    /* "Admin.SettingsSaved" (Settings saved)
    /* "Localizer.adminSettingsSaved"
    /* "Localizer.adminSettingsSavedLanguageItemName"
    */
    public get adminSettingsSaved() : string {
        return this.get(`_4A`);
    }

    /**
    /* "Admin.AlertMessage.UnlockUser" (User account "{0}" unlocked successfully.)
    /* "Localizer.adminAlertMessageUnlockUser"
    /* "Localizer.adminAlertMessageUnlockUserLanguageItemName"
    */
    public get adminAlertMessageUnlockUser() : string {
        return this.get(`_4B`);
    }

    /**
    /* "Admin.ConfirmationButton.UnlockUser" (Are you sure you want to unlock user "{0}"?)
    /* "Localizer.adminConfirmationButtonUnlockUser"
    /* "Localizer.adminConfirmationButtonUnlockUserLanguageItemName"
    */
    public get adminConfirmationButtonUnlockUser() : string {
        return this.get(`_4C`);
    }

    /**
    /* "Admin.ConfirmationButton.DeleteUser" (Are you sure you want to delete user "{0}"?)
    /* "Localizer.adminConfirmationButtonDeleteUser"
    /* "Localizer.adminConfirmationButtonDeleteUserLanguageItemName"
    */
    public get adminConfirmationButtonDeleteUser() : string {
        return this.get(`_4D`);
    }

    /**
    /* "Admin.ConfirmationButton.RestoreUser" (Are you sure you want to restore user "{0}"?)
    /* "Localizer.adminConfirmationButtonRestoreUser"
    /* "Localizer.adminConfirmationButtonRestoreUserLanguageItemName"
    */
    public get adminConfirmationButtonRestoreUser() : string {
        return this.get(`_4E`);
    }

    /**
    /* "Generic.Cancel" (Cancel)
    /* "Localizer.genericCancel"
    /* "Localizer.genericCancelLanguageItemName"
    */
    public get genericCancel() : string {
        return this.get(`_4F`);
    }

    /**
    /* "ResetPassword.PageTitle" (Set new password for your account)
    /* "Localizer.resetPasswordPageTitle"
    /* "Localizer.resetPasswordPageTitleLanguageItemName"
    */
    public get resetPasswordPageTitle() : string {
        return this.get(`_50`);
    }

    /**
    /* "ResetPassword.SuccessMessage" (Password set successfully)
    /* "Localizer.resetPasswordSuccessMessage"
    /* "Localizer.resetPasswordSuccessMessageLanguageItemName"
    */
    public get resetPasswordSuccessMessage() : string {
        return this.get(`_51`);
    }

    /**
    /* "ResetPassword.SuccessMessageAndInfo" (Password set successfully. You must accept terms of usage and privacy notice in order to use application.)
    /* "Localizer.resetPasswordSuccessMessageAndInfo"
    /* "Localizer.resetPasswordSuccessMessageAndInfoLanguageItemName"
    */
    public get resetPasswordSuccessMessageAndInfo() : string {
        return this.get(`_52`);
    }

    /**
    /* "ChangePassword.PageTitle" (Change password)
    /* "Localizer.changePasswordPageTitle"
    /* "Localizer.changePasswordPageTitleLanguageItemName"
    */
    public get changePasswordPageTitle() : string {
        return this.get(`_53`);
    }

    /**
    /* "ChangePassword.Button" (Change password)
    /* "Localizer.changePasswordButton"
    /* "Localizer.changePasswordButtonLanguageItemName"
    */
    public get changePasswordButton() : string {
        return this.get(`_54`);
    }

    /**
    /* "ChangePassword.WrongCurrentMessage" (Wrong current password)
    /* "Localizer.changePasswordWrongCurrentMessage"
    /* "Localizer.changePasswordWrongCurrentMessageLanguageItemName"
    */
    public get changePasswordWrongCurrentMessage() : string {
        return this.get(`_55`);
    }

    /**
    /* "ChangePassword.WeakPasswordMessage" (Password must have one non alphanumeric character, one lowercase ('a'-'z') character, one uppercase ('A'-'Z') character, one number and be at least 8 characters long)
    /* "Localizer.changePasswordWeakPasswordMessage"
    /* "Localizer.changePasswordWeakPasswordMessageLanguageItemName"
    */
    public get changePasswordWeakPasswordMessage() : string {
        return this.get(`_56`);
    }

    /**
    /* "Month.January" (January)
    /* "Localizer.monthJanuary"
    /* "Localizer.monthJanuaryLanguageItemName"
    */
    public get monthJanuary() : string {
        return this.get(`_57`);
    }

    /**
    /* "Month.February" (February)
    /* "Localizer.monthFebruary"
    /* "Localizer.monthFebruaryLanguageItemName"
    */
    public get monthFebruary() : string {
        return this.get(`_58`);
    }

    /**
    /* "Month.March" (March)
    /* "Localizer.monthMarch"
    /* "Localizer.monthMarchLanguageItemName"
    */
    public get monthMarch() : string {
        return this.get(`_59`);
    }

    /**
    /* "Month.April" (April)
    /* "Localizer.monthApril"
    /* "Localizer.monthAprilLanguageItemName"
    */
    public get monthApril() : string {
        return this.get(`_5A`);
    }

    /**
    /* "Month.May" (May)
    /* "Localizer.monthMay"
    /* "Localizer.monthMayLanguageItemName"
    */
    public get monthMay() : string {
        return this.get(`_5B`);
    }

    /**
    /* "Month.June" (June)
    /* "Localizer.monthJune"
    /* "Localizer.monthJuneLanguageItemName"
    */
    public get monthJune() : string {
        return this.get(`_5C`);
    }

    /**
    /* "Month.July" (July)
    /* "Localizer.monthJuly"
    /* "Localizer.monthJulyLanguageItemName"
    */
    public get monthJuly() : string {
        return this.get(`_5D`);
    }

    /**
    /* "Month.August" (August)
    /* "Localizer.monthAugust"
    /* "Localizer.monthAugustLanguageItemName"
    */
    public get monthAugust() : string {
        return this.get(`_5E`);
    }

    /**
    /* "Month.September" (September)
    /* "Localizer.monthSeptember"
    /* "Localizer.monthSeptemberLanguageItemName"
    */
    public get monthSeptember() : string {
        return this.get(`_5F`);
    }

    /**
    /* "Month.October" (October)
    /* "Localizer.monthOctober"
    /* "Localizer.monthOctoberLanguageItemName"
    */
    public get monthOctober() : string {
        return this.get(`_60`);
    }

    /**
    /* "Month.November" (November)
    /* "Localizer.monthNovember"
    /* "Localizer.monthNovemberLanguageItemName"
    */
    public get monthNovember() : string {
        return this.get(`_61`);
    }

    /**
    /* "Month.December" (December)
    /* "Localizer.monthDecember"
    /* "Localizer.monthDecemberLanguageItemName"
    */
    public get monthDecember() : string {
        return this.get(`_62`);
    }

    /**
    /* "Enum.UserRoleGroup.Admins" (Admins)
    /* "Localizer.enumUserRoleGroupAdmins"
    /* "Localizer.enumUserRoleGroupAdminsLanguageItemName"
    */
    public get enumUserRoleGroupAdmins() : string {
        return this.get(`_63`);
    }

    /**
    /* "Enum.UserRoleGroup.Subcontractors" (Subcontractors)
    /* "Localizer.enumUserRoleGroupSubcontractors"
    /* "Localizer.enumUserRoleGroupSubcontractorsLanguageItemName"
    */
    public get enumUserRoleGroupSubcontractors() : string {
        return this.get(`_64`);
    }

    /**
    /* "Enum.UserRoleGroup.Admins.Description" (Site & business administrators)
    /* "Localizer.enumUserRoleGroupAdminsDescription"
    /* "Localizer.enumUserRoleGroupAdminsDescriptionLanguageItemName"
    */
    public get enumUserRoleGroupAdminsDescription() : string {
        return this.get(`_65`);
    }

    /**
    /* "Enum.UserRoleGroup.Managers" (Managers)
    /* "Localizer.enumUserRoleGroupManagers"
    /* "Localizer.enumUserRoleGroupManagersLanguageItemName"
    */
    public get enumUserRoleGroupManagers() : string {
        return this.get(`_66`);
    }

    /**
    /* "Enum.UserRoleGroup.ContactPersons" (Contact persons)
    /* "Localizer.enumUserRoleGroupContactPersons"
    /* "Localizer.enumUserRoleGroupContactPersonsLanguageItemName"
    */
    public get enumUserRoleGroupContactPersons() : string {
        return this.get(`_67`);
    }

    /**
    /* "Enum.UserRoleGroup.Managers.Description" (Site managers & contact persons)
    /* "Localizer.enumUserRoleGroupManagersDescription"
    /* "Localizer.enumUserRoleGroupManagersDescriptionLanguageItemName"
    */
    public get enumUserRoleGroupManagersDescription() : string {
        return this.get(`_68`);
    }

    /**
    /* "Enum.UserRoleGroup.Employees" (Employees)
    /* "Localizer.enumUserRoleGroupEmployees"
    /* "Localizer.enumUserRoleGroupEmployeesLanguageItemName"
    */
    public get enumUserRoleGroupEmployees() : string {
        return this.get(`_69`);
    }

    /**
    /* "Enum.UserRoleGroup.Employees.Description" (Head mounters, mounters & drivers)
    /* "Localizer.enumUserRoleGroupEmployeesDescription"
    /* "Localizer.enumUserRoleGroupEmployeesDescriptionLanguageItemName"
    */
    public get enumUserRoleGroupEmployeesDescription() : string {
        return this.get(`_6A`);
    }

    /**
    /* "Admin.ChooseRole" (Choose a role)
    /* "Localizer.adminChooseRole"
    /* "Localizer.adminChooseRoleLanguageItemName"
    */
    public get adminChooseRole() : string {
        return this.get(`_6B`);
    }

    /**
    /* "Component.Footer.Contact" (Contact information)
    /* "Localizer.componentFooterContact"
    /* "Localizer.componentFooterContactLanguageItemName"
    */
    public get componentFooterContact() : string {
        return this.get(`_6C`);
    }

    /**
    /* "Component.Footer.Frontpage" (Frontpage)
    /* "Localizer.componentFooterFrontpage"
    /* "Localizer.componentFooterFrontpageLanguageItemName"
    */
    public get componentFooterFrontpage() : string {
        return this.get(`_6D`);
    }

    /**
    /* "Tasks.Dashboard.GetManual" (Welcome to Template Application dashboard, press Sign-in to start Your workday.\n\nAfter successful login You can change construction site or pickup a new task from the same page.\n\nWhen your workday is finished press Sign-out to start checkout process.)
    /* "Localizer.tasksDashboardGetManual"
    /* "Localizer.tasksDashboardGetManualLanguageItemName"
    */
    public get tasksDashboardGetManual() : string {
        return this.get(`_6E`);
    }

    /**
    /* "Admin.Grid.NoInvitationsText" (No invitations has been sent)
    /* "Localizer.adminGridNoInvitationsText"
    /* "Localizer.adminGridNoInvitationsTextLanguageItemName"
    */
    public get adminGridNoInvitationsText() : string {
        return this.get(`_6F`);
    }

    /**
    /* "Admin.Button.ResendInvitation" (Resend invitation)
    /* "Localizer.adminButtonResendInvitation"
    /* "Localizer.adminButtonResendInvitationLanguageItemName"
    */
    public get adminButtonResendInvitation() : string {
        return this.get(`_70`);
    }

    /**
    /* "Admin.Button.ResetPassword" (Reset password)
    /* "Localizer.adminButtonResetPassword"
    /* "Localizer.adminButtonResetPasswordLanguageItemName"
    */
    public get adminButtonResetPassword() : string {
        return this.get(`_71`);
    }

    /**
    /* "Admin.Label.AuthenticationType" (Authentication type)
    /* "Localizer.adminLabelAuthenticationType"
    /* "Localizer.adminLabelAuthenticationTypeLanguageItemName"
    */
    public get adminLabelAuthenticationType() : string {
        return this.get(`_72`);
    }

    /**
    /* "Enum.AuthType.Email" (Email)
    /* "Localizer.enumAuthTypeEmail"
    /* "Localizer.enumAuthTypeEmailLanguageItemName"
    */
    public get enumAuthTypeEmail() : string {
        return this.get(`_73`);
    }

    /**
    /* "Enum.AuthType.Phone" (SMS)
    /* "Localizer.enumAuthTypePhone"
    /* "Localizer.enumAuthTypePhoneLanguageItemName"
    */
    public get enumAuthTypePhone() : string {
        return this.get(`_74`);
    }

    /**
    /* "Admin.Tab.Invitations" (Invitations)
    /* "Localizer.adminTabInvitations"
    /* "Localizer.adminTabInvitationsLanguageItemName"
    */
    public get adminTabInvitations() : string {
        return this.get(`_75`);
    }

    /**
    /* "Admin.ConfirmationButton.ResetPassword" (Are you sure you want to reset password for user "{0}"?)
    /* "Localizer.adminConfirmationButtonResetPassword"
    /* "Localizer.adminConfirmationButtonResetPasswordLanguageItemName"
    */
    public get adminConfirmationButtonResetPassword() : string {
        return this.get(`_76`);
    }

    /**
    /* "Admin.ConfirmationButton.ResendInvitation" (Are you sure you want to invite user "{0}"?)
    /* "Localizer.adminConfirmationButtonResendInvitation"
    /* "Localizer.adminConfirmationButtonResendInvitationLanguageItemName"
    */
    public get adminConfirmationButtonResendInvitation() : string {
        return this.get(`_77`);
    }

    /**
    /* "Admin.Alert.UserPasswordInfo" (User account "{0}" does not have a password.)
    /* "Localizer.adminAlertUserPasswordInfo"
    /* "Localizer.adminAlertUserPasswordInfoLanguageItemName"
    */
    public get adminAlertUserPasswordInfo() : string {
        return this.get(`_78`);
    }

    /**
    /* "Admin.Grid.CreatedBy" (Created by)
    /* "Localizer.adminGridCreatedBy"
    /* "Localizer.adminGridCreatedByLanguageItemName"
    */
    public get adminGridCreatedBy() : string {
        return this.get(`_79`);
    }

    /**
    /* "Admin.Grid.Type" (Type)
    /* "Localizer.adminGridType"
    /* "Localizer.adminGridTypeLanguageItemName"
    */
    public get adminGridType() : string {
        return this.get(`_7A`);
    }

    /**
    /* "Generic.CreatedAt" (Created at)
    /* "Localizer.genericCreatedAt"
    /* "Localizer.genericCreatedAtLanguageItemName"
    */
    public get genericCreatedAt() : string {
        return this.get(`_7B`);
    }

    /**
    /* "Admin.Grid.ExpiresAt" (Expires at)
    /* "Localizer.adminGridExpiresAt"
    /* "Localizer.adminGridExpiresAtLanguageItemName"
    */
    public get adminGridExpiresAt() : string {
        return this.get(`_7C`);
    }

    /**
    /* "Admin.Grid.ProcessedAt" (Processed At)
    /* "Localizer.adminGridProcessedAt"
    /* "Localizer.adminGridProcessedAtLanguageItemName"
    */
    public get adminGridProcessedAt() : string {
        return this.get(`_7D`);
    }

    /**
    /* "Admin.Grid.Reusable" (Reusable)
    /* "Localizer.adminGridReusable"
    /* "Localizer.adminGridReusableLanguageItemName"
    */
    public get adminGridReusable() : string {
        return this.get(`_7E`);
    }

    /**
    /* "Admin.Grid.AuthType" (Auth type)
    /* "Localizer.adminGridAuthType"
    /* "Localizer.adminGridAuthTypeLanguageItemName"
    */
    public get adminGridAuthType() : string {
        return this.get(`_7F`);
    }

    /**
    /* "Admin.AlertMessage.AccountSaved" (User account "{0}" saved successfully.)
    /* "Localizer.adminAlertMessageAccountSaved"
    /* "Localizer.adminAlertMessageAccountSavedLanguageItemName"
    */
    public get adminAlertMessageAccountSaved() : string {
        return this.get(`_80`);
    }

    /**
    /* "Admin.AlertError.AccountExist" (User account "{0}" already exist.)
    /* "Localizer.adminAlertErrorAccountExist"
    /* "Localizer.adminAlertErrorAccountExistLanguageItemName"
    */
    public get adminAlertErrorAccountExist() : string {
        return this.get(`_81`);
    }

    /**
    /* "Admin.AlertError.WorkCardIdExists" (Work card id "{0}" is already registered for another user account.)
    /* "Localizer.adminAlertErrorWorkCardIdExists"
    /* "Localizer.adminAlertErrorWorkCardIdExistsLanguageItemName"
    */
    public get adminAlertErrorWorkCardIdExists() : string {
        return this.get(`_82`);
    }

    /**
    /* "Admin.AlertError.PhoneNumberInvalid" (Phone number is invalid.)
    /* "Localizer.adminAlertErrorPhoneNumberInvalid"
    /* "Localizer.adminAlertErrorPhoneNumberInvalidLanguageItemName"
    */
    public get adminAlertErrorPhoneNumberInvalid() : string {
        return this.get(`_83`);
    }

    /**
    /* "ForgotPassword.UsernameInput" (Email or phone number)
    /* "Localizer.forgotPasswordUsernameInput"
    /* "Localizer.forgotPasswordUsernameInputLanguageItemName"
    */
    public get forgotPasswordUsernameInput() : string {
        return this.get(`_84`);
    }

    /**
    /* "Enum.InvitationType.Invitation" (Invitation)
    /* "Localizer.enumInvitationTypeInvitation"
    /* "Localizer.enumInvitationTypeInvitationLanguageItemName"
    */
    public get enumInvitationTypeInvitation() : string {
        return this.get(`_85`);
    }

    /**
    /* "Enum.InvitationType.ResetPassword" (Reset password)
    /* "Localizer.enumInvitationTypeResetPassword"
    /* "Localizer.enumInvitationTypeResetPasswordLanguageItemName"
    */
    public get enumInvitationTypeResetPassword() : string {
        return this.get(`_86`);
    }

    /**
    /* "Enum.InvitationType.ForgotPassword" (Forgot password)
    /* "Localizer.enumInvitationTypeForgotPassword"
    /* "Localizer.enumInvitationTypeForgotPasswordLanguageItemName"
    */
    public get enumInvitationTypeForgotPassword() : string {
        return this.get(`_87`);
    }

    /**
    /* "Admin.ConfirmationButton.Rollback" (Are you sure that you want to rollback unsaved changes?)
    /* "Localizer.adminConfirmationButtonRollback"
    /* "Localizer.adminConfirmationButtonRollbackLanguageItemName"
    */
    public get adminConfirmationButtonRollback() : string {
        return this.get(`_88`);
    }

    /**
    /* "Widget.Pwa.Install" (Install)
    /* "Localizer.widgetPwaInstall"
    /* "Localizer.widgetPwaInstallLanguageItemName"
    */
    public get widgetPwaInstall() : string {
        return this.get(`_89`);
    }

    /**
    /* "Widget.Pwa.Description" (Add application to the home screen)
    /* "Localizer.widgetPwaDescription"
    /* "Localizer.widgetPwaDescriptionLanguageItemName"
    */
    public get widgetPwaDescription() : string {
        return this.get(`_8A`);
    }

    /**
    /* "Admin.OrganizationContracts.Label" (Organization Contracts)
    /* "Localizer.adminOrganizationContractsLabel"
    /* "Localizer.adminOrganizationContractsLabelLanguageItemName"
    */
    public get adminOrganizationContractsLabel() : string {
        return this.get(`_8B`);
    }

    /**
    /* "WorkOrders.Page.Title" (Work orders)
    /* "Localizer.workOrdersPageTitle"
    /* "Localizer.workOrdersPageTitleLanguageItemName"
    */
    public get workOrdersPageTitle() : string {
        return this.get(`_8C`);
    }

    /**
    /* "Dashboard.GetManual" (This is Dashboard page with widgets based on Your access role.)
    /* "Localizer.dashboardGetManual"
    /* "Localizer.dashboardGetManualLanguageItemName"
    */
    public get dashboardGetManual() : string {
        return this.get(`_8D`);
    }

    /**
    /* "ContactSupportPage.MessageSent" (Your request was sent to support team.)
    /* "Localizer.contactSupportPageMessageSent"
    /* "Localizer.contactSupportPageMessageSentLanguageItemName"
    */
    public get contactSupportPageMessageSent() : string {
        return this.get(`_8E`);
    }

    /**
    /* "ContactSupportPage.MessageWithIdSent" (Your request with id "{0}" was sent to support team.)
    /* "Localizer.contactSupportPageMessageWithIdSent"
    /* "Localizer.contactSupportPageMessageWithIdSentLanguageItemName"
    */
    public get contactSupportPageMessageWithIdSent() : string {
        return this.get(`_8F`);
    }

    /**
    /* "TopNav.AdminManagement" (Admin management)
    /* "Localizer.topNavAdminManagement"
    /* "Localizer.topNavAdminManagementLanguageItemName"
    */
    public get topNavAdminManagement() : string {
        return this.get(`_90`);
    }

    /**
    /* "UserManagementPage.Title" (User management)
    /* "Localizer.userManagementPageTitle"
    /* "Localizer.userManagementPageTitleLanguageItemName"
    */
    public get userManagementPageTitle() : string {
        return this.get(`_91`);
    }

    /**
    /* "UserManagementPage.Checkbox.ShowExpired" (Show expired)
    /* "Localizer.userManagementPageCheckboxShowExpired"
    /* "Localizer.userManagementPageCheckboxShowExpiredLanguageItemName"
    */
    public get userManagementPageCheckboxShowExpired() : string {
        return this.get(`_92`);
    }

    /**
    /* "ApplicationSettingsPage.Title" (Application settings)
    /* "Localizer.applicationSettingsPageTitle"
    /* "Localizer.applicationSettingsPageTitleLanguageItemName"
    */
    public get applicationSettingsPageTitle() : string {
        return this.get(`_93`);
    }

    /**
    /* "RoleName.Mounter" (RTP mounter)
    /* "Localizer.roleNameMounter"
    /* "Localizer.roleNameMounterLanguageItemName"
    */
    public get roleNameMounter() : string {
        return this.get(`_94`);
    }

    /**
    /* "RoleName.Admin" (Admin)
    /* "Localizer.roleNameAdmin"
    /* "Localizer.roleNameAdminLanguageItemName"
    */
    public get roleNameAdmin() : string {
        return this.get(`_95`);
    }

    /**
    /* "RoleName.ContactPerson" (Contact Person)
    /* "Localizer.roleNameContactPerson"
    /* "Localizer.roleNameContactPersonLanguageItemName"
    */
    public get roleNameContactPerson() : string {
        return this.get(`_96`);
    }

    /**
    /* "RoleName.BusinessManager" (Business Manager)
    /* "Localizer.roleNameBusinessManager"
    /* "Localizer.roleNameBusinessManagerLanguageItemName"
    */
    public get roleNameBusinessManager() : string {
        return this.get(`_97`);
    }

    /**
    /* "RoleName.Manager" (Manager)
    /* "Localizer.roleNameManager"
    /* "Localizer.roleNameManagerLanguageItemName"
    */
    public get roleNameManager() : string {
        return this.get(`_98`);
    }

    /**
    /* "AdminConsolePage.ClearRedisCache" (Clear Redis Cache)
    /* "Localizer.adminConsolePageClearRedisCache"
    /* "Localizer.adminConsolePageClearRedisCacheLanguageItemName"
    */
    public get adminConsolePageClearRedisCache() : string {
        return this.get(`_99`);
    }

    /**
    /* "AdminConsolePage.ClearRedisCache.Confirm" (Are you sure you want to clear Redis cache and session?)
    /* "Localizer.adminConsolePageClearRedisCacheConfirm"
    /* "Localizer.adminConsolePageClearRedisCacheConfirmLanguageItemName"
    */
    public get adminConsolePageClearRedisCacheConfirm() : string {
        return this.get(`_9A`);
    }

    /**
    /* "AdminConsolePage.DropUserSessions" (Drop Users Sessions)
    /* "Localizer.adminConsolePageDropUserSessions"
    /* "Localizer.adminConsolePageDropUserSessionsLanguageItemName"
    */
    public get adminConsolePageDropUserSessions() : string {
        return this.get(`_9B`);
    }

    /**
    /* "AdminConsolePage.DropUserSessions.Confirm" (Are you sure you want to drop all user session, user will need to re-login?)
    /* "Localizer.adminConsolePageDropUserSessionsConfirm"
    /* "Localizer.adminConsolePageDropUserSessionsConfirmLanguageItemName"
    */
    public get adminConsolePageDropUserSessionsConfirm() : string {
        return this.get(`_9C`);
    }

    /**
    /* "AdminConsolePage.TestEmail" (Test Email)
    /* "Localizer.adminConsolePageTestEmail"
    /* "Localizer.adminConsolePageTestEmailLanguageItemName"
    */
    public get adminConsolePageTestEmail() : string {
        return this.get(`_9D`);
    }

    /**
    /* "AdminConsolePage.TestEmail.Failed" (Email test failed.\nError:\n{0})
    /* "Localizer.adminConsolePageTestEmailFailed"
    /* "Localizer.adminConsolePageTestEmailFailedLanguageItemName"
    */
    public get adminConsolePageTestEmailFailed() : string {
        return this.get(`_9E`);
    }

    /**
    /* "AdminConsolePage.TestEmail.Success" (Email successfully sent.)
    /* "Localizer.adminConsolePageTestEmailSuccess"
    /* "Localizer.adminConsolePageTestEmailSuccessLanguageItemName"
    */
    public get adminConsolePageTestEmailSuccess() : string {
        return this.get(`_9F`);
    }

    /**
    /* "AdminConsolePage.TestPdf" (Test Pdf)
    /* "Localizer.adminConsolePageTestPdf"
    /* "Localizer.adminConsolePageTestPdfLanguageItemName"
    */
    public get adminConsolePageTestPdf() : string {
        return this.get(`_A0`);
    }

    /**
    /* "AdminConsolePage.TestPdf.Failed" (Pdf test failed.\nPdf version: "{0}".\nError:\n{1})
    /* "Localizer.adminConsolePageTestPdfFailed"
    /* "Localizer.adminConsolePageTestPdfFailedLanguageItemName"
    */
    public get adminConsolePageTestPdfFailed() : string {
        return this.get(`_A1`);
    }

    /**
    /* "AdminConsolePage.TestPdf.Success" (Pdf version: "{0}".)
    /* "Localizer.adminConsolePageTestPdfSuccess"
    /* "Localizer.adminConsolePageTestPdfSuccessLanguageItemName"
    */
    public get adminConsolePageTestPdfSuccess() : string {
        return this.get(`_A2`);
    }

    /**
    /* "AdminConsolePage.TestSms" (Test SMS)
    /* "Localizer.adminConsolePageTestSms"
    /* "Localizer.adminConsolePageTestSmsLanguageItemName"
    */
    public get adminConsolePageTestSms() : string {
        return this.get(`_A3`);
    }

    /**
    /* "AdminConsolePage.TestSms.Failed" (Sms test failed.\nError:\n{0})
    /* "Localizer.adminConsolePageTestSmsFailed"
    /* "Localizer.adminConsolePageTestSmsFailedLanguageItemName"
    */
    public get adminConsolePageTestSmsFailed() : string {
        return this.get(`_A4`);
    }

    /**
    /* "AdminConsolePage.TestSms.Success" (Sms successfully sent.)
    /* "Localizer.adminConsolePageTestSmsSuccess"
    /* "Localizer.adminConsolePageTestSmsSuccessLanguageItemName"
    */
    public get adminConsolePageTestSmsSuccess() : string {
        return this.get(`_A5`);
    }

    /**
    /* "AdminConsolePage.Title" (Admin console)
    /* "Localizer.adminConsolePageTitle"
    /* "Localizer.adminConsolePageTitleLanguageItemName"
    */
    public get adminConsolePageTitle() : string {
        return this.get(`_A6`);
    }

    /**
    /* "Validators.Email" (Email must be a proper email form)
    /* "Localizer.validatorsEmail"
    /* "Localizer.validatorsEmailLanguageItemName"
    */
    public get validatorsEmail() : string {
        return this.get(`_A7`);
    }

    /**
    /* "Validators.Password" (Password must contain at least 1 lowercase, 1 uppercase character, 1 special character and be at least 8 characters long)
    /* "Localizer.validatorsPassword"
    /* "Localizer.validatorsPasswordLanguageItemName"
    */
    public get validatorsPassword() : string {
        return this.get(`_A8`);
    }

    /**
    /* "Validators.Phone" (Incorrect phone number.)
    /* "Localizer.validatorsPhone"
    /* "Localizer.validatorsPhoneLanguageItemName"
    */
    public get validatorsPhone() : string {
        return this.get(`_A9`);
    }

    /**
    /* "Validators.Required" ({0} is required)
    /* "Localizer.validatorsRequired"
    /* "Localizer.validatorsRequiredLanguageItemName"
    */
    public get validatorsRequired() : string {
        return this.get(`_AA`);
    }

    /**
    /* "Validators.NumberRange" (Value must be in range {0} - {1}.)
    /* "Localizer.validatorsNumberRange"
    /* "Localizer.validatorsNumberRangeLanguageItemName"
    */
    public get validatorsNumberRange() : string {
        return this.get(`_AB`);
    }

    /**
    /* "Validators.Length" (Text is too short)
    /* "Localizer.validatorsLength"
    /* "Localizer.validatorsLengthLanguageItemName"
    */
    public get validatorsLength() : string {
        return this.get(`_AC`);
    }

    /**
    /* "Validators.Url" (Incorrect URL format.)
    /* "Localizer.validatorsUrl"
    /* "Localizer.validatorsUrlLanguageItemName"
    */
    public get validatorsUrl() : string {
        return this.get(`_AD`);
    }

    /**
    /* "Generic.Actions" (Actions)
    /* "Localizer.genericActions"
    /* "Localizer.genericActionsLanguageItemName"
    */
    public get genericActions() : string {
        return this.get(`_AE`);
    }

    /**
    /* "Generic.Save" (Save)
    /* "Localizer.genericSave"
    /* "Localizer.genericSaveLanguageItemName"
    */
    public get genericSave() : string {
        return this.get(`_AF`);
    }

    /**
    /* "Generic.Back" (Back)
    /* "Localizer.genericBack"
    /* "Localizer.genericBackLanguageItemName"
    */
    public get genericBack() : string {
        return this.get(`_B0`);
    }

    /**
    /* "Generic.Reload" (Reload)
    /* "Localizer.genericReload"
    /* "Localizer.genericReloadLanguageItemName"
    */
    public get genericReload() : string {
        return this.get(`_B1`);
    }

    /**
    /* "Generic.Search" (Search)
    /* "Localizer.genericSearch"
    /* "Localizer.genericSearchLanguageItemName"
    */
    public get genericSearch() : string {
        return this.get(`_B2`);
    }

    /**
    /* "Generic.Delete" (Delete)
    /* "Localizer.genericDelete"
    /* "Localizer.genericDeleteLanguageItemName"
    */
    public get genericDelete() : string {
        return this.get(`_B3`);
    }

    /**
    /* "Generic.Restore" (Restore)
    /* "Localizer.genericRestore"
    /* "Localizer.genericRestoreLanguageItemName"
    */
    public get genericRestore() : string {
        return this.get(`_B4`);
    }

    /**
    /* "Generic.Edit" (Edit)
    /* "Localizer.genericEdit"
    /* "Localizer.genericEditLanguageItemName"
    */
    public get genericEdit() : string {
        return this.get(`_B5`);
    }

    /**
    /* "Generic.Add" (Add)
    /* "Localizer.genericAdd"
    /* "Localizer.genericAddLanguageItemName"
    */
    public get genericAdd() : string {
        return this.get(`_B6`);
    }

    /**
    /* "Generic.Address" (Address)
    /* "Localizer.genericAddress"
    /* "Localizer.genericAddressLanguageItemName"
    */
    public get genericAddress() : string {
        return this.get(`_B7`);
    }

    /**
    /* "Generic.Activate" (Activate)
    /* "Localizer.genericActivate"
    /* "Localizer.genericActivateLanguageItemName"
    */
    public get genericActivate() : string {
        return this.get(`_B8`);
    }

    /**
    /* "Generic.Deactivate" (Deactivate)
    /* "Localizer.genericDeactivate"
    /* "Localizer.genericDeactivateLanguageItemName"
    */
    public get genericDeactivate() : string {
        return this.get(`_B9`);
    }

    /**
    /* "Generic.Next" (Next)
    /* "Localizer.genericNext"
    /* "Localizer.genericNextLanguageItemName"
    */
    public get genericNext() : string {
        return this.get(`_BA`);
    }

    /**
    /* "Generic.Date" (Date)
    /* "Localizer.genericDate"
    /* "Localizer.genericDateLanguageItemName"
    */
    public get genericDate() : string {
        return this.get(`_BB`);
    }

    /**
    /* "Generic.Loading" (Loading..)
    /* "Localizer.genericLoading"
    /* "Localizer.genericLoadingLanguageItemName"
    */
    public get genericLoading() : string {
        return this.get(`_BC`);
    }

    /**
    /* "Generic.Name" (Name)
    /* "Localizer.genericName"
    /* "Localizer.genericNameLanguageItemName"
    */
    public get genericName() : string {
        return this.get(`_BD`);
    }

    /**
    /* "Generic.NoData" (No data)
    /* "Localizer.genericNoData"
    /* "Localizer.genericNoDataLanguageItemName"
    */
    public get genericNoData() : string {
        return this.get(`_BE`);
    }

    /**
    /* "Generic.VatId" (VAT id)
    /* "Localizer.genericVatId"
    /* "Localizer.genericVatIdLanguageItemName"
    */
    public get genericVatId() : string {
        return this.get(`_BF`);
    }

    /**
    /* "Generic.BusinessId" (Business Id)
    /* "Localizer.genericBusinessId"
    /* "Localizer.genericBusinessIdLanguageItemName"
    */
    public get genericBusinessId() : string {
        return this.get(`_C0`);
    }

    /**
    /* "Generic.Accept" (Accept)
    /* "Localizer.genericAccept"
    /* "Localizer.genericAcceptLanguageItemName"
    */
    public get genericAccept() : string {
        return this.get(`_C1`);
    }

    /**
    /* "Generic.City" (City)
    /* "Localizer.genericCity"
    /* "Localizer.genericCityLanguageItemName"
    */
    public get genericCity() : string {
        return this.get(`_C2`);
    }

    /**
    /* "Generic.Close" (Close)
    /* "Localizer.genericClose"
    /* "Localizer.genericCloseLanguageItemName"
    */
    public get genericClose() : string {
        return this.get(`_C3`);
    }

    /**
    /* "Generic.Comment" (Information)
    /* "Localizer.genericComment"
    /* "Localizer.genericCommentLanguageItemName"
    */
    public get genericComment() : string {
        return this.get(`_C4`);
    }

    /**
    /* "Generic.Company" (Company)
    /* "Localizer.genericCompany"
    /* "Localizer.genericCompanyLanguageItemName"
    */
    public get genericCompany() : string {
        return this.get(`_C5`);
    }

    /**
    /* "Generic.Customer" (Customer)
    /* "Localizer.genericCustomer"
    /* "Localizer.genericCustomerLanguageItemName"
    */
    public get genericCustomer() : string {
        return this.get(`_C6`);
    }

    /**
    /* "Generic.Count" (Count)
    /* "Localizer.genericCount"
    /* "Localizer.genericCountLanguageItemName"
    */
    public get genericCount() : string {
        return this.get(`_C7`);
    }

    /**
    /* "Generic.Create" (Create)
    /* "Localizer.genericCreate"
    /* "Localizer.genericCreateLanguageItemName"
    */
    public get genericCreate() : string {
        return this.get(`_C8`);
    }

    /**
    /* "Generic.Day" (day)
    /* "Localizer.genericDay"
    /* "Localizer.genericDayLanguageItemName"
    */
    public get genericDay() : string {
        return this.get(`_C9`);
    }

    /**
    /* "Generic.Description" (Description)
    /* "Localizer.genericDescription"
    /* "Localizer.genericDescriptionLanguageItemName"
    */
    public get genericDescription() : string {
        return this.get(`_CA`);
    }

    /**
    /* "Generic.Email" (Email)
    /* "Localizer.genericEmail"
    /* "Localizer.genericEmailLanguageItemName"
    */
    public get genericEmail() : string {
        return this.get(`_CB`);
    }

    /**
    /* "Generic.Error" (Error)
    /* "Localizer.genericError"
    /* "Localizer.genericErrorLanguageItemName"
    */
    public get genericError() : string {
        return this.get(`_CC`);
    }

    /**
    /* "Generic.Favorite" (Favorites)
    /* "Localizer.genericFavorite"
    /* "Localizer.genericFavoriteLanguageItemName"
    */
    public get genericFavorite() : string {
        return this.get(`_CD`);
    }

    /**
    /* "Generic.FirstName" (First name)
    /* "Localizer.genericFirstName"
    /* "Localizer.genericFirstNameLanguageItemName"
    */
    public get genericFirstName() : string {
        return this.get(`_CE`);
    }

    /**
    /* "Generic.LastName" (Last name)
    /* "Localizer.genericLastName"
    /* "Localizer.genericLastNameLanguageItemName"
    */
    public get genericLastName() : string {
        return this.get(`_CF`);
    }

    /**
    /* "Generic.Login" (Login)
    /* "Localizer.genericLogin"
    /* "Localizer.genericLoginLanguageItemName"
    */
    public get genericLogin() : string {
        return this.get(`_D0`);
    }

    /**
    /* "Generic.Message" (Message)
    /* "Localizer.genericMessage"
    /* "Localizer.genericMessageLanguageItemName"
    */
    public get genericMessage() : string {
        return this.get(`_D1`);
    }

    /**
    /* "Generic.Month" (month)
    /* "Localizer.genericMonth"
    /* "Localizer.genericMonthLanguageItemName"
    */
    public get genericMonth() : string {
        return this.get(`_D2`);
    }

    /**
    /* "Generic.Password" (Password)
    /* "Localizer.genericPassword"
    /* "Localizer.genericPasswordLanguageItemName"
    */
    public get genericPassword() : string {
        return this.get(`_D3`);
    }

    /**
    /* "Generic.PhoneNumber" (Phone number)
    /* "Localizer.genericPhoneNumber"
    /* "Localizer.genericPhoneNumberLanguageItemName"
    */
    public get genericPhoneNumber() : string {
        return this.get(`_D4`);
    }

    /**
    /* "Generic.PostalCode" (Postal code)
    /* "Localizer.genericPostalCode"
    /* "Localizer.genericPostalCodeLanguageItemName"
    */
    public get genericPostalCode() : string {
        return this.get(`_D5`);
    }

    /**
    /* "Generic.Reject" (Reject)
    /* "Localizer.genericReject"
    /* "Localizer.genericRejectLanguageItemName"
    */
    public get genericReject() : string {
        return this.get(`_D6`);
    }

    /**
    /* "Generic.Send" (Send)
    /* "Localizer.genericSend"
    /* "Localizer.genericSendLanguageItemName"
    */
    public get genericSend() : string {
        return this.get(`_D7`);
    }

    /**
    /* "Generic.Week" (week)
    /* "Localizer.genericWeek"
    /* "Localizer.genericWeekLanguageItemName"
    */
    public get genericWeek() : string {
        return this.get(`_D8`);
    }

    /**
    /* "Generic.From" (From)
    /* "Localizer.genericFrom"
    /* "Localizer.genericFromLanguageItemName"
    */
    public get genericFrom() : string {
        return this.get(`_D9`);
    }

    /**
    /* "Generic.To" (To)
    /* "Localizer.genericTo"
    /* "Localizer.genericToLanguageItemName"
    */
    public get genericTo() : string {
        return this.get(`_DA`);
    }

    /**
    /* "Generic.Download" (Download)
    /* "Localizer.genericDownload"
    /* "Localizer.genericDownloadLanguageItemName"
    */
    public get genericDownload() : string {
        return this.get(`_DB`);
    }

    /**
    /* "Generic.Preview" (Preview)
    /* "Localizer.genericPreview"
    /* "Localizer.genericPreviewLanguageItemName"
    */
    public get genericPreview() : string {
        return this.get(`_DC`);
    }

    /**
    /* "Generic.Username" (Username)
    /* "Localizer.genericUsername"
    /* "Localizer.genericUsernameLanguageItemName"
    */
    public get genericUsername() : string {
        return this.get(`_DD`);
    }

    /**
    /* "Generic.Decline" (Decline)
    /* "Localizer.genericDecline"
    /* "Localizer.genericDeclineLanguageItemName"
    */
    public get genericDecline() : string {
        return this.get(`_DE`);
    }

    /**
    /* "Country.Finland" (Finland)
    /* "Localizer.countryFinland"
    /* "Localizer.countryFinlandLanguageItemName"
    */
    public get countryFinland() : string {
        return this.get(`_DF`);
    }

    /**
    /* "Country.Sweden" (Sweden)
    /* "Localizer.countrySweden"
    /* "Localizer.countrySwedenLanguageItemName"
    */
    public get countrySweden() : string {
        return this.get(`_E0`);
    }

    /**
    /* "Country.Norway" (Norway)
    /* "Localizer.countryNorway"
    /* "Localizer.countryNorwayLanguageItemName"
    */
    public get countryNorway() : string {
        return this.get(`_E1`);
    }

    /**
    /* "Country.Denmark" (Denmark)
    /* "Localizer.countryDenmark"
    /* "Localizer.countryDenmarkLanguageItemName"
    */
    public get countryDenmark() : string {
        return this.get(`_E2`);
    }

    /**
    /* "Country.Poland" (Poland)
    /* "Localizer.countryPoland"
    /* "Localizer.countryPolandLanguageItemName"
    */
    public get countryPoland() : string {
        return this.get(`_E3`);
    }

    /**
    /* "Country.Russia" (Russia)
    /* "Localizer.countryRussia"
    /* "Localizer.countryRussiaLanguageItemName"
    */
    public get countryRussia() : string {
        return this.get(`_E4`);
    }

    /**
    /* "Country.Ukraine" (Ukraine)
    /* "Localizer.countryUkraine"
    /* "Localizer.countryUkraineLanguageItemName"
    */
    public get countryUkraine() : string {
        return this.get(`_E5`);
    }

    /**
    /* "DashboardPage.Admin.Description" (User management & settings)
    /* "Localizer.dashboardPageAdminDescription"
    /* "Localizer.dashboardPageAdminDescriptionLanguageItemName"
    */
    public get dashboardPageAdminDescription() : string {
        return this.get(`_E6`);
    }

    /**
    /* "DashboardPage.ContactSupport.Description" (Contact support)
    /* "Localizer.dashboardPageContactSupportDescription"
    /* "Localizer.dashboardPageContactSupportDescriptionLanguageItemName"
    */
    public get dashboardPageContactSupportDescription() : string {
        return this.get(`_E7`);
    }

    /**
    /* "Country.UnitedStates" (United States)
    /* "Localizer.countryUnitedStates"
    /* "Localizer.countryUnitedStatesLanguageItemName"
    */
    public get countryUnitedStates() : string {
        return this.get(`_E8`);
    }

    /**
    /* "Offline.Title" (Offline)
    /* "Localizer.offlineTitle"
    /* "Localizer.offlineTitleLanguageItemName"
    */
    public get offlineTitle() : string {
        return this.get(`_E9`);
    }

    /**
    /* "Offline.Subtitle" (You are offline. Try again later or check your internet connection. If you are working from a mobile device, check your Internet or WiFi settings.)
    /* "Localizer.offlineSubtitle"
    /* "Localizer.offlineSubtitleLanguageItemName"
    */
    public get offlineSubtitle() : string {
        return this.get(`_EA`);
    }

    /**
    /* "Generic.ShowMore" (Show More)
    /* "Localizer.genericShowMore"
    /* "Localizer.genericShowMoreLanguageItemName"
    */
    public get genericShowMore() : string {
        return this.get(`_EB`);
    }

    /**
    /* "Mobile.NotificationsPage.NoNotifications" (No notifications)
    /* "Localizer.mobileNotificationsPageNoNotifications"
    /* "Localizer.mobileNotificationsPageNoNotificationsLanguageItemName"
    */
    public get mobileNotificationsPageNoNotifications() : string {
        return this.get(`_EC`);
    }

    /**
    /* "Mobile.NotificationsPage.Title" (Notifications)
    /* "Localizer.mobileNotificationsPageTitle"
    /* "Localizer.mobileNotificationsPageTitleLanguageItemName"
    */
    public get mobileNotificationsPageTitle() : string {
        return this.get(`_ED`);
    }

    /**
    /* "Admin.AlertError.AccountWithSamePhoneExist" (There is already an account with the given phone number. Please, specify a different phone number.)
    /* "Localizer.adminAlertErrorAccountWithSamePhoneExist"
    /* "Localizer.adminAlertErrorAccountWithSamePhoneExistLanguageItemName"
    */
    public get adminAlertErrorAccountWithSamePhoneExist() : string {
        return this.get(`_EE`);
    }

    /**
    /* "Admin.AlertError.AccountWithSameEmailExist" (There is already an account with the given email. Please, specify a different email.)
    /* "Localizer.adminAlertErrorAccountWithSameEmailExist"
    /* "Localizer.adminAlertErrorAccountWithSameEmailExistLanguageItemName"
    */
    public get adminAlertErrorAccountWithSameEmailExist() : string {
        return this.get(`_EF`);
    }

    /**
    /* "TopNav.AppointmentBooking" (Ajanvaraus)
    /* "Localizer.topNavAppointmentBooking"
    /* "Localizer.topNavAppointmentBookingLanguageItemName"
    */
    public get topNavAppointmentBooking() : string {
        return this.get(`_F0`);
    }

    /**
    /* "TopNav.Doctors" (Asiantuntijat)
    /* "Localizer.topNavDoctors"
    /* "Localizer.topNavDoctorsLanguageItemName"
    */
    public get topNavDoctors() : string {
        return this.get(`_F1`);
    }

    /**
    /* "TopNav.Services" (Palvelut)
    /* "Localizer.topNavServices"
    /* "Localizer.topNavServicesLanguageItemName"
    */
    public get topNavServices() : string {
        return this.get(`_F2`);
    }

    /**
    /* "TopNav.Clinics" (Erikoisklinikat)
    /* "Localizer.topNavClinics"
    /* "Localizer.topNavClinicsLanguageItemName"
    */
    public get topNavClinics() : string {
        return this.get(`_F3`);
    }

    /**
    /* "TopNav.OccupationalHealth" (Työterveys)
    /* "Localizer.topNavOccupationalHealth"
    /* "Localizer.topNavOccupationalHealthLanguageItemName"
    */
    public get topNavOccupationalHealth() : string {
        return this.get(`_F4`);
    }

    /**
    /* "TopNav.Pricing" (Hinnasto)
    /* "Localizer.topNavPricing"
    /* "Localizer.topNavPricingLanguageItemName"
    */
    public get topNavPricing() : string {
        return this.get(`_F5`);
    }

    /**
    /* "TopNav.Company" (Yritys)
    /* "Localizer.topNavCompany"
    /* "Localizer.topNavCompanyLanguageItemName"
    */
    public get topNavCompany() : string {
        return this.get(`_F6`);
    }

    /**
    /* "AppointmentPage.Title" (Ajanvaraus)
    /* "Localizer.appointmentPageTitle"
    /* "Localizer.appointmentPageTitleLanguageItemName"
    */
    public get appointmentPageTitle() : string {
        return this.get(`_F7`);
    }

    /**
    /* "DoctorsPage.Title" (Asiantuntijat)
    /* "Localizer.doctorsPageTitle"
    /* "Localizer.doctorsPageTitleLanguageItemName"
    */
    public get doctorsPageTitle() : string {
        return this.get(`_F8`);
    }

    /**
    /* "ServicesPage.Title" (Palvelut)
    /* "Localizer.servicesPageTitle"
    /* "Localizer.servicesPageTitleLanguageItemName"
    */
    public get servicesPageTitle() : string {
        return this.get(`_F9`);
    }

    /**
    /* "ClinicsPage.Title" (Erikoisklinikat)
    /* "Localizer.clinicsPageTitle"
    /* "Localizer.clinicsPageTitleLanguageItemName"
    */
    public get clinicsPageTitle() : string {
        return this.get(`_FA`);
    }

    /**
    /* "OccupationalHealthPage.Title" (Työterveys)
    /* "Localizer.occupationalHealthPageTitle"
    /* "Localizer.occupationalHealthPageTitleLanguageItemName"
    */
    public get occupationalHealthPageTitle() : string {
        return this.get(`_FB`);
    }

    /**
    /* "PricingPage.Title" (Hinnasto)
    /* "Localizer.pricingPageTitle"
    /* "Localizer.pricingPageTitleLanguageItemName"
    */
    public get pricingPageTitle() : string {
        return this.get(`_FC`);
    }

    /**
    /* "CompanyPage.Title" (Yritys)
    /* "Localizer.companyPageTitle"
    /* "Localizer.companyPageTitleLanguageItemName"
    */
    public get companyPageTitle() : string {
        return this.get(`_FD`);
    }

    /**
    /* "HomePage.Header" (Tervetuloa Lääkärikeskus Fenixiin!)
    /* "Localizer.homePageHeader"
    /* "Localizer.homePageHeaderLanguageItemName"
    */
    public get homePageHeader() : string {
        return this.get(`_FE`);
    }

    /**
    /* "HomePageHeader.BookATime" (Varaa aika verkossa)
    /* "Localizer.homePageHeaderBookATime"
    /* "Localizer.homePageHeaderBookATimeLanguageItemName"
    */
    public get homePageHeaderBookATime() : string {
        return this.get(`_FF`);
    }

    /**
    /* "HomePageHeader.CallUs" (Soita meille)
    /* "Localizer.homePageHeaderCallUs"
    /* "Localizer.homePageHeaderCallUsLanguageItemName"
    */
    public get homePageHeaderCallUs() : string {
        return this.get(`_100`);
    }

    /**
    /* "HomePageHeader.RemoteBooking" (DigiFenix Etävastaanotto)
    /* "Localizer.homePageHeaderRemoteBooking"
    /* "Localizer.homePageHeaderRemoteBookingLanguageItemName"
    */
    public get homePageHeaderRemoteBooking() : string {
        return this.get(`_101`);
    }

    /**
    /* "HomePageHeader.OccupationalHealthBooking" (Työterveyshuollon ajanvaraus)
    /* "Localizer.homePageHeaderOccupationalHealthBooking"
    /* "Localizer.homePageHeaderOccupationalHealthBookingLanguageItemName"
    */
    public get homePageHeaderOccupationalHealthBooking() : string {
        return this.get(`_102`);
    }

    /**
    /* "HomePageHeader.SearchForDoctor" (Etsi erikoisalaa, lääkäriä)
    /* "Localizer.homePageHeaderSearchForDoctor"
    /* "Localizer.homePageHeaderSearchForDoctorLanguageItemName"
    */
    public get homePageHeaderSearchForDoctor() : string {
        return this.get(`_103`);
    }

    /**
    /* "HomePageHeader.Location" (Toimipiste)
    /* "Localizer.homePageHeaderLocation"
    /* "Localizer.homePageHeaderLocationLanguageItemName"
    */
    public get homePageHeaderLocation() : string {
        return this.get(`_104`);
    }

    /**
    /* "Generic.Today" (Tänään)
    /* "Localizer.genericToday"
    /* "Localizer.genericTodayLanguageItemName"
    */
    public get genericToday() : string {
        return this.get(`_105`);
    }

    /**
    /* "Button.BookAppointment" (Varaa aika)
    /* "Localizer.buttonBookAppointment"
    /* "Localizer.buttonBookAppointmentLanguageItemName"
    */
    public get buttonBookAppointment() : string {
        return this.get(`_106`);
    }

    /**
    /* "AppointmentPage.InstantlyFreeTimes" (Heti vapaat ajat)
    /* "Localizer.appointmentPageInstantlyFreeTimes"
    /* "Localizer.appointmentPageInstantlyFreeTimesLanguageItemName"
    */
    public get appointmentPageInstantlyFreeTimes() : string {
        return this.get(`_107`);
    }

    /**
    /* "AppointmentPage.Specialty" (Erikoisala)
    /* "Localizer.appointmentPageSpecialty"
    /* "Localizer.appointmentPageSpecialtyLanguageItemName"
    */
    public get appointmentPageSpecialty() : string {
        return this.get(`_108`);
    }

    /**
    /* "AppointmentPage.NoFreeTimes" (Ei vapaita aikoja)
    /* "Localizer.appointmentPageNoFreeTimes"
    /* "Localizer.appointmentPageNoFreeTimesLanguageItemName"
    */
    public get appointmentPageNoFreeTimes() : string {
        return this.get(`_109`);
    }

    /**
    /* "AppointmentPage.ShowMoreTimes" (Näytä lisää aikoja)
    /* "Localizer.appointmentPageShowMoreTimes"
    /* "Localizer.appointmentPageShowMoreTimesLanguageItemName"
    */
    public get appointmentPageShowMoreTimes() : string {
        return this.get(`_10A`);
    }

    /**
    /* "Button.ShowMore" (Näytä lisää)
    /* "Localizer.buttonShowMore"
    /* "Localizer.buttonShowMoreLanguageItemName"
    */
    public get buttonShowMore() : string {
        return this.get(`_10B`);
    }

    /**
    /* "Button.ShowAll" (Näytä kaikki)
    /* "Localizer.buttonShowAll"
    /* "Localizer.buttonShowAllLanguageItemName"
    */
    public get buttonShowAll() : string {
        return this.get(`_10C`);
    }

    /**
    /* "Button.ReadMore" (Lue lisää)
    /* "Localizer.buttonReadMore"
    /* "Localizer.buttonReadMoreLanguageItemName"
    */
    public get buttonReadMore() : string {
        return this.get(`_10D`);
    }

    /**
    /* "BlogPosts.LatestBlogposts" (Ajankohtaista)
    /* "Localizer.blogPostsLatestBlogposts"
    /* "Localizer.blogPostsLatestBlogpostsLanguageItemName"
    */
    public get blogPostsLatestBlogposts() : string {
        return this.get(`_10E`);
    }

    /**
    /* "Button.ShowLess" (Näytä vähemmän)
    /* "Localizer.buttonShowLess"
    /* "Localizer.buttonShowLessLanguageItemName"
    */
    public get buttonShowLess() : string {
        return this.get(`_10F`);
    }

    /**
    /* "Button.ViewOnFacebook" (Katso Facebookissa)
    /* "Localizer.buttonViewOnFacebook"
    /* "Localizer.buttonViewOnFacebookLanguageItemName"
    */
    public get buttonViewOnFacebook() : string {
        return this.get(`_110`);
    }

    /**
    /* "News.SocialMedia" (Sosiaalinen media)
    /* "Localizer.newsSocialMedia"
    /* "Localizer.newsSocialMediaLanguageItemName"
    */
    public get newsSocialMedia() : string {
        return this.get(`_111`);
    }

    /**
    /* "AppointmentPage.AppointmentCanceling" (Ajanvarauksen peruutus)
    /* "Localizer.appointmentPageAppointmentCanceling"
    /* "Localizer.appointmentPageAppointmentCancelingLanguageItemName"
    */
    public get appointmentPageAppointmentCanceling() : string {
        return this.get(`_112`);
    }

    /**
    /* "AppointmentPage.SpecialistInCharge" (Hoitava asiantuntija)
    /* "Localizer.appointmentPageSpecialistInCharge"
    /* "Localizer.appointmentPageSpecialistInChargeLanguageItemName"
    */
    public get appointmentPageSpecialistInCharge() : string {
        return this.get(`_113`);
    }

    /**
    /* "AppointmentPage.SearchForTimesBetween" (Hae aikoja välillä)
    /* "Localizer.appointmentPageSearchForTimesBetween"
    /* "Localizer.appointmentPageSearchForTimesBetweenLanguageItemName"
    */
    public get appointmentPageSearchForTimesBetween() : string {
        return this.get(`_114`);
    }

    /**
    /* "AppointmentPage.ChooseTimeframe" (Valitse aikaväli)
    /* "Localizer.appointmentPageChooseTimeframe"
    /* "Localizer.appointmentPageChooseTimeframeLanguageItemName"
    */
    public get appointmentPageChooseTimeframe() : string {
        return this.get(`_115`);
    }

    /**
    /* "AppointmentPage.Doctor.NothingSelected" (Kaikki asiantuntijat)
    /* "Localizer.appointmentPageDoctorNothingSelected"
    /* "Localizer.appointmentPageDoctorNothingSelectedLanguageItemName"
    */
    public get appointmentPageDoctorNothingSelected() : string {
        return this.get(`_116`);
    }

    /**
    /* "AppointmentPage.MedicalField.NothingSelected" (Kaikki erikoisalat)
    /* "Localizer.appointmentPageMedicalFieldNothingSelected"
    /* "Localizer.appointmentPageMedicalFieldNothingSelectedLanguageItemName"
    */
    public get appointmentPageMedicalFieldNothingSelected() : string {
        return this.get(`_117`);
    }

    /**
    /* "AppointmentPage.Location.NothingSelected" (Kaikki toimipisteet)
    /* "Localizer.appointmentPageLocationNothingSelected"
    /* "Localizer.appointmentPageLocationNothingSelectedLanguageItemName"
    */
    public get appointmentPageLocationNothingSelected() : string {
        return this.get(`_118`);
    }

    /**
    /* "Button.GoToBooking" (Siirry ajanvaraukseen)
    /* "Localizer.buttonGoToBooking"
    /* "Localizer.buttonGoToBookingLanguageItemName"
    */
    public get buttonGoToBooking() : string {
        return this.get(`_119`);
    }

    /**
    /* "General.Locations" (Toimipisteet)
    /* "Localizer.generalLocations"
    /* "Localizer.generalLocationsLanguageItemName"
    */
    public get generalLocations() : string {
        return this.get(`_11A`);
    }

    /**
    /* "Contact.PhoneOpeningHours" (Puhelinajanvaraus auki aukioloaikojen mukaisesti)
    /* "Localizer.contactPhoneOpeningHours"
    /* "Localizer.contactPhoneOpeningHoursLanguageItemName"
    */
    public get contactPhoneOpeningHours() : string {
        return this.get(`_11B`);
    }

    /**
    /* "Form.Input.SSN" (Henkilötunnus)
    /* "Localizer.formInputSSN"
    /* "Localizer.formInputSSNLanguageItemName"
    */
    public get formInputSSN() : string {
        return this.get(`_11C`);
    }

    /**
    /* "ReserveTimeModal.NoOccupationalHealthFound" (Työterveyden asiakkuutta ei löytynyt)
    /* "Localizer.reserveTimeModalNoOccupationalHealthFound"
    /* "Localizer.reserveTimeModalNoOccupationalHealthFoundLanguageItemName"
    */
    public get reserveTimeModalNoOccupationalHealthFound() : string {
        return this.get(`_11D`);
    }

    /**
    /* "ReserveTimeModal.TimeBooked" (Aika varattu)
    /* "Localizer.reserveTimeModalTimeBooked"
    /* "Localizer.reserveTimeModalTimeBookedLanguageItemName"
    */
    public get reserveTimeModalTimeBooked() : string {
        return this.get(`_11E`);
    }

    /**
    /* "ReserveTimeModal.RegisterUsername" (Rekisteröi käyttäjätunnus)
    /* "Localizer.reserveTimeModalRegisterUsername"
    /* "Localizer.reserveTimeModalRegisterUsernameLanguageItemName"
    */
    public get reserveTimeModalRegisterUsername() : string {
        return this.get(`_11F`);
    }

    /**
    /* "ReserveTimeModal.Login" (Kirjaudu sisään)
    /* "Localizer.reserveTimeModalLogin"
    /* "Localizer.reserveTimeModalLoginLanguageItemName"
    */
    public get reserveTimeModalLogin() : string {
        return this.get(`_120`);
    }

    /**
    /* "ReserveTimeModal.BookingConfirmation" (Ajanvarauksen vahvistaminen)
    /* "Localizer.reserveTimeModalBookingConfirmation"
    /* "Localizer.reserveTimeModalBookingConfirmationLanguageItemName"
    */
    public get reserveTimeModalBookingConfirmation() : string {
        return this.get(`_121`);
    }

    /**
    /* "ReserveTimeModal.CreateUser" (Luo tunnus)
    /* "Localizer.reserveTimeModalCreateUser"
    /* "Localizer.reserveTimeModalCreateUserLanguageItemName"
    */
    public get reserveTimeModalCreateUser() : string {
        return this.get(`_122`);
    }

    /**
    /* "ReserveTimeModal.MoreInformation" (Haluatko antaa jotain lisätietoja varaukseen liittyen (esim: tulosyy)?)
    /* "Localizer.reserveTimeModalMoreInformation"
    /* "Localizer.reserveTimeModalMoreInformationLanguageItemName"
    */
    public get reserveTimeModalMoreInformation() : string {
        return this.get(`_123`);
    }

    /**
    /* "ReserveTimeModal.ConfirmBooking" (Vahvista varaus)
    /* "Localizer.reserveTimeModalConfirmBooking"
    /* "Localizer.reserveTimeModalConfirmBookingLanguageItemName"
    */
    public get reserveTimeModalConfirmBooking() : string {
        return this.get(`_124`);
    }

    /**
    /* "ReserveTimeModal.firstTimeBookingText" (Oletko ensimmäistä kertaa käyttämässä ajanvaraustamme? Luo itsellesi tai lapsellesi tunnukset)
    /* "Localizer.reserveTimeModalfirstTimeBookingText"
    /* "Localizer.reserveTimeModalfirstTimeBookingTextLanguageItemName"
    */
    public get reserveTimeModalfirstTimeBookingText() : string {
        return this.get(`_125`);
    }

    /**
    /* "ReserveTimeModal.YourInformation" (Omat tietosi:)
    /* "Localizer.reserveTimeModalYourInformation"
    /* "Localizer.reserveTimeModalYourInformationLanguageItemName"
    */
    public get reserveTimeModalYourInformation() : string {
        return this.get(`_126`);
    }

    /**
    /* "ReserveTimeModal.AppointmentDetails" (Varauksen tiedot:)
    /* "Localizer.reserveTimeModalAppointmentDetails"
    /* "Localizer.reserveTimeModalAppointmentDetailsLanguageItemName"
    */
    public get reserveTimeModalAppointmentDetails() : string {
        return this.get(`_127`);
    }

    /**
    /* "ReserveTimeModal.AppointmentDetails.Doctor" (Asiantuntijan nimi:)
    /* "Localizer.reserveTimeModalAppointmentDetailsDoctor"
    /* "Localizer.reserveTimeModalAppointmentDetailsDoctorLanguageItemName"
    */
    public get reserveTimeModalAppointmentDetailsDoctor() : string {
        return this.get(`_128`);
    }

    /**
    /* "ReserveTimeModal.AppointmentDetails.Date" (Päivämäärä:)
    /* "Localizer.reserveTimeModalAppointmentDetailsDate"
    /* "Localizer.reserveTimeModalAppointmentDetailsDateLanguageItemName"
    */
    public get reserveTimeModalAppointmentDetailsDate() : string {
        return this.get(`_129`);
    }

    /**
    /* "ReserveTimeModal.AppointmentDetails.Time" (Kellonaika:)
    /* "Localizer.reserveTimeModalAppointmentDetailsTime"
    /* "Localizer.reserveTimeModalAppointmentDetailsTimeLanguageItemName"
    */
    public get reserveTimeModalAppointmentDetailsTime() : string {
        return this.get(`_12A`);
    }

    /**
    /* "ReserveTimeModal.AppointmentDetails.Confirm" (Kiitos, aika varattu koodilla {0}.\n\nOtathan ylös varauksesi tiedot:)
    /* "Localizer.reserveTimeModalAppointmentDetailsConfirm"
    /* "Localizer.reserveTimeModalAppointmentDetailsConfirmLanguageItemName"
    */
    public get reserveTimeModalAppointmentDetailsConfirm() : string {
        return this.get(`_12B`);
    }

    /**
    /* "ContactSupportPage.ContactForm" (Yhteydenottolomake)
    /* "Localizer.contactSupportPageContactForm"
    /* "Localizer.contactSupportPageContactFormLanguageItemName"
    */
    public get contactSupportPageContactForm() : string {
        return this.get(`_12C`);
    }

    /**
    /* "ContactSupportPage.ElectronicBookingMessage" (Voit myös hyödyntää sähköistä ajanvarausjärjestelmäämme.)
    /* "Localizer.contactSupportPageElectronicBookingMessage"
    /* "Localizer.contactSupportPageElectronicBookingMessageLanguageItemName"
    */
    public get contactSupportPageElectronicBookingMessage() : string {
        return this.get(`_12D`);
    }

    /**
    /* "ContactSupportPage.MoWeTh" (MA, KE, TO)
    /* "Localizer.contactSupportPageMoWeTh"
    /* "Localizer.contactSupportPageMoWeThLanguageItemName"
    */
    public get contactSupportPageMoWeTh() : string {
        return this.get(`_12E`);
    }

    /**
    /* "ContactSupportPage.TuFr" (TI, PE)
    /* "Localizer.contactSupportPageTuFr"
    /* "Localizer.contactSupportPageTuFrLanguageItemName"
    */
    public get contactSupportPageTuFr() : string {
        return this.get(`_12F`);
    }

    /**
    /* "ContactSupportPage.Sa" (LA)
    /* "Localizer.contactSupportPageSa"
    /* "Localizer.contactSupportPageSaLanguageItemName"
    */
    public get contactSupportPageSa() : string {
        return this.get(`_130`);
    }

    /**
    /* "Footer.PhoneShortened" (Puh.)
    /* "Localizer.footerPhoneShortened"
    /* "Localizer.footerPhoneShortenedLanguageItemName"
    */
    public get footerPhoneShortened() : string {
        return this.get(`_131`);
    }

    /**
    /* "Footer.AllOpeningHours" (Kaikki Aukioloajat)
    /* "Localizer.footerAllOpeningHours"
    /* "Localizer.footerAllOpeningHoursLanguageItemName"
    */
    public get footerAllOpeningHours() : string {
        return this.get(`_132`);
    }

    /**
    /* "CancelAppointmentModal.LoginToCancel" (Kirjaudu sisään peruuttaaksesi ajan)
    /* "Localizer.cancelAppointmentModalLoginToCancel"
    /* "Localizer.cancelAppointmentModalLoginToCancelLanguageItemName"
    */
    public get cancelAppointmentModalLoginToCancel() : string {
        return this.get(`_133`);
    }

    /**
    /* "CancelAppointmentModal.EnterBookingNumberToCancel" (Kirjoita peruutettavan ajan tunnus)
    /* "Localizer.cancelAppointmentModalEnterBookingNumberToCancel"
    /* "Localizer.cancelAppointmentModalEnterBookingNumberToCancelLanguageItemName"
    */
    public get cancelAppointmentModalEnterBookingNumberToCancel() : string {
        return this.get(`_134`);
    }

    /**
    /* "CancelAppointmentModal.NoBookingFound" (Aikaa ei löydy)
    /* "Localizer.cancelAppointmentModalNoBookingFound"
    /* "Localizer.cancelAppointmentModalNoBookingFoundLanguageItemName"
    */
    public get cancelAppointmentModalNoBookingFound() : string {
        return this.get(`_135`);
    }

    /**
    /* "CancelAppointmentModal.GetInfo" (Hae tiedot)
    /* "Localizer.cancelAppointmentModalGetInfo"
    /* "Localizer.cancelAppointmentModalGetInfoLanguageItemName"
    */
    public get cancelAppointmentModalGetInfo() : string {
        return this.get(`_136`);
    }

    /**
    /* "CancelAppointmentModal.BookingInfo" (Varauksen tiedot)
    /* "Localizer.cancelAppointmentModalBookingInfo"
    /* "Localizer.cancelAppointmentModalBookingInfoLanguageItemName"
    */
    public get cancelAppointmentModalBookingInfo() : string {
        return this.get(`_137`);
    }

    /**
    /* "CancelAppointmentModal.Doctor" (Asiantuntija)
    /* "Localizer.cancelAppointmentModalDoctor"
    /* "Localizer.cancelAppointmentModalDoctorLanguageItemName"
    */
    public get cancelAppointmentModalDoctor() : string {
        return this.get(`_138`);
    }

    /**
    /* "CancelAppointmentModal.Specialty" (Erikoisala)
    /* "Localizer.cancelAppointmentModalSpecialty"
    /* "Localizer.cancelAppointmentModalSpecialtyLanguageItemName"
    */
    public get cancelAppointmentModalSpecialty() : string {
        return this.get(`_139`);
    }

    /**
    /* "CancelAppointmentModal.Time" (Aika)
    /* "Localizer.cancelAppointmentModalTime"
    /* "Localizer.cancelAppointmentModalTimeLanguageItemName"
    */
    public get cancelAppointmentModalTime() : string {
        return this.get(`_13A`);
    }

    /**
    /* "CancelAppointmentModal.CancelSuccess" (Ajan peruutus onnistui)
    /* "Localizer.cancelAppointmentModalCancelSuccess"
    /* "Localizer.cancelAppointmentModalCancelSuccessLanguageItemName"
    */
    public get cancelAppointmentModalCancelSuccess() : string {
        return this.get(`_13B`);
    }

    /**
    /* "CancelAppointmentModal.CancelSelectedBooking" (Peruuta valittu aika)
    /* "Localizer.cancelAppointmentModalCancelSelectedBooking"
    /* "Localizer.cancelAppointmentModalCancelSelectedBookingLanguageItemName"
    */
    public get cancelAppointmentModalCancelSelectedBooking() : string {
        return this.get(`_13C`);
    }

    /**
    /* "CancelAppointmentModal.BookingNumber" (Ajanvarauksen tunnus)
    /* "Localizer.cancelAppointmentModalBookingNumber"
    /* "Localizer.cancelAppointmentModalBookingNumberLanguageItemName"
    */
    public get cancelAppointmentModalBookingNumber() : string {
        return this.get(`_13D`);
    }

    /**
    /* "OccupationalHealthPage.OccupationalHealthTeamRoster" (Työterveyshuollon tiimiimme kuuluvat:)
    /* "Localizer.occupationalHealthPageOccupationalHealthTeamRoster"
    /* "Localizer.occupationalHealthPageOccupationalHealthTeamRosterLanguageItemName"
    */
    public get occupationalHealthPageOccupationalHealthTeamRoster() : string {
        return this.get(`_13E`);
    }

    /**
    /* "BlogPage.Title" (Ajankohtaista)
    /* "Localizer.blogPageTitle"
    /* "Localizer.blogPageTitleLanguageItemName"
    */
    public get blogPageTitle() : string {
        return this.get(`_13F`);
    }

    /**
    /* "JobsPage.Title" (Työpaikat)
    /* "Localizer.jobsPageTitle"
    /* "Localizer.jobsPageTitleLanguageItemName"
    */
    public get jobsPageTitle() : string {
        return this.get(`_140`);
    }

    /**
    /* "TopNav.Jobs" (Työpaikat)
    /* "Localizer.topNavJobs"
    /* "Localizer.topNavJobsLanguageItemName"
    */
    public get topNavJobs() : string {
        return this.get(`_141`);
    }

    /**
    /* "CancelAppointmentModal.FormError" (Ajan peruuttaminen epäonnistui. Ongelman toistuessa ota yhteyttä asiakastukeen ongelman selvittämiseksi.)
    /* "Localizer.cancelAppointmentModalFormError"
    /* "Localizer.cancelAppointmentModalFormErrorLanguageItemName"
    */
    public get cancelAppointmentModalFormError() : string {
        return this.get(`_142`);
    }

    /**
    /* "CancelAppointmentModal.LoginFailed" (Kirjautuminen epäonnistui, ota yhteyttä asiakaspalveluun.)
    /* "Localizer.cancelAppointmentModalLoginFailed"
    /* "Localizer.cancelAppointmentModalLoginFailedLanguageItemName"
    */
    public get cancelAppointmentModalLoginFailed() : string {
        return this.get(`_143`);
    }

    /**
    /* "JobsPage.OpenPositions" (Avoimet työpaikat)
    /* "Localizer.jobsPageOpenPositions"
    /* "Localizer.jobsPageOpenPositionsLanguageItemName"
    */
    public get jobsPageOpenPositions() : string {
        return this.get(`_144`);
    }

    /**
    /* "JobsPage.NoOpenPositions" (Ei avoimia paikkoja tällä hetkellä.)
    /* "Localizer.jobsPageNoOpenPositions"
    /* "Localizer.jobsPageNoOpenPositionsLanguageItemName"
    */
    public get jobsPageNoOpenPositions() : string {
        return this.get(`_145`);
    }

    /**
    /* "JobsPage.EmailMessagePart1" (Kiinnostuitko? Lähetä hakemuksesi osoitteeseen)
    /* "Localizer.jobsPageEmailMessagePart1"
    /* "Localizer.jobsPageEmailMessagePart1LanguageItemName"
    */
    public get jobsPageEmailMessagePart1() : string {
        return this.get(`_146`);
    }

    /**
    /* "JobsPage.EmailMessagePart2" ( Lisää hakemuksesi liitteeksi CV sekä halutessasi muita hakemustasi tukevia dokumentteja.)
    /* "Localizer.jobsPageEmailMessagePart2"
    /* "Localizer.jobsPageEmailMessagePart2LanguageItemName"
    */
    public get jobsPageEmailMessagePart2() : string {
        return this.get(`_147`);
    }

    /**
    /* "BlogPage.NoBlogpostsYet" (Blogipostauksia ei saatavilla. Tarkista tilanne myöhemmin uudestaan!)
    /* "Localizer.blogPageNoBlogpostsYet"
    /* "Localizer.blogPageNoBlogpostsYetLanguageItemName"
    */
    public get blogPageNoBlogpostsYet() : string {
        return this.get(`_148`);
    }

    /**
    /* "HomePage.InfluenzaHeader" (Punkkirokote 55€)
    /* "Localizer.homePageInfluenzaHeader"
    /* "Localizer.homePageInfluenzaHeaderLanguageItemName"
    */
    public get homePageInfluenzaHeader() : string {
        return this.get(`_149`);
    }

    /**
    /* "HomePage.InfluenzaText" (Nyt punkkirokote meiltä, ajanvaraus auki puh. 020 144 1511 sekä myös walk in-rokotus! Rokotus ja\n                                injektio yhteensä 55 €.)
    /* "Localizer.homePageInfluenzaText"
    /* "Localizer.homePageInfluenzaTextLanguageItemName"
    */
    public get homePageInfluenzaText() : string {
        return this.get(`_14A`);
    }

    /**
    /* "ErrorCodes.Registration.SsnExists" (Henkilötunnus on jo rekisteröity)
    /* "Localizer.errorCodesRegistrationSsnExists"
    /* "Localizer.errorCodesRegistrationSsnExistsLanguageItemName"
    */
    public get errorCodesRegistrationSsnExists() : string {
        return this.get(`_14B`);
    }

    /**
    /* "ErrorCodes.Registration.SsnInvalid" (Tarkista henkilötunnus)
    /* "Localizer.errorCodesRegistrationSsnInvalid"
    /* "Localizer.errorCodesRegistrationSsnInvalidLanguageItemName"
    */
    public get errorCodesRegistrationSsnInvalid() : string {
        return this.get(`_14C`);
    }

    /**
    /* "ErrorCodes.Registration.RegistrationFailed" (Rekisteröityminen ei onnistunut. Ole hyvä ja ota yhteys tukeen ongelman toistuessa)
    /* "Localizer.errorCodesRegistrationRegistrationFailed"
    /* "Localizer.errorCodesRegistrationRegistrationFailedLanguageItemName"
    */
    public get errorCodesRegistrationRegistrationFailed() : string {
        return this.get(`_14D`);
    }

    /**
    /* "ErrorCodes.Appointment.TooMany" (Tunnuksellasi on varattu jo olemassa olevia aikoja. Uuden ajan varaus ei onnistu.)
    /* "Localizer.errorCodesAppointmentTooMany"
    /* "Localizer.errorCodesAppointmentTooManyLanguageItemName"
    */
    public get errorCodesAppointmentTooMany() : string {
        return this.get(`_14E`);
    }

    /**
    /* "ErrorCodes.Appointment.Failed" (Ajanvaraus ei juuri nyt onnistunut. Yritä uudelleen ja ongelman jatkuessa ole hyvä ja ota yhteys asiakaspalveluun)
    /* "Localizer.errorCodesAppointmentFailed"
    /* "Localizer.errorCodesAppointmentFailedLanguageItemName"
    */
    public get errorCodesAppointmentFailed() : string {
        return this.get(`_14F`);
    }

    /**
    /* "ErrorCodes.Appointment.DeniedByCompany" (Ajanvaraus on estetty)
    /* "Localizer.errorCodesAppointmentDeniedByCompany"
    /* "Localizer.errorCodesAppointmentDeniedByCompanyLanguageItemName"
    */
    public get errorCodesAppointmentDeniedByCompany() : string {
        return this.get(`_150`);
    }

    /**
    /* "ErrorCodes.Appointment.Past" (Ajanvaraus epäonnistui. Aikaa ei voida varata menneisyyteen.)
    /* "Localizer.errorCodesAppointmentPast"
    /* "Localizer.errorCodesAppointmentPastLanguageItemName"
    */
    public get errorCodesAppointmentPast() : string {
        return this.get(`_151`);
    }

    /**
    /* "ErrorCodes.Appointment.Unknown" (Ajanvaraus ei onnistunut. Ole hyvä ja ota yhteys tukeen ongelman toistuessa.)
    /* "Localizer.errorCodesAppointmentUnknown"
    /* "Localizer.errorCodesAppointmentUnknownLanguageItemName"
    */
    public get errorCodesAppointmentUnknown() : string {
        return this.get(`_152`);
    }

    /**
    /* "AppointmentBookingServicePointFilter.Time" (Time)
    /* "Localizer.appointmentBookingServicePointFilterTime"
    /* "Localizer.appointmentBookingServicePointFilterTimeLanguageItemName"
    */
    public get appointmentBookingServicePointFilterTime() : string {
        return this.get(`_153`);
    }

    /**
    /* "Button.GoToService" (Siirry palveluun)
    /* "Localizer.buttonGoToService"
    /* "Localizer.buttonGoToServiceLanguageItemName"
    */
    public get buttonGoToService() : string {
        return this.get(`_154`);
    }

    /**
    /* "Form.Input.Attachments" (Liitteet)
    /* "Localizer.formInputAttachments"
    /* "Localizer.formInputAttachmentsLanguageItemName"
    */
    public get formInputAttachments() : string {
        return this.get(`_155`);
    }

    /**
    /* "JobApplication.ApplicationSent" (Hakemus lähetetty, kiitos! Olemme sinuun yhteydessä mahdollisimman pian.)
    /* "Localizer.jobApplicationApplicationSent"
    /* "Localizer.jobApplicationApplicationSentLanguageItemName"
    */
    public get jobApplicationApplicationSent() : string {
        return this.get(`_156`);
    }

    /**
    /* "JobsPage.SendApplication" (Lähetä hakemus)
    /* "Localizer.jobsPageSendApplication"
    /* "Localizer.jobsPageSendApplicationLanguageItemName"
    */
    public get jobsPageSendApplication() : string {
        return this.get(`_157`);
    }

    /**
    /* "JobsPage.ApplicationForm" (Lähetä hakemus)
    /* "Localizer.jobsPageApplicationForm"
    /* "Localizer.jobsPageApplicationFormLanguageItemName"
    */
    public get jobsPageApplicationForm() : string {
        return this.get(`_158`);
    }

    /**
    /* "JobsPage.ApplicationFormTip" (Voit lisätä liitteiksi CV:n lisäksi myös muita hakemustasi tukevia dokumentteja.)
    /* "Localizer.jobsPageApplicationFormTip"
    /* "Localizer.jobsPageApplicationFormTipLanguageItemName"
    */
    public get jobsPageApplicationFormTip() : string {
        return this.get(`_159`);
    }

    /**
    /* "JobApplication.MessagePlaceholder" (Kerro lyhyesti itsestäsi ja miksi haet kyseistä työtehtävää.)
    /* "Localizer.jobApplicationMessagePlaceholder"
    /* "Localizer.jobApplicationMessagePlaceholderLanguageItemName"
    */
    public get jobApplicationMessagePlaceholder() : string {
        return this.get(`_15A`);
    }

    /**
    /* "JobsPage.ApplicationForm.FileSizeAndTypeMessage" (Suurin sallittu tiedostokoko on 2mb, sallitut tiedostomuodot .pdf, .doc ja .docx.)
    /* "Localizer.jobsPageApplicationFormFileSizeAndTypeMessage"
    /* "Localizer.jobsPageApplicationFormFileSizeAndTypeMessageLanguageItemName"
    */
    public get jobsPageApplicationFormFileSizeAndTypeMessage() : string {
        return this.get(`_15B`);
    }

    /**
    /* "JobsPage.OpenApplicationFormHeader" (Lähetä avoin hakemus)
    /* "Localizer.jobsPageOpenApplicationFormHeader"
    /* "Localizer.jobsPageOpenApplicationFormHeaderLanguageItemName"
    */
    public get jobsPageOpenApplicationFormHeader() : string {
        return this.get(`_15C`);
    }

    /**
    /* "JobsPage.OpenApplication" (Avoin hakemus)
    /* "Localizer.jobsPageOpenApplication"
    /* "Localizer.jobsPageOpenApplicationLanguageItemName"
    */
    public get jobsPageOpenApplication() : string {
        return this.get(`_15D`);
    }

    /**
    /* "ErrorCodes.Appointment.AlreadyReserved" (Aika jonka koitit varata on jo varattu. Ole hyvä ja yritä varata toinen aika. Ongelman toistuessa ota yhteyttä asiakaspalveluun.)
    /* "Localizer.errorCodesAppointmentAlreadyReserved"
    /* "Localizer.errorCodesAppointmentAlreadyReservedLanguageItemName"
    */
    public get errorCodesAppointmentAlreadyReserved() : string {
        return this.get(`_15E`);
    }

    /**
    /* "LocationPage.OpeningHours" (Aukioloajat)
    /* "Localizer.locationPageOpeningHours"
    /* "Localizer.locationPageOpeningHoursLanguageItemName"
    */
    public get locationPageOpeningHours() : string {
        return this.get(`_15F`);
    }

    /**
    /* "AppointmentPage.OccupationalHealthInfo" (Työterveyshuollon asiakkaat voivat varata sairaanhoidollisissa asioissa ajan myös yleislääkärille.)
    /* "Localizer.appointmentPageOccupationalHealthInfo"
    /* "Localizer.appointmentPageOccupationalHealthInfoLanguageItemName"
    */
    public get appointmentPageOccupationalHealthInfo() : string {
        return this.get(`_160`);
    }

    /**
    /* "AppointmentPage.Kela65InfoBold" (Ajanvaraus Kela 65 -vastaanotoille on avoinna.)
    /* "Localizer.appointmentPageKela65InfoBold"
    /* "Localizer.appointmentPageKela65InfoBoldLanguageItemName"
    */
    public get appointmentPageKela65InfoBold() : string {
        return this.get(`_161`);
    }

    /**
    /* "AppointmentPage.Kela65InfoText" (Varaa aika soittamalla: \n- Porvoo: 020 144 1511\n- Loviisa: 020 144 1514 \n\nKun soitat, **mainitsethan, että kyseessä on valinnanvapauskokeiluun liittyvä vastaanotto.** \n\nHuomioithan, että **kaikki lääkärimme eivät ole mukana valinnanvapauskokeilussa.** \n\nLue lisää Kela 65 valinnanvapauskokeilusta [tästä](https://www.laakarikeskusfenix.fi/ServicePageView?type=service&id=65))
    /* "Localizer.appointmentPageKela65InfoText"
    /* "Localizer.appointmentPageKela65InfoTextLanguageItemName"
    */
    public get appointmentPageKela65InfoText() : string {
        return this.get(`_162`);
    }

    /**
    /* "LocationPage.AccordingToAgreement" (Sopimuksen mukaan)
    /* "Localizer.locationPageAccordingToAgreement"
    /* "Localizer.locationPageAccordingToAgreementLanguageItemName"
    */
    public get locationPageAccordingToAgreement() : string {
        return this.get(`_163`);
    }

    /**
    /* "BlogPost.WrittenBy" (Kirjoittanut)
    /* "Localizer.blogPostWrittenBy"
    /* "Localizer.blogPostWrittenByLanguageItemName"
    */
    public get blogPostWrittenBy() : string {
        return this.get(`_164`);
    }

    /**
    /* "Button.ReadWholeArticle" (Lue koko artikkeli)
    /* "Localizer.buttonReadWholeArticle"
    /* "Localizer.buttonReadWholeArticleLanguageItemName"
    */
    public get buttonReadWholeArticle() : string {
        return this.get(`_165`);
    }

    /**
    /* "Button.LoadMore" (Lataa lisää)
    /* "Localizer.buttonLoadMore"
    /* "Localizer.buttonLoadMoreLanguageItemName"
    */
    public get buttonLoadMore() : string {
        return this.get(`_166`);
    }

    /**
    /* "PhoneBookingWidget.Title" (Puhelinvastaanottoajat)
    /* "Localizer.phoneBookingWidgetTitle"
    /* "Localizer.phoneBookingWidgetTitleLanguageItemName"
    */
    public get phoneBookingWidgetTitle() : string {
        return this.get(`_167`);
    }

    /**
    /* "Recent.ComingSoon" (Ajankohtaisia kirjoituksia tulossa pian.)
    /* "Localizer.recentComingSoon"
    /* "Localizer.recentComingSoonLanguageItemName"
    */
    public get recentComingSoon() : string {
        return this.get(`_168`);
    }

    /**
    /* "Form.Input.EmailAgain" (Sähköposti uudestaan)
    /* "Localizer.formInputEmailAgain"
    /* "Localizer.formInputEmailAgainLanguageItemName"
    */
    public get formInputEmailAgain() : string {
        return this.get(`_169`);
    }

    /**
    /* "ReserveTimeModal.EmailMissing" (Puuttuva sähköpostiosoite)
    /* "Localizer.reserveTimeModalEmailMissing"
    /* "Localizer.reserveTimeModalEmailMissingLanguageItemName"
    */
    public get reserveTimeModalEmailMissing() : string {
        return this.get(`_16A`);
    }

    /**
    /* "EmailForm.UpdateFailed" (Sähköpostiosoitteen päivittäminen epäonnistui, ole hyvä ja yritä uudestaan. Ongelman toistuessa ota yhteyttä asiakaspalveluun.)
    /* "Localizer.emailFormUpdateFailed"
    /* "Localizer.emailFormUpdateFailedLanguageItemName"
    */
    public get emailFormUpdateFailed() : string {
        return this.get(`_16B`);
    }

    /**
    /* "ReserveTimeModal.MissingEmailMessage" (Tiliisi ei ole liitetty sähköpostiosoitetta. Syötä sähköpostiosoitteesi jatkaaksesi ajanvarausta.)
    /* "Localizer.reserveTimeModalMissingEmailMessage"
    /* "Localizer.reserveTimeModalMissingEmailMessageLanguageItemName"
    */
    public get reserveTimeModalMissingEmailMessage() : string {
        return this.get(`_16C`);
    }

    /**
    /* "EmailForm.EmailNotValid" (Syötetty sähköpostiosoite ei ole validi.)
    /* "Localizer.emailFormEmailNotValid"
    /* "Localizer.emailFormEmailNotValidLanguageItemName"
    */
    public get emailFormEmailNotValid() : string {
        return this.get(`_16D`);
    }

    /**
    /* "EmailForm.EmailsDoNotMatch" (Syötetyt sähköpostiosoitteet eivät täsmää.)
    /* "Localizer.emailFormEmailsDoNotMatch"
    /* "Localizer.emailFormEmailsDoNotMatchLanguageItemName"
    */
    public get emailFormEmailsDoNotMatch() : string {
        return this.get(`_16E`);
    }

    /**
    /* "AppointmentPage.WantToCancelAppointment" (Haluatko peruuttaa varatun ajan?)
    /* "Localizer.appointmentPageWantToCancelAppointment"
    /* "Localizer.appointmentPageWantToCancelAppointmentLanguageItemName"
    */
    public get appointmentPageWantToCancelAppointment() : string {
        return this.get(`_16F`);
    }

    /**
    /* "Services.TeamIncludes" (-tiimiin kuuluvat:)
    /* "Localizer.servicesTeamIncludes"
    /* "Localizer.servicesTeamIncludesLanguageItemName"
    */
    public get servicesTeamIncludes() : string {
        return this.get(`_170`);
    }

    /**
    /* "Services.FavoriteServices" (Suositut palvelut)
    /* "Localizer.servicesFavoriteServices"
    /* "Localizer.servicesFavoriteServicesLanguageItemName"
    */
    public get servicesFavoriteServices() : string {
        return this.get(`_171`);
    }

    /**
    /* "Services.AllServicesAlphabetical" (Kaikki palvelut (aakkosittain))
    /* "Localizer.servicesAllServicesAlphabetical"
    /* "Localizer.servicesAllServicesAlphabeticalLanguageItemName"
    */
    public get servicesAllServicesAlphabetical() : string {
        return this.get(`_172`);
    }

    /**
    /* "ReserveTimeModal.MissingInfo" (Puuttuva tieto)
    /* "Localizer.reserveTimeModalMissingInfo"
    /* "Localizer.reserveTimeModalMissingInfoLanguageItemName"
    */
    public get reserveTimeModalMissingInfo() : string {
        return this.get(`_173`);
    }

    /**
    /* "ReserveTimeModal.AppointmentDetails.Duration" (Kesto:)
    /* "Localizer.reserveTimeModalAppointmentDetailsDuration"
    /* "Localizer.reserveTimeModalAppointmentDetailsDurationLanguageItemName"
    */
    public get reserveTimeModalAppointmentDetailsDuration() : string {
        return this.get(`_174`);
    }

    /**
    /* "ReserveTimeModal.AppointmentDetails.Specialty" (Ala:)
    /* "Localizer.reserveTimeModalAppointmentDetailsSpecialty"
    /* "Localizer.reserveTimeModalAppointmentDetailsSpecialtyLanguageItemName"
    */
    public get reserveTimeModalAppointmentDetailsSpecialty() : string {
        return this.get(`_175`);
    }

    /**
    /* "ReserveTimeModal.AppointmentDetails.Location" (Toimipiste:)
    /* "Localizer.reserveTimeModalAppointmentDetailsLocation"
    /* "Localizer.reserveTimeModalAppointmentDetailsLocationLanguageItemName"
    */
    public get reserveTimeModalAppointmentDetailsLocation() : string {
        return this.get(`_176`);
    }

    /**
    /* "ReserveTimeModal.AppointmentDetails.MedicalCenterFenix" (Lääkärikeskus Fenix)
    /* "Localizer.reserveTimeModalAppointmentDetailsMedicalCenterFenix"
    /* "Localizer.reserveTimeModalAppointmentDetailsMedicalCenterFenixLanguageItemName"
    */
    public get reserveTimeModalAppointmentDetailsMedicalCenterFenix() : string {
        return this.get(`_177`);
    }

    /**
    /* "ReserveTimeModal.CheckInfoText" (Tarkista että tietosi ovat ajan tasalla. Mikäli huomaat että tietosi eivät ole oikein, korjaa tiedot ennen varauksen vahvistamista.)
    /* "Localizer.reserveTimeModalCheckInfoText"
    /* "Localizer.reserveTimeModalCheckInfoTextLanguageItemName"
    */
    public get reserveTimeModalCheckInfoText() : string {
        return this.get(`_178`);
    }

    /**
    /* "ReserveTimeModal.EditContactInfo" (Muokkaa omia yhteystietoja)
    /* "Localizer.reserveTimeModalEditContactInfo"
    /* "Localizer.reserveTimeModalEditContactInfoLanguageItemName"
    */
    public get reserveTimeModalEditContactInfo() : string {
        return this.get(`_179`);
    }

    /**
    /* "Form.Input.PhoneAgain" (Puhelinnumero uudelleen)
    /* "Localizer.formInputPhoneAgain"
    /* "Localizer.formInputPhoneAgainLanguageItemName"
    */
    public get formInputPhoneAgain() : string {
        return this.get(`_17A`);
    }

    /**
    /* "ReserveTimeModal.SavingContactInfoFailed" (Yhteystietojen päivittäminen epäonnistui, ole hyvä ja yritä uudestaan. Ongelman toistuessa ota yhteyttä asiakaspalveluun.)
    /* "Localizer.reserveTimeModalSavingContactInfoFailed"
    /* "Localizer.reserveTimeModalSavingContactInfoFailedLanguageItemName"
    */
    public get reserveTimeModalSavingContactInfoFailed() : string {
        return this.get(`_17B`);
    }

    /**
    /* "EditContactInfoForm.PhonesDoNotMatch" (Syötetyt puhelinnumerot eivät täsmää.)
    /* "Localizer.editContactInfoFormPhonesDoNotMatch"
    /* "Localizer.editContactInfoFormPhonesDoNotMatchLanguageItemName"
    */
    public get editContactInfoFormPhonesDoNotMatch() : string {
        return this.get(`_17C`);
    }

    /**
    /* "EditContactInfoForm.PhoneNumberNotValid" (Syötetty puhelinnumero ei ole validi.)
    /* "Localizer.editContactInfoFormPhoneNumberNotValid"
    /* "Localizer.editContactInfoFormPhoneNumberNotValidLanguageItemName"
    */
    public get editContactInfoFormPhoneNumberNotValid() : string {
        return this.get(`_17D`);
    }

    /**
    /* "ReserveTimeModal.MissingInfoMessage" (Yhteystietosi ovat puutteelliset. Lisää tietoihisi sekä sähköpostiosoite että puhelinnumero viimeistelläksesi varauksesi.)
    /* "Localizer.reserveTimeModalMissingInfoMessage"
    /* "Localizer.reserveTimeModalMissingInfoMessageLanguageItemName"
    */
    public get reserveTimeModalMissingInfoMessage() : string {
        return this.get(`_17E`);
    }

    /**
    /* "ContactInfoReminderView.Message" (Huomasimme, että et ole jättänyt yhteystietoja (sähköposti tai puhelinnumero), joita tarvitsemme mahdollisten muutosten tai lisätietojen toimittamista varten.)
    /* "Localizer.contactInfoReminderViewMessage"
    /* "Localizer.contactInfoReminderViewMessageLanguageItemName"
    */
    public get contactInfoReminderViewMessage() : string {
        return this.get(`_17F`);
    }

    /**
    /* "ContactInfoReminderView.MessagePt2" (Ole hyvä ja täytä tiedot jotta voimme jatkaa varauksesi viimeistelyssä.)
    /* "Localizer.contactInfoReminderViewMessagePt2"
    /* "Localizer.contactInfoReminderViewMessagePt2LanguageItemName"
    */
    public get contactInfoReminderViewMessagePt2() : string {
        return this.get(`_180`);
    }

    /**
    /* "ContactInfoReminderView.Title" (Yhteystiedot puuttuvat)
    /* "Localizer.contactInfoReminderViewTitle"
    /* "Localizer.contactInfoReminderViewTitleLanguageItemName"
    */
    public get contactInfoReminderViewTitle() : string {
        return this.get(`_181`);
    }

    /**
    /* "ReserveTimeModal.AppointmentDetails.ConfirmPhoneTime" (Kiitos, puhelinaika varattu koodilla {0}.\n\nOtathan ylös varauksesi tiedot:)
    /* "Localizer.reserveTimeModalAppointmentDetailsConfirmPhoneTime"
    /* "Localizer.reserveTimeModalAppointmentDetailsConfirmPhoneTimeLanguageItemName"
    */
    public get reserveTimeModalAppointmentDetailsConfirmPhoneTime() : string {
        return this.get(`_182`);
    }

    /**
    /* "Services.InstructionServices" (Asiointiohjeet)
    /* "Localizer.servicesInstructionServices"
    /* "Localizer.servicesInstructionServicesLanguageItemName"
    */
    public get servicesInstructionServices() : string {
        return this.get(`_183`);
    }

    /**
    /* "OccupationalHealth.ContactUs" (Ota yhteyttä)
    /* "Localizer.occupationalHealthContactUs"
    /* "Localizer.occupationalHealthContactUsLanguageItemName"
    */
    public get occupationalHealthContactUs() : string {
        return this.get(`_184`);
    }

    /**
    /* "InfluenzaVaccinationWidget.Title" (Influenssarokotusajat)
    /* "Localizer.influenzaVaccinationWidgetTitle"
    /* "Localizer.influenzaVaccinationWidgetTitleLanguageItemName"
    */
    public get influenzaVaccinationWidgetTitle() : string {
        return this.get(`_185`);
    }

    /**
    /* "CompanyPage.PrivacyPolicy" (Tietosuojaseloste)
    /* "Localizer.companyPagePrivacyPolicy"
    /* "Localizer.companyPagePrivacyPolicyLanguageItemName"
    */
    public get companyPagePrivacyPolicy() : string {
        return this.get(`_186`);
    }

    /**
    /* "CompanyPage.TermsOfUse" (Käyttöehdot)
    /* "Localizer.companyPageTermsOfUse"
    /* "Localizer.companyPageTermsOfUseLanguageItemName"
    */
    public get companyPageTermsOfUse() : string {
        return this.get(`_187`);
    }

    /**
    /* "DigiFenixPage.Title" (DigiFenix)
    /* "Localizer.digiFenixPageTitle"
    /* "Localizer.digiFenixPageTitleLanguageItemName"
    */
    public get digiFenixPageTitle() : string {
        return this.get(`_188`);
    }

    /**
    /* "DigiFenixPage.TopNavTitle" (DigiFenix)
    /* "Localizer.digiFenixPageTopNavTitle"
    /* "Localizer.digiFenixPageTopNavTitleLanguageItemName"
    */
    public get digiFenixPageTopNavTitle() : string {
        return this.get(`_189`);
    }

    /**
    /* "DigiFenixPage.WebVersionButton" (DigiFenix verkossa)
    /* "Localizer.digiFenixPageWebVersionButton"
    /* "Localizer.digiFenixPageWebVersionButtonLanguageItemName"
    */
    public get digiFenixPageWebVersionButton() : string {
        return this.get(`_18A`);
    }

    /**
    /* "Search.Title" (Haku)
    /* "Localizer.searchTitle"
    /* "Localizer.searchTitleLanguageItemName"
    */
    public get searchTitle() : string {
        return this.get(`_18B`);
    }

    /**
    /* "SearchPage.noFilterSelected" (Suodata hakutuloksia)
    /* "Localizer.searchPagenoFilterSelected"
    /* "Localizer.searchPagenoFilterSelectedLanguageItemName"
    */
    public get searchPagenoFilterSelected() : string {
        return this.get(`_18C`);
    }

    /**
    /* "SearchPage.doctor" (Asiantuntija)
    /* "Localizer.searchPagedoctor"
    /* "Localizer.searchPagedoctorLanguageItemName"
    */
    public get searchPagedoctor() : string {
        return this.get(`_18D`);
    }

    /**
    /* "SearchPage.service" (Palvelu)
    /* "Localizer.searchPageservice"
    /* "Localizer.searchPageserviceLanguageItemName"
    */
    public get searchPageservice() : string {
        return this.get(`_18E`);
    }

    /**
    /* "SearchPage.clinic" (Klinikka)
    /* "Localizer.searchPageclinic"
    /* "Localizer.searchPageclinicLanguageItemName"
    */
    public get searchPageclinic() : string {
        return this.get(`_18F`);
    }

    /**
    /* "SearchPage.voucher" (Palveluseteli)
    /* "Localizer.searchPagevoucher"
    /* "Localizer.searchPagevoucherLanguageItemName"
    */
    public get searchPagevoucher() : string {
        return this.get(`_190`);
    }

    /**
    /* "SearchPage.medicalField" (Erikoisala)
    /* "Localizer.searchPagemedicalField"
    /* "Localizer.searchPagemedicalFieldLanguageItemName"
    */
    public get searchPagemedicalField() : string {
        return this.get(`_191`);
    }

    /**
    /* "TopNav.Locations" (Toimipisteet)
    /* "Localizer.topNavLocations"
    /* "Localizer.topNavLocationsLanguageItemName"
    */
    public get topNavLocations() : string {
        return this.get(`_192`);
    }

    /**
    /* "SearchPage.medicalFields" (Erikoisalat)
    /* "Localizer.searchPagemedicalFields"
    /* "Localizer.searchPagemedicalFieldsLanguageItemName"
    */
    public get searchPagemedicalFields() : string {
        return this.get(`_193`);
    }

    /**
    /* "SearchPage.vouchers" (Palvelusetelit)
    /* "Localizer.searchPagevouchers"
    /* "Localizer.searchPagevouchersLanguageItemName"
    */
    public get searchPagevouchers() : string {
        return this.get(`_194`);
    }

    /**
    /* "SearchPage.allResults" (Kaikki tulokset)
    /* "Localizer.searchPageallResults"
    /* "Localizer.searchPageallResultsLanguageItemName"
    */
    public get searchPageallResults() : string {
        return this.get(`_195`);
    }

    /**
    /* "SearchPage.noResults" (Ei tuloksia)
    /* "Localizer.searchPagenoResults"
    /* "Localizer.searchPagenoResultsLanguageItemName"
    */
    public get searchPagenoResults() : string {
        return this.get(`_196`);
    }

    /**
    /* "SearchPage.searchFromApplication" (Hae sivuilta)
    /* "Localizer.searchPagesearchFromApplication"
    /* "Localizer.searchPagesearchFromApplicationLanguageItemName"
    */
    public get searchPagesearchFromApplication() : string {
        return this.get(`_197`);
    }

    /**
    /* "SearchPage.hits" (hakutulosta)
    /* "Localizer.searchPagehits"
    /* "Localizer.searchPagehitsLanguageItemName"
    */
    public get searchPagehits() : string {
        return this.get(`_198`);
    }

    /**
    /* "SearchPage.found" (Löydettiin)
    /* "Localizer.searchPagefound"
    /* "Localizer.searchPagefoundLanguageItemName"
    */
    public get searchPagefound() : string {
        return this.get(`_199`);
    }

    /**
    /* "SearchPage.serviceError" (Hakutoiminto ei ole juuri nyt saatavilla, yritä myöhemmin uudestaan.)
    /* "Localizer.searchPageserviceError"
    /* "Localizer.searchPageserviceErrorLanguageItemName"
    */
    public get searchPageserviceError() : string {
        return this.get(`_19A`);
    }

    /**
    /* "Searchpage.search" (Hae)
    /* "Localizer.searchpagesearch"
    /* "Localizer.searchpagesearchLanguageItemName"
    */
    public get searchpagesearch() : string {
        return this.get(`_19B`);
    }

    /**
    /* "ChildAppointmentCard.Title" (Lastenlääkäreiden ajat)
    /* "Localizer.childAppointmentCardTitle"
    /* "Localizer.childAppointmentCardTitleLanguageItemName"
    */
    public get childAppointmentCardTitle() : string {
        return this.get(`_19C`);
    }

    /**
    /* "OccupationalHealthOfferForm.Title" (Pyydä tarjous)
    /* "Localizer.occupationalHealthOfferFormTitle"
    /* "Localizer.occupationalHealthOfferFormTitleLanguageItemName"
    */
    public get occupationalHealthOfferFormTitle() : string {
        return this.get(`_19D`);
    }

    /**
    /* "Form.Input.Name" (Nimi)
    /* "Localizer.formInputName"
    /* "Localizer.formInputNameLanguageItemName"
    */
    public get formInputName() : string {
        return this.get(`_19E`);
    }

    /**
    /* "Form.Input.CompanyName" (Yrityksen nimi)
    /* "Localizer.formInputCompanyName"
    /* "Localizer.formInputCompanyNameLanguageItemName"
    */
    public get formInputCompanyName() : string {
        return this.get(`_19F`);
    }

    /**
    /* "OccupationalHealthOfferForm.FormTitle" (Pyydä tarjous työterveydestä)
    /* "Localizer.occupationalHealthOfferFormFormTitle"
    /* "Localizer.occupationalHealthOfferFormFormTitleLanguageItemName"
    */
    public get occupationalHealthOfferFormFormTitle() : string {
        return this.get(`_1A0`);
    }

    /**
    /* "OccupationalHealthPage.ButtonText" (Pyydä tarjous)
    /* "Localizer.occupationalHealthPageButtonText"
    /* "Localizer.occupationalHealthPageButtonTextLanguageItemName"
    */
    public get occupationalHealthPageButtonText() : string {
        return this.get(`_1A1`);
    }

    /**
    /* "CancelAppointmentModal.12hMessage" (Varauksesi on alle 12h päässä. Ota yhteyttä asiakaspalveluun peruaksesi ajan.)
    /* "Localizer.cancelAppointmentModal12hMessage"
    /* "Localizer.cancelAppointmentModal12hMessageLanguageItemName"
    */
    public get cancelAppointmentModal12hMessage() : string {
        return this.get(`_1A2`);
    }

    /**
    /* "OccupationalHealthPage.References" (Asiakkaamme kertovat)
    /* "Localizer.occupationalHealthPageReferences"
    /* "Localizer.occupationalHealthPageReferencesLanguageItemName"
    */
    public get occupationalHealthPageReferences() : string {
        return this.get(`_1A3`);
    }

    /**
    /* "CompanyPage.Feedback" (Anna palautetta)
    /* "Localizer.companyPageFeedback"
    /* "Localizer.companyPageFeedbackLanguageItemName"
    */
    public get companyPageFeedback() : string {
        return this.get(`_1A4`);
    }

    /**
    /* "CancelAppointmentModal.24hMessage" (Varauksesi on alle 24h päässä. Ota yhteyttä asiakaspalveluun peruaksesi ajan.)
    /* "Localizer.cancelAppointmentModal24hMessage"
    /* "Localizer.cancelAppointmentModal24hMessageLanguageItemName"
    */
    public get cancelAppointmentModal24hMessage() : string {
        return this.get(`_1A5`);
    }

    /**
    /* "ReservationGuideModal.Title" (Valitse maksaja tai palvelu)
    /* "Localizer.reservationGuideModalTitle"
    /* "Localizer.reservationGuideModalTitleLanguageItemName"
    */
    public get reservationGuideModalTitle() : string {
        return this.get(`_1A6`);
    }

    /**
    /* "ReservationGuideModal.Options.PrivateIndividual" (Yksityisasiointi)
    /* "Localizer.reservationGuideModalOptionsPrivateIndividual"
    /* "Localizer.reservationGuideModalOptionsPrivateIndividualLanguageItemName"
    */
    public get reservationGuideModalOptionsPrivateIndividual() : string {
        return this.get(`_1A7`);
    }

    /**
    /* "ReservationGuideModal.Options.Kela65" (Kela65-asiointi)
    /* "Localizer.reservationGuideModalOptionsKela65"
    /* "Localizer.reservationGuideModalOptionsKela65LanguageItemName"
    */
    public get reservationGuideModalOptionsKela65() : string {
        return this.get(`_1A8`);
    }

    /**
    /* "ReservationGuideModal.Options.OccupationalHealth" (Työterveysasiointi)
    /* "Localizer.reservationGuideModalOptionsOccupationalHealth"
    /* "Localizer.reservationGuideModalOptionsOccupationalHealthLanguageItemName"
    */
    public get reservationGuideModalOptionsOccupationalHealth() : string {
        return this.get(`_1A9`);
    }

    /**
    /* "AppointmentPage.Kela65Label" (Kela65)
    /* "Localizer.appointmentPageKela65Label"
    /* "Localizer.appointmentPageKela65LabelLanguageItemName"
    */
    public get appointmentPageKela65Label() : string {
        return this.get(`_1AA`);
    }

    /**
    /* "Kela65AppointmentCard.Title" (Kela65:n ajat)
    /* "Localizer.kela65AppointmentCardTitle"
    /* "Localizer.kela65AppointmentCardTitleLanguageItemName"
    */
    public get kela65AppointmentCardTitle() : string {
        return this.get(`_1AB`);
    }

    /**
    /* "OpeningHoursPage.Title" (Aukioloajat)
    /* "Localizer.openingHoursPageTitle"
    /* "Localizer.openingHoursPageTitleLanguageItemName"
    */
    public get openingHoursPageTitle() : string {
        return this.get(`_1AC`);
    }

    /**
    /* "ContactSupportPage.DigiFenixAvailable" (Digifenixin kautta voit myös varata ajan.)
    /* "Localizer.contactSupportPageDigiFenixAvailable"
    /* "Localizer.contactSupportPageDigiFenixAvailableLanguageItemName"
    */
    public get contactSupportPageDigiFenixAvailable() : string {
        return this.get(`_1AD`);
    }

    /**
    /* "Footer.QuickLinks.Billing" (Laskutus)
    /* "Localizer.footerQuickLinksBilling"
    /* "Localizer.footerQuickLinksBillingLanguageItemName"
    */
    public get footerQuickLinksBilling() : string {
        return this.get(`_1AE`);
    }

    /**
    /* "Footer.QuickLinks.Billing.ServiceId" (98)
    /* "Localizer.footerQuickLinksBillingServiceId"
    /* "Localizer.footerQuickLinksBillingServiceIdLanguageItemName"
    */
    public get footerQuickLinksBillingServiceId() : string {
        return this.get(`_1AF`);
    }

    /**
    /* "Footer.QuickLinks" (Pikalinkit)
    /* "Localizer.footerQuickLinks"
    /* "Localizer.footerQuickLinksLanguageItemName"
    */
    public get footerQuickLinks() : string {
        return this.get(`_1B0`);
    }

    /**
    /* "Footer.ServicePointsTitle" (Toimipisteet)
    /* "Localizer.footerServicePointsTitle"
    /* "Localizer.footerServicePointsTitleLanguageItemName"
    */
    public get footerServicePointsTitle() : string {
        return this.get(`_1B1`);
    }

    /**
    /* "Footer.DownloadApp" (Lataa DigiFenix sovellus:)
    /* "Localizer.footerDownloadApp"
    /* "Localizer.footerDownloadAppLanguageItemName"
    */
    public get footerDownloadApp() : string {
        return this.get(`_1B2`);
    }

    /**
    /* "ContactSupportPage.SeasonalHoursMessage" (Katso poikkeavat aukioloajat täältä)
    /* "Localizer.contactSupportPageSeasonalHoursMessage"
    /* "Localizer.contactSupportPageSeasonalHoursMessageLanguageItemName"
    */
    public get contactSupportPageSeasonalHoursMessage() : string {
        return this.get(`_1B3`);
    }

    /**
    /* "NewslettersPage.Title" (Uutiskirjeet)
    /* "Localizer.newslettersPageTitle"
    /* "Localizer.newslettersPageTitleLanguageItemName"
    */
    public get newslettersPageTitle() : string {
        return this.get(`_1B4`);
    }

    /**
    /* "NewslettersPage.GeneralSectionTitle" (Yleinen)
    /* "Localizer.newslettersPageGeneralSectionTitle"
    /* "Localizer.newslettersPageGeneralSectionTitleLanguageItemName"
    */
    public get newslettersPageGeneralSectionTitle() : string {
        return this.get(`_1B5`);
    }

    /**
    /* "NewslettersPage.OccupationalSectionTitle" (Työterveyshuolto)
    /* "Localizer.newslettersPageOccupationalSectionTitle"
    /* "Localizer.newslettersPageOccupationalSectionTitleLanguageItemName"
    */
    public get newslettersPageOccupationalSectionTitle() : string {
        return this.get(`_1B6`);
    }

    /**
    /* "NewslettersPage.SubscriptionSectionTitle" (Tilaa uutiskirje)
    /* "Localizer.newslettersPageSubscriptionSectionTitle"
    /* "Localizer.newslettersPageSubscriptionSectionTitleLanguageItemName"
    */
    public get newslettersPageSubscriptionSectionTitle() : string {
        return this.get(`_1B7`);
    }

    /**
    /* "ReserveTimeModal.AppointmentDetails.ConfirmDoctor" (Hoitava asiantuntija)
    /* "Localizer.reserveTimeModalAppointmentDetailsConfirmDoctor"
    /* "Localizer.reserveTimeModalAppointmentDetailsConfirmDoctorLanguageItemName"
    */
    public get reserveTimeModalAppointmentDetailsConfirmDoctor() : string {
        return this.get(`_1B8`);
    }

    /**
    /* "ReserveTimeModal.AppointmentDetails.ConfirmTime" (Aika)
    /* "Localizer.reserveTimeModalAppointmentDetailsConfirmTime"
    /* "Localizer.reserveTimeModalAppointmentDetailsConfirmTimeLanguageItemName"
    */
    public get reserveTimeModalAppointmentDetailsConfirmTime() : string {
        return this.get(`_1B9`);
    }

    /**
    /* "ReserveTimeModal.AppointmentDetails.ConfirmLocation" (Paikka)
    /* "Localizer.reserveTimeModalAppointmentDetailsConfirmLocation"
    /* "Localizer.reserveTimeModalAppointmentDetailsConfirmLocationLanguageItemName"
    */
    public get reserveTimeModalAppointmentDetailsConfirmLocation() : string {
        return this.get(`_1BA`);
    }

    /**
    /* "ReserveTimeModal.AppointmentDetails.ConfirmEndSection" (Tarvitset varauksen tunnuksen, jos haluat peruuttaa ajanvarauksen sähköisesti.\n\nJos olet antanut meille sähköpostiosoitteesi, lähetämme sinulle varauksesta vahvistuksen sähköpostiin.)
    /* "Localizer.reserveTimeModalAppointmentDetailsConfirmEndSection"
    /* "Localizer.reserveTimeModalAppointmentDetailsConfirmEndSectionLanguageItemName"
    */
    public get reserveTimeModalAppointmentDetailsConfirmEndSection() : string {
        return this.get(`_1BB`);
    }

    /**
    /* "ReserveTimeModal.AppointmentDetails.ConfirmDate" (Päivämäärä)
    /* "Localizer.reserveTimeModalAppointmentDetailsConfirmDate"
    /* "Localizer.reserveTimeModalAppointmentDetailsConfirmDateLanguageItemName"
    */
    public get reserveTimeModalAppointmentDetailsConfirmDate() : string {
        return this.get(`_1BC`);
    }

    /**
    /* "Newsletters.WantToSubscribe" (Haluatko tilata Fenixin uutiskirjeen?)
    /* "Localizer.newslettersWantToSubscribe"
    /* "Localizer.newslettersWantToSubscribeLanguageItemName"
    */
    public get newslettersWantToSubscribe() : string {
        return this.get(`_1BD`);
    }

    /**
    /* "Newsletters.SubscribeHere" (Tilaa tästä)
    /* "Localizer.newslettersSubscribeHere"
    /* "Localizer.newslettersSubscribeHereLanguageItemName"
    */
    public get newslettersSubscribeHere() : string {
        return this.get(`_1BE`);
    }

    /**
    /* "AppointmentPage.Location" (Toimipiste)
    /* "Localizer.appointmentPageLocation"
    /* "Localizer.appointmentPageLocationLanguageItemName"
    */
    public get appointmentPageLocation() : string {
        return this.get(`_1BF`);
    }
}

//Singleton
export default new Localizer();